export const score_data = [
	{
		"Index": 1,
		"Rank": 1,
		"Item": "NFT People #3719",
		"Score": 100
	  },
	  {
		"Index": 2,
		"Rank": 2,
		"Item": "NFT People #0312",
		"Score": 99
	  },
	  {
		"Index": 3,
		"Rank": 3,
		"Item": "NFT People #1605",
		"Score": 96
	  },
	  {
		"Index": 4,
		"Rank": 4,
		"Item": "NFT People #1490",
		"Score": 94
	  },
	  {
		"Index": 5,
		"Rank": 5,
		"Item": "NFT People #2018",
		"Score": 93
	  },
	  {
		"Index": 6,
		"Rank": 6,
		"Item": "NFT People #1453",
		"Score": 92
	  },
	  {
		"Index": 7,
		"Rank": 6,
		"Item": "NFT People #2030",
		"Score": 92
	  },
	  {
		"Index": 8,
		"Rank": 6,
		"Item": "NFT People #2409",
		"Score": 92
	  },
	  {
		"Index": 9,
		"Rank": 6,
		"Item": "NFT People #2715",
		"Score": 92
	  },
	  {
		"Index": 10,
		"Rank": 7,
		"Item": "NFT People #1971",
		"Score": 91
	  },
	  {
		"Index": 11,
		"Rank": 7,
		"Item": "NFT People #3168",
		"Score": 91
	  },
	  {
		"Index": 12,
		"Rank": 7,
		"Item": "NFT People #3377",
		"Score": 91
	  },
	  {
		"Index": 13,
		"Rank": 7,
		"Item": "NFT People #4159",
		"Score": 91
	  },
	  {
		"Index": 14,
		"Rank": 8,
		"Item": "NFT People #2445",
		"Score": 90
	  },
	  {
		"Index": 15,
		"Rank": 8,
		"Item": "NFT People #2846",
		"Score": 90
	  },
	  {
		"Index": 16,
		"Rank": 8,
		"Item": "NFT People #3319",
		"Score": 90
	  },
	  {
		"Index": 17,
		"Rank": 9,
		"Item": "NFT People #0173",
		"Score": 89
	  },
	  {
		"Index": 18,
		"Rank": 9,
		"Item": "NFT People #4579",
		"Score": 89
	  },
	  {
		"Index": 19,
		"Rank": 9,
		"Item": "NFT People #4901",
		"Score": 89
	  },
	  {
		"Index": 20,
		"Rank": 10,
		"Item": "NFT People #0186",
		"Score": 88
	  },
	  {
		"Index": 21,
		"Rank": 10,
		"Item": "NFT People #3365",
		"Score": 88
	  },
	  {
		"Index": 22,
		"Rank": 10,
		"Item": "NFT People #3868",
		"Score": 88
	  },
	  {
		"Index": 23,
		"Rank": 11,
		"Item": "NFT People #1119",
		"Score": 87
	  },
	  {
		"Index": 24,
		"Rank": 11,
		"Item": "NFT People #3707",
		"Score": 87
	  },
	  {
		"Index": 25,
		"Rank": 11,
		"Item": "NFT People #4670",
		"Score": 87
	  },
	  {
		"Index": 26,
		"Rank": 11,
		"Item": "NFT People #4736",
		"Score": 87
	  },
	  {
		"Index": 27,
		"Rank": 11,
		"Item": "NFT People #4815",
		"Score": 87
	  },
	  {
		"Index": 28,
		"Rank": 12,
		"Item": "NFT People #0635",
		"Score": 86
	  },
	  {
		"Index": 29,
		"Rank": 12,
		"Item": "NFT People #2394",
		"Score": 86
	  },
	  {
		"Index": 30,
		"Rank": 12,
		"Item": "NFT People #2702",
		"Score": 86
	  },
	  {
		"Index": 31,
		"Rank": 12,
		"Item": "NFT People #3013",
		"Score": 86
	  },
	  {
		"Index": 32,
		"Rank": 12,
		"Item": "NFT People #3891",
		"Score": 86
	  },
	  {
		"Index": 33,
		"Rank": 12,
		"Item": "NFT People #4318",
		"Score": 86
	  },
	  {
		"Index": 34,
		"Rank": 13,
		"Item": "NFT People #0442",
		"Score": 85
	  },
	  {
		"Index": 35,
		"Rank": 14,
		"Item": "NFT People #0376",
		"Score": 84
	  },
	  {
		"Index": 36,
		"Rank": 14,
		"Item": "NFT People #0526",
		"Score": 84
	  },
	  {
		"Index": 37,
		"Rank": 14,
		"Item": "NFT People #0898",
		"Score": 84
	  },
	  {
		"Index": 38,
		"Rank": 14,
		"Item": "NFT People #1224",
		"Score": 84
	  },
	  {
		"Index": 39,
		"Rank": 14,
		"Item": "NFT People #1257",
		"Score": 84
	  },
	  {
		"Index": 40,
		"Rank": 14,
		"Item": "NFT People #2615",
		"Score": 84
	  },
	  {
		"Index": 41,
		"Rank": 14,
		"Item": "NFT People #2807",
		"Score": 84
	  },
	  {
		"Index": 42,
		"Rank": 14,
		"Item": "NFT People #3974",
		"Score": 84
	  },
	  {
		"Index": 43,
		"Rank": 14,
		"Item": "NFT People #4856",
		"Score": 84
	  },
	  {
		"Index": 44,
		"Rank": 15,
		"Item": "NFT People #0281",
		"Score": 83
	  },
	  {
		"Index": 45,
		"Rank": 15,
		"Item": "NFT People #0587",
		"Score": 83
	  },
	  {
		"Index": 46,
		"Rank": 15,
		"Item": "NFT People #1299",
		"Score": 83
	  },
	  {
		"Index": 47,
		"Rank": 15,
		"Item": "NFT People #1882",
		"Score": 83
	  },
	  {
		"Index": 48,
		"Rank": 15,
		"Item": "NFT People #1900",
		"Score": 83
	  },
	  {
		"Index": 49,
		"Rank": 15,
		"Item": "NFT People #2059",
		"Score": 83
	  },
	  {
		"Index": 50,
		"Rank": 15,
		"Item": "NFT People #2486",
		"Score": 83
	  },
	  {
		"Index": 51,
		"Rank": 15,
		"Item": "NFT People #2518",
		"Score": 83
	  },
	  {
		"Index": 52,
		"Rank": 15,
		"Item": "NFT People #2759",
		"Score": 83
	  },
	  {
		"Index": 53,
		"Rank": 15,
		"Item": "NFT People #2902",
		"Score": 83
	  },
	  {
		"Index": 54,
		"Rank": 15,
		"Item": "NFT People #2955",
		"Score": 83
	  },
	  {
		"Index": 55,
		"Rank": 15,
		"Item": "NFT People #3831",
		"Score": 83
	  },
	  {
		"Index": 56,
		"Rank": 15,
		"Item": "NFT People #4793",
		"Score": 83
	  },
	  {
		"Index": 57,
		"Rank": 16,
		"Item": "NFT People #0470",
		"Score": 82
	  },
	  {
		"Index": 58,
		"Rank": 16,
		"Item": "NFT People #1527",
		"Score": 82
	  },
	  {
		"Index": 59,
		"Rank": 16,
		"Item": "NFT People #1635",
		"Score": 82
	  },
	  {
		"Index": 60,
		"Rank": 16,
		"Item": "NFT People #1674",
		"Score": 82
	  },
	  {
		"Index": 61,
		"Rank": 16,
		"Item": "NFT People #1849",
		"Score": 82
	  },
	  {
		"Index": 62,
		"Rank": 16,
		"Item": "NFT People #2294",
		"Score": 82
	  },
	  {
		"Index": 63,
		"Rank": 16,
		"Item": "NFT People #2806",
		"Score": 82
	  },
	  {
		"Index": 64,
		"Rank": 16,
		"Item": "NFT People #3261",
		"Score": 82
	  },
	  {
		"Index": 65,
		"Rank": 16,
		"Item": "NFT People #3534",
		"Score": 82
	  },
	  {
		"Index": 66,
		"Rank": 16,
		"Item": "NFT People #4662",
		"Score": 82
	  },
	  {
		"Index": 67,
		"Rank": 16,
		"Item": "NFT People #4733",
		"Score": 82
	  },
	  {
		"Index": 68,
		"Rank": 16,
		"Item": "NFT People #4951",
		"Score": 82
	  },
	  {
		"Index": 69,
		"Rank": 17,
		"Item": "NFT People #0256",
		"Score": 81
	  },
	  {
		"Index": 70,
		"Rank": 17,
		"Item": "NFT People #0432",
		"Score": 81
	  },
	  {
		"Index": 71,
		"Rank": 17,
		"Item": "NFT People #1008",
		"Score": 81
	  },
	  {
		"Index": 72,
		"Rank": 17,
		"Item": "NFT People #2062",
		"Score": 81
	  },
	  {
		"Index": 73,
		"Rank": 17,
		"Item": "NFT People #2252",
		"Score": 81
	  },
	  {
		"Index": 74,
		"Rank": 17,
		"Item": "NFT People #2288",
		"Score": 81
	  },
	  {
		"Index": 75,
		"Rank": 17,
		"Item": "NFT People #2658",
		"Score": 81
	  },
	  {
		"Index": 76,
		"Rank": 17,
		"Item": "NFT People #2929",
		"Score": 81
	  },
	  {
		"Index": 77,
		"Rank": 17,
		"Item": "NFT People #3113",
		"Score": 81
	  },
	  {
		"Index": 78,
		"Rank": 17,
		"Item": "NFT People #3716",
		"Score": 81
	  },
	  {
		"Index": 79,
		"Rank": 17,
		"Item": "NFT People #4044",
		"Score": 81
	  },
	  {
		"Index": 80,
		"Rank": 18,
		"Item": "NFT People #0162",
		"Score": 80
	  },
	  {
		"Index": 81,
		"Rank": 18,
		"Item": "NFT People #0252",
		"Score": 80
	  },
	  {
		"Index": 82,
		"Rank": 18,
		"Item": "NFT People #1121",
		"Score": 80
	  },
	  {
		"Index": 83,
		"Rank": 18,
		"Item": "NFT People #1206",
		"Score": 80
	  },
	  {
		"Index": 84,
		"Rank": 18,
		"Item": "NFT People #1320",
		"Score": 80
	  },
	  {
		"Index": 85,
		"Rank": 18,
		"Item": "NFT People #1348",
		"Score": 80
	  },
	  {
		"Index": 86,
		"Rank": 18,
		"Item": "NFT People #1482",
		"Score": 80
	  },
	  {
		"Index": 87,
		"Rank": 18,
		"Item": "NFT People #1784",
		"Score": 80
	  },
	  {
		"Index": 88,
		"Rank": 18,
		"Item": "NFT People #1824",
		"Score": 80
	  },
	  {
		"Index": 89,
		"Rank": 18,
		"Item": "NFT People #1859",
		"Score": 80
	  },
	  {
		"Index": 90,
		"Rank": 18,
		"Item": "NFT People #1895",
		"Score": 80
	  },
	  {
		"Index": 91,
		"Rank": 18,
		"Item": "NFT People #2312",
		"Score": 80
	  },
	  {
		"Index": 92,
		"Rank": 18,
		"Item": "NFT People #2541",
		"Score": 80
	  },
	  {
		"Index": 93,
		"Rank": 18,
		"Item": "NFT People #2608",
		"Score": 80
	  },
	  {
		"Index": 94,
		"Rank": 18,
		"Item": "NFT People #2633",
		"Score": 80
	  },
	  {
		"Index": 95,
		"Rank": 18,
		"Item": "NFT People #3290",
		"Score": 80
	  },
	  {
		"Index": 96,
		"Rank": 18,
		"Item": "NFT People #3523",
		"Score": 80
	  },
	  {
		"Index": 97,
		"Rank": 18,
		"Item": "NFT People #3589",
		"Score": 80
	  },
	  {
		"Index": 98,
		"Rank": 18,
		"Item": "NFT People #3751",
		"Score": 80
	  },
	  {
		"Index": 99,
		"Rank": 18,
		"Item": "NFT People #3835",
		"Score": 80
	  },
	  {
		"Index": 100,
		"Rank": 18,
		"Item": "NFT People #3940",
		"Score": 80
	  },
	  {
		"Index": 101,
		"Rank": 18,
		"Item": "NFT People #4333",
		"Score": 80
	  },
	  {
		"Index": 102,
		"Rank": 18,
		"Item": "NFT People #4368",
		"Score": 80
	  },
	  {
		"Index": 103,
		"Rank": 18,
		"Item": "NFT People #4413",
		"Score": 80
	  },
	  {
		"Index": 104,
		"Rank": 18,
		"Item": "NFT People #4424",
		"Score": 80
	  },
	  {
		"Index": 105,
		"Rank": 18,
		"Item": "NFT People #4637",
		"Score": 80
	  },
	  {
		"Index": 106,
		"Rank": 19,
		"Item": "NFT People #0211",
		"Score": 79
	  },
	  {
		"Index": 107,
		"Rank": 19,
		"Item": "NFT People #0581",
		"Score": 79
	  },
	  {
		"Index": 108,
		"Rank": 19,
		"Item": "NFT People #0600",
		"Score": 79
	  },
	  {
		"Index": 109,
		"Rank": 19,
		"Item": "NFT People #0707",
		"Score": 79
	  },
	  {
		"Index": 110,
		"Rank": 19,
		"Item": "NFT People #0895",
		"Score": 79
	  },
	  {
		"Index": 111,
		"Rank": 19,
		"Item": "NFT People #0969",
		"Score": 79
	  },
	  {
		"Index": 112,
		"Rank": 19,
		"Item": "NFT People #1870",
		"Score": 79
	  },
	  {
		"Index": 113,
		"Rank": 19,
		"Item": "NFT People #1931",
		"Score": 79
	  },
	  {
		"Index": 114,
		"Rank": 19,
		"Item": "NFT People #2233",
		"Score": 79
	  },
	  {
		"Index": 115,
		"Rank": 19,
		"Item": "NFT People #2305",
		"Score": 79
	  },
	  {
		"Index": 116,
		"Rank": 19,
		"Item": "NFT People #2356",
		"Score": 79
	  },
	  {
		"Index": 117,
		"Rank": 19,
		"Item": "NFT People #2413",
		"Score": 79
	  },
	  {
		"Index": 118,
		"Rank": 19,
		"Item": "NFT People #3591",
		"Score": 79
	  },
	  {
		"Index": 119,
		"Rank": 19,
		"Item": "NFT People #3795",
		"Score": 79
	  },
	  {
		"Index": 120,
		"Rank": 19,
		"Item": "NFT People #4142",
		"Score": 79
	  },
	  {
		"Index": 121,
		"Rank": 19,
		"Item": "NFT People #4309",
		"Score": 79
	  },
	  {
		"Index": 122,
		"Rank": 19,
		"Item": "NFT People #4421",
		"Score": 79
	  },
	  {
		"Index": 123,
		"Rank": 19,
		"Item": "NFT People #4472",
		"Score": 79
	  },
	  {
		"Index": 124,
		"Rank": 19,
		"Item": "NFT People #4505",
		"Score": 79
	  },
	  {
		"Index": 125,
		"Rank": 19,
		"Item": "NFT People #4610",
		"Score": 79
	  },
	  {
		"Index": 126,
		"Rank": 19,
		"Item": "NFT People #4687",
		"Score": 79
	  },
	  {
		"Index": 127,
		"Rank": 19,
		"Item": "NFT People #4924",
		"Score": 79
	  },
	  {
		"Index": 128,
		"Rank": 20,
		"Item": "NFT People #0531",
		"Score": 78
	  },
	  {
		"Index": 129,
		"Rank": 20,
		"Item": "NFT People #1920",
		"Score": 78
	  },
	  {
		"Index": 130,
		"Rank": 20,
		"Item": "NFT People #1924",
		"Score": 78
	  },
	  {
		"Index": 131,
		"Rank": 20,
		"Item": "NFT People #2065",
		"Score": 78
	  },
	  {
		"Index": 132,
		"Rank": 20,
		"Item": "NFT People #2116",
		"Score": 78
	  },
	  {
		"Index": 133,
		"Rank": 20,
		"Item": "NFT People #2794",
		"Score": 78
	  },
	  {
		"Index": 134,
		"Rank": 20,
		"Item": "NFT People #2978",
		"Score": 78
	  },
	  {
		"Index": 135,
		"Rank": 20,
		"Item": "NFT People #3302",
		"Score": 78
	  },
	  {
		"Index": 136,
		"Rank": 20,
		"Item": "NFT People #3401",
		"Score": 78
	  },
	  {
		"Index": 137,
		"Rank": 20,
		"Item": "NFT People #3631",
		"Score": 78
	  },
	  {
		"Index": 138,
		"Rank": 20,
		"Item": "NFT People #3836",
		"Score": 78
	  },
	  {
		"Index": 139,
		"Rank": 20,
		"Item": "NFT People #4525",
		"Score": 78
	  },
	  {
		"Index": 140,
		"Rank": 21,
		"Item": "NFT People #0313",
		"Score": 77
	  },
	  {
		"Index": 141,
		"Rank": 21,
		"Item": "NFT People #0331",
		"Score": 77
	  },
	  {
		"Index": 142,
		"Rank": 21,
		"Item": "NFT People #0462",
		"Score": 77
	  },
	  {
		"Index": 143,
		"Rank": 21,
		"Item": "NFT People #0764",
		"Score": 77
	  },
	  {
		"Index": 144,
		"Rank": 21,
		"Item": "NFT People #0837",
		"Score": 77
	  },
	  {
		"Index": 145,
		"Rank": 21,
		"Item": "NFT People #0905",
		"Score": 77
	  },
	  {
		"Index": 146,
		"Rank": 21,
		"Item": "NFT People #1042",
		"Score": 77
	  },
	  {
		"Index": 147,
		"Rank": 21,
		"Item": "NFT People #1342",
		"Score": 77
	  },
	  {
		"Index": 148,
		"Rank": 21,
		"Item": "NFT People #1388",
		"Score": 77
	  },
	  {
		"Index": 149,
		"Rank": 21,
		"Item": "NFT People #1454",
		"Score": 77
	  },
	  {
		"Index": 150,
		"Rank": 21,
		"Item": "NFT People #1610",
		"Score": 77
	  },
	  {
		"Index": 151,
		"Rank": 21,
		"Item": "NFT People #1619",
		"Score": 77
	  },
	  {
		"Index": 152,
		"Rank": 21,
		"Item": "NFT People #1911",
		"Score": 77
	  },
	  {
		"Index": 153,
		"Rank": 21,
		"Item": "NFT People #1986",
		"Score": 77
	  },
	  {
		"Index": 154,
		"Rank": 21,
		"Item": "NFT People #2217",
		"Score": 77
	  },
	  {
		"Index": 155,
		"Rank": 21,
		"Item": "NFT People #2699",
		"Score": 77
	  },
	  {
		"Index": 156,
		"Rank": 21,
		"Item": "NFT People #2911",
		"Score": 77
	  },
	  {
		"Index": 157,
		"Rank": 21,
		"Item": "NFT People #3467",
		"Score": 77
	  },
	  {
		"Index": 158,
		"Rank": 21,
		"Item": "NFT People #3617",
		"Score": 77
	  },
	  {
		"Index": 159,
		"Rank": 21,
		"Item": "NFT People #3659",
		"Score": 77
	  },
	  {
		"Index": 160,
		"Rank": 21,
		"Item": "NFT People #3911",
		"Score": 77
	  },
	  {
		"Index": 161,
		"Rank": 21,
		"Item": "NFT People #4000",
		"Score": 77
	  },
	  {
		"Index": 162,
		"Rank": 21,
		"Item": "NFT People #4808",
		"Score": 77
	  },
	  {
		"Index": 163,
		"Rank": 21,
		"Item": "NFT People #4846",
		"Score": 77
	  },
	  {
		"Index": 164,
		"Rank": 21,
		"Item": "NFT People #4938",
		"Score": 77
	  },
	  {
		"Index": 165,
		"Rank": 22,
		"Item": "NFT People #0071",
		"Score": 76
	  },
	  {
		"Index": 166,
		"Rank": 22,
		"Item": "NFT People #0168",
		"Score": 76
	  },
	  {
		"Index": 167,
		"Rank": 22,
		"Item": "NFT People #0457",
		"Score": 76
	  },
	  {
		"Index": 168,
		"Rank": 22,
		"Item": "NFT People #0591",
		"Score": 76
	  },
	  {
		"Index": 169,
		"Rank": 22,
		"Item": "NFT People #0595",
		"Score": 76
	  },
	  {
		"Index": 170,
		"Rank": 22,
		"Item": "NFT People #0950",
		"Score": 76
	  },
	  {
		"Index": 171,
		"Rank": 22,
		"Item": "NFT People #1021",
		"Score": 76
	  },
	  {
		"Index": 172,
		"Rank": 22,
		"Item": "NFT People #1440",
		"Score": 76
	  },
	  {
		"Index": 173,
		"Rank": 22,
		"Item": "NFT People #1613",
		"Score": 76
	  },
	  {
		"Index": 174,
		"Rank": 22,
		"Item": "NFT People #1854",
		"Score": 76
	  },
	  {
		"Index": 175,
		"Rank": 22,
		"Item": "NFT People #1973",
		"Score": 76
	  },
	  {
		"Index": 176,
		"Rank": 22,
		"Item": "NFT People #2063",
		"Score": 76
	  },
	  {
		"Index": 177,
		"Rank": 22,
		"Item": "NFT People #2130",
		"Score": 76
	  },
	  {
		"Index": 178,
		"Rank": 22,
		"Item": "NFT People #2170",
		"Score": 76
	  },
	  {
		"Index": 179,
		"Rank": 22,
		"Item": "NFT People #2174",
		"Score": 76
	  },
	  {
		"Index": 180,
		"Rank": 22,
		"Item": "NFT People #2195",
		"Score": 76
	  },
	  {
		"Index": 181,
		"Rank": 22,
		"Item": "NFT People #2218",
		"Score": 76
	  },
	  {
		"Index": 182,
		"Rank": 22,
		"Item": "NFT People #2274",
		"Score": 76
	  },
	  {
		"Index": 183,
		"Rank": 22,
		"Item": "NFT People #2617",
		"Score": 76
	  },
	  {
		"Index": 184,
		"Rank": 22,
		"Item": "NFT People #2917",
		"Score": 76
	  },
	  {
		"Index": 185,
		"Rank": 22,
		"Item": "NFT People #3106",
		"Score": 76
	  },
	  {
		"Index": 186,
		"Rank": 22,
		"Item": "NFT People #3449",
		"Score": 76
	  },
	  {
		"Index": 187,
		"Rank": 22,
		"Item": "NFT People #3742",
		"Score": 76
	  },
	  {
		"Index": 188,
		"Rank": 22,
		"Item": "NFT People #3773",
		"Score": 76
	  },
	  {
		"Index": 189,
		"Rank": 22,
		"Item": "NFT People #4113",
		"Score": 76
	  },
	  {
		"Index": 190,
		"Rank": 22,
		"Item": "NFT People #4133",
		"Score": 76
	  },
	  {
		"Index": 191,
		"Rank": 22,
		"Item": "NFT People #4186",
		"Score": 76
	  },
	  {
		"Index": 192,
		"Rank": 22,
		"Item": "NFT People #4204",
		"Score": 76
	  },
	  {
		"Index": 193,
		"Rank": 22,
		"Item": "NFT People #4429",
		"Score": 76
	  },
	  {
		"Index": 194,
		"Rank": 22,
		"Item": "NFT People #4768",
		"Score": 76
	  },
	  {
		"Index": 195,
		"Rank": 22,
		"Item": "NFT People #4812",
		"Score": 76
	  },
	  {
		"Index": 196,
		"Rank": 22,
		"Item": "NFT People #4843",
		"Score": 76
	  },
	  {
		"Index": 197,
		"Rank": 23,
		"Item": "NFT People #0005",
		"Score": 75
	  },
	  {
		"Index": 198,
		"Rank": 23,
		"Item": "NFT People #0045",
		"Score": 75
	  },
	  {
		"Index": 199,
		"Rank": 23,
		"Item": "NFT People #0114",
		"Score": 75
	  },
	  {
		"Index": 200,
		"Rank": 23,
		"Item": "NFT People #0147",
		"Score": 75
	  },
	  {
		"Index": 201,
		"Rank": 23,
		"Item": "NFT People #0195",
		"Score": 75
	  },
	  {
		"Index": 202,
		"Rank": 23,
		"Item": "NFT People #0201",
		"Score": 75
	  },
	  {
		"Index": 203,
		"Rank": 23,
		"Item": "NFT People #0264",
		"Score": 75
	  },
	  {
		"Index": 204,
		"Rank": 23,
		"Item": "NFT People #0564",
		"Score": 75
	  },
	  {
		"Index": 205,
		"Rank": 23,
		"Item": "NFT People #0597",
		"Score": 75
	  },
	  {
		"Index": 206,
		"Rank": 23,
		"Item": "NFT People #0732",
		"Score": 75
	  },
	  {
		"Index": 207,
		"Rank": 23,
		"Item": "NFT People #0956",
		"Score": 75
	  },
	  {
		"Index": 208,
		"Rank": 23,
		"Item": "NFT People #0971",
		"Score": 75
	  },
	  {
		"Index": 209,
		"Rank": 23,
		"Item": "NFT People #0984",
		"Score": 75
	  },
	  {
		"Index": 210,
		"Rank": 23,
		"Item": "NFT People #0986",
		"Score": 75
	  },
	  {
		"Index": 211,
		"Rank": 23,
		"Item": "NFT People #1087",
		"Score": 75
	  },
	  {
		"Index": 212,
		"Rank": 23,
		"Item": "NFT People #1107",
		"Score": 75
	  },
	  {
		"Index": 213,
		"Rank": 23,
		"Item": "NFT People #1128",
		"Score": 75
	  },
	  {
		"Index": 214,
		"Rank": 23,
		"Item": "NFT People #1139",
		"Score": 75
	  },
	  {
		"Index": 215,
		"Rank": 23,
		"Item": "NFT People #1210",
		"Score": 75
	  },
	  {
		"Index": 216,
		"Rank": 23,
		"Item": "NFT People #1212",
		"Score": 75
	  },
	  {
		"Index": 217,
		"Rank": 23,
		"Item": "NFT People #1351",
		"Score": 75
	  },
	  {
		"Index": 218,
		"Rank": 23,
		"Item": "NFT People #1362",
		"Score": 75
	  },
	  {
		"Index": 219,
		"Rank": 23,
		"Item": "NFT People #1372",
		"Score": 75
	  },
	  {
		"Index": 220,
		"Rank": 23,
		"Item": "NFT People #1403",
		"Score": 75
	  },
	  {
		"Index": 221,
		"Rank": 23,
		"Item": "NFT People #1442",
		"Score": 75
	  },
	  {
		"Index": 222,
		"Rank": 23,
		"Item": "NFT People #1690",
		"Score": 75
	  },
	  {
		"Index": 223,
		"Rank": 23,
		"Item": "NFT People #1743",
		"Score": 75
	  },
	  {
		"Index": 224,
		"Rank": 23,
		"Item": "NFT People #1744",
		"Score": 75
	  },
	  {
		"Index": 225,
		"Rank": 23,
		"Item": "NFT People #1754",
		"Score": 75
	  },
	  {
		"Index": 226,
		"Rank": 23,
		"Item": "NFT People #1783",
		"Score": 75
	  },
	  {
		"Index": 227,
		"Rank": 23,
		"Item": "NFT People #1850",
		"Score": 75
	  },
	  {
		"Index": 228,
		"Rank": 23,
		"Item": "NFT People #2010",
		"Score": 75
	  },
	  {
		"Index": 229,
		"Rank": 23,
		"Item": "NFT People #2248",
		"Score": 75
	  },
	  {
		"Index": 230,
		"Rank": 23,
		"Item": "NFT People #2276",
		"Score": 75
	  },
	  {
		"Index": 231,
		"Rank": 23,
		"Item": "NFT People #2295",
		"Score": 75
	  },
	  {
		"Index": 232,
		"Rank": 23,
		"Item": "NFT People #2529",
		"Score": 75
	  },
	  {
		"Index": 233,
		"Rank": 23,
		"Item": "NFT People #2948",
		"Score": 75
	  },
	  {
		"Index": 234,
		"Rank": 23,
		"Item": "NFT People #3071",
		"Score": 75
	  },
	  {
		"Index": 235,
		"Rank": 23,
		"Item": "NFT People #3114",
		"Score": 75
	  },
	  {
		"Index": 236,
		"Rank": 23,
		"Item": "NFT People #3312",
		"Score": 75
	  },
	  {
		"Index": 237,
		"Rank": 23,
		"Item": "NFT People #3481",
		"Score": 75
	  },
	  {
		"Index": 238,
		"Rank": 23,
		"Item": "NFT People #3881",
		"Score": 75
	  },
	  {
		"Index": 239,
		"Rank": 23,
		"Item": "NFT People #3942",
		"Score": 75
	  },
	  {
		"Index": 240,
		"Rank": 23,
		"Item": "NFT People #3947",
		"Score": 75
	  },
	  {
		"Index": 241,
		"Rank": 23,
		"Item": "NFT People #4062",
		"Score": 75
	  },
	  {
		"Index": 242,
		"Rank": 23,
		"Item": "NFT People #4130",
		"Score": 75
	  },
	  {
		"Index": 243,
		"Rank": 23,
		"Item": "NFT People #4341",
		"Score": 75
	  },
	  {
		"Index": 244,
		"Rank": 23,
		"Item": "NFT People #4349",
		"Score": 75
	  },
	  {
		"Index": 245,
		"Rank": 23,
		"Item": "NFT People #4456",
		"Score": 75
	  },
	  {
		"Index": 246,
		"Rank": 23,
		"Item": "NFT People #4478",
		"Score": 75
	  },
	  {
		"Index": 247,
		"Rank": 23,
		"Item": "NFT People #4496",
		"Score": 75
	  },
	  {
		"Index": 248,
		"Rank": 23,
		"Item": "NFT People #4658",
		"Score": 75
	  },
	  {
		"Index": 249,
		"Rank": 23,
		"Item": "NFT People #4716",
		"Score": 75
	  },
	  {
		"Index": 250,
		"Rank": 23,
		"Item": "NFT People #4742",
		"Score": 75
	  },
	  {
		"Index": 251,
		"Rank": 23,
		"Item": "NFT People #4818",
		"Score": 75
	  },
	  {
		"Index": 252,
		"Rank": 23,
		"Item": "NFT People #4956",
		"Score": 75
	  },
	  {
		"Index": 253,
		"Rank": 23,
		"Item": "NFT People #4977",
		"Score": 75
	  },
	  {
		"Index": 254,
		"Rank": 24,
		"Item": "NFT People #0063",
		"Score": 74
	  },
	  {
		"Index": 255,
		"Rank": 24,
		"Item": "NFT People #0386",
		"Score": 74
	  },
	  {
		"Index": 256,
		"Rank": 24,
		"Item": "NFT People #0658",
		"Score": 74
	  },
	  {
		"Index": 257,
		"Rank": 24,
		"Item": "NFT People #0786",
		"Score": 74
	  },
	  {
		"Index": 258,
		"Rank": 24,
		"Item": "NFT People #0814",
		"Score": 74
	  },
	  {
		"Index": 259,
		"Rank": 24,
		"Item": "NFT People #0899",
		"Score": 74
	  },
	  {
		"Index": 260,
		"Rank": 24,
		"Item": "NFT People #0958",
		"Score": 74
	  },
	  {
		"Index": 261,
		"Rank": 24,
		"Item": "NFT People #1125",
		"Score": 74
	  },
	  {
		"Index": 262,
		"Rank": 24,
		"Item": "NFT People #1144",
		"Score": 74
	  },
	  {
		"Index": 263,
		"Rank": 24,
		"Item": "NFT People #1235",
		"Score": 74
	  },
	  {
		"Index": 264,
		"Rank": 24,
		"Item": "NFT People #1572",
		"Score": 74
	  },
	  {
		"Index": 265,
		"Rank": 24,
		"Item": "NFT People #2189",
		"Score": 74
	  },
	  {
		"Index": 266,
		"Rank": 24,
		"Item": "NFT People #2203",
		"Score": 74
	  },
	  {
		"Index": 267,
		"Rank": 24,
		"Item": "NFT People #2546",
		"Score": 74
	  },
	  {
		"Index": 268,
		"Rank": 24,
		"Item": "NFT People #3431",
		"Score": 74
	  },
	  {
		"Index": 269,
		"Rank": 24,
		"Item": "NFT People #3517",
		"Score": 74
	  },
	  {
		"Index": 270,
		"Rank": 24,
		"Item": "NFT People #3543",
		"Score": 74
	  },
	  {
		"Index": 271,
		"Rank": 24,
		"Item": "NFT People #3544",
		"Score": 74
	  },
	  {
		"Index": 272,
		"Rank": 24,
		"Item": "NFT People #3583",
		"Score": 74
	  },
	  {
		"Index": 273,
		"Rank": 24,
		"Item": "NFT People #4832",
		"Score": 74
	  },
	  {
		"Index": 274,
		"Rank": 24,
		"Item": "NFT People #4894",
		"Score": 74
	  },
	  {
		"Index": 275,
		"Rank": 25,
		"Item": "NFT People #0085",
		"Score": 73
	  },
	  {
		"Index": 276,
		"Rank": 25,
		"Item": "NFT People #0236",
		"Score": 73
	  },
	  {
		"Index": 277,
		"Rank": 25,
		"Item": "NFT People #0394",
		"Score": 73
	  },
	  {
		"Index": 278,
		"Rank": 25,
		"Item": "NFT People #0437",
		"Score": 73
	  },
	  {
		"Index": 279,
		"Rank": 25,
		"Item": "NFT People #0576",
		"Score": 73
	  },
	  {
		"Index": 280,
		"Rank": 25,
		"Item": "NFT People #0609",
		"Score": 73
	  },
	  {
		"Index": 281,
		"Rank": 25,
		"Item": "NFT People #0644",
		"Score": 73
	  },
	  {
		"Index": 282,
		"Rank": 25,
		"Item": "NFT People #0664",
		"Score": 73
	  },
	  {
		"Index": 283,
		"Rank": 25,
		"Item": "NFT People #0674",
		"Score": 73
	  },
	  {
		"Index": 284,
		"Rank": 25,
		"Item": "NFT People #0881",
		"Score": 73
	  },
	  {
		"Index": 285,
		"Rank": 25,
		"Item": "NFT People #0925",
		"Score": 73
	  },
	  {
		"Index": 286,
		"Rank": 25,
		"Item": "NFT People #0978",
		"Score": 73
	  },
	  {
		"Index": 287,
		"Rank": 25,
		"Item": "NFT People #0980",
		"Score": 73
	  },
	  {
		"Index": 288,
		"Rank": 25,
		"Item": "NFT People #1023",
		"Score": 73
	  },
	  {
		"Index": 289,
		"Rank": 25,
		"Item": "NFT People #1067",
		"Score": 73
	  },
	  {
		"Index": 290,
		"Rank": 25,
		"Item": "NFT People #1304",
		"Score": 73
	  },
	  {
		"Index": 291,
		"Rank": 25,
		"Item": "NFT People #1314",
		"Score": 73
	  },
	  {
		"Index": 292,
		"Rank": 25,
		"Item": "NFT People #1371",
		"Score": 73
	  },
	  {
		"Index": 293,
		"Rank": 25,
		"Item": "NFT People #1410",
		"Score": 73
	  },
	  {
		"Index": 294,
		"Rank": 25,
		"Item": "NFT People #1420",
		"Score": 73
	  },
	  {
		"Index": 295,
		"Rank": 25,
		"Item": "NFT People #1439",
		"Score": 73
	  },
	  {
		"Index": 296,
		"Rank": 25,
		"Item": "NFT People #1753",
		"Score": 73
	  },
	  {
		"Index": 297,
		"Rank": 25,
		"Item": "NFT People #1782",
		"Score": 73
	  },
	  {
		"Index": 298,
		"Rank": 25,
		"Item": "NFT People #1899",
		"Score": 73
	  },
	  {
		"Index": 299,
		"Rank": 25,
		"Item": "NFT People #1917",
		"Score": 73
	  },
	  {
		"Index": 300,
		"Rank": 25,
		"Item": "NFT People #1935",
		"Score": 73
	  },
	  {
		"Index": 301,
		"Rank": 25,
		"Item": "NFT People #1937",
		"Score": 73
	  },
	  {
		"Index": 302,
		"Rank": 25,
		"Item": "NFT People #1956",
		"Score": 73
	  },
	  {
		"Index": 303,
		"Rank": 25,
		"Item": "NFT People #1991",
		"Score": 73
	  },
	  {
		"Index": 304,
		"Rank": 25,
		"Item": "NFT People #2094",
		"Score": 73
	  },
	  {
		"Index": 305,
		"Rank": 25,
		"Item": "NFT People #2176",
		"Score": 73
	  },
	  {
		"Index": 306,
		"Rank": 25,
		"Item": "NFT People #2315",
		"Score": 73
	  },
	  {
		"Index": 307,
		"Rank": 25,
		"Item": "NFT People #2330",
		"Score": 73
	  },
	  {
		"Index": 308,
		"Rank": 25,
		"Item": "NFT People #2417",
		"Score": 73
	  },
	  {
		"Index": 309,
		"Rank": 25,
		"Item": "NFT People #2442",
		"Score": 73
	  },
	  {
		"Index": 310,
		"Rank": 25,
		"Item": "NFT People #2473",
		"Score": 73
	  },
	  {
		"Index": 311,
		"Rank": 25,
		"Item": "NFT People #2569",
		"Score": 73
	  },
	  {
		"Index": 312,
		"Rank": 25,
		"Item": "NFT People #2577",
		"Score": 73
	  },
	  {
		"Index": 313,
		"Rank": 25,
		"Item": "NFT People #2709",
		"Score": 73
	  },
	  {
		"Index": 314,
		"Rank": 25,
		"Item": "NFT People #2896",
		"Score": 73
	  },
	  {
		"Index": 315,
		"Rank": 25,
		"Item": "NFT People #2936",
		"Score": 73
	  },
	  {
		"Index": 316,
		"Rank": 25,
		"Item": "NFT People #2966",
		"Score": 73
	  },
	  {
		"Index": 317,
		"Rank": 25,
		"Item": "NFT People #2973",
		"Score": 73
	  },
	  {
		"Index": 318,
		"Rank": 25,
		"Item": "NFT People #3118",
		"Score": 73
	  },
	  {
		"Index": 319,
		"Rank": 25,
		"Item": "NFT People #3225",
		"Score": 73
	  },
	  {
		"Index": 320,
		"Rank": 25,
		"Item": "NFT People #3307",
		"Score": 73
	  },
	  {
		"Index": 321,
		"Rank": 25,
		"Item": "NFT People #3323",
		"Score": 73
	  },
	  {
		"Index": 322,
		"Rank": 25,
		"Item": "NFT People #3429",
		"Score": 73
	  },
	  {
		"Index": 323,
		"Rank": 25,
		"Item": "NFT People #3518",
		"Score": 73
	  },
	  {
		"Index": 324,
		"Rank": 25,
		"Item": "NFT People #3538",
		"Score": 73
	  },
	  {
		"Index": 325,
		"Rank": 25,
		"Item": "NFT People #3545",
		"Score": 73
	  },
	  {
		"Index": 326,
		"Rank": 25,
		"Item": "NFT People #3574",
		"Score": 73
	  },
	  {
		"Index": 327,
		"Rank": 25,
		"Item": "NFT People #3755",
		"Score": 73
	  },
	  {
		"Index": 328,
		"Rank": 25,
		"Item": "NFT People #3975",
		"Score": 73
	  },
	  {
		"Index": 329,
		"Rank": 25,
		"Item": "NFT People #3978",
		"Score": 73
	  },
	  {
		"Index": 330,
		"Rank": 25,
		"Item": "NFT People #4036",
		"Score": 73
	  },
	  {
		"Index": 331,
		"Rank": 25,
		"Item": "NFT People #4192",
		"Score": 73
	  },
	  {
		"Index": 332,
		"Rank": 25,
		"Item": "NFT People #4205",
		"Score": 73
	  },
	  {
		"Index": 333,
		"Rank": 25,
		"Item": "NFT People #4304",
		"Score": 73
	  },
	  {
		"Index": 334,
		"Rank": 25,
		"Item": "NFT People #4307",
		"Score": 73
	  },
	  {
		"Index": 335,
		"Rank": 25,
		"Item": "NFT People #4316",
		"Score": 73
	  },
	  {
		"Index": 336,
		"Rank": 25,
		"Item": "NFT People #4371",
		"Score": 73
	  },
	  {
		"Index": 337,
		"Rank": 25,
		"Item": "NFT People #4376",
		"Score": 73
	  },
	  {
		"Index": 338,
		"Rank": 25,
		"Item": "NFT People #4470",
		"Score": 73
	  },
	  {
		"Index": 339,
		"Rank": 25,
		"Item": "NFT People #4620",
		"Score": 73
	  },
	  {
		"Index": 340,
		"Rank": 25,
		"Item": "NFT People #4766",
		"Score": 73
	  },
	  {
		"Index": 341,
		"Rank": 25,
		"Item": "NFT People #4866",
		"Score": 73
	  },
	  {
		"Index": 342,
		"Rank": 25,
		"Item": "NFT People #4905",
		"Score": 73
	  },
	  {
		"Index": 343,
		"Rank": 25,
		"Item": "NFT People #4958",
		"Score": 73
	  },
	  {
		"Index": 344,
		"Rank": 26,
		"Item": "NFT People #0014",
		"Score": 72
	  },
	  {
		"Index": 345,
		"Rank": 26,
		"Item": "NFT People #0022",
		"Score": 72
	  },
	  {
		"Index": 346,
		"Rank": 26,
		"Item": "NFT People #0029",
		"Score": 72
	  },
	  {
		"Index": 347,
		"Rank": 26,
		"Item": "NFT People #0057",
		"Score": 72
	  },
	  {
		"Index": 348,
		"Rank": 26,
		"Item": "NFT People #0068",
		"Score": 72
	  },
	  {
		"Index": 349,
		"Rank": 26,
		"Item": "NFT People #0104",
		"Score": 72
	  },
	  {
		"Index": 350,
		"Rank": 26,
		"Item": "NFT People #0108",
		"Score": 72
	  },
	  {
		"Index": 351,
		"Rank": 26,
		"Item": "NFT People #0225",
		"Score": 72
	  },
	  {
		"Index": 352,
		"Rank": 26,
		"Item": "NFT People #0329",
		"Score": 72
	  },
	  {
		"Index": 353,
		"Rank": 26,
		"Item": "NFT People #0403",
		"Score": 72
	  },
	  {
		"Index": 354,
		"Rank": 26,
		"Item": "NFT People #0431",
		"Score": 72
	  },
	  {
		"Index": 355,
		"Rank": 26,
		"Item": "NFT People #0631",
		"Score": 72
	  },
	  {
		"Index": 356,
		"Rank": 26,
		"Item": "NFT People #0652",
		"Score": 72
	  },
	  {
		"Index": 357,
		"Rank": 26,
		"Item": "NFT People #0702",
		"Score": 72
	  },
	  {
		"Index": 358,
		"Rank": 26,
		"Item": "NFT People #0923",
		"Score": 72
	  },
	  {
		"Index": 359,
		"Rank": 26,
		"Item": "NFT People #0952",
		"Score": 72
	  },
	  {
		"Index": 360,
		"Rank": 26,
		"Item": "NFT People #1120",
		"Score": 72
	  },
	  {
		"Index": 361,
		"Rank": 26,
		"Item": "NFT People #1263",
		"Score": 72
	  },
	  {
		"Index": 362,
		"Rank": 26,
		"Item": "NFT People #1271",
		"Score": 72
	  },
	  {
		"Index": 363,
		"Rank": 26,
		"Item": "NFT People #1321",
		"Score": 72
	  },
	  {
		"Index": 364,
		"Rank": 26,
		"Item": "NFT People #1426",
		"Score": 72
	  },
	  {
		"Index": 365,
		"Rank": 26,
		"Item": "NFT People #1533",
		"Score": 72
	  },
	  {
		"Index": 366,
		"Rank": 26,
		"Item": "NFT People #1654",
		"Score": 72
	  },
	  {
		"Index": 367,
		"Rank": 26,
		"Item": "NFT People #1667",
		"Score": 72
	  },
	  {
		"Index": 368,
		"Rank": 26,
		"Item": "NFT People #1748",
		"Score": 72
	  },
	  {
		"Index": 369,
		"Rank": 26,
		"Item": "NFT People #1775",
		"Score": 72
	  },
	  {
		"Index": 370,
		"Rank": 26,
		"Item": "NFT People #1804",
		"Score": 72
	  },
	  {
		"Index": 371,
		"Rank": 26,
		"Item": "NFT People #1848",
		"Score": 72
	  },
	  {
		"Index": 372,
		"Rank": 26,
		"Item": "NFT People #1886",
		"Score": 72
	  },
	  {
		"Index": 373,
		"Rank": 26,
		"Item": "NFT People #2022",
		"Score": 72
	  },
	  {
		"Index": 374,
		"Rank": 26,
		"Item": "NFT People #2029",
		"Score": 72
	  },
	  {
		"Index": 375,
		"Rank": 26,
		"Item": "NFT People #2045",
		"Score": 72
	  },
	  {
		"Index": 376,
		"Rank": 26,
		"Item": "NFT People #2102",
		"Score": 72
	  },
	  {
		"Index": 377,
		"Rank": 26,
		"Item": "NFT People #2127",
		"Score": 72
	  },
	  {
		"Index": 378,
		"Rank": 26,
		"Item": "NFT People #2152",
		"Score": 72
	  },
	  {
		"Index": 379,
		"Rank": 26,
		"Item": "NFT People #2415",
		"Score": 72
	  },
	  {
		"Index": 380,
		"Rank": 26,
		"Item": "NFT People #2481",
		"Score": 72
	  },
	  {
		"Index": 381,
		"Rank": 26,
		"Item": "NFT People #2483",
		"Score": 72
	  },
	  {
		"Index": 382,
		"Rank": 26,
		"Item": "NFT People #2542",
		"Score": 72
	  },
	  {
		"Index": 383,
		"Rank": 26,
		"Item": "NFT People #2576",
		"Score": 72
	  },
	  {
		"Index": 384,
		"Rank": 26,
		"Item": "NFT People #2680",
		"Score": 72
	  },
	  {
		"Index": 385,
		"Rank": 26,
		"Item": "NFT People #2757",
		"Score": 72
	  },
	  {
		"Index": 386,
		"Rank": 26,
		"Item": "NFT People #3015",
		"Score": 72
	  },
	  {
		"Index": 387,
		"Rank": 26,
		"Item": "NFT People #3027",
		"Score": 72
	  },
	  {
		"Index": 388,
		"Rank": 26,
		"Item": "NFT People #3128",
		"Score": 72
	  },
	  {
		"Index": 389,
		"Rank": 26,
		"Item": "NFT People #3148",
		"Score": 72
	  },
	  {
		"Index": 390,
		"Rank": 26,
		"Item": "NFT People #3217",
		"Score": 72
	  },
	  {
		"Index": 391,
		"Rank": 26,
		"Item": "NFT People #3264",
		"Score": 72
	  },
	  {
		"Index": 392,
		"Rank": 26,
		"Item": "NFT People #3267",
		"Score": 72
	  },
	  {
		"Index": 393,
		"Rank": 26,
		"Item": "NFT People #3344",
		"Score": 72
	  },
	  {
		"Index": 394,
		"Rank": 26,
		"Item": "NFT People #3427",
		"Score": 72
	  },
	  {
		"Index": 395,
		"Rank": 26,
		"Item": "NFT People #3597",
		"Score": 72
	  },
	  {
		"Index": 396,
		"Rank": 26,
		"Item": "NFT People #3642",
		"Score": 72
	  },
	  {
		"Index": 397,
		"Rank": 26,
		"Item": "NFT People #3667",
		"Score": 72
	  },
	  {
		"Index": 398,
		"Rank": 26,
		"Item": "NFT People #3753",
		"Score": 72
	  },
	  {
		"Index": 399,
		"Rank": 26,
		"Item": "NFT People #4174",
		"Score": 72
	  },
	  {
		"Index": 400,
		"Rank": 26,
		"Item": "NFT People #4210",
		"Score": 72
	  },
	  {
		"Index": 401,
		"Rank": 26,
		"Item": "NFT People #4321",
		"Score": 72
	  },
	  {
		"Index": 402,
		"Rank": 26,
		"Item": "NFT People #4366",
		"Score": 72
	  },
	  {
		"Index": 403,
		"Rank": 26,
		"Item": "NFT People #4411",
		"Score": 72
	  },
	  {
		"Index": 404,
		"Rank": 26,
		"Item": "NFT People #4425",
		"Score": 72
	  },
	  {
		"Index": 405,
		"Rank": 26,
		"Item": "NFT People #4464",
		"Score": 72
	  },
	  {
		"Index": 406,
		"Rank": 26,
		"Item": "NFT People #4547",
		"Score": 72
	  },
	  {
		"Index": 407,
		"Rank": 26,
		"Item": "NFT People #4644",
		"Score": 72
	  },
	  {
		"Index": 408,
		"Rank": 26,
		"Item": "NFT People #4714",
		"Score": 72
	  },
	  {
		"Index": 409,
		"Rank": 26,
		"Item": "NFT People #4770",
		"Score": 72
	  },
	  {
		"Index": 410,
		"Rank": 26,
		"Item": "NFT People #4895",
		"Score": 72
	  },
	  {
		"Index": 411,
		"Rank": 26,
		"Item": "NFT People #4900",
		"Score": 72
	  },
	  {
		"Index": 412,
		"Rank": 27,
		"Item": "NFT People #0009",
		"Score": 71
	  },
	  {
		"Index": 413,
		"Rank": 27,
		"Item": "NFT People #0098",
		"Score": 71
	  },
	  {
		"Index": 414,
		"Rank": 27,
		"Item": "NFT People #0117",
		"Score": 71
	  },
	  {
		"Index": 415,
		"Rank": 27,
		"Item": "NFT People #0131",
		"Score": 71
	  },
	  {
		"Index": 416,
		"Rank": 27,
		"Item": "NFT People #0247",
		"Score": 71
	  },
	  {
		"Index": 417,
		"Rank": 27,
		"Item": "NFT People #0274",
		"Score": 71
	  },
	  {
		"Index": 418,
		"Rank": 27,
		"Item": "NFT People #0301",
		"Score": 71
	  },
	  {
		"Index": 419,
		"Rank": 27,
		"Item": "NFT People #0424",
		"Score": 71
	  },
	  {
		"Index": 420,
		"Rank": 27,
		"Item": "NFT People #0498",
		"Score": 71
	  },
	  {
		"Index": 421,
		"Rank": 27,
		"Item": "NFT People #0500",
		"Score": 71
	  },
	  {
		"Index": 422,
		"Rank": 27,
		"Item": "NFT People #0583",
		"Score": 71
	  },
	  {
		"Index": 423,
		"Rank": 27,
		"Item": "NFT People #0584",
		"Score": 71
	  },
	  {
		"Index": 424,
		"Rank": 27,
		"Item": "NFT People #0589",
		"Score": 71
	  },
	  {
		"Index": 425,
		"Rank": 27,
		"Item": "NFT People #0612",
		"Score": 71
	  },
	  {
		"Index": 426,
		"Rank": 27,
		"Item": "NFT People #0614",
		"Score": 71
	  },
	  {
		"Index": 427,
		"Rank": 27,
		"Item": "NFT People #0715",
		"Score": 71
	  },
	  {
		"Index": 428,
		"Rank": 27,
		"Item": "NFT People #0813",
		"Score": 71
	  },
	  {
		"Index": 429,
		"Rank": 27,
		"Item": "NFT People #0815",
		"Score": 71
	  },
	  {
		"Index": 430,
		"Rank": 27,
		"Item": "NFT People #0840",
		"Score": 71
	  },
	  {
		"Index": 431,
		"Rank": 27,
		"Item": "NFT People #0850",
		"Score": 71
	  },
	  {
		"Index": 432,
		"Rank": 27,
		"Item": "NFT People #1013",
		"Score": 71
	  },
	  {
		"Index": 433,
		"Rank": 27,
		"Item": "NFT People #1024",
		"Score": 71
	  },
	  {
		"Index": 434,
		"Rank": 27,
		"Item": "NFT People #1026",
		"Score": 71
	  },
	  {
		"Index": 435,
		"Rank": 27,
		"Item": "NFT People #1108",
		"Score": 71
	  },
	  {
		"Index": 436,
		"Rank": 27,
		"Item": "NFT People #1149",
		"Score": 71
	  },
	  {
		"Index": 437,
		"Rank": 27,
		"Item": "NFT People #1248",
		"Score": 71
	  },
	  {
		"Index": 438,
		"Rank": 27,
		"Item": "NFT People #1343",
		"Score": 71
	  },
	  {
		"Index": 439,
		"Rank": 27,
		"Item": "NFT People #1375",
		"Score": 71
	  },
	  {
		"Index": 440,
		"Rank": 27,
		"Item": "NFT People #1408",
		"Score": 71
	  },
	  {
		"Index": 441,
		"Rank": 27,
		"Item": "NFT People #1421",
		"Score": 71
	  },
	  {
		"Index": 442,
		"Rank": 27,
		"Item": "NFT People #1435",
		"Score": 71
	  },
	  {
		"Index": 443,
		"Rank": 27,
		"Item": "NFT People #1476",
		"Score": 71
	  },
	  {
		"Index": 444,
		"Rank": 27,
		"Item": "NFT People #1554",
		"Score": 71
	  },
	  {
		"Index": 445,
		"Rank": 27,
		"Item": "NFT People #1598",
		"Score": 71
	  },
	  {
		"Index": 446,
		"Rank": 27,
		"Item": "NFT People #1720",
		"Score": 71
	  },
	  {
		"Index": 447,
		"Rank": 27,
		"Item": "NFT People #1834",
		"Score": 71
	  },
	  {
		"Index": 448,
		"Rank": 27,
		"Item": "NFT People #1879",
		"Score": 71
	  },
	  {
		"Index": 449,
		"Rank": 27,
		"Item": "NFT People #1974",
		"Score": 71
	  },
	  {
		"Index": 450,
		"Rank": 27,
		"Item": "NFT People #1988",
		"Score": 71
	  },
	  {
		"Index": 451,
		"Rank": 27,
		"Item": "NFT People #1993",
		"Score": 71
	  },
	  {
		"Index": 452,
		"Rank": 27,
		"Item": "NFT People #2002",
		"Score": 71
	  },
	  {
		"Index": 453,
		"Rank": 27,
		"Item": "NFT People #2009",
		"Score": 71
	  },
	  {
		"Index": 454,
		"Rank": 27,
		"Item": "NFT People #2074",
		"Score": 71
	  },
	  {
		"Index": 455,
		"Rank": 27,
		"Item": "NFT People #2171",
		"Score": 71
	  },
	  {
		"Index": 456,
		"Rank": 27,
		"Item": "NFT People #2223",
		"Score": 71
	  },
	  {
		"Index": 457,
		"Rank": 27,
		"Item": "NFT People #2399",
		"Score": 71
	  },
	  {
		"Index": 458,
		"Rank": 27,
		"Item": "NFT People #2453",
		"Score": 71
	  },
	  {
		"Index": 459,
		"Rank": 27,
		"Item": "NFT People #2455",
		"Score": 71
	  },
	  {
		"Index": 460,
		"Rank": 27,
		"Item": "NFT People #2517",
		"Score": 71
	  },
	  {
		"Index": 461,
		"Rank": 27,
		"Item": "NFT People #2639",
		"Score": 71
	  },
	  {
		"Index": 462,
		"Rank": 27,
		"Item": "NFT People #2664",
		"Score": 71
	  },
	  {
		"Index": 463,
		"Rank": 27,
		"Item": "NFT People #2712",
		"Score": 71
	  },
	  {
		"Index": 464,
		"Rank": 27,
		"Item": "NFT People #2852",
		"Score": 71
	  },
	  {
		"Index": 465,
		"Rank": 27,
		"Item": "NFT People #3032",
		"Score": 71
	  },
	  {
		"Index": 466,
		"Rank": 27,
		"Item": "NFT People #3038",
		"Score": 71
	  },
	  {
		"Index": 467,
		"Rank": 27,
		"Item": "NFT People #3218",
		"Score": 71
	  },
	  {
		"Index": 468,
		"Rank": 27,
		"Item": "NFT People #3241",
		"Score": 71
	  },
	  {
		"Index": 469,
		"Rank": 27,
		"Item": "NFT People #3326",
		"Score": 71
	  },
	  {
		"Index": 470,
		"Rank": 27,
		"Item": "NFT People #3327",
		"Score": 71
	  },
	  {
		"Index": 471,
		"Rank": 27,
		"Item": "NFT People #3336",
		"Score": 71
	  },
	  {
		"Index": 472,
		"Rank": 27,
		"Item": "NFT People #3341",
		"Score": 71
	  },
	  {
		"Index": 473,
		"Rank": 27,
		"Item": "NFT People #3385",
		"Score": 71
	  },
	  {
		"Index": 474,
		"Rank": 27,
		"Item": "NFT People #3405",
		"Score": 71
	  },
	  {
		"Index": 475,
		"Rank": 27,
		"Item": "NFT People #3433",
		"Score": 71
	  },
	  {
		"Index": 476,
		"Rank": 27,
		"Item": "NFT People #3557",
		"Score": 71
	  },
	  {
		"Index": 477,
		"Rank": 27,
		"Item": "NFT People #3569",
		"Score": 71
	  },
	  {
		"Index": 478,
		"Rank": 27,
		"Item": "NFT People #3595",
		"Score": 71
	  },
	  {
		"Index": 479,
		"Rank": 27,
		"Item": "NFT People #3735",
		"Score": 71
	  },
	  {
		"Index": 480,
		"Rank": 27,
		"Item": "NFT People #3779",
		"Score": 71
	  },
	  {
		"Index": 481,
		"Rank": 27,
		"Item": "NFT People #3857",
		"Score": 71
	  },
	  {
		"Index": 482,
		"Rank": 27,
		"Item": "NFT People #3870",
		"Score": 71
	  },
	  {
		"Index": 483,
		"Rank": 27,
		"Item": "NFT People #3985",
		"Score": 71
	  },
	  {
		"Index": 484,
		"Rank": 27,
		"Item": "NFT People #3997",
		"Score": 71
	  },
	  {
		"Index": 485,
		"Rank": 27,
		"Item": "NFT People #4056",
		"Score": 71
	  },
	  {
		"Index": 486,
		"Rank": 27,
		"Item": "NFT People #4115",
		"Score": 71
	  },
	  {
		"Index": 487,
		"Rank": 27,
		"Item": "NFT People #4180",
		"Score": 71
	  },
	  {
		"Index": 488,
		"Rank": 27,
		"Item": "NFT People #4269",
		"Score": 71
	  },
	  {
		"Index": 489,
		"Rank": 27,
		"Item": "NFT People #4345",
		"Score": 71
	  },
	  {
		"Index": 490,
		"Rank": 27,
		"Item": "NFT People #4408",
		"Score": 71
	  },
	  {
		"Index": 491,
		"Rank": 27,
		"Item": "NFT People #4461",
		"Score": 71
	  },
	  {
		"Index": 492,
		"Rank": 27,
		"Item": "NFT People #4511",
		"Score": 71
	  },
	  {
		"Index": 493,
		"Rank": 27,
		"Item": "NFT People #4689",
		"Score": 71
	  },
	  {
		"Index": 494,
		"Rank": 27,
		"Item": "NFT People #4758",
		"Score": 71
	  },
	  {
		"Index": 495,
		"Rank": 27,
		"Item": "NFT People #4869",
		"Score": 71
	  },
	  {
		"Index": 496,
		"Rank": 27,
		"Item": "NFT People #4955",
		"Score": 71
	  },
	  {
		"Index": 497,
		"Rank": 27,
		"Item": "NFT People #4984",
		"Score": 71
	  },
	  {
		"Index": 498,
		"Rank": 28,
		"Item": "NFT People #0246",
		"Score": 70
	  },
	  {
		"Index": 499,
		"Rank": 28,
		"Item": "NFT People #0717",
		"Score": 70
	  },
	  {
		"Index": 500,
		"Rank": 28,
		"Item": "NFT People #0737",
		"Score": 70
	  },
	  {
		"Index": 501,
		"Rank": 28,
		"Item": "NFT People #0774",
		"Score": 70
	  },
	  {
		"Index": 502,
		"Rank": 28,
		"Item": "NFT People #0937",
		"Score": 70
	  },
	  {
		"Index": 503,
		"Rank": 28,
		"Item": "NFT People #0947",
		"Score": 70
	  },
	  {
		"Index": 504,
		"Rank": 28,
		"Item": "NFT People #0974",
		"Score": 70
	  },
	  {
		"Index": 505,
		"Rank": 28,
		"Item": "NFT People #1244",
		"Score": 70
	  },
	  {
		"Index": 506,
		"Rank": 28,
		"Item": "NFT People #1259",
		"Score": 70
	  },
	  {
		"Index": 507,
		"Rank": 28,
		"Item": "NFT People #1484",
		"Score": 70
	  },
	  {
		"Index": 508,
		"Rank": 28,
		"Item": "NFT People #1816",
		"Score": 70
	  },
	  {
		"Index": 509,
		"Rank": 28,
		"Item": "NFT People #2092",
		"Score": 70
	  },
	  {
		"Index": 510,
		"Rank": 28,
		"Item": "NFT People #2329",
		"Score": 70
	  },
	  {
		"Index": 511,
		"Rank": 28,
		"Item": "NFT People #2428",
		"Score": 70
	  },
	  {
		"Index": 512,
		"Rank": 28,
		"Item": "NFT People #2437",
		"Score": 70
	  },
	  {
		"Index": 513,
		"Rank": 28,
		"Item": "NFT People #2444",
		"Score": 70
	  },
	  {
		"Index": 514,
		"Rank": 28,
		"Item": "NFT People #3007",
		"Score": 70
	  },
	  {
		"Index": 515,
		"Rank": 28,
		"Item": "NFT People #3073",
		"Score": 70
	  },
	  {
		"Index": 516,
		"Rank": 28,
		"Item": "NFT People #3098",
		"Score": 70
	  },
	  {
		"Index": 517,
		"Rank": 28,
		"Item": "NFT People #3269",
		"Score": 70
	  },
	  {
		"Index": 518,
		"Rank": 28,
		"Item": "NFT People #3289",
		"Score": 70
	  },
	  {
		"Index": 519,
		"Rank": 28,
		"Item": "NFT People #3316",
		"Score": 70
	  },
	  {
		"Index": 520,
		"Rank": 28,
		"Item": "NFT People #3361",
		"Score": 70
	  },
	  {
		"Index": 521,
		"Rank": 28,
		"Item": "NFT People #3559",
		"Score": 70
	  },
	  {
		"Index": 522,
		"Rank": 28,
		"Item": "NFT People #3859",
		"Score": 70
	  },
	  {
		"Index": 523,
		"Rank": 28,
		"Item": "NFT People #3875",
		"Score": 70
	  },
	  {
		"Index": 524,
		"Rank": 28,
		"Item": "NFT People #4049",
		"Score": 70
	  },
	  {
		"Index": 525,
		"Rank": 28,
		"Item": "NFT People #4067",
		"Score": 70
	  },
	  {
		"Index": 526,
		"Rank": 28,
		"Item": "NFT People #4225",
		"Score": 70
	  },
	  {
		"Index": 527,
		"Rank": 28,
		"Item": "NFT People #4270",
		"Score": 70
	  },
	  {
		"Index": 528,
		"Rank": 28,
		"Item": "NFT People #4299",
		"Score": 70
	  },
	  {
		"Index": 529,
		"Rank": 28,
		"Item": "NFT People #4519",
		"Score": 70
	  },
	  {
		"Index": 530,
		"Rank": 28,
		"Item": "NFT People #4786",
		"Score": 70
	  },
	  {
		"Index": 531,
		"Rank": 28,
		"Item": "NFT People #4833",
		"Score": 70
	  },
	  {
		"Index": 532,
		"Rank": 28,
		"Item": "NFT People #4842",
		"Score": 70
	  },
	  {
		"Index": 533,
		"Rank": 28,
		"Item": "NFT People #4876",
		"Score": 70
	  },
	  {
		"Index": 534,
		"Rank": 28,
		"Item": "NFT People #4887",
		"Score": 70
	  },
	  {
		"Index": 535,
		"Rank": 29,
		"Item": "NFT People #0002",
		"Score": 69
	  },
	  {
		"Index": 536,
		"Rank": 29,
		"Item": "NFT People #0095",
		"Score": 69
	  },
	  {
		"Index": 537,
		"Rank": 29,
		"Item": "NFT People #0138",
		"Score": 69
	  },
	  {
		"Index": 538,
		"Rank": 29,
		"Item": "NFT People #0172",
		"Score": 69
	  },
	  {
		"Index": 539,
		"Rank": 29,
		"Item": "NFT People #0333",
		"Score": 69
	  },
	  {
		"Index": 540,
		"Rank": 29,
		"Item": "NFT People #0375",
		"Score": 69
	  },
	  {
		"Index": 541,
		"Rank": 29,
		"Item": "NFT People #0384",
		"Score": 69
	  },
	  {
		"Index": 542,
		"Rank": 29,
		"Item": "NFT People #0399",
		"Score": 69
	  },
	  {
		"Index": 543,
		"Rank": 29,
		"Item": "NFT People #0404",
		"Score": 69
	  },
	  {
		"Index": 544,
		"Rank": 29,
		"Item": "NFT People #0430",
		"Score": 69
	  },
	  {
		"Index": 545,
		"Rank": 29,
		"Item": "NFT People #0494",
		"Score": 69
	  },
	  {
		"Index": 546,
		"Rank": 29,
		"Item": "NFT People #0511",
		"Score": 69
	  },
	  {
		"Index": 547,
		"Rank": 29,
		"Item": "NFT People #0618",
		"Score": 69
	  },
	  {
		"Index": 548,
		"Rank": 29,
		"Item": "NFT People #0711",
		"Score": 69
	  },
	  {
		"Index": 549,
		"Rank": 29,
		"Item": "NFT People #0720",
		"Score": 69
	  },
	  {
		"Index": 550,
		"Rank": 29,
		"Item": "NFT People #0746",
		"Score": 69
	  },
	  {
		"Index": 551,
		"Rank": 29,
		"Item": "NFT People #0790",
		"Score": 69
	  },
	  {
		"Index": 552,
		"Rank": 29,
		"Item": "NFT People #0820",
		"Score": 69
	  },
	  {
		"Index": 553,
		"Rank": 29,
		"Item": "NFT People #0869",
		"Score": 69
	  },
	  {
		"Index": 554,
		"Rank": 29,
		"Item": "NFT People #0949",
		"Score": 69
	  },
	  {
		"Index": 555,
		"Rank": 29,
		"Item": "NFT People #0996",
		"Score": 69
	  },
	  {
		"Index": 556,
		"Rank": 29,
		"Item": "NFT People #1011",
		"Score": 69
	  },
	  {
		"Index": 557,
		"Rank": 29,
		"Item": "NFT People #1074",
		"Score": 69
	  },
	  {
		"Index": 558,
		"Rank": 29,
		"Item": "NFT People #1109",
		"Score": 69
	  },
	  {
		"Index": 559,
		"Rank": 29,
		"Item": "NFT People #1208",
		"Score": 69
	  },
	  {
		"Index": 560,
		"Rank": 29,
		"Item": "NFT People #1382",
		"Score": 69
	  },
	  {
		"Index": 561,
		"Rank": 29,
		"Item": "NFT People #1427",
		"Score": 69
	  },
	  {
		"Index": 562,
		"Rank": 29,
		"Item": "NFT People #1530",
		"Score": 69
	  },
	  {
		"Index": 563,
		"Rank": 29,
		"Item": "NFT People #1723",
		"Score": 69
	  },
	  {
		"Index": 564,
		"Rank": 29,
		"Item": "NFT People #1752",
		"Score": 69
	  },
	  {
		"Index": 565,
		"Rank": 29,
		"Item": "NFT People #1915",
		"Score": 69
	  },
	  {
		"Index": 566,
		"Rank": 29,
		"Item": "NFT People #1954",
		"Score": 69
	  },
	  {
		"Index": 567,
		"Rank": 29,
		"Item": "NFT People #1978",
		"Score": 69
	  },
	  {
		"Index": 568,
		"Rank": 29,
		"Item": "NFT People #2005",
		"Score": 69
	  },
	  {
		"Index": 569,
		"Rank": 29,
		"Item": "NFT People #2016",
		"Score": 69
	  },
	  {
		"Index": 570,
		"Rank": 29,
		"Item": "NFT People #2047",
		"Score": 69
	  },
	  {
		"Index": 571,
		"Rank": 29,
		"Item": "NFT People #2121",
		"Score": 69
	  },
	  {
		"Index": 572,
		"Rank": 29,
		"Item": "NFT People #2172",
		"Score": 69
	  },
	  {
		"Index": 573,
		"Rank": 29,
		"Item": "NFT People #2179",
		"Score": 69
	  },
	  {
		"Index": 574,
		"Rank": 29,
		"Item": "NFT People #2220",
		"Score": 69
	  },
	  {
		"Index": 575,
		"Rank": 29,
		"Item": "NFT People #2230",
		"Score": 69
	  },
	  {
		"Index": 576,
		"Rank": 29,
		"Item": "NFT People #2279",
		"Score": 69
	  },
	  {
		"Index": 577,
		"Rank": 29,
		"Item": "NFT People #2461",
		"Score": 69
	  },
	  {
		"Index": 578,
		"Rank": 29,
		"Item": "NFT People #2530",
		"Score": 69
	  },
	  {
		"Index": 579,
		"Rank": 29,
		"Item": "NFT People #2549",
		"Score": 69
	  },
	  {
		"Index": 580,
		"Rank": 29,
		"Item": "NFT People #2582",
		"Score": 69
	  },
	  {
		"Index": 581,
		"Rank": 29,
		"Item": "NFT People #2652",
		"Score": 69
	  },
	  {
		"Index": 582,
		"Rank": 29,
		"Item": "NFT People #2671",
		"Score": 69
	  },
	  {
		"Index": 583,
		"Rank": 29,
		"Item": "NFT People #2755",
		"Score": 69
	  },
	  {
		"Index": 584,
		"Rank": 29,
		"Item": "NFT People #2840",
		"Score": 69
	  },
	  {
		"Index": 585,
		"Rank": 29,
		"Item": "NFT People #2863",
		"Score": 69
	  },
	  {
		"Index": 586,
		"Rank": 29,
		"Item": "NFT People #2888",
		"Score": 69
	  },
	  {
		"Index": 587,
		"Rank": 29,
		"Item": "NFT People #2964",
		"Score": 69
	  },
	  {
		"Index": 588,
		"Rank": 29,
		"Item": "NFT People #3044",
		"Score": 69
	  },
	  {
		"Index": 589,
		"Rank": 29,
		"Item": "NFT People #3064",
		"Score": 69
	  },
	  {
		"Index": 590,
		"Rank": 29,
		"Item": "NFT People #3151",
		"Score": 69
	  },
	  {
		"Index": 591,
		"Rank": 29,
		"Item": "NFT People #3202",
		"Score": 69
	  },
	  {
		"Index": 592,
		"Rank": 29,
		"Item": "NFT People #3347",
		"Score": 69
	  },
	  {
		"Index": 593,
		"Rank": 29,
		"Item": "NFT People #3413",
		"Score": 69
	  },
	  {
		"Index": 594,
		"Rank": 29,
		"Item": "NFT People #3447",
		"Score": 69
	  },
	  {
		"Index": 595,
		"Rank": 29,
		"Item": "NFT People #3450",
		"Score": 69
	  },
	  {
		"Index": 596,
		"Rank": 29,
		"Item": "NFT People #3487",
		"Score": 69
	  },
	  {
		"Index": 597,
		"Rank": 29,
		"Item": "NFT People #3566",
		"Score": 69
	  },
	  {
		"Index": 598,
		"Rank": 29,
		"Item": "NFT People #3624",
		"Score": 69
	  },
	  {
		"Index": 599,
		"Rank": 29,
		"Item": "NFT People #3630",
		"Score": 69
	  },
	  {
		"Index": 600,
		"Rank": 29,
		"Item": "NFT People #3796",
		"Score": 69
	  },
	  {
		"Index": 601,
		"Rank": 29,
		"Item": "NFT People #3813",
		"Score": 69
	  },
	  {
		"Index": 602,
		"Rank": 29,
		"Item": "NFT People #3908",
		"Score": 69
	  },
	  {
		"Index": 603,
		"Rank": 29,
		"Item": "NFT People #3953",
		"Score": 69
	  },
	  {
		"Index": 604,
		"Rank": 29,
		"Item": "NFT People #4031",
		"Score": 69
	  },
	  {
		"Index": 605,
		"Rank": 29,
		"Item": "NFT People #4041",
		"Score": 69
	  },
	  {
		"Index": 606,
		"Rank": 29,
		"Item": "NFT People #4051",
		"Score": 69
	  },
	  {
		"Index": 607,
		"Rank": 29,
		"Item": "NFT People #4054",
		"Score": 69
	  },
	  {
		"Index": 608,
		"Rank": 29,
		"Item": "NFT People #4093",
		"Score": 69
	  },
	  {
		"Index": 609,
		"Rank": 29,
		"Item": "NFT People #4249",
		"Score": 69
	  },
	  {
		"Index": 610,
		"Rank": 29,
		"Item": "NFT People #4359",
		"Score": 69
	  },
	  {
		"Index": 611,
		"Rank": 29,
		"Item": "NFT People #4433",
		"Score": 69
	  },
	  {
		"Index": 612,
		"Rank": 29,
		"Item": "NFT People #4530",
		"Score": 69
	  },
	  {
		"Index": 613,
		"Rank": 29,
		"Item": "NFT People #4614",
		"Score": 69
	  },
	  {
		"Index": 614,
		"Rank": 29,
		"Item": "NFT People #4664",
		"Score": 69
	  },
	  {
		"Index": 615,
		"Rank": 29,
		"Item": "NFT People #4802",
		"Score": 69
	  },
	  {
		"Index": 616,
		"Rank": 29,
		"Item": "NFT People #4874",
		"Score": 69
	  },
	  {
		"Index": 617,
		"Rank": 29,
		"Item": "NFT People #4891",
		"Score": 69
	  },
	  {
		"Index": 618,
		"Rank": 29,
		"Item": "NFT People #4922",
		"Score": 69
	  },
	  {
		"Index": 619,
		"Rank": 30,
		"Item": "NFT People #0039",
		"Score": 68
	  },
	  {
		"Index": 620,
		"Rank": 30,
		"Item": "NFT People #0040",
		"Score": 68
	  },
	  {
		"Index": 621,
		"Rank": 30,
		"Item": "NFT People #0127",
		"Score": 68
	  },
	  {
		"Index": 622,
		"Rank": 30,
		"Item": "NFT People #0130",
		"Score": 68
	  },
	  {
		"Index": 623,
		"Rank": 30,
		"Item": "NFT People #0203",
		"Score": 68
	  },
	  {
		"Index": 624,
		"Rank": 30,
		"Item": "NFT People #0282",
		"Score": 68
	  },
	  {
		"Index": 625,
		"Rank": 30,
		"Item": "NFT People #0283",
		"Score": 68
	  },
	  {
		"Index": 626,
		"Rank": 30,
		"Item": "NFT People #0286",
		"Score": 68
	  },
	  {
		"Index": 627,
		"Rank": 30,
		"Item": "NFT People #0370",
		"Score": 68
	  },
	  {
		"Index": 628,
		"Rank": 30,
		"Item": "NFT People #0495",
		"Score": 68
	  },
	  {
		"Index": 629,
		"Rank": 30,
		"Item": "NFT People #0598",
		"Score": 68
	  },
	  {
		"Index": 630,
		"Rank": 30,
		"Item": "NFT People #0648",
		"Score": 68
	  },
	  {
		"Index": 631,
		"Rank": 30,
		"Item": "NFT People #0688",
		"Score": 68
	  },
	  {
		"Index": 632,
		"Rank": 30,
		"Item": "NFT People #0694",
		"Score": 68
	  },
	  {
		"Index": 633,
		"Rank": 30,
		"Item": "NFT People #0703",
		"Score": 68
	  },
	  {
		"Index": 634,
		"Rank": 30,
		"Item": "NFT People #0735",
		"Score": 68
	  },
	  {
		"Index": 635,
		"Rank": 30,
		"Item": "NFT People #0779",
		"Score": 68
	  },
	  {
		"Index": 636,
		"Rank": 30,
		"Item": "NFT People #0852",
		"Score": 68
	  },
	  {
		"Index": 637,
		"Rank": 30,
		"Item": "NFT People #0902",
		"Score": 68
	  },
	  {
		"Index": 638,
		"Rank": 30,
		"Item": "NFT People #0966",
		"Score": 68
	  },
	  {
		"Index": 639,
		"Rank": 30,
		"Item": "NFT People #0975",
		"Score": 68
	  },
	  {
		"Index": 640,
		"Rank": 30,
		"Item": "NFT People #0990",
		"Score": 68
	  },
	  {
		"Index": 641,
		"Rank": 30,
		"Item": "NFT People #1076",
		"Score": 68
	  },
	  {
		"Index": 642,
		"Rank": 30,
		"Item": "NFT People #1132",
		"Score": 68
	  },
	  {
		"Index": 643,
		"Rank": 30,
		"Item": "NFT People #1138",
		"Score": 68
	  },
	  {
		"Index": 644,
		"Rank": 30,
		"Item": "NFT People #1163",
		"Score": 68
	  },
	  {
		"Index": 645,
		"Rank": 30,
		"Item": "NFT People #1202",
		"Score": 68
	  },
	  {
		"Index": 646,
		"Rank": 30,
		"Item": "NFT People #1230",
		"Score": 68
	  },
	  {
		"Index": 647,
		"Rank": 30,
		"Item": "NFT People #1337",
		"Score": 68
	  },
	  {
		"Index": 648,
		"Rank": 30,
		"Item": "NFT People #1374",
		"Score": 68
	  },
	  {
		"Index": 649,
		"Rank": 30,
		"Item": "NFT People #1381",
		"Score": 68
	  },
	  {
		"Index": 650,
		"Rank": 30,
		"Item": "NFT People #1422",
		"Score": 68
	  },
	  {
		"Index": 651,
		"Rank": 30,
		"Item": "NFT People #1434",
		"Score": 68
	  },
	  {
		"Index": 652,
		"Rank": 30,
		"Item": "NFT People #1515",
		"Score": 68
	  },
	  {
		"Index": 653,
		"Rank": 30,
		"Item": "NFT People #1596",
		"Score": 68
	  },
	  {
		"Index": 654,
		"Rank": 30,
		"Item": "NFT People #1599",
		"Score": 68
	  },
	  {
		"Index": 655,
		"Rank": 30,
		"Item": "NFT People #1735",
		"Score": 68
	  },
	  {
		"Index": 656,
		"Rank": 30,
		"Item": "NFT People #1757",
		"Score": 68
	  },
	  {
		"Index": 657,
		"Rank": 30,
		"Item": "NFT People #1780",
		"Score": 68
	  },
	  {
		"Index": 658,
		"Rank": 30,
		"Item": "NFT People #1819",
		"Score": 68
	  },
	  {
		"Index": 659,
		"Rank": 30,
		"Item": "NFT People #1861",
		"Score": 68
	  },
	  {
		"Index": 660,
		"Rank": 30,
		"Item": "NFT People #1892",
		"Score": 68
	  },
	  {
		"Index": 661,
		"Rank": 30,
		"Item": "NFT People #2089",
		"Score": 68
	  },
	  {
		"Index": 662,
		"Rank": 30,
		"Item": "NFT People #2091",
		"Score": 68
	  },
	  {
		"Index": 663,
		"Rank": 30,
		"Item": "NFT People #2183",
		"Score": 68
	  },
	  {
		"Index": 664,
		"Rank": 30,
		"Item": "NFT People #2265",
		"Score": 68
	  },
	  {
		"Index": 665,
		"Rank": 30,
		"Item": "NFT People #2289",
		"Score": 68
	  },
	  {
		"Index": 666,
		"Rank": 30,
		"Item": "NFT People #2376",
		"Score": 68
	  },
	  {
		"Index": 667,
		"Rank": 30,
		"Item": "NFT People #2400",
		"Score": 68
	  },
	  {
		"Index": 668,
		"Rank": 30,
		"Item": "NFT People #2420",
		"Score": 68
	  },
	  {
		"Index": 669,
		"Rank": 30,
		"Item": "NFT People #2459",
		"Score": 68
	  },
	  {
		"Index": 670,
		"Rank": 30,
		"Item": "NFT People #2506",
		"Score": 68
	  },
	  {
		"Index": 671,
		"Rank": 30,
		"Item": "NFT People #2605",
		"Score": 68
	  },
	  {
		"Index": 672,
		"Rank": 30,
		"Item": "NFT People #2627",
		"Score": 68
	  },
	  {
		"Index": 673,
		"Rank": 30,
		"Item": "NFT People #2662",
		"Score": 68
	  },
	  {
		"Index": 674,
		"Rank": 30,
		"Item": "NFT People #2668",
		"Score": 68
	  },
	  {
		"Index": 675,
		"Rank": 30,
		"Item": "NFT People #2676",
		"Score": 68
	  },
	  {
		"Index": 676,
		"Rank": 30,
		"Item": "NFT People #2776",
		"Score": 68
	  },
	  {
		"Index": 677,
		"Rank": 30,
		"Item": "NFT People #2800",
		"Score": 68
	  },
	  {
		"Index": 678,
		"Rank": 30,
		"Item": "NFT People #2957",
		"Score": 68
	  },
	  {
		"Index": 679,
		"Rank": 30,
		"Item": "NFT People #2960",
		"Score": 68
	  },
	  {
		"Index": 680,
		"Rank": 30,
		"Item": "NFT People #3017",
		"Score": 68
	  },
	  {
		"Index": 681,
		"Rank": 30,
		"Item": "NFT People #3030",
		"Score": 68
	  },
	  {
		"Index": 682,
		"Rank": 30,
		"Item": "NFT People #3042",
		"Score": 68
	  },
	  {
		"Index": 683,
		"Rank": 30,
		"Item": "NFT People #3051",
		"Score": 68
	  },
	  {
		"Index": 684,
		"Rank": 30,
		"Item": "NFT People #3116",
		"Score": 68
	  },
	  {
		"Index": 685,
		"Rank": 30,
		"Item": "NFT People #3164",
		"Score": 68
	  },
	  {
		"Index": 686,
		"Rank": 30,
		"Item": "NFT People #3196",
		"Score": 68
	  },
	  {
		"Index": 687,
		"Rank": 30,
		"Item": "NFT People #3220",
		"Score": 68
	  },
	  {
		"Index": 688,
		"Rank": 30,
		"Item": "NFT People #3252",
		"Score": 68
	  },
	  {
		"Index": 689,
		"Rank": 30,
		"Item": "NFT People #3253",
		"Score": 68
	  },
	  {
		"Index": 690,
		"Rank": 30,
		"Item": "NFT People #3280",
		"Score": 68
	  },
	  {
		"Index": 691,
		"Rank": 30,
		"Item": "NFT People #3325",
		"Score": 68
	  },
	  {
		"Index": 692,
		"Rank": 30,
		"Item": "NFT People #3507",
		"Score": 68
	  },
	  {
		"Index": 693,
		"Rank": 30,
		"Item": "NFT People #3512",
		"Score": 68
	  },
	  {
		"Index": 694,
		"Rank": 30,
		"Item": "NFT People #3552",
		"Score": 68
	  },
	  {
		"Index": 695,
		"Rank": 30,
		"Item": "NFT People #3556",
		"Score": 68
	  },
	  {
		"Index": 696,
		"Rank": 30,
		"Item": "NFT People #3639",
		"Score": 68
	  },
	  {
		"Index": 697,
		"Rank": 30,
		"Item": "NFT People #3666",
		"Score": 68
	  },
	  {
		"Index": 698,
		"Rank": 30,
		"Item": "NFT People #3671",
		"Score": 68
	  },
	  {
		"Index": 699,
		"Rank": 30,
		"Item": "NFT People #3675",
		"Score": 68
	  },
	  {
		"Index": 700,
		"Rank": 30,
		"Item": "NFT People #3903",
		"Score": 68
	  },
	  {
		"Index": 701,
		"Rank": 30,
		"Item": "NFT People #3930",
		"Score": 68
	  },
	  {
		"Index": 702,
		"Rank": 30,
		"Item": "NFT People #3931",
		"Score": 68
	  },
	  {
		"Index": 703,
		"Rank": 30,
		"Item": "NFT People #3979",
		"Score": 68
	  },
	  {
		"Index": 704,
		"Rank": 30,
		"Item": "NFT People #3980",
		"Score": 68
	  },
	  {
		"Index": 705,
		"Rank": 30,
		"Item": "NFT People #4026",
		"Score": 68
	  },
	  {
		"Index": 706,
		"Rank": 30,
		"Item": "NFT People #4045",
		"Score": 68
	  },
	  {
		"Index": 707,
		"Rank": 30,
		"Item": "NFT People #4116",
		"Score": 68
	  },
	  {
		"Index": 708,
		"Rank": 30,
		"Item": "NFT People #4121",
		"Score": 68
	  },
	  {
		"Index": 709,
		"Rank": 30,
		"Item": "NFT People #4153",
		"Score": 68
	  },
	  {
		"Index": 710,
		"Rank": 30,
		"Item": "NFT People #4177",
		"Score": 68
	  },
	  {
		"Index": 711,
		"Rank": 30,
		"Item": "NFT People #4195",
		"Score": 68
	  },
	  {
		"Index": 712,
		"Rank": 30,
		"Item": "NFT People #4305",
		"Score": 68
	  },
	  {
		"Index": 713,
		"Rank": 30,
		"Item": "NFT People #4354",
		"Score": 68
	  },
	  {
		"Index": 714,
		"Rank": 30,
		"Item": "NFT People #4365",
		"Score": 68
	  },
	  {
		"Index": 715,
		"Rank": 30,
		"Item": "NFT People #4583",
		"Score": 68
	  },
	  {
		"Index": 716,
		"Rank": 30,
		"Item": "NFT People #4600",
		"Score": 68
	  },
	  {
		"Index": 717,
		"Rank": 30,
		"Item": "NFT People #4630",
		"Score": 68
	  },
	  {
		"Index": 718,
		"Rank": 30,
		"Item": "NFT People #4761",
		"Score": 68
	  },
	  {
		"Index": 719,
		"Rank": 30,
		"Item": "NFT People #4795",
		"Score": 68
	  },
	  {
		"Index": 720,
		"Rank": 30,
		"Item": "NFT People #4800",
		"Score": 68
	  },
	  {
		"Index": 721,
		"Rank": 30,
		"Item": "NFT People #4820",
		"Score": 68
	  },
	  {
		"Index": 722,
		"Rank": 30,
		"Item": "NFT People #4830",
		"Score": 68
	  },
	  {
		"Index": 723,
		"Rank": 30,
		"Item": "NFT People #4870",
		"Score": 68
	  },
	  {
		"Index": 724,
		"Rank": 30,
		"Item": "NFT People #4967",
		"Score": 68
	  },
	  {
		"Index": 725,
		"Rank": 30,
		"Item": "NFT People #4980",
		"Score": 68
	  },
	  {
		"Index": 726,
		"Rank": 31,
		"Item": "NFT People #0025",
		"Score": 67
	  },
	  {
		"Index": 727,
		"Rank": 31,
		"Item": "NFT People #0064",
		"Score": 67
	  },
	  {
		"Index": 728,
		"Rank": 31,
		"Item": "NFT People #0215",
		"Score": 67
	  },
	  {
		"Index": 729,
		"Rank": 31,
		"Item": "NFT People #0385",
		"Score": 67
	  },
	  {
		"Index": 730,
		"Rank": 31,
		"Item": "NFT People #0697",
		"Score": 67
	  },
	  {
		"Index": 731,
		"Rank": 31,
		"Item": "NFT People #0713",
		"Score": 67
	  },
	  {
		"Index": 732,
		"Rank": 31,
		"Item": "NFT People #0792",
		"Score": 67
	  },
	  {
		"Index": 733,
		"Rank": 31,
		"Item": "NFT People #0821",
		"Score": 67
	  },
	  {
		"Index": 734,
		"Rank": 31,
		"Item": "NFT People #0972",
		"Score": 67
	  },
	  {
		"Index": 735,
		"Rank": 31,
		"Item": "NFT People #1169",
		"Score": 67
	  },
	  {
		"Index": 736,
		"Rank": 31,
		"Item": "NFT People #1196",
		"Score": 67
	  },
	  {
		"Index": 737,
		"Rank": 31,
		"Item": "NFT People #1253",
		"Score": 67
	  },
	  {
		"Index": 738,
		"Rank": 31,
		"Item": "NFT People #1273",
		"Score": 67
	  },
	  {
		"Index": 739,
		"Rank": 31,
		"Item": "NFT People #1347",
		"Score": 67
	  },
	  {
		"Index": 740,
		"Rank": 31,
		"Item": "NFT People #1461",
		"Score": 67
	  },
	  {
		"Index": 741,
		"Rank": 31,
		"Item": "NFT People #1491",
		"Score": 67
	  },
	  {
		"Index": 742,
		"Rank": 31,
		"Item": "NFT People #1563",
		"Score": 67
	  },
	  {
		"Index": 743,
		"Rank": 31,
		"Item": "NFT People #1632",
		"Score": 67
	  },
	  {
		"Index": 744,
		"Rank": 31,
		"Item": "NFT People #1710",
		"Score": 67
	  },
	  {
		"Index": 745,
		"Rank": 31,
		"Item": "NFT People #1788",
		"Score": 67
	  },
	  {
		"Index": 746,
		"Rank": 31,
		"Item": "NFT People #1826",
		"Score": 67
	  },
	  {
		"Index": 747,
		"Rank": 31,
		"Item": "NFT People #1862",
		"Score": 67
	  },
	  {
		"Index": 748,
		"Rank": 31,
		"Item": "NFT People #1865",
		"Score": 67
	  },
	  {
		"Index": 749,
		"Rank": 31,
		"Item": "NFT People #1880",
		"Score": 67
	  },
	  {
		"Index": 750,
		"Rank": 31,
		"Item": "NFT People #1897",
		"Score": 67
	  },
	  {
		"Index": 751,
		"Rank": 31,
		"Item": "NFT People #1944",
		"Score": 67
	  },
	  {
		"Index": 752,
		"Rank": 31,
		"Item": "NFT People #1952",
		"Score": 67
	  },
	  {
		"Index": 753,
		"Rank": 31,
		"Item": "NFT People #2020",
		"Score": 67
	  },
	  {
		"Index": 754,
		"Rank": 31,
		"Item": "NFT People #2114",
		"Score": 67
	  },
	  {
		"Index": 755,
		"Rank": 31,
		"Item": "NFT People #2123",
		"Score": 67
	  },
	  {
		"Index": 756,
		"Rank": 31,
		"Item": "NFT People #2447",
		"Score": 67
	  },
	  {
		"Index": 757,
		"Rank": 31,
		"Item": "NFT People #2512",
		"Score": 67
	  },
	  {
		"Index": 758,
		"Rank": 31,
		"Item": "NFT People #2613",
		"Score": 67
	  },
	  {
		"Index": 759,
		"Rank": 31,
		"Item": "NFT People #2661",
		"Score": 67
	  },
	  {
		"Index": 760,
		"Rank": 31,
		"Item": "NFT People #2903",
		"Score": 67
	  },
	  {
		"Index": 761,
		"Rank": 31,
		"Item": "NFT People #2926",
		"Score": 67
	  },
	  {
		"Index": 762,
		"Rank": 31,
		"Item": "NFT People #3194",
		"Score": 67
	  },
	  {
		"Index": 763,
		"Rank": 31,
		"Item": "NFT People #3268",
		"Score": 67
	  },
	  {
		"Index": 764,
		"Rank": 31,
		"Item": "NFT People #3284",
		"Score": 67
	  },
	  {
		"Index": 765,
		"Rank": 31,
		"Item": "NFT People #3409",
		"Score": 67
	  },
	  {
		"Index": 766,
		"Rank": 31,
		"Item": "NFT People #3627",
		"Score": 67
	  },
	  {
		"Index": 767,
		"Rank": 31,
		"Item": "NFT People #3662",
		"Score": 67
	  },
	  {
		"Index": 768,
		"Rank": 31,
		"Item": "NFT People #3668",
		"Score": 67
	  },
	  {
		"Index": 769,
		"Rank": 31,
		"Item": "NFT People #3678",
		"Score": 67
	  },
	  {
		"Index": 770,
		"Rank": 31,
		"Item": "NFT People #3846",
		"Score": 67
	  },
	  {
		"Index": 771,
		"Rank": 31,
		"Item": "NFT People #3935",
		"Score": 67
	  },
	  {
		"Index": 772,
		"Rank": 31,
		"Item": "NFT People #3939",
		"Score": 67
	  },
	  {
		"Index": 773,
		"Rank": 31,
		"Item": "NFT People #4007",
		"Score": 67
	  },
	  {
		"Index": 774,
		"Rank": 31,
		"Item": "NFT People #4016",
		"Score": 67
	  },
	  {
		"Index": 775,
		"Rank": 31,
		"Item": "NFT People #4251",
		"Score": 67
	  },
	  {
		"Index": 776,
		"Rank": 31,
		"Item": "NFT People #4257",
		"Score": 67
	  },
	  {
		"Index": 777,
		"Rank": 31,
		"Item": "NFT People #4336",
		"Score": 67
	  },
	  {
		"Index": 778,
		"Rank": 31,
		"Item": "NFT People #4428",
		"Score": 67
	  },
	  {
		"Index": 779,
		"Rank": 31,
		"Item": "NFT People #4796",
		"Score": 67
	  },
	  {
		"Index": 780,
		"Rank": 31,
		"Item": "NFT People #4862",
		"Score": 67
	  },
	  {
		"Index": 781,
		"Rank": 32,
		"Item": "NFT People #0019",
		"Score": 66
	  },
	  {
		"Index": 782,
		"Rank": 32,
		"Item": "NFT People #0174",
		"Score": 66
	  },
	  {
		"Index": 783,
		"Rank": 32,
		"Item": "NFT People #0250",
		"Score": 66
	  },
	  {
		"Index": 784,
		"Rank": 32,
		"Item": "NFT People #0294",
		"Score": 66
	  },
	  {
		"Index": 785,
		"Rank": 32,
		"Item": "NFT People #0318",
		"Score": 66
	  },
	  {
		"Index": 786,
		"Rank": 32,
		"Item": "NFT People #0322",
		"Score": 66
	  },
	  {
		"Index": 787,
		"Rank": 32,
		"Item": "NFT People #0330",
		"Score": 66
	  },
	  {
		"Index": 788,
		"Rank": 32,
		"Item": "NFT People #0395",
		"Score": 66
	  },
	  {
		"Index": 789,
		"Rank": 32,
		"Item": "NFT People #0516",
		"Score": 66
	  },
	  {
		"Index": 790,
		"Rank": 32,
		"Item": "NFT People #0641",
		"Score": 66
	  },
	  {
		"Index": 791,
		"Rank": 32,
		"Item": "NFT People #0675",
		"Score": 66
	  },
	  {
		"Index": 792,
		"Rank": 32,
		"Item": "NFT People #0701",
		"Score": 66
	  },
	  {
		"Index": 793,
		"Rank": 32,
		"Item": "NFT People #0726",
		"Score": 66
	  },
	  {
		"Index": 794,
		"Rank": 32,
		"Item": "NFT People #0738",
		"Score": 66
	  },
	  {
		"Index": 795,
		"Rank": 32,
		"Item": "NFT People #0741",
		"Score": 66
	  },
	  {
		"Index": 796,
		"Rank": 32,
		"Item": "NFT People #0759",
		"Score": 66
	  },
	  {
		"Index": 797,
		"Rank": 32,
		"Item": "NFT People #0833",
		"Score": 66
	  },
	  {
		"Index": 798,
		"Rank": 32,
		"Item": "NFT People #0872",
		"Score": 66
	  },
	  {
		"Index": 799,
		"Rank": 32,
		"Item": "NFT People #0945",
		"Score": 66
	  },
	  {
		"Index": 800,
		"Rank": 32,
		"Item": "NFT People #1002",
		"Score": 66
	  },
	  {
		"Index": 801,
		"Rank": 32,
		"Item": "NFT People #1047",
		"Score": 66
	  },
	  {
		"Index": 802,
		"Rank": 32,
		"Item": "NFT People #1064",
		"Score": 66
	  },
	  {
		"Index": 803,
		"Rank": 32,
		"Item": "NFT People #1161",
		"Score": 66
	  },
	  {
		"Index": 804,
		"Rank": 32,
		"Item": "NFT People #1162",
		"Score": 66
	  },
	  {
		"Index": 805,
		"Rank": 32,
		"Item": "NFT People #1219",
		"Score": 66
	  },
	  {
		"Index": 806,
		"Rank": 32,
		"Item": "NFT People #1277",
		"Score": 66
	  },
	  {
		"Index": 807,
		"Rank": 32,
		"Item": "NFT People #1301",
		"Score": 66
	  },
	  {
		"Index": 808,
		"Rank": 32,
		"Item": "NFT People #1345",
		"Score": 66
	  },
	  {
		"Index": 809,
		"Rank": 32,
		"Item": "NFT People #1360",
		"Score": 66
	  },
	  {
		"Index": 810,
		"Rank": 32,
		"Item": "NFT People #1432",
		"Score": 66
	  },
	  {
		"Index": 811,
		"Rank": 32,
		"Item": "NFT People #1479",
		"Score": 66
	  },
	  {
		"Index": 812,
		"Rank": 32,
		"Item": "NFT People #1504",
		"Score": 66
	  },
	  {
		"Index": 813,
		"Rank": 32,
		"Item": "NFT People #1638",
		"Score": 66
	  },
	  {
		"Index": 814,
		"Rank": 32,
		"Item": "NFT People #1762",
		"Score": 66
	  },
	  {
		"Index": 815,
		"Rank": 32,
		"Item": "NFT People #1825",
		"Score": 66
	  },
	  {
		"Index": 816,
		"Rank": 32,
		"Item": "NFT People #1913",
		"Score": 66
	  },
	  {
		"Index": 817,
		"Rank": 32,
		"Item": "NFT People #1936",
		"Score": 66
	  },
	  {
		"Index": 818,
		"Rank": 32,
		"Item": "NFT People #2027",
		"Score": 66
	  },
	  {
		"Index": 819,
		"Rank": 32,
		"Item": "NFT People #2049",
		"Score": 66
	  },
	  {
		"Index": 820,
		"Rank": 32,
		"Item": "NFT People #2093",
		"Score": 66
	  },
	  {
		"Index": 821,
		"Rank": 32,
		"Item": "NFT People #2148",
		"Score": 66
	  },
	  {
		"Index": 822,
		"Rank": 32,
		"Item": "NFT People #2184",
		"Score": 66
	  },
	  {
		"Index": 823,
		"Rank": 32,
		"Item": "NFT People #2214",
		"Score": 66
	  },
	  {
		"Index": 824,
		"Rank": 32,
		"Item": "NFT People #2221",
		"Score": 66
	  },
	  {
		"Index": 825,
		"Rank": 32,
		"Item": "NFT People #2257",
		"Score": 66
	  },
	  {
		"Index": 826,
		"Rank": 32,
		"Item": "NFT People #2322",
		"Score": 66
	  },
	  {
		"Index": 827,
		"Rank": 32,
		"Item": "NFT People #2348",
		"Score": 66
	  },
	  {
		"Index": 828,
		"Rank": 32,
		"Item": "NFT People #2422",
		"Score": 66
	  },
	  {
		"Index": 829,
		"Rank": 32,
		"Item": "NFT People #2493",
		"Score": 66
	  },
	  {
		"Index": 830,
		"Rank": 32,
		"Item": "NFT People #2534",
		"Score": 66
	  },
	  {
		"Index": 831,
		"Rank": 32,
		"Item": "NFT People #2543",
		"Score": 66
	  },
	  {
		"Index": 832,
		"Rank": 32,
		"Item": "NFT People #2551",
		"Score": 66
	  },
	  {
		"Index": 833,
		"Rank": 32,
		"Item": "NFT People #2772",
		"Score": 66
	  },
	  {
		"Index": 834,
		"Rank": 32,
		"Item": "NFT People #2865",
		"Score": 66
	  },
	  {
		"Index": 835,
		"Rank": 32,
		"Item": "NFT People #2928",
		"Score": 66
	  },
	  {
		"Index": 836,
		"Rank": 32,
		"Item": "NFT People #2976",
		"Score": 66
	  },
	  {
		"Index": 837,
		"Rank": 32,
		"Item": "NFT People #2993",
		"Score": 66
	  },
	  {
		"Index": 838,
		"Rank": 32,
		"Item": "NFT People #3001",
		"Score": 66
	  },
	  {
		"Index": 839,
		"Rank": 32,
		"Item": "NFT People #3101",
		"Score": 66
	  },
	  {
		"Index": 840,
		"Rank": 32,
		"Item": "NFT People #3109",
		"Score": 66
	  },
	  {
		"Index": 841,
		"Rank": 32,
		"Item": "NFT People #3132",
		"Score": 66
	  },
	  {
		"Index": 842,
		"Rank": 32,
		"Item": "NFT People #3135",
		"Score": 66
	  },
	  {
		"Index": 843,
		"Rank": 32,
		"Item": "NFT People #3186",
		"Score": 66
	  },
	  {
		"Index": 844,
		"Rank": 32,
		"Item": "NFT People #3208",
		"Score": 66
	  },
	  {
		"Index": 845,
		"Rank": 32,
		"Item": "NFT People #3210",
		"Score": 66
	  },
	  {
		"Index": 846,
		"Rank": 32,
		"Item": "NFT People #3380",
		"Score": 66
	  },
	  {
		"Index": 847,
		"Rank": 32,
		"Item": "NFT People #3391",
		"Score": 66
	  },
	  {
		"Index": 848,
		"Rank": 32,
		"Item": "NFT People #3415",
		"Score": 66
	  },
	  {
		"Index": 849,
		"Rank": 32,
		"Item": "NFT People #3437",
		"Score": 66
	  },
	  {
		"Index": 850,
		"Rank": 32,
		"Item": "NFT People #3465",
		"Score": 66
	  },
	  {
		"Index": 851,
		"Rank": 32,
		"Item": "NFT People #3500",
		"Score": 66
	  },
	  {
		"Index": 852,
		"Rank": 32,
		"Item": "NFT People #3593",
		"Score": 66
	  },
	  {
		"Index": 853,
		"Rank": 32,
		"Item": "NFT People #3638",
		"Score": 66
	  },
	  {
		"Index": 854,
		"Rank": 32,
		"Item": "NFT People #3676",
		"Score": 66
	  },
	  {
		"Index": 855,
		"Rank": 32,
		"Item": "NFT People #3704",
		"Score": 66
	  },
	  {
		"Index": 856,
		"Rank": 32,
		"Item": "NFT People #3743",
		"Score": 66
	  },
	  {
		"Index": 857,
		"Rank": 32,
		"Item": "NFT People #3768",
		"Score": 66
	  },
	  {
		"Index": 858,
		"Rank": 32,
		"Item": "NFT People #3810",
		"Score": 66
	  },
	  {
		"Index": 859,
		"Rank": 32,
		"Item": "NFT People #3811",
		"Score": 66
	  },
	  {
		"Index": 860,
		"Rank": 32,
		"Item": "NFT People #3816",
		"Score": 66
	  },
	  {
		"Index": 861,
		"Rank": 32,
		"Item": "NFT People #3916",
		"Score": 66
	  },
	  {
		"Index": 862,
		"Rank": 32,
		"Item": "NFT People #4034",
		"Score": 66
	  },
	  {
		"Index": 863,
		"Rank": 32,
		"Item": "NFT People #4198",
		"Score": 66
	  },
	  {
		"Index": 864,
		"Rank": 32,
		"Item": "NFT People #4207",
		"Score": 66
	  },
	  {
		"Index": 865,
		"Rank": 32,
		"Item": "NFT People #4234",
		"Score": 66
	  },
	  {
		"Index": 866,
		"Rank": 32,
		"Item": "NFT People #4311",
		"Score": 66
	  },
	  {
		"Index": 867,
		"Rank": 32,
		"Item": "NFT People #4338",
		"Score": 66
	  },
	  {
		"Index": 868,
		"Rank": 32,
		"Item": "NFT People #4367",
		"Score": 66
	  },
	  {
		"Index": 869,
		"Rank": 32,
		"Item": "NFT People #4383",
		"Score": 66
	  },
	  {
		"Index": 870,
		"Rank": 32,
		"Item": "NFT People #4398",
		"Score": 66
	  },
	  {
		"Index": 871,
		"Rank": 32,
		"Item": "NFT People #4432",
		"Score": 66
	  },
	  {
		"Index": 872,
		"Rank": 32,
		"Item": "NFT People #4487",
		"Score": 66
	  },
	  {
		"Index": 873,
		"Rank": 32,
		"Item": "NFT People #4557",
		"Score": 66
	  },
	  {
		"Index": 874,
		"Rank": 32,
		"Item": "NFT People #4584",
		"Score": 66
	  },
	  {
		"Index": 875,
		"Rank": 32,
		"Item": "NFT People #4589",
		"Score": 66
	  },
	  {
		"Index": 876,
		"Rank": 32,
		"Item": "NFT People #4623",
		"Score": 66
	  },
	  {
		"Index": 877,
		"Rank": 32,
		"Item": "NFT People #4639",
		"Score": 66
	  },
	  {
		"Index": 878,
		"Rank": 32,
		"Item": "NFT People #4746",
		"Score": 66
	  },
	  {
		"Index": 879,
		"Rank": 32,
		"Item": "NFT People #4828",
		"Score": 66
	  },
	  {
		"Index": 880,
		"Rank": 32,
		"Item": "NFT People #4851",
		"Score": 66
	  },
	  {
		"Index": 881,
		"Rank": 32,
		"Item": "NFT People #4863",
		"Score": 66
	  },
	  {
		"Index": 882,
		"Rank": 32,
		"Item": "NFT People #4889",
		"Score": 66
	  },
	  {
		"Index": 883,
		"Rank": 32,
		"Item": "NFT People #4899",
		"Score": 66
	  },
	  {
		"Index": 884,
		"Rank": 32,
		"Item": "NFT People #4908",
		"Score": 66
	  },
	  {
		"Index": 885,
		"Rank": 32,
		"Item": "NFT People #4942",
		"Score": 66
	  },
	  {
		"Index": 886,
		"Rank": 32,
		"Item": "NFT People #4979",
		"Score": 66
	  },
	  {
		"Index": 887,
		"Rank": 33,
		"Item": "NFT People #0066",
		"Score": 65
	  },
	  {
		"Index": 888,
		"Rank": 33,
		"Item": "NFT People #0069",
		"Score": 65
	  },
	  {
		"Index": 889,
		"Rank": 33,
		"Item": "NFT People #0198",
		"Score": 65
	  },
	  {
		"Index": 890,
		"Rank": 33,
		"Item": "NFT People #0253",
		"Score": 65
	  },
	  {
		"Index": 891,
		"Rank": 33,
		"Item": "NFT People #0300",
		"Score": 65
	  },
	  {
		"Index": 892,
		"Rank": 33,
		"Item": "NFT People #0360",
		"Score": 65
	  },
	  {
		"Index": 893,
		"Rank": 33,
		"Item": "NFT People #0371",
		"Score": 65
	  },
	  {
		"Index": 894,
		"Rank": 33,
		"Item": "NFT People #0411",
		"Score": 65
	  },
	  {
		"Index": 895,
		"Rank": 33,
		"Item": "NFT People #0413",
		"Score": 65
	  },
	  {
		"Index": 896,
		"Rank": 33,
		"Item": "NFT People #0453",
		"Score": 65
	  },
	  {
		"Index": 897,
		"Rank": 33,
		"Item": "NFT People #0569",
		"Score": 65
	  },
	  {
		"Index": 898,
		"Rank": 33,
		"Item": "NFT People #0596",
		"Score": 65
	  },
	  {
		"Index": 899,
		"Rank": 33,
		"Item": "NFT People #0617",
		"Score": 65
	  },
	  {
		"Index": 900,
		"Rank": 33,
		"Item": "NFT People #0654",
		"Score": 65
	  },
	  {
		"Index": 901,
		"Rank": 33,
		"Item": "NFT People #0727",
		"Score": 65
	  },
	  {
		"Index": 902,
		"Rank": 33,
		"Item": "NFT People #0855",
		"Score": 65
	  },
	  {
		"Index": 903,
		"Rank": 33,
		"Item": "NFT People #0867",
		"Score": 65
	  },
	  {
		"Index": 904,
		"Rank": 33,
		"Item": "NFT People #0908",
		"Score": 65
	  },
	  {
		"Index": 905,
		"Rank": 33,
		"Item": "NFT People #0941",
		"Score": 65
	  },
	  {
		"Index": 906,
		"Rank": 33,
		"Item": "NFT People #1014",
		"Score": 65
	  },
	  {
		"Index": 907,
		"Rank": 33,
		"Item": "NFT People #1020",
		"Score": 65
	  },
	  {
		"Index": 908,
		"Rank": 33,
		"Item": "NFT People #1058",
		"Score": 65
	  },
	  {
		"Index": 909,
		"Rank": 33,
		"Item": "NFT People #1113",
		"Score": 65
	  },
	  {
		"Index": 910,
		"Rank": 33,
		"Item": "NFT People #1126",
		"Score": 65
	  },
	  {
		"Index": 911,
		"Rank": 33,
		"Item": "NFT People #1145",
		"Score": 65
	  },
	  {
		"Index": 912,
		"Rank": 33,
		"Item": "NFT People #1279",
		"Score": 65
	  },
	  {
		"Index": 913,
		"Rank": 33,
		"Item": "NFT People #1291",
		"Score": 65
	  },
	  {
		"Index": 914,
		"Rank": 33,
		"Item": "NFT People #1333",
		"Score": 65
	  },
	  {
		"Index": 915,
		"Rank": 33,
		"Item": "NFT People #1370",
		"Score": 65
	  },
	  {
		"Index": 916,
		"Rank": 33,
		"Item": "NFT People #1373",
		"Score": 65
	  },
	  {
		"Index": 917,
		"Rank": 33,
		"Item": "NFT People #1436",
		"Score": 65
	  },
	  {
		"Index": 918,
		"Rank": 33,
		"Item": "NFT People #1470",
		"Score": 65
	  },
	  {
		"Index": 919,
		"Rank": 33,
		"Item": "NFT People #1487",
		"Score": 65
	  },
	  {
		"Index": 920,
		"Rank": 33,
		"Item": "NFT People #1493",
		"Score": 65
	  },
	  {
		"Index": 921,
		"Rank": 33,
		"Item": "NFT People #1503",
		"Score": 65
	  },
	  {
		"Index": 922,
		"Rank": 33,
		"Item": "NFT People #1570",
		"Score": 65
	  },
	  {
		"Index": 923,
		"Rank": 33,
		"Item": "NFT People #1595",
		"Score": 65
	  },
	  {
		"Index": 924,
		"Rank": 33,
		"Item": "NFT People #1601",
		"Score": 65
	  },
	  {
		"Index": 925,
		"Rank": 33,
		"Item": "NFT People #1618",
		"Score": 65
	  },
	  {
		"Index": 926,
		"Rank": 33,
		"Item": "NFT People #1633",
		"Score": 65
	  },
	  {
		"Index": 927,
		"Rank": 33,
		"Item": "NFT People #1650",
		"Score": 65
	  },
	  {
		"Index": 928,
		"Rank": 33,
		"Item": "NFT People #1671",
		"Score": 65
	  },
	  {
		"Index": 929,
		"Rank": 33,
		"Item": "NFT People #1678",
		"Score": 65
	  },
	  {
		"Index": 930,
		"Rank": 33,
		"Item": "NFT People #1713",
		"Score": 65
	  },
	  {
		"Index": 931,
		"Rank": 33,
		"Item": "NFT People #1759",
		"Score": 65
	  },
	  {
		"Index": 932,
		"Rank": 33,
		"Item": "NFT People #1827",
		"Score": 65
	  },
	  {
		"Index": 933,
		"Rank": 33,
		"Item": "NFT People #1856",
		"Score": 65
	  },
	  {
		"Index": 934,
		"Rank": 33,
		"Item": "NFT People #1860",
		"Score": 65
	  },
	  {
		"Index": 935,
		"Rank": 33,
		"Item": "NFT People #1872",
		"Score": 65
	  },
	  {
		"Index": 936,
		"Rank": 33,
		"Item": "NFT People #1878",
		"Score": 65
	  },
	  {
		"Index": 937,
		"Rank": 33,
		"Item": "NFT People #1919",
		"Score": 65
	  },
	  {
		"Index": 938,
		"Rank": 33,
		"Item": "NFT People #1928",
		"Score": 65
	  },
	  {
		"Index": 939,
		"Rank": 33,
		"Item": "NFT People #1941",
		"Score": 65
	  },
	  {
		"Index": 940,
		"Rank": 33,
		"Item": "NFT People #2051",
		"Score": 65
	  },
	  {
		"Index": 941,
		"Rank": 33,
		"Item": "NFT People #2110",
		"Score": 65
	  },
	  {
		"Index": 942,
		"Rank": 33,
		"Item": "NFT People #2136",
		"Score": 65
	  },
	  {
		"Index": 943,
		"Rank": 33,
		"Item": "NFT People #2188",
		"Score": 65
	  },
	  {
		"Index": 944,
		"Rank": 33,
		"Item": "NFT People #2212",
		"Score": 65
	  },
	  {
		"Index": 945,
		"Rank": 33,
		"Item": "NFT People #2254",
		"Score": 65
	  },
	  {
		"Index": 946,
		"Rank": 33,
		"Item": "NFT People #2264",
		"Score": 65
	  },
	  {
		"Index": 947,
		"Rank": 33,
		"Item": "NFT People #2319",
		"Score": 65
	  },
	  {
		"Index": 948,
		"Rank": 33,
		"Item": "NFT People #2351",
		"Score": 65
	  },
	  {
		"Index": 949,
		"Rank": 33,
		"Item": "NFT People #2368",
		"Score": 65
	  },
	  {
		"Index": 950,
		"Rank": 33,
		"Item": "NFT People #2378",
		"Score": 65
	  },
	  {
		"Index": 951,
		"Rank": 33,
		"Item": "NFT People #2416",
		"Score": 65
	  },
	  {
		"Index": 952,
		"Rank": 33,
		"Item": "NFT People #2423",
		"Score": 65
	  },
	  {
		"Index": 953,
		"Rank": 33,
		"Item": "NFT People #2476",
		"Score": 65
	  },
	  {
		"Index": 954,
		"Rank": 33,
		"Item": "NFT People #2495",
		"Score": 65
	  },
	  {
		"Index": 955,
		"Rank": 33,
		"Item": "NFT People #2521",
		"Score": 65
	  },
	  {
		"Index": 956,
		"Rank": 33,
		"Item": "NFT People #2611",
		"Score": 65
	  },
	  {
		"Index": 957,
		"Rank": 33,
		"Item": "NFT People #2797",
		"Score": 65
	  },
	  {
		"Index": 958,
		"Rank": 33,
		"Item": "NFT People #2916",
		"Score": 65
	  },
	  {
		"Index": 959,
		"Rank": 33,
		"Item": "NFT People #2963",
		"Score": 65
	  },
	  {
		"Index": 960,
		"Rank": 33,
		"Item": "NFT People #2987",
		"Score": 65
	  },
	  {
		"Index": 961,
		"Rank": 33,
		"Item": "NFT People #2988",
		"Score": 65
	  },
	  {
		"Index": 962,
		"Rank": 33,
		"Item": "NFT People #3000",
		"Score": 65
	  },
	  {
		"Index": 963,
		"Rank": 33,
		"Item": "NFT People #3037",
		"Score": 65
	  },
	  {
		"Index": 964,
		"Rank": 33,
		"Item": "NFT People #3074",
		"Score": 65
	  },
	  {
		"Index": 965,
		"Rank": 33,
		"Item": "NFT People #3085",
		"Score": 65
	  },
	  {
		"Index": 966,
		"Rank": 33,
		"Item": "NFT People #3092",
		"Score": 65
	  },
	  {
		"Index": 967,
		"Rank": 33,
		"Item": "NFT People #3102",
		"Score": 65
	  },
	  {
		"Index": 968,
		"Rank": 33,
		"Item": "NFT People #3129",
		"Score": 65
	  },
	  {
		"Index": 969,
		"Rank": 33,
		"Item": "NFT People #3237",
		"Score": 65
	  },
	  {
		"Index": 970,
		"Rank": 33,
		"Item": "NFT People #3242",
		"Score": 65
	  },
	  {
		"Index": 971,
		"Rank": 33,
		"Item": "NFT People #3265",
		"Score": 65
	  },
	  {
		"Index": 972,
		"Rank": 33,
		"Item": "NFT People #3266",
		"Score": 65
	  },
	  {
		"Index": 973,
		"Rank": 33,
		"Item": "NFT People #3297",
		"Score": 65
	  },
	  {
		"Index": 974,
		"Rank": 33,
		"Item": "NFT People #3304",
		"Score": 65
	  },
	  {
		"Index": 975,
		"Rank": 33,
		"Item": "NFT People #3313",
		"Score": 65
	  },
	  {
		"Index": 976,
		"Rank": 33,
		"Item": "NFT People #3340",
		"Score": 65
	  },
	  {
		"Index": 977,
		"Rank": 33,
		"Item": "NFT People #3367",
		"Score": 65
	  },
	  {
		"Index": 978,
		"Rank": 33,
		"Item": "NFT People #3470",
		"Score": 65
	  },
	  {
		"Index": 979,
		"Rank": 33,
		"Item": "NFT People #3499",
		"Score": 65
	  },
	  {
		"Index": 980,
		"Rank": 33,
		"Item": "NFT People #3511",
		"Score": 65
	  },
	  {
		"Index": 981,
		"Rank": 33,
		"Item": "NFT People #3681",
		"Score": 65
	  },
	  {
		"Index": 982,
		"Rank": 33,
		"Item": "NFT People #3780",
		"Score": 65
	  },
	  {
		"Index": 983,
		"Rank": 33,
		"Item": "NFT People #3808",
		"Score": 65
	  },
	  {
		"Index": 984,
		"Rank": 33,
		"Item": "NFT People #3838",
		"Score": 65
	  },
	  {
		"Index": 985,
		"Rank": 33,
		"Item": "NFT People #3877",
		"Score": 65
	  },
	  {
		"Index": 986,
		"Rank": 33,
		"Item": "NFT People #3905",
		"Score": 65
	  },
	  {
		"Index": 987,
		"Rank": 33,
		"Item": "NFT People #3989",
		"Score": 65
	  },
	  {
		"Index": 988,
		"Rank": 33,
		"Item": "NFT People #4032",
		"Score": 65
	  },
	  {
		"Index": 989,
		"Rank": 33,
		"Item": "NFT People #4055",
		"Score": 65
	  },
	  {
		"Index": 990,
		"Rank": 33,
		"Item": "NFT People #4089",
		"Score": 65
	  },
	  {
		"Index": 991,
		"Rank": 33,
		"Item": "NFT People #4110",
		"Score": 65
	  },
	  {
		"Index": 992,
		"Rank": 33,
		"Item": "NFT People #4242",
		"Score": 65
	  },
	  {
		"Index": 993,
		"Rank": 33,
		"Item": "NFT People #4263",
		"Score": 65
	  },
	  {
		"Index": 994,
		"Rank": 33,
		"Item": "NFT People #4350",
		"Score": 65
	  },
	  {
		"Index": 995,
		"Rank": 33,
		"Item": "NFT People #4360",
		"Score": 65
	  },
	  {
		"Index": 996,
		"Rank": 33,
		"Item": "NFT People #4380",
		"Score": 65
	  },
	  {
		"Index": 997,
		"Rank": 33,
		"Item": "NFT People #4401",
		"Score": 65
	  },
	  {
		"Index": 998,
		"Rank": 33,
		"Item": "NFT People #4460",
		"Score": 65
	  },
	  {
		"Index": 999,
		"Rank": 33,
		"Item": "NFT People #4476",
		"Score": 65
	  },
	  {
		"Index": 1000,
		"Rank": 33,
		"Item": "NFT People #4603",
		"Score": 65
	  },
	  {
		"Index": 1001,
		"Rank": 33,
		"Item": "NFT People #4643",
		"Score": 65
	  },
	  {
		"Index": 1002,
		"Rank": 33,
		"Item": "NFT People #4649",
		"Score": 65
	  },
	  {
		"Index": 1003,
		"Rank": 33,
		"Item": "NFT People #4674",
		"Score": 65
	  },
	  {
		"Index": 1004,
		"Rank": 33,
		"Item": "NFT People #4803",
		"Score": 65
	  },
	  {
		"Index": 1005,
		"Rank": 33,
		"Item": "NFT People #4893",
		"Score": 65
	  },
	  {
		"Index": 1006,
		"Rank": 33,
		"Item": "NFT People #4898",
		"Score": 65
	  },
	  {
		"Index": 1007,
		"Rank": 33,
		"Item": "NFT People #4988",
		"Score": 65
	  },
	  {
		"Index": 1008,
		"Rank": 33,
		"Item": "NFT People #4993",
		"Score": 65
	  },
	  {
		"Index": 1009,
		"Rank": 34,
		"Item": "NFT People #0001",
		"Score": 64
	  },
	  {
		"Index": 1010,
		"Rank": 34,
		"Item": "NFT People #0048",
		"Score": 64
	  },
	  {
		"Index": 1011,
		"Rank": 34,
		"Item": "NFT People #0093",
		"Score": 64
	  },
	  {
		"Index": 1012,
		"Rank": 34,
		"Item": "NFT People #0157",
		"Score": 64
	  },
	  {
		"Index": 1013,
		"Rank": 34,
		"Item": "NFT People #0158",
		"Score": 64
	  },
	  {
		"Index": 1014,
		"Rank": 34,
		"Item": "NFT People #0192",
		"Score": 64
	  },
	  {
		"Index": 1015,
		"Rank": 34,
		"Item": "NFT People #0238",
		"Score": 64
	  },
	  {
		"Index": 1016,
		"Rank": 34,
		"Item": "NFT People #0279",
		"Score": 64
	  },
	  {
		"Index": 1017,
		"Rank": 34,
		"Item": "NFT People #0280",
		"Score": 64
	  },
	  {
		"Index": 1018,
		"Rank": 34,
		"Item": "NFT People #0317",
		"Score": 64
	  },
	  {
		"Index": 1019,
		"Rank": 34,
		"Item": "NFT People #0419",
		"Score": 64
	  },
	  {
		"Index": 1020,
		"Rank": 34,
		"Item": "NFT People #0499",
		"Score": 64
	  },
	  {
		"Index": 1021,
		"Rank": 34,
		"Item": "NFT People #0501",
		"Score": 64
	  },
	  {
		"Index": 1022,
		"Rank": 34,
		"Item": "NFT People #0509",
		"Score": 64
	  },
	  {
		"Index": 1023,
		"Rank": 34,
		"Item": "NFT People #0566",
		"Score": 64
	  },
	  {
		"Index": 1024,
		"Rank": 34,
		"Item": "NFT People #0605",
		"Score": 64
	  },
	  {
		"Index": 1025,
		"Rank": 34,
		"Item": "NFT People #0610",
		"Score": 64
	  },
	  {
		"Index": 1026,
		"Rank": 34,
		"Item": "NFT People #0623",
		"Score": 64
	  },
	  {
		"Index": 1027,
		"Rank": 34,
		"Item": "NFT People #0655",
		"Score": 64
	  },
	  {
		"Index": 1028,
		"Rank": 34,
		"Item": "NFT People #0665",
		"Score": 64
	  },
	  {
		"Index": 1029,
		"Rank": 34,
		"Item": "NFT People #0671",
		"Score": 64
	  },
	  {
		"Index": 1030,
		"Rank": 34,
		"Item": "NFT People #0676",
		"Score": 64
	  },
	  {
		"Index": 1031,
		"Rank": 34,
		"Item": "NFT People #0917",
		"Score": 64
	  },
	  {
		"Index": 1032,
		"Rank": 34,
		"Item": "NFT People #0951",
		"Score": 64
	  },
	  {
		"Index": 1033,
		"Rank": 34,
		"Item": "NFT People #0976",
		"Score": 64
	  },
	  {
		"Index": 1034,
		"Rank": 34,
		"Item": "NFT People #0991",
		"Score": 64
	  },
	  {
		"Index": 1035,
		"Rank": 34,
		"Item": "NFT People #0998",
		"Score": 64
	  },
	  {
		"Index": 1036,
		"Rank": 34,
		"Item": "NFT People #1001",
		"Score": 64
	  },
	  {
		"Index": 1037,
		"Rank": 34,
		"Item": "NFT People #1134",
		"Score": 64
	  },
	  {
		"Index": 1038,
		"Rank": 34,
		"Item": "NFT People #1141",
		"Score": 64
	  },
	  {
		"Index": 1039,
		"Rank": 34,
		"Item": "NFT People #1160",
		"Score": 64
	  },
	  {
		"Index": 1040,
		"Rank": 34,
		"Item": "NFT People #1204",
		"Score": 64
	  },
	  {
		"Index": 1041,
		"Rank": 34,
		"Item": "NFT People #1284",
		"Score": 64
	  },
	  {
		"Index": 1042,
		"Rank": 34,
		"Item": "NFT People #1310",
		"Score": 64
	  },
	  {
		"Index": 1043,
		"Rank": 34,
		"Item": "NFT People #1377",
		"Score": 64
	  },
	  {
		"Index": 1044,
		"Rank": 34,
		"Item": "NFT People #1400",
		"Score": 64
	  },
	  {
		"Index": 1045,
		"Rank": 34,
		"Item": "NFT People #1428",
		"Score": 64
	  },
	  {
		"Index": 1046,
		"Rank": 34,
		"Item": "NFT People #1477",
		"Score": 64
	  },
	  {
		"Index": 1047,
		"Rank": 34,
		"Item": "NFT People #1529",
		"Score": 64
	  },
	  {
		"Index": 1048,
		"Rank": 34,
		"Item": "NFT People #1582",
		"Score": 64
	  },
	  {
		"Index": 1049,
		"Rank": 34,
		"Item": "NFT People #1670",
		"Score": 64
	  },
	  {
		"Index": 1050,
		"Rank": 34,
		"Item": "NFT People #1689",
		"Score": 64
	  },
	  {
		"Index": 1051,
		"Rank": 34,
		"Item": "NFT People #1702",
		"Score": 64
	  },
	  {
		"Index": 1052,
		"Rank": 34,
		"Item": "NFT People #1727",
		"Score": 64
	  },
	  {
		"Index": 1053,
		"Rank": 34,
		"Item": "NFT People #1904",
		"Score": 64
	  },
	  {
		"Index": 1054,
		"Rank": 34,
		"Item": "NFT People #2035",
		"Score": 64
	  },
	  {
		"Index": 1055,
		"Rank": 34,
		"Item": "NFT People #2036",
		"Score": 64
	  },
	  {
		"Index": 1056,
		"Rank": 34,
		"Item": "NFT People #2048",
		"Score": 64
	  },
	  {
		"Index": 1057,
		"Rank": 34,
		"Item": "NFT People #2104",
		"Score": 64
	  },
	  {
		"Index": 1058,
		"Rank": 34,
		"Item": "NFT People #2175",
		"Score": 64
	  },
	  {
		"Index": 1059,
		"Rank": 34,
		"Item": "NFT People #2187",
		"Score": 64
	  },
	  {
		"Index": 1060,
		"Rank": 34,
		"Item": "NFT People #2190",
		"Score": 64
	  },
	  {
		"Index": 1061,
		"Rank": 34,
		"Item": "NFT People #2228",
		"Score": 64
	  },
	  {
		"Index": 1062,
		"Rank": 34,
		"Item": "NFT People #2243",
		"Score": 64
	  },
	  {
		"Index": 1063,
		"Rank": 34,
		"Item": "NFT People #2261",
		"Score": 64
	  },
	  {
		"Index": 1064,
		"Rank": 34,
		"Item": "NFT People #2361",
		"Score": 64
	  },
	  {
		"Index": 1065,
		"Rank": 34,
		"Item": "NFT People #2391",
		"Score": 64
	  },
	  {
		"Index": 1066,
		"Rank": 34,
		"Item": "NFT People #2419",
		"Score": 64
	  },
	  {
		"Index": 1067,
		"Rank": 34,
		"Item": "NFT People #2480",
		"Score": 64
	  },
	  {
		"Index": 1068,
		"Rank": 34,
		"Item": "NFT People #2490",
		"Score": 64
	  },
	  {
		"Index": 1069,
		"Rank": 34,
		"Item": "NFT People #2515",
		"Score": 64
	  },
	  {
		"Index": 1070,
		"Rank": 34,
		"Item": "NFT People #2554",
		"Score": 64
	  },
	  {
		"Index": 1071,
		"Rank": 34,
		"Item": "NFT People #2566",
		"Score": 64
	  },
	  {
		"Index": 1072,
		"Rank": 34,
		"Item": "NFT People #2581",
		"Score": 64
	  },
	  {
		"Index": 1073,
		"Rank": 34,
		"Item": "NFT People #2594",
		"Score": 64
	  },
	  {
		"Index": 1074,
		"Rank": 34,
		"Item": "NFT People #2635",
		"Score": 64
	  },
	  {
		"Index": 1075,
		"Rank": 34,
		"Item": "NFT People #2651",
		"Score": 64
	  },
	  {
		"Index": 1076,
		"Rank": 34,
		"Item": "NFT People #2684",
		"Score": 64
	  },
	  {
		"Index": 1077,
		"Rank": 34,
		"Item": "NFT People #2756",
		"Score": 64
	  },
	  {
		"Index": 1078,
		"Rank": 34,
		"Item": "NFT People #2770",
		"Score": 64
	  },
	  {
		"Index": 1079,
		"Rank": 34,
		"Item": "NFT People #2861",
		"Score": 64
	  },
	  {
		"Index": 1080,
		"Rank": 34,
		"Item": "NFT People #2870",
		"Score": 64
	  },
	  {
		"Index": 1081,
		"Rank": 34,
		"Item": "NFT People #2937",
		"Score": 64
	  },
	  {
		"Index": 1082,
		"Rank": 34,
		"Item": "NFT People #3029",
		"Score": 64
	  },
	  {
		"Index": 1083,
		"Rank": 34,
		"Item": "NFT People #3165",
		"Score": 64
	  },
	  {
		"Index": 1084,
		"Rank": 34,
		"Item": "NFT People #3170",
		"Score": 64
	  },
	  {
		"Index": 1085,
		"Rank": 34,
		"Item": "NFT People #3206",
		"Score": 64
	  },
	  {
		"Index": 1086,
		"Rank": 34,
		"Item": "NFT People #3207",
		"Score": 64
	  },
	  {
		"Index": 1087,
		"Rank": 34,
		"Item": "NFT People #3254",
		"Score": 64
	  },
	  {
		"Index": 1088,
		"Rank": 34,
		"Item": "NFT People #3351",
		"Score": 64
	  },
	  {
		"Index": 1089,
		"Rank": 34,
		"Item": "NFT People #3358",
		"Score": 64
	  },
	  {
		"Index": 1090,
		"Rank": 34,
		"Item": "NFT People #3372",
		"Score": 64
	  },
	  {
		"Index": 1091,
		"Rank": 34,
		"Item": "NFT People #3422",
		"Score": 64
	  },
	  {
		"Index": 1092,
		"Rank": 34,
		"Item": "NFT People #3430",
		"Score": 64
	  },
	  {
		"Index": 1093,
		"Rank": 34,
		"Item": "NFT People #3442",
		"Score": 64
	  },
	  {
		"Index": 1094,
		"Rank": 34,
		"Item": "NFT People #3445",
		"Score": 64
	  },
	  {
		"Index": 1095,
		"Rank": 34,
		"Item": "NFT People #3502",
		"Score": 64
	  },
	  {
		"Index": 1096,
		"Rank": 34,
		"Item": "NFT People #3554",
		"Score": 64
	  },
	  {
		"Index": 1097,
		"Rank": 34,
		"Item": "NFT People #3587",
		"Score": 64
	  },
	  {
		"Index": 1098,
		"Rank": 34,
		"Item": "NFT People #3612",
		"Score": 64
	  },
	  {
		"Index": 1099,
		"Rank": 34,
		"Item": "NFT People #3619",
		"Score": 64
	  },
	  {
		"Index": 1100,
		"Rank": 34,
		"Item": "NFT People #3640",
		"Score": 64
	  },
	  {
		"Index": 1101,
		"Rank": 34,
		"Item": "NFT People #3645",
		"Score": 64
	  },
	  {
		"Index": 1102,
		"Rank": 34,
		"Item": "NFT People #3720",
		"Score": 64
	  },
	  {
		"Index": 1103,
		"Rank": 34,
		"Item": "NFT People #3736",
		"Score": 64
	  },
	  {
		"Index": 1104,
		"Rank": 34,
		"Item": "NFT People #3772",
		"Score": 64
	  },
	  {
		"Index": 1105,
		"Rank": 34,
		"Item": "NFT People #3873",
		"Score": 64
	  },
	  {
		"Index": 1106,
		"Rank": 34,
		"Item": "NFT People #3918",
		"Score": 64
	  },
	  {
		"Index": 1107,
		"Rank": 34,
		"Item": "NFT People #3949",
		"Score": 64
	  },
	  {
		"Index": 1108,
		"Rank": 34,
		"Item": "NFT People #3972",
		"Score": 64
	  },
	  {
		"Index": 1109,
		"Rank": 34,
		"Item": "NFT People #3977",
		"Score": 64
	  },
	  {
		"Index": 1110,
		"Rank": 34,
		"Item": "NFT People #4084",
		"Score": 64
	  },
	  {
		"Index": 1111,
		"Rank": 34,
		"Item": "NFT People #4138",
		"Score": 64
	  },
	  {
		"Index": 1112,
		"Rank": 34,
		"Item": "NFT People #4255",
		"Score": 64
	  },
	  {
		"Index": 1113,
		"Rank": 34,
		"Item": "NFT People #4260",
		"Score": 64
	  },
	  {
		"Index": 1114,
		"Rank": 34,
		"Item": "NFT People #4288",
		"Score": 64
	  },
	  {
		"Index": 1115,
		"Rank": 34,
		"Item": "NFT People #4334",
		"Score": 64
	  },
	  {
		"Index": 1116,
		"Rank": 34,
		"Item": "NFT People #4346",
		"Score": 64
	  },
	  {
		"Index": 1117,
		"Rank": 34,
		"Item": "NFT People #4395",
		"Score": 64
	  },
	  {
		"Index": 1118,
		"Rank": 34,
		"Item": "NFT People #4500",
		"Score": 64
	  },
	  {
		"Index": 1119,
		"Rank": 34,
		"Item": "NFT People #4539",
		"Score": 64
	  },
	  {
		"Index": 1120,
		"Rank": 34,
		"Item": "NFT People #4560",
		"Score": 64
	  },
	  {
		"Index": 1121,
		"Rank": 34,
		"Item": "NFT People #4569",
		"Score": 64
	  },
	  {
		"Index": 1122,
		"Rank": 34,
		"Item": "NFT People #4730",
		"Score": 64
	  },
	  {
		"Index": 1123,
		"Rank": 34,
		"Item": "NFT People #4749",
		"Score": 64
	  },
	  {
		"Index": 1124,
		"Rank": 34,
		"Item": "NFT People #4791",
		"Score": 64
	  },
	  {
		"Index": 1125,
		"Rank": 34,
		"Item": "NFT People #4879",
		"Score": 64
	  },
	  {
		"Index": 1126,
		"Rank": 34,
		"Item": "NFT People #4929",
		"Score": 64
	  },
	  {
		"Index": 1127,
		"Rank": 34,
		"Item": "NFT People #4935",
		"Score": 64
	  },
	  {
		"Index": 1128,
		"Rank": 34,
		"Item": "NFT People #4971",
		"Score": 64
	  },
	  {
		"Index": 1129,
		"Rank": 34,
		"Item": "NFT People #4985",
		"Score": 64
	  },
	  {
		"Index": 1130,
		"Rank": 35,
		"Item": "NFT People #0254",
		"Score": 63
	  },
	  {
		"Index": 1131,
		"Rank": 35,
		"Item": "NFT People #0368",
		"Score": 63
	  },
	  {
		"Index": 1132,
		"Rank": 35,
		"Item": "NFT People #0497",
		"Score": 63
	  },
	  {
		"Index": 1133,
		"Rank": 35,
		"Item": "NFT People #0512",
		"Score": 63
	  },
	  {
		"Index": 1134,
		"Rank": 35,
		"Item": "NFT People #0683",
		"Score": 63
	  },
	  {
		"Index": 1135,
		"Rank": 35,
		"Item": "NFT People #0730",
		"Score": 63
	  },
	  {
		"Index": 1136,
		"Rank": 35,
		"Item": "NFT People #0918",
		"Score": 63
	  },
	  {
		"Index": 1137,
		"Rank": 35,
		"Item": "NFT People #1044",
		"Score": 63
	  },
	  {
		"Index": 1138,
		"Rank": 35,
		"Item": "NFT People #1046",
		"Score": 63
	  },
	  {
		"Index": 1139,
		"Rank": 35,
		"Item": "NFT People #1086",
		"Score": 63
	  },
	  {
		"Index": 1140,
		"Rank": 35,
		"Item": "NFT People #1105",
		"Score": 63
	  },
	  {
		"Index": 1141,
		"Rank": 35,
		"Item": "NFT People #1258",
		"Score": 63
	  },
	  {
		"Index": 1142,
		"Rank": 35,
		"Item": "NFT People #1413",
		"Score": 63
	  },
	  {
		"Index": 1143,
		"Rank": 35,
		"Item": "NFT People #1481",
		"Score": 63
	  },
	  {
		"Index": 1144,
		"Rank": 35,
		"Item": "NFT People #1508",
		"Score": 63
	  },
	  {
		"Index": 1145,
		"Rank": 35,
		"Item": "NFT People #1644",
		"Score": 63
	  },
	  {
		"Index": 1146,
		"Rank": 35,
		"Item": "NFT People #1673",
		"Score": 63
	  },
	  {
		"Index": 1147,
		"Rank": 35,
		"Item": "NFT People #1736",
		"Score": 63
	  },
	  {
		"Index": 1148,
		"Rank": 35,
		"Item": "NFT People #1969",
		"Score": 63
	  },
	  {
		"Index": 1149,
		"Rank": 35,
		"Item": "NFT People #1999",
		"Score": 63
	  },
	  {
		"Index": 1150,
		"Rank": 35,
		"Item": "NFT People #2040",
		"Score": 63
	  },
	  {
		"Index": 1151,
		"Rank": 35,
		"Item": "NFT People #2066",
		"Score": 63
	  },
	  {
		"Index": 1152,
		"Rank": 35,
		"Item": "NFT People #2128",
		"Score": 63
	  },
	  {
		"Index": 1153,
		"Rank": 35,
		"Item": "NFT People #2144",
		"Score": 63
	  },
	  {
		"Index": 1154,
		"Rank": 35,
		"Item": "NFT People #2165",
		"Score": 63
	  },
	  {
		"Index": 1155,
		"Rank": 35,
		"Item": "NFT People #2204",
		"Score": 63
	  },
	  {
		"Index": 1156,
		"Rank": 35,
		"Item": "NFT People #2232",
		"Score": 63
	  },
	  {
		"Index": 1157,
		"Rank": 35,
		"Item": "NFT People #2245",
		"Score": 63
	  },
	  {
		"Index": 1158,
		"Rank": 35,
		"Item": "NFT People #2306",
		"Score": 63
	  },
	  {
		"Index": 1159,
		"Rank": 35,
		"Item": "NFT People #2326",
		"Score": 63
	  },
	  {
		"Index": 1160,
		"Rank": 35,
		"Item": "NFT People #2494",
		"Score": 63
	  },
	  {
		"Index": 1161,
		"Rank": 35,
		"Item": "NFT People #2539",
		"Score": 63
	  },
	  {
		"Index": 1162,
		"Rank": 35,
		"Item": "NFT People #2579",
		"Score": 63
	  },
	  {
		"Index": 1163,
		"Rank": 35,
		"Item": "NFT People #2634",
		"Score": 63
	  },
	  {
		"Index": 1164,
		"Rank": 35,
		"Item": "NFT People #2856",
		"Score": 63
	  },
	  {
		"Index": 1165,
		"Rank": 35,
		"Item": "NFT People #2874",
		"Score": 63
	  },
	  {
		"Index": 1166,
		"Rank": 35,
		"Item": "NFT People #2876",
		"Score": 63
	  },
	  {
		"Index": 1167,
		"Rank": 35,
		"Item": "NFT People #2922",
		"Score": 63
	  },
	  {
		"Index": 1168,
		"Rank": 35,
		"Item": "NFT People #2942",
		"Score": 63
	  },
	  {
		"Index": 1169,
		"Rank": 35,
		"Item": "NFT People #3075",
		"Score": 63
	  },
	  {
		"Index": 1170,
		"Rank": 35,
		"Item": "NFT People #3088",
		"Score": 63
	  },
	  {
		"Index": 1171,
		"Rank": 35,
		"Item": "NFT People #3308",
		"Score": 63
	  },
	  {
		"Index": 1172,
		"Rank": 35,
		"Item": "NFT People #3355",
		"Score": 63
	  },
	  {
		"Index": 1173,
		"Rank": 35,
		"Item": "NFT People #3359",
		"Score": 63
	  },
	  {
		"Index": 1174,
		"Rank": 35,
		"Item": "NFT People #3386",
		"Score": 63
	  },
	  {
		"Index": 1175,
		"Rank": 35,
		"Item": "NFT People #3394",
		"Score": 63
	  },
	  {
		"Index": 1176,
		"Rank": 35,
		"Item": "NFT People #3513",
		"Score": 63
	  },
	  {
		"Index": 1177,
		"Rank": 35,
		"Item": "NFT People #3522",
		"Score": 63
	  },
	  {
		"Index": 1178,
		"Rank": 35,
		"Item": "NFT People #3548",
		"Score": 63
	  },
	  {
		"Index": 1179,
		"Rank": 35,
		"Item": "NFT People #3592",
		"Score": 63
	  },
	  {
		"Index": 1180,
		"Rank": 35,
		"Item": "NFT People #3605",
		"Score": 63
	  },
	  {
		"Index": 1181,
		"Rank": 35,
		"Item": "NFT People #3915",
		"Score": 63
	  },
	  {
		"Index": 1182,
		"Rank": 35,
		"Item": "NFT People #4075",
		"Score": 63
	  },
	  {
		"Index": 1183,
		"Rank": 35,
		"Item": "NFT People #4120",
		"Score": 63
	  },
	  {
		"Index": 1184,
		"Rank": 35,
		"Item": "NFT People #4231",
		"Score": 63
	  },
	  {
		"Index": 1185,
		"Rank": 35,
		"Item": "NFT People #4306",
		"Score": 63
	  },
	  {
		"Index": 1186,
		"Rank": 35,
		"Item": "NFT People #4405",
		"Score": 63
	  },
	  {
		"Index": 1187,
		"Rank": 35,
		"Item": "NFT People #4448",
		"Score": 63
	  },
	  {
		"Index": 1188,
		"Rank": 35,
		"Item": "NFT People #4512",
		"Score": 63
	  },
	  {
		"Index": 1189,
		"Rank": 35,
		"Item": "NFT People #4527",
		"Score": 63
	  },
	  {
		"Index": 1190,
		"Rank": 35,
		"Item": "NFT People #4631",
		"Score": 63
	  },
	  {
		"Index": 1191,
		"Rank": 35,
		"Item": "NFT People #4654",
		"Score": 63
	  },
	  {
		"Index": 1192,
		"Rank": 35,
		"Item": "NFT People #4771",
		"Score": 63
	  },
	  {
		"Index": 1193,
		"Rank": 35,
		"Item": "NFT People #4781",
		"Score": 63
	  },
	  {
		"Index": 1194,
		"Rank": 35,
		"Item": "NFT People #4991",
		"Score": 63
	  },
	  {
		"Index": 1195,
		"Rank": 36,
		"Item": "NFT People #0060",
		"Score": 62
	  },
	  {
		"Index": 1196,
		"Rank": 36,
		"Item": "NFT People #0065",
		"Score": 62
	  },
	  {
		"Index": 1197,
		"Rank": 36,
		"Item": "NFT People #0073",
		"Score": 62
	  },
	  {
		"Index": 1198,
		"Rank": 36,
		"Item": "NFT People #0132",
		"Score": 62
	  },
	  {
		"Index": 1199,
		"Rank": 36,
		"Item": "NFT People #0217",
		"Score": 62
	  },
	  {
		"Index": 1200,
		"Rank": 36,
		"Item": "NFT People #0242",
		"Score": 62
	  },
	  {
		"Index": 1201,
		"Rank": 36,
		"Item": "NFT People #0304",
		"Score": 62
	  },
	  {
		"Index": 1202,
		"Rank": 36,
		"Item": "NFT People #0378",
		"Score": 62
	  },
	  {
		"Index": 1203,
		"Rank": 36,
		"Item": "NFT People #0380",
		"Score": 62
	  },
	  {
		"Index": 1204,
		"Rank": 36,
		"Item": "NFT People #0409",
		"Score": 62
	  },
	  {
		"Index": 1205,
		"Rank": 36,
		"Item": "NFT People #0456",
		"Score": 62
	  },
	  {
		"Index": 1206,
		"Rank": 36,
		"Item": "NFT People #0515",
		"Score": 62
	  },
	  {
		"Index": 1207,
		"Rank": 36,
		"Item": "NFT People #0611",
		"Score": 62
	  },
	  {
		"Index": 1208,
		"Rank": 36,
		"Item": "NFT People #0636",
		"Score": 62
	  },
	  {
		"Index": 1209,
		"Rank": 36,
		"Item": "NFT People #0659",
		"Score": 62
	  },
	  {
		"Index": 1210,
		"Rank": 36,
		"Item": "NFT People #0681",
		"Score": 62
	  },
	  {
		"Index": 1211,
		"Rank": 36,
		"Item": "NFT People #0752",
		"Score": 62
	  },
	  {
		"Index": 1212,
		"Rank": 36,
		"Item": "NFT People #0783",
		"Score": 62
	  },
	  {
		"Index": 1213,
		"Rank": 36,
		"Item": "NFT People #0799",
		"Score": 62
	  },
	  {
		"Index": 1214,
		"Rank": 36,
		"Item": "NFT People #0817",
		"Score": 62
	  },
	  {
		"Index": 1215,
		"Rank": 36,
		"Item": "NFT People #0830",
		"Score": 62
	  },
	  {
		"Index": 1216,
		"Rank": 36,
		"Item": "NFT People #0862",
		"Score": 62
	  },
	  {
		"Index": 1217,
		"Rank": 36,
		"Item": "NFT People #0864",
		"Score": 62
	  },
	  {
		"Index": 1218,
		"Rank": 36,
		"Item": "NFT People #0891",
		"Score": 62
	  },
	  {
		"Index": 1219,
		"Rank": 36,
		"Item": "NFT People #0964",
		"Score": 62
	  },
	  {
		"Index": 1220,
		"Rank": 36,
		"Item": "NFT People #0988",
		"Score": 62
	  },
	  {
		"Index": 1221,
		"Rank": 36,
		"Item": "NFT People #0992",
		"Score": 62
	  },
	  {
		"Index": 1222,
		"Rank": 36,
		"Item": "NFT People #0997",
		"Score": 62
	  },
	  {
		"Index": 1223,
		"Rank": 36,
		"Item": "NFT People #1004",
		"Score": 62
	  },
	  {
		"Index": 1224,
		"Rank": 36,
		"Item": "NFT People #1070",
		"Score": 62
	  },
	  {
		"Index": 1225,
		"Rank": 36,
		"Item": "NFT People #1072",
		"Score": 62
	  },
	  {
		"Index": 1226,
		"Rank": 36,
		"Item": "NFT People #1098",
		"Score": 62
	  },
	  {
		"Index": 1227,
		"Rank": 36,
		"Item": "NFT People #1150",
		"Score": 62
	  },
	  {
		"Index": 1228,
		"Rank": 36,
		"Item": "NFT People #1182",
		"Score": 62
	  },
	  {
		"Index": 1229,
		"Rank": 36,
		"Item": "NFT People #1199",
		"Score": 62
	  },
	  {
		"Index": 1230,
		"Rank": 36,
		"Item": "NFT People #1213",
		"Score": 62
	  },
	  {
		"Index": 1231,
		"Rank": 36,
		"Item": "NFT People #1240",
		"Score": 62
	  },
	  {
		"Index": 1232,
		"Rank": 36,
		"Item": "NFT People #1285",
		"Score": 62
	  },
	  {
		"Index": 1233,
		"Rank": 36,
		"Item": "NFT People #1376",
		"Score": 62
	  },
	  {
		"Index": 1234,
		"Rank": 36,
		"Item": "NFT People #1385",
		"Score": 62
	  },
	  {
		"Index": 1235,
		"Rank": 36,
		"Item": "NFT People #1392",
		"Score": 62
	  },
	  {
		"Index": 1236,
		"Rank": 36,
		"Item": "NFT People #1409",
		"Score": 62
	  },
	  {
		"Index": 1237,
		"Rank": 36,
		"Item": "NFT People #1416",
		"Score": 62
	  },
	  {
		"Index": 1238,
		"Rank": 36,
		"Item": "NFT People #1430",
		"Score": 62
	  },
	  {
		"Index": 1239,
		"Rank": 36,
		"Item": "NFT People #1433",
		"Score": 62
	  },
	  {
		"Index": 1240,
		"Rank": 36,
		"Item": "NFT People #1446",
		"Score": 62
	  },
	  {
		"Index": 1241,
		"Rank": 36,
		"Item": "NFT People #1474",
		"Score": 62
	  },
	  {
		"Index": 1242,
		"Rank": 36,
		"Item": "NFT People #1565",
		"Score": 62
	  },
	  {
		"Index": 1243,
		"Rank": 36,
		"Item": "NFT People #1685",
		"Score": 62
	  },
	  {
		"Index": 1244,
		"Rank": 36,
		"Item": "NFT People #1809",
		"Score": 62
	  },
	  {
		"Index": 1245,
		"Rank": 36,
		"Item": "NFT People #1839",
		"Score": 62
	  },
	  {
		"Index": 1246,
		"Rank": 36,
		"Item": "NFT People #1933",
		"Score": 62
	  },
	  {
		"Index": 1247,
		"Rank": 36,
		"Item": "NFT People #1949",
		"Score": 62
	  },
	  {
		"Index": 1248,
		"Rank": 36,
		"Item": "NFT People #1959",
		"Score": 62
	  },
	  {
		"Index": 1249,
		"Rank": 36,
		"Item": "NFT People #1979",
		"Score": 62
	  },
	  {
		"Index": 1250,
		"Rank": 36,
		"Item": "NFT People #1994",
		"Score": 62
	  },
	  {
		"Index": 1251,
		"Rank": 36,
		"Item": "NFT People #2001",
		"Score": 62
	  },
	  {
		"Index": 1252,
		"Rank": 36,
		"Item": "NFT People #2026",
		"Score": 62
	  },
	  {
		"Index": 1253,
		"Rank": 36,
		"Item": "NFT People #2046",
		"Score": 62
	  },
	  {
		"Index": 1254,
		"Rank": 36,
		"Item": "NFT People #2085",
		"Score": 62
	  },
	  {
		"Index": 1255,
		"Rank": 36,
		"Item": "NFT People #2142",
		"Score": 62
	  },
	  {
		"Index": 1256,
		"Rank": 36,
		"Item": "NFT People #2247",
		"Score": 62
	  },
	  {
		"Index": 1257,
		"Rank": 36,
		"Item": "NFT People #2262",
		"Score": 62
	  },
	  {
		"Index": 1258,
		"Rank": 36,
		"Item": "NFT People #2286",
		"Score": 62
	  },
	  {
		"Index": 1259,
		"Rank": 36,
		"Item": "NFT People #2298",
		"Score": 62
	  },
	  {
		"Index": 1260,
		"Rank": 36,
		"Item": "NFT People #2331",
		"Score": 62
	  },
	  {
		"Index": 1261,
		"Rank": 36,
		"Item": "NFT People #2387",
		"Score": 62
	  },
	  {
		"Index": 1262,
		"Rank": 36,
		"Item": "NFT People #2390",
		"Score": 62
	  },
	  {
		"Index": 1263,
		"Rank": 36,
		"Item": "NFT People #2414",
		"Score": 62
	  },
	  {
		"Index": 1264,
		"Rank": 36,
		"Item": "NFT People #2454",
		"Score": 62
	  },
	  {
		"Index": 1265,
		"Rank": 36,
		"Item": "NFT People #2567",
		"Score": 62
	  },
	  {
		"Index": 1266,
		"Rank": 36,
		"Item": "NFT People #2618",
		"Score": 62
	  },
	  {
		"Index": 1267,
		"Rank": 36,
		"Item": "NFT People #2632",
		"Score": 62
	  },
	  {
		"Index": 1268,
		"Rank": 36,
		"Item": "NFT People #2722",
		"Score": 62
	  },
	  {
		"Index": 1269,
		"Rank": 36,
		"Item": "NFT People #2742",
		"Score": 62
	  },
	  {
		"Index": 1270,
		"Rank": 36,
		"Item": "NFT People #2764",
		"Score": 62
	  },
	  {
		"Index": 1271,
		"Rank": 36,
		"Item": "NFT People #2787",
		"Score": 62
	  },
	  {
		"Index": 1272,
		"Rank": 36,
		"Item": "NFT People #2835",
		"Score": 62
	  },
	  {
		"Index": 1273,
		"Rank": 36,
		"Item": "NFT People #2886",
		"Score": 62
	  },
	  {
		"Index": 1274,
		"Rank": 36,
		"Item": "NFT People #2898",
		"Score": 62
	  },
	  {
		"Index": 1275,
		"Rank": 36,
		"Item": "NFT People #2954",
		"Score": 62
	  },
	  {
		"Index": 1276,
		"Rank": 36,
		"Item": "NFT People #2970",
		"Score": 62
	  },
	  {
		"Index": 1277,
		"Rank": 36,
		"Item": "NFT People #2983",
		"Score": 62
	  },
	  {
		"Index": 1278,
		"Rank": 36,
		"Item": "NFT People #3040",
		"Score": 62
	  },
	  {
		"Index": 1279,
		"Rank": 36,
		"Item": "NFT People #3077",
		"Score": 62
	  },
	  {
		"Index": 1280,
		"Rank": 36,
		"Item": "NFT People #3097",
		"Score": 62
	  },
	  {
		"Index": 1281,
		"Rank": 36,
		"Item": "NFT People #3107",
		"Score": 62
	  },
	  {
		"Index": 1282,
		"Rank": 36,
		"Item": "NFT People #3139",
		"Score": 62
	  },
	  {
		"Index": 1283,
		"Rank": 36,
		"Item": "NFT People #3156",
		"Score": 62
	  },
	  {
		"Index": 1284,
		"Rank": 36,
		"Item": "NFT People #3178",
		"Score": 62
	  },
	  {
		"Index": 1285,
		"Rank": 36,
		"Item": "NFT People #3188",
		"Score": 62
	  },
	  {
		"Index": 1286,
		"Rank": 36,
		"Item": "NFT People #3259",
		"Score": 62
	  },
	  {
		"Index": 1287,
		"Rank": 36,
		"Item": "NFT People #3260",
		"Score": 62
	  },
	  {
		"Index": 1288,
		"Rank": 36,
		"Item": "NFT People #3288",
		"Score": 62
	  },
	  {
		"Index": 1289,
		"Rank": 36,
		"Item": "NFT People #3291",
		"Score": 62
	  },
	  {
		"Index": 1290,
		"Rank": 36,
		"Item": "NFT People #3301",
		"Score": 62
	  },
	  {
		"Index": 1291,
		"Rank": 36,
		"Item": "NFT People #3366",
		"Score": 62
	  },
	  {
		"Index": 1292,
		"Rank": 36,
		"Item": "NFT People #3384",
		"Score": 62
	  },
	  {
		"Index": 1293,
		"Rank": 36,
		"Item": "NFT People #3454",
		"Score": 62
	  },
	  {
		"Index": 1294,
		"Rank": 36,
		"Item": "NFT People #3516",
		"Score": 62
	  },
	  {
		"Index": 1295,
		"Rank": 36,
		"Item": "NFT People #3539",
		"Score": 62
	  },
	  {
		"Index": 1296,
		"Rank": 36,
		"Item": "NFT People #3546",
		"Score": 62
	  },
	  {
		"Index": 1297,
		"Rank": 36,
		"Item": "NFT People #3572",
		"Score": 62
	  },
	  {
		"Index": 1298,
		"Rank": 36,
		"Item": "NFT People #3590",
		"Score": 62
	  },
	  {
		"Index": 1299,
		"Rank": 36,
		"Item": "NFT People #3614",
		"Score": 62
	  },
	  {
		"Index": 1300,
		"Rank": 36,
		"Item": "NFT People #3697",
		"Score": 62
	  },
	  {
		"Index": 1301,
		"Rank": 36,
		"Item": "NFT People #3726",
		"Score": 62
	  },
	  {
		"Index": 1302,
		"Rank": 36,
		"Item": "NFT People #3734",
		"Score": 62
	  },
	  {
		"Index": 1303,
		"Rank": 36,
		"Item": "NFT People #3763",
		"Score": 62
	  },
	  {
		"Index": 1304,
		"Rank": 36,
		"Item": "NFT People #3878",
		"Score": 62
	  },
	  {
		"Index": 1305,
		"Rank": 36,
		"Item": "NFT People #3954",
		"Score": 62
	  },
	  {
		"Index": 1306,
		"Rank": 36,
		"Item": "NFT People #3981",
		"Score": 62
	  },
	  {
		"Index": 1307,
		"Rank": 36,
		"Item": "NFT People #3983",
		"Score": 62
	  },
	  {
		"Index": 1308,
		"Rank": 36,
		"Item": "NFT People #4022",
		"Score": 62
	  },
	  {
		"Index": 1309,
		"Rank": 36,
		"Item": "NFT People #4048",
		"Score": 62
	  },
	  {
		"Index": 1310,
		"Rank": 36,
		"Item": "NFT People #4064",
		"Score": 62
	  },
	  {
		"Index": 1311,
		"Rank": 36,
		"Item": "NFT People #4080",
		"Score": 62
	  },
	  {
		"Index": 1312,
		"Rank": 36,
		"Item": "NFT People #4125",
		"Score": 62
	  },
	  {
		"Index": 1313,
		"Rank": 36,
		"Item": "NFT People #4143",
		"Score": 62
	  },
	  {
		"Index": 1314,
		"Rank": 36,
		"Item": "NFT People #4200",
		"Score": 62
	  },
	  {
		"Index": 1315,
		"Rank": 36,
		"Item": "NFT People #4209",
		"Score": 62
	  },
	  {
		"Index": 1316,
		"Rank": 36,
		"Item": "NFT People #4239",
		"Score": 62
	  },
	  {
		"Index": 1317,
		"Rank": 36,
		"Item": "NFT People #4259",
		"Score": 62
	  },
	  {
		"Index": 1318,
		"Rank": 36,
		"Item": "NFT People #4355",
		"Score": 62
	  },
	  {
		"Index": 1319,
		"Rank": 36,
		"Item": "NFT People #4418",
		"Score": 62
	  },
	  {
		"Index": 1320,
		"Rank": 36,
		"Item": "NFT People #4430",
		"Score": 62
	  },
	  {
		"Index": 1321,
		"Rank": 36,
		"Item": "NFT People #4477",
		"Score": 62
	  },
	  {
		"Index": 1322,
		"Rank": 36,
		"Item": "NFT People #4493",
		"Score": 62
	  },
	  {
		"Index": 1323,
		"Rank": 36,
		"Item": "NFT People #4506",
		"Score": 62
	  },
	  {
		"Index": 1324,
		"Rank": 36,
		"Item": "NFT People #4522",
		"Score": 62
	  },
	  {
		"Index": 1325,
		"Rank": 36,
		"Item": "NFT People #4599",
		"Score": 62
	  },
	  {
		"Index": 1326,
		"Rank": 36,
		"Item": "NFT People #4607",
		"Score": 62
	  },
	  {
		"Index": 1327,
		"Rank": 36,
		"Item": "NFT People #4704",
		"Score": 62
	  },
	  {
		"Index": 1328,
		"Rank": 36,
		"Item": "NFT People #4738",
		"Score": 62
	  },
	  {
		"Index": 1329,
		"Rank": 36,
		"Item": "NFT People #4752",
		"Score": 62
	  },
	  {
		"Index": 1330,
		"Rank": 36,
		"Item": "NFT People #4778",
		"Score": 62
	  },
	  {
		"Index": 1331,
		"Rank": 36,
		"Item": "NFT People #4798",
		"Score": 62
	  },
	  {
		"Index": 1332,
		"Rank": 36,
		"Item": "NFT People #4847",
		"Score": 62
	  },
	  {
		"Index": 1333,
		"Rank": 36,
		"Item": "NFT People #4860",
		"Score": 62
	  },
	  {
		"Index": 1334,
		"Rank": 36,
		"Item": "NFT People #4881",
		"Score": 62
	  },
	  {
		"Index": 1335,
		"Rank": 36,
		"Item": "NFT People #4909",
		"Score": 62
	  },
	  {
		"Index": 1336,
		"Rank": 36,
		"Item": "NFT People #4969",
		"Score": 62
	  },
	  {
		"Index": 1337,
		"Rank": 36,
		"Item": "NFT People #4973",
		"Score": 62
	  },
	  {
		"Index": 1338,
		"Rank": 37,
		"Item": "NFT People #0074",
		"Score": 61
	  },
	  {
		"Index": 1339,
		"Rank": 37,
		"Item": "NFT People #0090",
		"Score": 61
	  },
	  {
		"Index": 1340,
		"Rank": 37,
		"Item": "NFT People #0113",
		"Score": 61
	  },
	  {
		"Index": 1341,
		"Rank": 37,
		"Item": "NFT People #0139",
		"Score": 61
	  },
	  {
		"Index": 1342,
		"Rank": 37,
		"Item": "NFT People #0359",
		"Score": 61
	  },
	  {
		"Index": 1343,
		"Rank": 37,
		"Item": "NFT People #0377",
		"Score": 61
	  },
	  {
		"Index": 1344,
		"Rank": 37,
		"Item": "NFT People #0379",
		"Score": 61
	  },
	  {
		"Index": 1345,
		"Rank": 37,
		"Item": "NFT People #0397",
		"Score": 61
	  },
	  {
		"Index": 1346,
		"Rank": 37,
		"Item": "NFT People #0415",
		"Score": 61
	  },
	  {
		"Index": 1347,
		"Rank": 37,
		"Item": "NFT People #0416",
		"Score": 61
	  },
	  {
		"Index": 1348,
		"Rank": 37,
		"Item": "NFT People #0425",
		"Score": 61
	  },
	  {
		"Index": 1349,
		"Rank": 37,
		"Item": "NFT People #0505",
		"Score": 61
	  },
	  {
		"Index": 1350,
		"Rank": 37,
		"Item": "NFT People #0546",
		"Score": 61
	  },
	  {
		"Index": 1351,
		"Rank": 37,
		"Item": "NFT People #0632",
		"Score": 61
	  },
	  {
		"Index": 1352,
		"Rank": 37,
		"Item": "NFT People #0639",
		"Score": 61
	  },
	  {
		"Index": 1353,
		"Rank": 37,
		"Item": "NFT People #0693",
		"Score": 61
	  },
	  {
		"Index": 1354,
		"Rank": 37,
		"Item": "NFT People #0719",
		"Score": 61
	  },
	  {
		"Index": 1355,
		"Rank": 37,
		"Item": "NFT People #0729",
		"Score": 61
	  },
	  {
		"Index": 1356,
		"Rank": 37,
		"Item": "NFT People #0756",
		"Score": 61
	  },
	  {
		"Index": 1357,
		"Rank": 37,
		"Item": "NFT People #0766",
		"Score": 61
	  },
	  {
		"Index": 1358,
		"Rank": 37,
		"Item": "NFT People #0796",
		"Score": 61
	  },
	  {
		"Index": 1359,
		"Rank": 37,
		"Item": "NFT People #0819",
		"Score": 61
	  },
	  {
		"Index": 1360,
		"Rank": 37,
		"Item": "NFT People #0832",
		"Score": 61
	  },
	  {
		"Index": 1361,
		"Rank": 37,
		"Item": "NFT People #0854",
		"Score": 61
	  },
	  {
		"Index": 1362,
		"Rank": 37,
		"Item": "NFT People #0868",
		"Score": 61
	  },
	  {
		"Index": 1363,
		"Rank": 37,
		"Item": "NFT People #0931",
		"Score": 61
	  },
	  {
		"Index": 1364,
		"Rank": 37,
		"Item": "NFT People #1016",
		"Score": 61
	  },
	  {
		"Index": 1365,
		"Rank": 37,
		"Item": "NFT People #1029",
		"Score": 61
	  },
	  {
		"Index": 1366,
		"Rank": 37,
		"Item": "NFT People #1043",
		"Score": 61
	  },
	  {
		"Index": 1367,
		"Rank": 37,
		"Item": "NFT People #1137",
		"Score": 61
	  },
	  {
		"Index": 1368,
		"Rank": 37,
		"Item": "NFT People #1180",
		"Score": 61
	  },
	  {
		"Index": 1369,
		"Rank": 37,
		"Item": "NFT People #1188",
		"Score": 61
	  },
	  {
		"Index": 1370,
		"Rank": 37,
		"Item": "NFT People #1226",
		"Score": 61
	  },
	  {
		"Index": 1371,
		"Rank": 37,
		"Item": "NFT People #1229",
		"Score": 61
	  },
	  {
		"Index": 1372,
		"Rank": 37,
		"Item": "NFT People #1250",
		"Score": 61
	  },
	  {
		"Index": 1373,
		"Rank": 37,
		"Item": "NFT People #1325",
		"Score": 61
	  },
	  {
		"Index": 1374,
		"Rank": 37,
		"Item": "NFT People #1415",
		"Score": 61
	  },
	  {
		"Index": 1375,
		"Rank": 37,
		"Item": "NFT People #1458",
		"Score": 61
	  },
	  {
		"Index": 1376,
		"Rank": 37,
		"Item": "NFT People #1495",
		"Score": 61
	  },
	  {
		"Index": 1377,
		"Rank": 37,
		"Item": "NFT People #1501",
		"Score": 61
	  },
	  {
		"Index": 1378,
		"Rank": 37,
		"Item": "NFT People #1558",
		"Score": 61
	  },
	  {
		"Index": 1379,
		"Rank": 37,
		"Item": "NFT People #1566",
		"Score": 61
	  },
	  {
		"Index": 1380,
		"Rank": 37,
		"Item": "NFT People #1603",
		"Score": 61
	  },
	  {
		"Index": 1381,
		"Rank": 37,
		"Item": "NFT People #1614",
		"Score": 61
	  },
	  {
		"Index": 1382,
		"Rank": 37,
		"Item": "NFT People #1623",
		"Score": 61
	  },
	  {
		"Index": 1383,
		"Rank": 37,
		"Item": "NFT People #1655",
		"Score": 61
	  },
	  {
		"Index": 1384,
		"Rank": 37,
		"Item": "NFT People #1694",
		"Score": 61
	  },
	  {
		"Index": 1385,
		"Rank": 37,
		"Item": "NFT People #1716",
		"Score": 61
	  },
	  {
		"Index": 1386,
		"Rank": 37,
		"Item": "NFT People #1734",
		"Score": 61
	  },
	  {
		"Index": 1387,
		"Rank": 37,
		"Item": "NFT People #1772",
		"Score": 61
	  },
	  {
		"Index": 1388,
		"Rank": 37,
		"Item": "NFT People #1778",
		"Score": 61
	  },
	  {
		"Index": 1389,
		"Rank": 37,
		"Item": "NFT People #1946",
		"Score": 61
	  },
	  {
		"Index": 1390,
		"Rank": 37,
		"Item": "NFT People #2023",
		"Score": 61
	  },
	  {
		"Index": 1391,
		"Rank": 37,
		"Item": "NFT People #2033",
		"Score": 61
	  },
	  {
		"Index": 1392,
		"Rank": 37,
		"Item": "NFT People #2058",
		"Score": 61
	  },
	  {
		"Index": 1393,
		"Rank": 37,
		"Item": "NFT People #2077",
		"Score": 61
	  },
	  {
		"Index": 1394,
		"Rank": 37,
		"Item": "NFT People #2158",
		"Score": 61
	  },
	  {
		"Index": 1395,
		"Rank": 37,
		"Item": "NFT People #2161",
		"Score": 61
	  },
	  {
		"Index": 1396,
		"Rank": 37,
		"Item": "NFT People #2166",
		"Score": 61
	  },
	  {
		"Index": 1397,
		"Rank": 37,
		"Item": "NFT People #2215",
		"Score": 61
	  },
	  {
		"Index": 1398,
		"Rank": 37,
		"Item": "NFT People #2231",
		"Score": 61
	  },
	  {
		"Index": 1399,
		"Rank": 37,
		"Item": "NFT People #2309",
		"Score": 61
	  },
	  {
		"Index": 1400,
		"Rank": 37,
		"Item": "NFT People #2392",
		"Score": 61
	  },
	  {
		"Index": 1401,
		"Rank": 37,
		"Item": "NFT People #2402",
		"Score": 61
	  },
	  {
		"Index": 1402,
		"Rank": 37,
		"Item": "NFT People #2452",
		"Score": 61
	  },
	  {
		"Index": 1403,
		"Rank": 37,
		"Item": "NFT People #2514",
		"Score": 61
	  },
	  {
		"Index": 1404,
		"Rank": 37,
		"Item": "NFT People #2565",
		"Score": 61
	  },
	  {
		"Index": 1405,
		"Rank": 37,
		"Item": "NFT People #2623",
		"Score": 61
	  },
	  {
		"Index": 1406,
		"Rank": 37,
		"Item": "NFT People #2681",
		"Score": 61
	  },
	  {
		"Index": 1407,
		"Rank": 37,
		"Item": "NFT People #2696",
		"Score": 61
	  },
	  {
		"Index": 1408,
		"Rank": 37,
		"Item": "NFT People #2747",
		"Score": 61
	  },
	  {
		"Index": 1409,
		"Rank": 37,
		"Item": "NFT People #2774",
		"Score": 61
	  },
	  {
		"Index": 1410,
		"Rank": 37,
		"Item": "NFT People #2818",
		"Score": 61
	  },
	  {
		"Index": 1411,
		"Rank": 37,
		"Item": "NFT People #2823",
		"Score": 61
	  },
	  {
		"Index": 1412,
		"Rank": 37,
		"Item": "NFT People #2831",
		"Score": 61
	  },
	  {
		"Index": 1413,
		"Rank": 37,
		"Item": "NFT People #2839",
		"Score": 61
	  },
	  {
		"Index": 1414,
		"Rank": 37,
		"Item": "NFT People #2862",
		"Score": 61
	  },
	  {
		"Index": 1415,
		"Rank": 37,
		"Item": "NFT People #2881",
		"Score": 61
	  },
	  {
		"Index": 1416,
		"Rank": 37,
		"Item": "NFT People #2912",
		"Score": 61
	  },
	  {
		"Index": 1417,
		"Rank": 37,
		"Item": "NFT People #2930",
		"Score": 61
	  },
	  {
		"Index": 1418,
		"Rank": 37,
		"Item": "NFT People #3019",
		"Score": 61
	  },
	  {
		"Index": 1419,
		"Rank": 37,
		"Item": "NFT People #3023",
		"Score": 61
	  },
	  {
		"Index": 1420,
		"Rank": 37,
		"Item": "NFT People #3059",
		"Score": 61
	  },
	  {
		"Index": 1421,
		"Rank": 37,
		"Item": "NFT People #3060",
		"Score": 61
	  },
	  {
		"Index": 1422,
		"Rank": 37,
		"Item": "NFT People #3093",
		"Score": 61
	  },
	  {
		"Index": 1423,
		"Rank": 37,
		"Item": "NFT People #3103",
		"Score": 61
	  },
	  {
		"Index": 1424,
		"Rank": 37,
		"Item": "NFT People #3105",
		"Score": 61
	  },
	  {
		"Index": 1425,
		"Rank": 37,
		"Item": "NFT People #3144",
		"Score": 61
	  },
	  {
		"Index": 1426,
		"Rank": 37,
		"Item": "NFT People #3243",
		"Score": 61
	  },
	  {
		"Index": 1427,
		"Rank": 37,
		"Item": "NFT People #3328",
		"Score": 61
	  },
	  {
		"Index": 1428,
		"Rank": 37,
		"Item": "NFT People #3436",
		"Score": 61
	  },
	  {
		"Index": 1429,
		"Rank": 37,
		"Item": "NFT People #3471",
		"Score": 61
	  },
	  {
		"Index": 1430,
		"Rank": 37,
		"Item": "NFT People #3494",
		"Score": 61
	  },
	  {
		"Index": 1431,
		"Rank": 37,
		"Item": "NFT People #3506",
		"Score": 61
	  },
	  {
		"Index": 1432,
		"Rank": 37,
		"Item": "NFT People #3549",
		"Score": 61
	  },
	  {
		"Index": 1433,
		"Rank": 37,
		"Item": "NFT People #3553",
		"Score": 61
	  },
	  {
		"Index": 1434,
		"Rank": 37,
		"Item": "NFT People #3601",
		"Score": 61
	  },
	  {
		"Index": 1435,
		"Rank": 37,
		"Item": "NFT People #3618",
		"Score": 61
	  },
	  {
		"Index": 1436,
		"Rank": 37,
		"Item": "NFT People #3654",
		"Score": 61
	  },
	  {
		"Index": 1437,
		"Rank": 37,
		"Item": "NFT People #3721",
		"Score": 61
	  },
	  {
		"Index": 1438,
		"Rank": 37,
		"Item": "NFT People #3759",
		"Score": 61
	  },
	  {
		"Index": 1439,
		"Rank": 37,
		"Item": "NFT People #3760",
		"Score": 61
	  },
	  {
		"Index": 1440,
		"Rank": 37,
		"Item": "NFT People #3782",
		"Score": 61
	  },
	  {
		"Index": 1441,
		"Rank": 37,
		"Item": "NFT People #3799",
		"Score": 61
	  },
	  {
		"Index": 1442,
		"Rank": 37,
		"Item": "NFT People #3834",
		"Score": 61
	  },
	  {
		"Index": 1443,
		"Rank": 37,
		"Item": "NFT People #3874",
		"Score": 61
	  },
	  {
		"Index": 1444,
		"Rank": 37,
		"Item": "NFT People #3920",
		"Score": 61
	  },
	  {
		"Index": 1445,
		"Rank": 37,
		"Item": "NFT People #3992",
		"Score": 61
	  },
	  {
		"Index": 1446,
		"Rank": 37,
		"Item": "NFT People #3996",
		"Score": 61
	  },
	  {
		"Index": 1447,
		"Rank": 37,
		"Item": "NFT People #4002",
		"Score": 61
	  },
	  {
		"Index": 1448,
		"Rank": 37,
		"Item": "NFT People #4024",
		"Score": 61
	  },
	  {
		"Index": 1449,
		"Rank": 37,
		"Item": "NFT People #4053",
		"Score": 61
	  },
	  {
		"Index": 1450,
		"Rank": 37,
		"Item": "NFT People #4083",
		"Score": 61
	  },
	  {
		"Index": 1451,
		"Rank": 37,
		"Item": "NFT People #4105",
		"Score": 61
	  },
	  {
		"Index": 1452,
		"Rank": 37,
		"Item": "NFT People #4152",
		"Score": 61
	  },
	  {
		"Index": 1453,
		"Rank": 37,
		"Item": "NFT People #4194",
		"Score": 61
	  },
	  {
		"Index": 1454,
		"Rank": 37,
		"Item": "NFT People #4201",
		"Score": 61
	  },
	  {
		"Index": 1455,
		"Rank": 37,
		"Item": "NFT People #4214",
		"Score": 61
	  },
	  {
		"Index": 1456,
		"Rank": 37,
		"Item": "NFT People #4244",
		"Score": 61
	  },
	  {
		"Index": 1457,
		"Rank": 37,
		"Item": "NFT People #4282",
		"Score": 61
	  },
	  {
		"Index": 1458,
		"Rank": 37,
		"Item": "NFT People #4284",
		"Score": 61
	  },
	  {
		"Index": 1459,
		"Rank": 37,
		"Item": "NFT People #4353",
		"Score": 61
	  },
	  {
		"Index": 1460,
		"Rank": 37,
		"Item": "NFT People #4390",
		"Score": 61
	  },
	  {
		"Index": 1461,
		"Rank": 37,
		"Item": "NFT People #4434",
		"Score": 61
	  },
	  {
		"Index": 1462,
		"Rank": 37,
		"Item": "NFT People #4449",
		"Score": 61
	  },
	  {
		"Index": 1463,
		"Rank": 37,
		"Item": "NFT People #4457",
		"Score": 61
	  },
	  {
		"Index": 1464,
		"Rank": 37,
		"Item": "NFT People #4482",
		"Score": 61
	  },
	  {
		"Index": 1465,
		"Rank": 37,
		"Item": "NFT People #4543",
		"Score": 61
	  },
	  {
		"Index": 1466,
		"Rank": 37,
		"Item": "NFT People #4570",
		"Score": 61
	  },
	  {
		"Index": 1467,
		"Rank": 37,
		"Item": "NFT People #4595",
		"Score": 61
	  },
	  {
		"Index": 1468,
		"Rank": 37,
		"Item": "NFT People #4652",
		"Score": 61
	  },
	  {
		"Index": 1469,
		"Rank": 37,
		"Item": "NFT People #4696",
		"Score": 61
	  },
	  {
		"Index": 1470,
		"Rank": 37,
		"Item": "NFT People #4702",
		"Score": 61
	  },
	  {
		"Index": 1471,
		"Rank": 37,
		"Item": "NFT People #4724",
		"Score": 61
	  },
	  {
		"Index": 1472,
		"Rank": 37,
		"Item": "NFT People #4765",
		"Score": 61
	  },
	  {
		"Index": 1473,
		"Rank": 37,
		"Item": "NFT People #4785",
		"Score": 61
	  },
	  {
		"Index": 1474,
		"Rank": 37,
		"Item": "NFT People #4906",
		"Score": 61
	  },
	  {
		"Index": 1475,
		"Rank": 37,
		"Item": "NFT People #4943",
		"Score": 61
	  },
	  {
		"Index": 1476,
		"Rank": 37,
		"Item": "NFT People #4945",
		"Score": 61
	  },
	  {
		"Index": 1477,
		"Rank": 37,
		"Item": "NFT People #4953",
		"Score": 61
	  },
	  {
		"Index": 1478,
		"Rank": 38,
		"Item": "NFT People #0013",
		"Score": 60
	  },
	  {
		"Index": 1479,
		"Rank": 38,
		"Item": "NFT People #0034",
		"Score": 60
	  },
	  {
		"Index": 1480,
		"Rank": 38,
		"Item": "NFT People #0049",
		"Score": 60
	  },
	  {
		"Index": 1481,
		"Rank": 38,
		"Item": "NFT People #0053",
		"Score": 60
	  },
	  {
		"Index": 1482,
		"Rank": 38,
		"Item": "NFT People #0097",
		"Score": 60
	  },
	  {
		"Index": 1483,
		"Rank": 38,
		"Item": "NFT People #0110",
		"Score": 60
	  },
	  {
		"Index": 1484,
		"Rank": 38,
		"Item": "NFT People #0146",
		"Score": 60
	  },
	  {
		"Index": 1485,
		"Rank": 38,
		"Item": "NFT People #0218",
		"Score": 60
	  },
	  {
		"Index": 1486,
		"Rank": 38,
		"Item": "NFT People #0221",
		"Score": 60
	  },
	  {
		"Index": 1487,
		"Rank": 38,
		"Item": "NFT People #0320",
		"Score": 60
	  },
	  {
		"Index": 1488,
		"Rank": 38,
		"Item": "NFT People #0339",
		"Score": 60
	  },
	  {
		"Index": 1489,
		"Rank": 38,
		"Item": "NFT People #0349",
		"Score": 60
	  },
	  {
		"Index": 1490,
		"Rank": 38,
		"Item": "NFT People #0364",
		"Score": 60
	  },
	  {
		"Index": 1491,
		"Rank": 38,
		"Item": "NFT People #0392",
		"Score": 60
	  },
	  {
		"Index": 1492,
		"Rank": 38,
		"Item": "NFT People #0429",
		"Score": 60
	  },
	  {
		"Index": 1493,
		"Rank": 38,
		"Item": "NFT People #0510",
		"Score": 60
	  },
	  {
		"Index": 1494,
		"Rank": 38,
		"Item": "NFT People #0517",
		"Score": 60
	  },
	  {
		"Index": 1495,
		"Rank": 38,
		"Item": "NFT People #0518",
		"Score": 60
	  },
	  {
		"Index": 1496,
		"Rank": 38,
		"Item": "NFT People #0519",
		"Score": 60
	  },
	  {
		"Index": 1497,
		"Rank": 38,
		"Item": "NFT People #0522",
		"Score": 60
	  },
	  {
		"Index": 1498,
		"Rank": 38,
		"Item": "NFT People #0523",
		"Score": 60
	  },
	  {
		"Index": 1499,
		"Rank": 38,
		"Item": "NFT People #0541",
		"Score": 60
	  },
	  {
		"Index": 1500,
		"Rank": 38,
		"Item": "NFT People #0661",
		"Score": 60
	  },
	  {
		"Index": 1501,
		"Rank": 38,
		"Item": "NFT People #0773",
		"Score": 60
	  },
	  {
		"Index": 1502,
		"Rank": 38,
		"Item": "NFT People #0778",
		"Score": 60
	  },
	  {
		"Index": 1503,
		"Rank": 38,
		"Item": "NFT People #0807",
		"Score": 60
	  },
	  {
		"Index": 1504,
		"Rank": 38,
		"Item": "NFT People #0886",
		"Score": 60
	  },
	  {
		"Index": 1505,
		"Rank": 38,
		"Item": "NFT People #0911",
		"Score": 60
	  },
	  {
		"Index": 1506,
		"Rank": 38,
		"Item": "NFT People #1009",
		"Score": 60
	  },
	  {
		"Index": 1507,
		"Rank": 38,
		"Item": "NFT People #1111",
		"Score": 60
	  },
	  {
		"Index": 1508,
		"Rank": 38,
		"Item": "NFT People #1127",
		"Score": 60
	  },
	  {
		"Index": 1509,
		"Rank": 38,
		"Item": "NFT People #1239",
		"Score": 60
	  },
	  {
		"Index": 1510,
		"Rank": 38,
		"Item": "NFT People #1242",
		"Score": 60
	  },
	  {
		"Index": 1511,
		"Rank": 38,
		"Item": "NFT People #1289",
		"Score": 60
	  },
	  {
		"Index": 1512,
		"Rank": 38,
		"Item": "NFT People #1323",
		"Score": 60
	  },
	  {
		"Index": 1513,
		"Rank": 38,
		"Item": "NFT People #1329",
		"Score": 60
	  },
	  {
		"Index": 1514,
		"Rank": 38,
		"Item": "NFT People #1334",
		"Score": 60
	  },
	  {
		"Index": 1515,
		"Rank": 38,
		"Item": "NFT People #1358",
		"Score": 60
	  },
	  {
		"Index": 1516,
		"Rank": 38,
		"Item": "NFT People #1368",
		"Score": 60
	  },
	  {
		"Index": 1517,
		"Rank": 38,
		"Item": "NFT People #1405",
		"Score": 60
	  },
	  {
		"Index": 1518,
		"Rank": 38,
		"Item": "NFT People #1418",
		"Score": 60
	  },
	  {
		"Index": 1519,
		"Rank": 38,
		"Item": "NFT People #1457",
		"Score": 60
	  },
	  {
		"Index": 1520,
		"Rank": 38,
		"Item": "NFT People #1460",
		"Score": 60
	  },
	  {
		"Index": 1521,
		"Rank": 38,
		"Item": "NFT People #1498",
		"Score": 60
	  },
	  {
		"Index": 1522,
		"Rank": 38,
		"Item": "NFT People #1500",
		"Score": 60
	  },
	  {
		"Index": 1523,
		"Rank": 38,
		"Item": "NFT People #1507",
		"Score": 60
	  },
	  {
		"Index": 1524,
		"Rank": 38,
		"Item": "NFT People #1513",
		"Score": 60
	  },
	  {
		"Index": 1525,
		"Rank": 38,
		"Item": "NFT People #1574",
		"Score": 60
	  },
	  {
		"Index": 1526,
		"Rank": 38,
		"Item": "NFT People #1581",
		"Score": 60
	  },
	  {
		"Index": 1527,
		"Rank": 38,
		"Item": "NFT People #1606",
		"Score": 60
	  },
	  {
		"Index": 1528,
		"Rank": 38,
		"Item": "NFT People #1625",
		"Score": 60
	  },
	  {
		"Index": 1529,
		"Rank": 38,
		"Item": "NFT People #1649",
		"Score": 60
	  },
	  {
		"Index": 1530,
		"Rank": 38,
		"Item": "NFT People #1697",
		"Score": 60
	  },
	  {
		"Index": 1531,
		"Rank": 38,
		"Item": "NFT People #1792",
		"Score": 60
	  },
	  {
		"Index": 1532,
		"Rank": 38,
		"Item": "NFT People #1794",
		"Score": 60
	  },
	  {
		"Index": 1533,
		"Rank": 38,
		"Item": "NFT People #1828",
		"Score": 60
	  },
	  {
		"Index": 1534,
		"Rank": 38,
		"Item": "NFT People #1863",
		"Score": 60
	  },
	  {
		"Index": 1535,
		"Rank": 38,
		"Item": "NFT People #1883",
		"Score": 60
	  },
	  {
		"Index": 1536,
		"Rank": 38,
		"Item": "NFT People #1912",
		"Score": 60
	  },
	  {
		"Index": 1537,
		"Rank": 38,
		"Item": "NFT People #2025",
		"Score": 60
	  },
	  {
		"Index": 1538,
		"Rank": 38,
		"Item": "NFT People #2078",
		"Score": 60
	  },
	  {
		"Index": 1539,
		"Rank": 38,
		"Item": "NFT People #2096",
		"Score": 60
	  },
	  {
		"Index": 1540,
		"Rank": 38,
		"Item": "NFT People #2111",
		"Score": 60
	  },
	  {
		"Index": 1541,
		"Rank": 38,
		"Item": "NFT People #2118",
		"Score": 60
	  },
	  {
		"Index": 1542,
		"Rank": 38,
		"Item": "NFT People #2219",
		"Score": 60
	  },
	  {
		"Index": 1543,
		"Rank": 38,
		"Item": "NFT People #2299",
		"Score": 60
	  },
	  {
		"Index": 1544,
		"Rank": 38,
		"Item": "NFT People #2332",
		"Score": 60
	  },
	  {
		"Index": 1545,
		"Rank": 38,
		"Item": "NFT People #2342",
		"Score": 60
	  },
	  {
		"Index": 1546,
		"Rank": 38,
		"Item": "NFT People #2380",
		"Score": 60
	  },
	  {
		"Index": 1547,
		"Rank": 38,
		"Item": "NFT People #2425",
		"Score": 60
	  },
	  {
		"Index": 1548,
		"Rank": 38,
		"Item": "NFT People #2477",
		"Score": 60
	  },
	  {
		"Index": 1549,
		"Rank": 38,
		"Item": "NFT People #2555",
		"Score": 60
	  },
	  {
		"Index": 1550,
		"Rank": 38,
		"Item": "NFT People #2574",
		"Score": 60
	  },
	  {
		"Index": 1551,
		"Rank": 38,
		"Item": "NFT People #2588",
		"Score": 60
	  },
	  {
		"Index": 1552,
		"Rank": 38,
		"Item": "NFT People #2601",
		"Score": 60
	  },
	  {
		"Index": 1553,
		"Rank": 38,
		"Item": "NFT People #2629",
		"Score": 60
	  },
	  {
		"Index": 1554,
		"Rank": 38,
		"Item": "NFT People #2640",
		"Score": 60
	  },
	  {
		"Index": 1555,
		"Rank": 38,
		"Item": "NFT People #2647",
		"Score": 60
	  },
	  {
		"Index": 1556,
		"Rank": 38,
		"Item": "NFT People #2656",
		"Score": 60
	  },
	  {
		"Index": 1557,
		"Rank": 38,
		"Item": "NFT People #2659",
		"Score": 60
	  },
	  {
		"Index": 1558,
		"Rank": 38,
		"Item": "NFT People #2710",
		"Score": 60
	  },
	  {
		"Index": 1559,
		"Rank": 38,
		"Item": "NFT People #2718",
		"Score": 60
	  },
	  {
		"Index": 1560,
		"Rank": 38,
		"Item": "NFT People #2728",
		"Score": 60
	  },
	  {
		"Index": 1561,
		"Rank": 38,
		"Item": "NFT People #2767",
		"Score": 60
	  },
	  {
		"Index": 1562,
		"Rank": 38,
		"Item": "NFT People #2778",
		"Score": 60
	  },
	  {
		"Index": 1563,
		"Rank": 38,
		"Item": "NFT People #2913",
		"Score": 60
	  },
	  {
		"Index": 1564,
		"Rank": 38,
		"Item": "NFT People #2967",
		"Score": 60
	  },
	  {
		"Index": 1565,
		"Rank": 38,
		"Item": "NFT People #2974",
		"Score": 60
	  },
	  {
		"Index": 1566,
		"Rank": 38,
		"Item": "NFT People #3047",
		"Score": 60
	  },
	  {
		"Index": 1567,
		"Rank": 38,
		"Item": "NFT People #3067",
		"Score": 60
	  },
	  {
		"Index": 1568,
		"Rank": 38,
		"Item": "NFT People #3069",
		"Score": 60
	  },
	  {
		"Index": 1569,
		"Rank": 38,
		"Item": "NFT People #3080",
		"Score": 60
	  },
	  {
		"Index": 1570,
		"Rank": 38,
		"Item": "NFT People #3094",
		"Score": 60
	  },
	  {
		"Index": 1571,
		"Rank": 38,
		"Item": "NFT People #3146",
		"Score": 60
	  },
	  {
		"Index": 1572,
		"Rank": 38,
		"Item": "NFT People #3174",
		"Score": 60
	  },
	  {
		"Index": 1573,
		"Rank": 38,
		"Item": "NFT People #3177",
		"Score": 60
	  },
	  {
		"Index": 1574,
		"Rank": 38,
		"Item": "NFT People #3181",
		"Score": 60
	  },
	  {
		"Index": 1575,
		"Rank": 38,
		"Item": "NFT People #3216",
		"Score": 60
	  },
	  {
		"Index": 1576,
		"Rank": 38,
		"Item": "NFT People #3235",
		"Score": 60
	  },
	  {
		"Index": 1577,
		"Rank": 38,
		"Item": "NFT People #3247",
		"Score": 60
	  },
	  {
		"Index": 1578,
		"Rank": 38,
		"Item": "NFT People #3324",
		"Score": 60
	  },
	  {
		"Index": 1579,
		"Rank": 38,
		"Item": "NFT People #3425",
		"Score": 60
	  },
	  {
		"Index": 1580,
		"Rank": 38,
		"Item": "NFT People #3469",
		"Score": 60
	  },
	  {
		"Index": 1581,
		"Rank": 38,
		"Item": "NFT People #3561",
		"Score": 60
	  },
	  {
		"Index": 1582,
		"Rank": 38,
		"Item": "NFT People #3565",
		"Score": 60
	  },
	  {
		"Index": 1583,
		"Rank": 38,
		"Item": "NFT People #3573",
		"Score": 60
	  },
	  {
		"Index": 1584,
		"Rank": 38,
		"Item": "NFT People #3600",
		"Score": 60
	  },
	  {
		"Index": 1585,
		"Rank": 38,
		"Item": "NFT People #3616",
		"Score": 60
	  },
	  {
		"Index": 1586,
		"Rank": 38,
		"Item": "NFT People #3620",
		"Score": 60
	  },
	  {
		"Index": 1587,
		"Rank": 38,
		"Item": "NFT People #3649",
		"Score": 60
	  },
	  {
		"Index": 1588,
		"Rank": 38,
		"Item": "NFT People #3677",
		"Score": 60
	  },
	  {
		"Index": 1589,
		"Rank": 38,
		"Item": "NFT People #3724",
		"Score": 60
	  },
	  {
		"Index": 1590,
		"Rank": 38,
		"Item": "NFT People #3738",
		"Score": 60
	  },
	  {
		"Index": 1591,
		"Rank": 38,
		"Item": "NFT People #3786",
		"Score": 60
	  },
	  {
		"Index": 1592,
		"Rank": 38,
		"Item": "NFT People #3824",
		"Score": 60
	  },
	  {
		"Index": 1593,
		"Rank": 38,
		"Item": "NFT People #3860",
		"Score": 60
	  },
	  {
		"Index": 1594,
		"Rank": 38,
		"Item": "NFT People #3872",
		"Score": 60
	  },
	  {
		"Index": 1595,
		"Rank": 38,
		"Item": "NFT People #3880",
		"Score": 60
	  },
	  {
		"Index": 1596,
		"Rank": 38,
		"Item": "NFT People #3900",
		"Score": 60
	  },
	  {
		"Index": 1597,
		"Rank": 38,
		"Item": "NFT People #3924",
		"Score": 60
	  },
	  {
		"Index": 1598,
		"Rank": 38,
		"Item": "NFT People #3960",
		"Score": 60
	  },
	  {
		"Index": 1599,
		"Rank": 38,
		"Item": "NFT People #4050",
		"Score": 60
	  },
	  {
		"Index": 1600,
		"Rank": 38,
		"Item": "NFT People #4095",
		"Score": 60
	  },
	  {
		"Index": 1601,
		"Rank": 38,
		"Item": "NFT People #4136",
		"Score": 60
	  },
	  {
		"Index": 1602,
		"Rank": 38,
		"Item": "NFT People #4178",
		"Score": 60
	  },
	  {
		"Index": 1603,
		"Rank": 38,
		"Item": "NFT People #4189",
		"Score": 60
	  },
	  {
		"Index": 1604,
		"Rank": 38,
		"Item": "NFT People #4224",
		"Score": 60
	  },
	  {
		"Index": 1605,
		"Rank": 38,
		"Item": "NFT People #4226",
		"Score": 60
	  },
	  {
		"Index": 1606,
		"Rank": 38,
		"Item": "NFT People #4229",
		"Score": 60
	  },
	  {
		"Index": 1607,
		"Rank": 38,
		"Item": "NFT People #4265",
		"Score": 60
	  },
	  {
		"Index": 1608,
		"Rank": 38,
		"Item": "NFT People #4293",
		"Score": 60
	  },
	  {
		"Index": 1609,
		"Rank": 38,
		"Item": "NFT People #4325",
		"Score": 60
	  },
	  {
		"Index": 1610,
		"Rank": 38,
		"Item": "NFT People #4328",
		"Score": 60
	  },
	  {
		"Index": 1611,
		"Rank": 38,
		"Item": "NFT People #4372",
		"Score": 60
	  },
	  {
		"Index": 1612,
		"Rank": 38,
		"Item": "NFT People #4382",
		"Score": 60
	  },
	  {
		"Index": 1613,
		"Rank": 38,
		"Item": "NFT People #4414",
		"Score": 60
	  },
	  {
		"Index": 1614,
		"Rank": 38,
		"Item": "NFT People #4426",
		"Score": 60
	  },
	  {
		"Index": 1615,
		"Rank": 38,
		"Item": "NFT People #4442",
		"Score": 60
	  },
	  {
		"Index": 1616,
		"Rank": 38,
		"Item": "NFT People #4492",
		"Score": 60
	  },
	  {
		"Index": 1617,
		"Rank": 38,
		"Item": "NFT People #4509",
		"Score": 60
	  },
	  {
		"Index": 1618,
		"Rank": 38,
		"Item": "NFT People #4548",
		"Score": 60
	  },
	  {
		"Index": 1619,
		"Rank": 38,
		"Item": "NFT People #4586",
		"Score": 60
	  },
	  {
		"Index": 1620,
		"Rank": 38,
		"Item": "NFT People #4625",
		"Score": 60
	  },
	  {
		"Index": 1621,
		"Rank": 38,
		"Item": "NFT People #4663",
		"Score": 60
	  },
	  {
		"Index": 1622,
		"Rank": 38,
		"Item": "NFT People #4682",
		"Score": 60
	  },
	  {
		"Index": 1623,
		"Rank": 38,
		"Item": "NFT People #4694",
		"Score": 60
	  },
	  {
		"Index": 1624,
		"Rank": 38,
		"Item": "NFT People #4751",
		"Score": 60
	  },
	  {
		"Index": 1625,
		"Rank": 38,
		"Item": "NFT People #4756",
		"Score": 60
	  },
	  {
		"Index": 1626,
		"Rank": 38,
		"Item": "NFT People #4759",
		"Score": 60
	  },
	  {
		"Index": 1627,
		"Rank": 38,
		"Item": "NFT People #4789",
		"Score": 60
	  },
	  {
		"Index": 1628,
		"Rank": 38,
		"Item": "NFT People #4817",
		"Score": 60
	  },
	  {
		"Index": 1629,
		"Rank": 38,
		"Item": "NFT People #4931",
		"Score": 60
	  },
	  {
		"Index": 1630,
		"Rank": 38,
		"Item": "NFT People #4931",
		"Score": 60
	  },
	  {
		"Index": 1631,
		"Rank": 38,
		"Item": "NFT People #4970",
		"Score": 60
	  },
	  {
		"Index": 1632,
		"Rank": 38,
		"Item": "NFT People #4981",
		"Score": 60
	  },
	  {
		"Index": 1633,
		"Rank": 39,
		"Item": "NFT People #0011",
		"Score": 59
	  },
	  {
		"Index": 1634,
		"Rank": 39,
		"Item": "NFT People #0087",
		"Score": 59
	  },
	  {
		"Index": 1635,
		"Rank": 39,
		"Item": "NFT People #0207",
		"Score": 59
	  },
	  {
		"Index": 1636,
		"Rank": 39,
		"Item": "NFT People #0350",
		"Score": 59
	  },
	  {
		"Index": 1637,
		"Rank": 39,
		"Item": "NFT People #0381",
		"Score": 59
	  },
	  {
		"Index": 1638,
		"Rank": 39,
		"Item": "NFT People #0436",
		"Score": 59
	  },
	  {
		"Index": 1639,
		"Rank": 39,
		"Item": "NFT People #1065",
		"Score": 59
	  },
	  {
		"Index": 1640,
		"Rank": 39,
		"Item": "NFT People #1154",
		"Score": 59
	  },
	  {
		"Index": 1641,
		"Rank": 39,
		"Item": "NFT People #1155",
		"Score": 59
	  },
	  {
		"Index": 1642,
		"Rank": 39,
		"Item": "NFT People #1176",
		"Score": 59
	  },
	  {
		"Index": 1643,
		"Rank": 39,
		"Item": "NFT People #1209",
		"Score": 59
	  },
	  {
		"Index": 1644,
		"Rank": 39,
		"Item": "NFT People #1214",
		"Score": 59
	  },
	  {
		"Index": 1645,
		"Rank": 39,
		"Item": "NFT People #1255",
		"Score": 59
	  },
	  {
		"Index": 1646,
		"Rank": 39,
		"Item": "NFT People #1265",
		"Score": 59
	  },
	  {
		"Index": 1647,
		"Rank": 39,
		"Item": "NFT People #1445",
		"Score": 59
	  },
	  {
		"Index": 1648,
		"Rank": 39,
		"Item": "NFT People #1489",
		"Score": 59
	  },
	  {
		"Index": 1649,
		"Rank": 39,
		"Item": "NFT People #1557",
		"Score": 59
	  },
	  {
		"Index": 1650,
		"Rank": 39,
		"Item": "NFT People #1643",
		"Score": 59
	  },
	  {
		"Index": 1651,
		"Rank": 39,
		"Item": "NFT People #1698",
		"Score": 59
	  },
	  {
		"Index": 1652,
		"Rank": 39,
		"Item": "NFT People #1712",
		"Score": 59
	  },
	  {
		"Index": 1653,
		"Rank": 39,
		"Item": "NFT People #1739",
		"Score": 59
	  },
	  {
		"Index": 1654,
		"Rank": 39,
		"Item": "NFT People #1884",
		"Score": 59
	  },
	  {
		"Index": 1655,
		"Rank": 39,
		"Item": "NFT People #1932",
		"Score": 59
	  },
	  {
		"Index": 1656,
		"Rank": 39,
		"Item": "NFT People #2004",
		"Score": 59
	  },
	  {
		"Index": 1657,
		"Rank": 39,
		"Item": "NFT People #2034",
		"Score": 59
	  },
	  {
		"Index": 1658,
		"Rank": 39,
		"Item": "NFT People #2135",
		"Score": 59
	  },
	  {
		"Index": 1659,
		"Rank": 39,
		"Item": "NFT People #2159",
		"Score": 59
	  },
	  {
		"Index": 1660,
		"Rank": 39,
		"Item": "NFT People #2168",
		"Score": 59
	  },
	  {
		"Index": 1661,
		"Rank": 39,
		"Item": "NFT People #2235",
		"Score": 59
	  },
	  {
		"Index": 1662,
		"Rank": 39,
		"Item": "NFT People #2260",
		"Score": 59
	  },
	  {
		"Index": 1663,
		"Rank": 39,
		"Item": "NFT People #2297",
		"Score": 59
	  },
	  {
		"Index": 1664,
		"Rank": 39,
		"Item": "NFT People #2616",
		"Score": 59
	  },
	  {
		"Index": 1665,
		"Rank": 39,
		"Item": "NFT People #2621",
		"Score": 59
	  },
	  {
		"Index": 1666,
		"Rank": 39,
		"Item": "NFT People #2799",
		"Score": 59
	  },
	  {
		"Index": 1667,
		"Rank": 39,
		"Item": "NFT People #2834",
		"Score": 59
	  },
	  {
		"Index": 1668,
		"Rank": 39,
		"Item": "NFT People #2847",
		"Score": 59
	  },
	  {
		"Index": 1669,
		"Rank": 39,
		"Item": "NFT People #2867",
		"Score": 59
	  },
	  {
		"Index": 1670,
		"Rank": 39,
		"Item": "NFT People #2878",
		"Score": 59
	  },
	  {
		"Index": 1671,
		"Rank": 39,
		"Item": "NFT People #2933",
		"Score": 59
	  },
	  {
		"Index": 1672,
		"Rank": 39,
		"Item": "NFT People #2998",
		"Score": 59
	  },
	  {
		"Index": 1673,
		"Rank": 39,
		"Item": "NFT People #3034",
		"Score": 59
	  },
	  {
		"Index": 1674,
		"Rank": 39,
		"Item": "NFT People #3158",
		"Score": 59
	  },
	  {
		"Index": 1675,
		"Rank": 39,
		"Item": "NFT People #3185",
		"Score": 59
	  },
	  {
		"Index": 1676,
		"Rank": 39,
		"Item": "NFT People #3189",
		"Score": 59
	  },
	  {
		"Index": 1677,
		"Rank": 39,
		"Item": "NFT People #3277",
		"Score": 59
	  },
	  {
		"Index": 1678,
		"Rank": 39,
		"Item": "NFT People #3514",
		"Score": 59
	  },
	  {
		"Index": 1679,
		"Rank": 39,
		"Item": "NFT People #3527",
		"Score": 59
	  },
	  {
		"Index": 1680,
		"Rank": 39,
		"Item": "NFT People #3558",
		"Score": 59
	  },
	  {
		"Index": 1681,
		"Rank": 39,
		"Item": "NFT People #3656",
		"Score": 59
	  },
	  {
		"Index": 1682,
		"Rank": 39,
		"Item": "NFT People #3739",
		"Score": 59
	  },
	  {
		"Index": 1683,
		"Rank": 39,
		"Item": "NFT People #3842",
		"Score": 59
	  },
	  {
		"Index": 1684,
		"Rank": 39,
		"Item": "NFT People #4090",
		"Score": 59
	  },
	  {
		"Index": 1685,
		"Rank": 39,
		"Item": "NFT People #4097",
		"Score": 59
	  },
	  {
		"Index": 1686,
		"Rank": 39,
		"Item": "NFT People #4122",
		"Score": 59
	  },
	  {
		"Index": 1687,
		"Rank": 39,
		"Item": "NFT People #4202",
		"Score": 59
	  },
	  {
		"Index": 1688,
		"Rank": 39,
		"Item": "NFT People #4230",
		"Score": 59
	  },
	  {
		"Index": 1689,
		"Rank": 39,
		"Item": "NFT People #4252",
		"Score": 59
	  },
	  {
		"Index": 1690,
		"Rank": 39,
		"Item": "NFT People #4296",
		"Score": 59
	  },
	  {
		"Index": 1691,
		"Rank": 39,
		"Item": "NFT People #4454",
		"Score": 59
	  },
	  {
		"Index": 1692,
		"Rank": 39,
		"Item": "NFT People #4513",
		"Score": 59
	  },
	  {
		"Index": 1693,
		"Rank": 39,
		"Item": "NFT People #4552",
		"Score": 59
	  },
	  {
		"Index": 1694,
		"Rank": 39,
		"Item": "NFT People #4616",
		"Score": 59
	  },
	  {
		"Index": 1695,
		"Rank": 39,
		"Item": "NFT People #4653",
		"Score": 59
	  },
	  {
		"Index": 1696,
		"Rank": 39,
		"Item": "NFT People #4668",
		"Score": 59
	  },
	  {
		"Index": 1697,
		"Rank": 39,
		"Item": "NFT People #4735",
		"Score": 59
	  },
	  {
		"Index": 1698,
		"Rank": 39,
		"Item": "NFT People #4747",
		"Score": 59
	  },
	  {
		"Index": 1699,
		"Rank": 40,
		"Item": "NFT People #0028",
		"Score": 58
	  },
	  {
		"Index": 1700,
		"Rank": 40,
		"Item": "NFT People #0033",
		"Score": 58
	  },
	  {
		"Index": 1701,
		"Rank": 40,
		"Item": "NFT People #0035",
		"Score": 58
	  },
	  {
		"Index": 1702,
		"Rank": 40,
		"Item": "NFT People #0059",
		"Score": 58
	  },
	  {
		"Index": 1703,
		"Rank": 40,
		"Item": "NFT People #0079",
		"Score": 58
	  },
	  {
		"Index": 1704,
		"Rank": 40,
		"Item": "NFT People #0086",
		"Score": 58
	  },
	  {
		"Index": 1705,
		"Rank": 40,
		"Item": "NFT People #0101",
		"Score": 58
	  },
	  {
		"Index": 1706,
		"Rank": 40,
		"Item": "NFT People #0152",
		"Score": 58
	  },
	  {
		"Index": 1707,
		"Rank": 40,
		"Item": "NFT People #0159",
		"Score": 58
	  },
	  {
		"Index": 1708,
		"Rank": 40,
		"Item": "NFT People #0197",
		"Score": 58
	  },
	  {
		"Index": 1709,
		"Rank": 40,
		"Item": "NFT People #0206",
		"Score": 58
	  },
	  {
		"Index": 1710,
		"Rank": 40,
		"Item": "NFT People #0265",
		"Score": 58
	  },
	  {
		"Index": 1711,
		"Rank": 40,
		"Item": "NFT People #0418",
		"Score": 58
	  },
	  {
		"Index": 1712,
		"Rank": 40,
		"Item": "NFT People #0439",
		"Score": 58
	  },
	  {
		"Index": 1713,
		"Rank": 40,
		"Item": "NFT People #0524",
		"Score": 58
	  },
	  {
		"Index": 1714,
		"Rank": 40,
		"Item": "NFT People #0530",
		"Score": 58
	  },
	  {
		"Index": 1715,
		"Rank": 40,
		"Item": "NFT People #0704",
		"Score": 58
	  },
	  {
		"Index": 1716,
		"Rank": 40,
		"Item": "NFT People #0709",
		"Score": 58
	  },
	  {
		"Index": 1717,
		"Rank": 40,
		"Item": "NFT People #0772",
		"Score": 58
	  },
	  {
		"Index": 1718,
		"Rank": 40,
		"Item": "NFT People #0784",
		"Score": 58
	  },
	  {
		"Index": 1719,
		"Rank": 40,
		"Item": "NFT People #0788",
		"Score": 58
	  },
	  {
		"Index": 1720,
		"Rank": 40,
		"Item": "NFT People #0789",
		"Score": 58
	  },
	  {
		"Index": 1721,
		"Rank": 40,
		"Item": "NFT People #0834",
		"Score": 58
	  },
	  {
		"Index": 1722,
		"Rank": 40,
		"Item": "NFT People #0838",
		"Score": 58
	  },
	  {
		"Index": 1723,
		"Rank": 40,
		"Item": "NFT People #0871",
		"Score": 58
	  },
	  {
		"Index": 1724,
		"Rank": 40,
		"Item": "NFT People #0906",
		"Score": 58
	  },
	  {
		"Index": 1725,
		"Rank": 40,
		"Item": "NFT People #0921",
		"Score": 58
	  },
	  {
		"Index": 1726,
		"Rank": 40,
		"Item": "NFT People #0985",
		"Score": 58
	  },
	  {
		"Index": 1727,
		"Rank": 40,
		"Item": "NFT People #1007",
		"Score": 58
	  },
	  {
		"Index": 1728,
		"Rank": 40,
		"Item": "NFT People #1102",
		"Score": 58
	  },
	  {
		"Index": 1729,
		"Rank": 40,
		"Item": "NFT People #1135",
		"Score": 58
	  },
	  {
		"Index": 1730,
		"Rank": 40,
		"Item": "NFT People #1159",
		"Score": 58
	  },
	  {
		"Index": 1731,
		"Rank": 40,
		"Item": "NFT People #1174",
		"Score": 58
	  },
	  {
		"Index": 1732,
		"Rank": 40,
		"Item": "NFT People #1232",
		"Score": 58
	  },
	  {
		"Index": 1733,
		"Rank": 40,
		"Item": "NFT People #1238",
		"Score": 58
	  },
	  {
		"Index": 1734,
		"Rank": 40,
		"Item": "NFT People #1262",
		"Score": 58
	  },
	  {
		"Index": 1735,
		"Rank": 40,
		"Item": "NFT People #1270",
		"Score": 58
	  },
	  {
		"Index": 1736,
		"Rank": 40,
		"Item": "NFT People #1281",
		"Score": 58
	  },
	  {
		"Index": 1737,
		"Rank": 40,
		"Item": "NFT People #1353",
		"Score": 58
	  },
	  {
		"Index": 1738,
		"Rank": 40,
		"Item": "NFT People #1356",
		"Score": 58
	  },
	  {
		"Index": 1739,
		"Rank": 40,
		"Item": "NFT People #1389",
		"Score": 58
	  },
	  {
		"Index": 1740,
		"Rank": 40,
		"Item": "NFT People #1407",
		"Score": 58
	  },
	  {
		"Index": 1741,
		"Rank": 40,
		"Item": "NFT People #1412",
		"Score": 58
	  },
	  {
		"Index": 1742,
		"Rank": 40,
		"Item": "NFT People #1441",
		"Score": 58
	  },
	  {
		"Index": 1743,
		"Rank": 40,
		"Item": "NFT People #1459",
		"Score": 58
	  },
	  {
		"Index": 1744,
		"Rank": 40,
		"Item": "NFT People #1488",
		"Score": 58
	  },
	  {
		"Index": 1745,
		"Rank": 40,
		"Item": "NFT People #1556",
		"Score": 58
	  },
	  {
		"Index": 1746,
		"Rank": 40,
		"Item": "NFT People #1584",
		"Score": 58
	  },
	  {
		"Index": 1747,
		"Rank": 40,
		"Item": "NFT People #1594",
		"Score": 58
	  },
	  {
		"Index": 1748,
		"Rank": 40,
		"Item": "NFT People #1616",
		"Score": 58
	  },
	  {
		"Index": 1749,
		"Rank": 40,
		"Item": "NFT People #1621",
		"Score": 58
	  },
	  {
		"Index": 1750,
		"Rank": 40,
		"Item": "NFT People #1658",
		"Score": 58
	  },
	  {
		"Index": 1751,
		"Rank": 40,
		"Item": "NFT People #1701",
		"Score": 58
	  },
	  {
		"Index": 1752,
		"Rank": 40,
		"Item": "NFT People #1729",
		"Score": 58
	  },
	  {
		"Index": 1753,
		"Rank": 40,
		"Item": "NFT People #1737",
		"Score": 58
	  },
	  {
		"Index": 1754,
		"Rank": 40,
		"Item": "NFT People #1798",
		"Score": 58
	  },
	  {
		"Index": 1755,
		"Rank": 40,
		"Item": "NFT People #1805",
		"Score": 58
	  },
	  {
		"Index": 1756,
		"Rank": 40,
		"Item": "NFT People #1829",
		"Score": 58
	  },
	  {
		"Index": 1757,
		"Rank": 40,
		"Item": "NFT People #1887",
		"Score": 58
	  },
	  {
		"Index": 1758,
		"Rank": 40,
		"Item": "NFT People #1888",
		"Score": 58
	  },
	  {
		"Index": 1759,
		"Rank": 40,
		"Item": "NFT People #1901",
		"Score": 58
	  },
	  {
		"Index": 1760,
		"Rank": 40,
		"Item": "NFT People #1914",
		"Score": 58
	  },
	  {
		"Index": 1761,
		"Rank": 40,
		"Item": "NFT People #1921",
		"Score": 58
	  },
	  {
		"Index": 1762,
		"Rank": 40,
		"Item": "NFT People #1945",
		"Score": 58
	  },
	  {
		"Index": 1763,
		"Rank": 40,
		"Item": "NFT People #1955",
		"Score": 58
	  },
	  {
		"Index": 1764,
		"Rank": 40,
		"Item": "NFT People #1982",
		"Score": 58
	  },
	  {
		"Index": 1765,
		"Rank": 40,
		"Item": "NFT People #1997",
		"Score": 58
	  },
	  {
		"Index": 1766,
		"Rank": 40,
		"Item": "NFT People #2015",
		"Score": 58
	  },
	  {
		"Index": 1767,
		"Rank": 40,
		"Item": "NFT People #2032",
		"Score": 58
	  },
	  {
		"Index": 1768,
		"Rank": 40,
		"Item": "NFT People #2060",
		"Score": 58
	  },
	  {
		"Index": 1769,
		"Rank": 40,
		"Item": "NFT People #2108",
		"Score": 58
	  },
	  {
		"Index": 1770,
		"Rank": 40,
		"Item": "NFT People #2151",
		"Score": 58
	  },
	  {
		"Index": 1771,
		"Rank": 40,
		"Item": "NFT People #2192",
		"Score": 58
	  },
	  {
		"Index": 1772,
		"Rank": 40,
		"Item": "NFT People #2196",
		"Score": 58
	  },
	  {
		"Index": 1773,
		"Rank": 40,
		"Item": "NFT People #2208",
		"Score": 58
	  },
	  {
		"Index": 1774,
		"Rank": 40,
		"Item": "NFT People #2211",
		"Score": 58
	  },
	  {
		"Index": 1775,
		"Rank": 40,
		"Item": "NFT People #2255",
		"Score": 58
	  },
	  {
		"Index": 1776,
		"Rank": 40,
		"Item": "NFT People #2313",
		"Score": 58
	  },
	  {
		"Index": 1777,
		"Rank": 40,
		"Item": "NFT People #2324",
		"Score": 58
	  },
	  {
		"Index": 1778,
		"Rank": 40,
		"Item": "NFT People #2343",
		"Score": 58
	  },
	  {
		"Index": 1779,
		"Rank": 40,
		"Item": "NFT People #2472",
		"Score": 58
	  },
	  {
		"Index": 1780,
		"Rank": 40,
		"Item": "NFT People #2510",
		"Score": 58
	  },
	  {
		"Index": 1781,
		"Rank": 40,
		"Item": "NFT People #2535",
		"Score": 58
	  },
	  {
		"Index": 1782,
		"Rank": 40,
		"Item": "NFT People #2553",
		"Score": 58
	  },
	  {
		"Index": 1783,
		"Rank": 40,
		"Item": "NFT People #2573",
		"Score": 58
	  },
	  {
		"Index": 1784,
		"Rank": 40,
		"Item": "NFT People #2587",
		"Score": 58
	  },
	  {
		"Index": 1785,
		"Rank": 40,
		"Item": "NFT People #2592",
		"Score": 58
	  },
	  {
		"Index": 1786,
		"Rank": 40,
		"Item": "NFT People #2612",
		"Score": 58
	  },
	  {
		"Index": 1787,
		"Rank": 40,
		"Item": "NFT People #2619",
		"Score": 58
	  },
	  {
		"Index": 1788,
		"Rank": 40,
		"Item": "NFT People #2673",
		"Score": 58
	  },
	  {
		"Index": 1789,
		"Rank": 40,
		"Item": "NFT People #2689",
		"Score": 58
	  },
	  {
		"Index": 1790,
		"Rank": 40,
		"Item": "NFT People #2690",
		"Score": 58
	  },
	  {
		"Index": 1791,
		"Rank": 40,
		"Item": "NFT People #2695",
		"Score": 58
	  },
	  {
		"Index": 1792,
		"Rank": 40,
		"Item": "NFT People #2704",
		"Score": 58
	  },
	  {
		"Index": 1793,
		"Rank": 40,
		"Item": "NFT People #2737",
		"Score": 58
	  },
	  {
		"Index": 1794,
		"Rank": 40,
		"Item": "NFT People #2766",
		"Score": 58
	  },
	  {
		"Index": 1795,
		"Rank": 40,
		"Item": "NFT People #2785",
		"Score": 58
	  },
	  {
		"Index": 1796,
		"Rank": 40,
		"Item": "NFT People #2803",
		"Score": 58
	  },
	  {
		"Index": 1797,
		"Rank": 40,
		"Item": "NFT People #2851",
		"Score": 58
	  },
	  {
		"Index": 1798,
		"Rank": 40,
		"Item": "NFT People #2854",
		"Score": 58
	  },
	  {
		"Index": 1799,
		"Rank": 40,
		"Item": "NFT People #2940",
		"Score": 58
	  },
	  {
		"Index": 1800,
		"Rank": 40,
		"Item": "NFT People #2952",
		"Score": 58
	  },
	  {
		"Index": 1801,
		"Rank": 40,
		"Item": "NFT People #2965",
		"Score": 58
	  },
	  {
		"Index": 1802,
		"Rank": 40,
		"Item": "NFT People #3002",
		"Score": 58
	  },
	  {
		"Index": 1803,
		"Rank": 40,
		"Item": "NFT People #3020",
		"Score": 58
	  },
	  {
		"Index": 1804,
		"Rank": 40,
		"Item": "NFT People #3082",
		"Score": 58
	  },
	  {
		"Index": 1805,
		"Rank": 40,
		"Item": "NFT People #3190",
		"Score": 58
	  },
	  {
		"Index": 1806,
		"Rank": 40,
		"Item": "NFT People #3192",
		"Score": 58
	  },
	  {
		"Index": 1807,
		"Rank": 40,
		"Item": "NFT People #3195",
		"Score": 58
	  },
	  {
		"Index": 1808,
		"Rank": 40,
		"Item": "NFT People #3251",
		"Score": 58
	  },
	  {
		"Index": 1809,
		"Rank": 40,
		"Item": "NFT People #3345",
		"Score": 58
	  },
	  {
		"Index": 1810,
		"Rank": 40,
		"Item": "NFT People #3350",
		"Score": 58
	  },
	  {
		"Index": 1811,
		"Rank": 40,
		"Item": "NFT People #3357",
		"Score": 58
	  },
	  {
		"Index": 1812,
		"Rank": 40,
		"Item": "NFT People #3378",
		"Score": 58
	  },
	  {
		"Index": 1813,
		"Rank": 40,
		"Item": "NFT People #3388",
		"Score": 58
	  },
	  {
		"Index": 1814,
		"Rank": 40,
		"Item": "NFT People #3404",
		"Score": 58
	  },
	  {
		"Index": 1815,
		"Rank": 40,
		"Item": "NFT People #3412",
		"Score": 58
	  },
	  {
		"Index": 1816,
		"Rank": 40,
		"Item": "NFT People #3455",
		"Score": 58
	  },
	  {
		"Index": 1817,
		"Rank": 40,
		"Item": "NFT People #3480",
		"Score": 58
	  },
	  {
		"Index": 1818,
		"Rank": 40,
		"Item": "NFT People #3567",
		"Score": 58
	  },
	  {
		"Index": 1819,
		"Rank": 40,
		"Item": "NFT People #3586",
		"Score": 58
	  },
	  {
		"Index": 1820,
		"Rank": 40,
		"Item": "NFT People #3606",
		"Score": 58
	  },
	  {
		"Index": 1821,
		"Rank": 40,
		"Item": "NFT People #3643",
		"Score": 58
	  },
	  {
		"Index": 1822,
		"Rank": 40,
		"Item": "NFT People #3687",
		"Score": 58
	  },
	  {
		"Index": 1823,
		"Rank": 40,
		"Item": "NFT People #3691",
		"Score": 58
	  },
	  {
		"Index": 1824,
		"Rank": 40,
		"Item": "NFT People #3749",
		"Score": 58
	  },
	  {
		"Index": 1825,
		"Rank": 40,
		"Item": "NFT People #3756",
		"Score": 58
	  },
	  {
		"Index": 1826,
		"Rank": 40,
		"Item": "NFT People #3762",
		"Score": 58
	  },
	  {
		"Index": 1827,
		"Rank": 40,
		"Item": "NFT People #3783",
		"Score": 58
	  },
	  {
		"Index": 1828,
		"Rank": 40,
		"Item": "NFT People #3789",
		"Score": 58
	  },
	  {
		"Index": 1829,
		"Rank": 40,
		"Item": "NFT People #3803",
		"Score": 58
	  },
	  {
		"Index": 1830,
		"Rank": 40,
		"Item": "NFT People #3804",
		"Score": 58
	  },
	  {
		"Index": 1831,
		"Rank": 40,
		"Item": "NFT People #3820",
		"Score": 58
	  },
	  {
		"Index": 1832,
		"Rank": 40,
		"Item": "NFT People #3823",
		"Score": 58
	  },
	  {
		"Index": 1833,
		"Rank": 40,
		"Item": "NFT People #3853",
		"Score": 58
	  },
	  {
		"Index": 1834,
		"Rank": 40,
		"Item": "NFT People #3862",
		"Score": 58
	  },
	  {
		"Index": 1835,
		"Rank": 40,
		"Item": "NFT People #3889",
		"Score": 58
	  },
	  {
		"Index": 1836,
		"Rank": 40,
		"Item": "NFT People #3896",
		"Score": 58
	  },
	  {
		"Index": 1837,
		"Rank": 40,
		"Item": "NFT People #3899",
		"Score": 58
	  },
	  {
		"Index": 1838,
		"Rank": 40,
		"Item": "NFT People #3955",
		"Score": 58
	  },
	  {
		"Index": 1839,
		"Rank": 40,
		"Item": "NFT People #3961",
		"Score": 58
	  },
	  {
		"Index": 1840,
		"Rank": 40,
		"Item": "NFT People #3971",
		"Score": 58
	  },
	  {
		"Index": 1841,
		"Rank": 40,
		"Item": "NFT People #4021",
		"Score": 58
	  },
	  {
		"Index": 1842,
		"Rank": 40,
		"Item": "NFT People #4027",
		"Score": 58
	  },
	  {
		"Index": 1843,
		"Rank": 40,
		"Item": "NFT People #4060",
		"Score": 58
	  },
	  {
		"Index": 1844,
		"Rank": 40,
		"Item": "NFT People #4074",
		"Score": 58
	  },
	  {
		"Index": 1845,
		"Rank": 40,
		"Item": "NFT People #4132",
		"Score": 58
	  },
	  {
		"Index": 1846,
		"Rank": 40,
		"Item": "NFT People #4134",
		"Score": 58
	  },
	  {
		"Index": 1847,
		"Rank": 40,
		"Item": "NFT People #4147",
		"Score": 58
	  },
	  {
		"Index": 1848,
		"Rank": 40,
		"Item": "NFT People #4247",
		"Score": 58
	  },
	  {
		"Index": 1849,
		"Rank": 40,
		"Item": "NFT People #4300",
		"Score": 58
	  },
	  {
		"Index": 1850,
		"Rank": 40,
		"Item": "NFT People #4303",
		"Score": 58
	  },
	  {
		"Index": 1851,
		"Rank": 40,
		"Item": "NFT People #4335",
		"Score": 58
	  },
	  {
		"Index": 1852,
		"Rank": 40,
		"Item": "NFT People #4348",
		"Score": 58
	  },
	  {
		"Index": 1853,
		"Rank": 40,
		"Item": "NFT People #4370",
		"Score": 58
	  },
	  {
		"Index": 1854,
		"Rank": 40,
		"Item": "NFT People #4373",
		"Score": 58
	  },
	  {
		"Index": 1855,
		"Rank": 40,
		"Item": "NFT People #4412",
		"Score": 58
	  },
	  {
		"Index": 1856,
		"Rank": 40,
		"Item": "NFT People #4451",
		"Score": 58
	  },
	  {
		"Index": 1857,
		"Rank": 40,
		"Item": "NFT People #4455",
		"Score": 58
	  },
	  {
		"Index": 1858,
		"Rank": 40,
		"Item": "NFT People #4489",
		"Score": 58
	  },
	  {
		"Index": 1859,
		"Rank": 40,
		"Item": "NFT People #4494",
		"Score": 58
	  },
	  {
		"Index": 1860,
		"Rank": 40,
		"Item": "NFT People #4495",
		"Score": 58
	  },
	  {
		"Index": 1861,
		"Rank": 40,
		"Item": "NFT People #4501",
		"Score": 58
	  },
	  {
		"Index": 1862,
		"Rank": 40,
		"Item": "NFT People #4561",
		"Score": 58
	  },
	  {
		"Index": 1863,
		"Rank": 40,
		"Item": "NFT People #4582",
		"Score": 58
	  },
	  {
		"Index": 1864,
		"Rank": 40,
		"Item": "NFT People #4596",
		"Score": 58
	  },
	  {
		"Index": 1865,
		"Rank": 40,
		"Item": "NFT People #4615",
		"Score": 58
	  },
	  {
		"Index": 1866,
		"Rank": 40,
		"Item": "NFT People #4622",
		"Score": 58
	  },
	  {
		"Index": 1867,
		"Rank": 40,
		"Item": "NFT People #4661",
		"Score": 58
	  },
	  {
		"Index": 1868,
		"Rank": 40,
		"Item": "NFT People #4666",
		"Score": 58
	  },
	  {
		"Index": 1869,
		"Rank": 40,
		"Item": "NFT People #4672",
		"Score": 58
	  },
	  {
		"Index": 1870,
		"Rank": 40,
		"Item": "NFT People #4681",
		"Score": 58
	  },
	  {
		"Index": 1871,
		"Rank": 40,
		"Item": "NFT People #4732",
		"Score": 58
	  },
	  {
		"Index": 1872,
		"Rank": 40,
		"Item": "NFT People #4750",
		"Score": 58
	  },
	  {
		"Index": 1873,
		"Rank": 40,
		"Item": "NFT People #4764",
		"Score": 58
	  },
	  {
		"Index": 1874,
		"Rank": 40,
		"Item": "NFT People #4801",
		"Score": 58
	  },
	  {
		"Index": 1875,
		"Rank": 40,
		"Item": "NFT People #4841",
		"Score": 58
	  },
	  {
		"Index": 1876,
		"Rank": 40,
		"Item": "NFT People #4940",
		"Score": 58
	  },
	  {
		"Index": 1877,
		"Rank": 40,
		"Item": "NFT People #4944",
		"Score": 58
	  },
	  {
		"Index": 1878,
		"Rank": 41,
		"Item": "NFT People #0024",
		"Score": 57
	  },
	  {
		"Index": 1879,
		"Rank": 41,
		"Item": "NFT People #0041",
		"Score": 57
	  },
	  {
		"Index": 1880,
		"Rank": 41,
		"Item": "NFT People #0044",
		"Score": 57
	  },
	  {
		"Index": 1881,
		"Rank": 41,
		"Item": "NFT People #0070",
		"Score": 57
	  },
	  {
		"Index": 1882,
		"Rank": 41,
		"Item": "NFT People #0081",
		"Score": 57
	  },
	  {
		"Index": 1883,
		"Rank": 41,
		"Item": "NFT People #0088",
		"Score": 57
	  },
	  {
		"Index": 1884,
		"Rank": 41,
		"Item": "NFT People #0106",
		"Score": 57
	  },
	  {
		"Index": 1885,
		"Rank": 41,
		"Item": "NFT People #0107",
		"Score": 57
	  },
	  {
		"Index": 1886,
		"Rank": 41,
		"Item": "NFT People #0125",
		"Score": 57
	  },
	  {
		"Index": 1887,
		"Rank": 41,
		"Item": "NFT People #0200",
		"Score": 57
	  },
	  {
		"Index": 1888,
		"Rank": 41,
		"Item": "NFT People #0255",
		"Score": 57
	  },
	  {
		"Index": 1889,
		"Rank": 41,
		"Item": "NFT People #0257",
		"Score": 57
	  },
	  {
		"Index": 1890,
		"Rank": 41,
		"Item": "NFT People #0268",
		"Score": 57
	  },
	  {
		"Index": 1891,
		"Rank": 41,
		"Item": "NFT People #0292",
		"Score": 57
	  },
	  {
		"Index": 1892,
		"Rank": 41,
		"Item": "NFT People #0296",
		"Score": 57
	  },
	  {
		"Index": 1893,
		"Rank": 41,
		"Item": "NFT People #0302",
		"Score": 57
	  },
	  {
		"Index": 1894,
		"Rank": 41,
		"Item": "NFT People #0327",
		"Score": 57
	  },
	  {
		"Index": 1895,
		"Rank": 41,
		"Item": "NFT People #0357",
		"Score": 57
	  },
	  {
		"Index": 1896,
		"Rank": 41,
		"Item": "NFT People #0433",
		"Score": 57
	  },
	  {
		"Index": 1897,
		"Rank": 41,
		"Item": "NFT People #0434",
		"Score": 57
	  },
	  {
		"Index": 1898,
		"Rank": 41,
		"Item": "NFT People #0441",
		"Score": 57
	  },
	  {
		"Index": 1899,
		"Rank": 41,
		"Item": "NFT People #0444",
		"Score": 57
	  },
	  {
		"Index": 1900,
		"Rank": 41,
		"Item": "NFT People #0473",
		"Score": 57
	  },
	  {
		"Index": 1901,
		"Rank": 41,
		"Item": "NFT People #0491",
		"Score": 57
	  },
	  {
		"Index": 1902,
		"Rank": 41,
		"Item": "NFT People #0502",
		"Score": 57
	  },
	  {
		"Index": 1903,
		"Rank": 41,
		"Item": "NFT People #0580",
		"Score": 57
	  },
	  {
		"Index": 1904,
		"Rank": 41,
		"Item": "NFT People #0585",
		"Score": 57
	  },
	  {
		"Index": 1905,
		"Rank": 41,
		"Item": "NFT People #0743",
		"Score": 57
	  },
	  {
		"Index": 1906,
		"Rank": 41,
		"Item": "NFT People #0748",
		"Score": 57
	  },
	  {
		"Index": 1907,
		"Rank": 41,
		"Item": "NFT People #0798",
		"Score": 57
	  },
	  {
		"Index": 1908,
		"Rank": 41,
		"Item": "NFT People #0816",
		"Score": 57
	  },
	  {
		"Index": 1909,
		"Rank": 41,
		"Item": "NFT People #0835",
		"Score": 57
	  },
	  {
		"Index": 1910,
		"Rank": 41,
		"Item": "NFT People #0870",
		"Score": 57
	  },
	  {
		"Index": 1911,
		"Rank": 41,
		"Item": "NFT People #0888",
		"Score": 57
	  },
	  {
		"Index": 1912,
		"Rank": 41,
		"Item": "NFT People #0933",
		"Score": 57
	  },
	  {
		"Index": 1913,
		"Rank": 41,
		"Item": "NFT People #0953",
		"Score": 57
	  },
	  {
		"Index": 1914,
		"Rank": 41,
		"Item": "NFT People #0954",
		"Score": 57
	  },
	  {
		"Index": 1915,
		"Rank": 41,
		"Item": "NFT People #1034",
		"Score": 57
	  },
	  {
		"Index": 1916,
		"Rank": 41,
		"Item": "NFT People #1054",
		"Score": 57
	  },
	  {
		"Index": 1917,
		"Rank": 41,
		"Item": "NFT People #1077",
		"Score": 57
	  },
	  {
		"Index": 1918,
		"Rank": 41,
		"Item": "NFT People #1082",
		"Score": 57
	  },
	  {
		"Index": 1919,
		"Rank": 41,
		"Item": "NFT People #1186",
		"Score": 57
	  },
	  {
		"Index": 1920,
		"Rank": 41,
		"Item": "NFT People #1269",
		"Score": 57
	  },
	  {
		"Index": 1921,
		"Rank": 41,
		"Item": "NFT People #1398",
		"Score": 57
	  },
	  {
		"Index": 1922,
		"Rank": 41,
		"Item": "NFT People #1451",
		"Score": 57
	  },
	  {
		"Index": 1923,
		"Rank": 41,
		"Item": "NFT People #1463",
		"Score": 57
	  },
	  {
		"Index": 1924,
		"Rank": 41,
		"Item": "NFT People #1467",
		"Score": 57
	  },
	  {
		"Index": 1925,
		"Rank": 41,
		"Item": "NFT People #1532",
		"Score": 57
	  },
	  {
		"Index": 1926,
		"Rank": 41,
		"Item": "NFT People #1555",
		"Score": 57
	  },
	  {
		"Index": 1927,
		"Rank": 41,
		"Item": "NFT People #1568",
		"Score": 57
	  },
	  {
		"Index": 1928,
		"Rank": 41,
		"Item": "NFT People #1682",
		"Score": 57
	  },
	  {
		"Index": 1929,
		"Rank": 41,
		"Item": "NFT People #1797",
		"Score": 57
	  },
	  {
		"Index": 1930,
		"Rank": 41,
		"Item": "NFT People #1813",
		"Score": 57
	  },
	  {
		"Index": 1931,
		"Rank": 41,
		"Item": "NFT People #1832",
		"Score": 57
	  },
	  {
		"Index": 1932,
		"Rank": 41,
		"Item": "NFT People #1846",
		"Score": 57
	  },
	  {
		"Index": 1933,
		"Rank": 41,
		"Item": "NFT People #1855",
		"Score": 57
	  },
	  {
		"Index": 1934,
		"Rank": 41,
		"Item": "NFT People #1875",
		"Score": 57
	  },
	  {
		"Index": 1935,
		"Rank": 41,
		"Item": "NFT People #1950",
		"Score": 57
	  },
	  {
		"Index": 1936,
		"Rank": 41,
		"Item": "NFT People #1972",
		"Score": 57
	  },
	  {
		"Index": 1937,
		"Rank": 41,
		"Item": "NFT People #2039",
		"Score": 57
	  },
	  {
		"Index": 1938,
		"Rank": 41,
		"Item": "NFT People #2042",
		"Score": 57
	  },
	  {
		"Index": 1939,
		"Rank": 41,
		"Item": "NFT People #2054",
		"Score": 57
	  },
	  {
		"Index": 1940,
		"Rank": 41,
		"Item": "NFT People #2087",
		"Score": 57
	  },
	  {
		"Index": 1941,
		"Rank": 41,
		"Item": "NFT People #2125",
		"Score": 57
	  },
	  {
		"Index": 1942,
		"Rank": 41,
		"Item": "NFT People #2143",
		"Score": 57
	  },
	  {
		"Index": 1943,
		"Rank": 41,
		"Item": "NFT People #2167",
		"Score": 57
	  },
	  {
		"Index": 1944,
		"Rank": 41,
		"Item": "NFT People #2210",
		"Score": 57
	  },
	  {
		"Index": 1945,
		"Rank": 41,
		"Item": "NFT People #2244",
		"Score": 57
	  },
	  {
		"Index": 1946,
		"Rank": 41,
		"Item": "NFT People #2259",
		"Score": 57
	  },
	  {
		"Index": 1947,
		"Rank": 41,
		"Item": "NFT People #2302",
		"Score": 57
	  },
	  {
		"Index": 1948,
		"Rank": 41,
		"Item": "NFT People #2303",
		"Score": 57
	  },
	  {
		"Index": 1949,
		"Rank": 41,
		"Item": "NFT People #2307",
		"Score": 57
	  },
	  {
		"Index": 1950,
		"Rank": 41,
		"Item": "NFT People #2350",
		"Score": 57
	  },
	  {
		"Index": 1951,
		"Rank": 41,
		"Item": "NFT People #2369",
		"Score": 57
	  },
	  {
		"Index": 1952,
		"Rank": 41,
		"Item": "NFT People #2385",
		"Score": 57
	  },
	  {
		"Index": 1953,
		"Rank": 41,
		"Item": "NFT People #2386",
		"Score": 57
	  },
	  {
		"Index": 1954,
		"Rank": 41,
		"Item": "NFT People #2398",
		"Score": 57
	  },
	  {
		"Index": 1955,
		"Rank": 41,
		"Item": "NFT People #2482",
		"Score": 57
	  },
	  {
		"Index": 1956,
		"Rank": 41,
		"Item": "NFT People #2513",
		"Score": 57
	  },
	  {
		"Index": 1957,
		"Rank": 41,
		"Item": "NFT People #2591",
		"Score": 57
	  },
	  {
		"Index": 1958,
		"Rank": 41,
		"Item": "NFT People #2624",
		"Score": 57
	  },
	  {
		"Index": 1959,
		"Rank": 41,
		"Item": "NFT People #2644",
		"Score": 57
	  },
	  {
		"Index": 1960,
		"Rank": 41,
		"Item": "NFT People #2657",
		"Score": 57
	  },
	  {
		"Index": 1961,
		"Rank": 41,
		"Item": "NFT People #2666",
		"Score": 57
	  },
	  {
		"Index": 1962,
		"Rank": 41,
		"Item": "NFT People #2736",
		"Score": 57
	  },
	  {
		"Index": 1963,
		"Rank": 41,
		"Item": "NFT People #2741",
		"Score": 57
	  },
	  {
		"Index": 1964,
		"Rank": 41,
		"Item": "NFT People #2791",
		"Score": 57
	  },
	  {
		"Index": 1965,
		"Rank": 41,
		"Item": "NFT People #2827",
		"Score": 57
	  },
	  {
		"Index": 1966,
		"Rank": 41,
		"Item": "NFT People #2832",
		"Score": 57
	  },
	  {
		"Index": 1967,
		"Rank": 41,
		"Item": "NFT People #2880",
		"Score": 57
	  },
	  {
		"Index": 1968,
		"Rank": 41,
		"Item": "NFT People #2910",
		"Score": 57
	  },
	  {
		"Index": 1969,
		"Rank": 41,
		"Item": "NFT People #2968",
		"Score": 57
	  },
	  {
		"Index": 1970,
		"Rank": 41,
		"Item": "NFT People #3011",
		"Score": 57
	  },
	  {
		"Index": 1971,
		"Rank": 41,
		"Item": "NFT People #3035",
		"Score": 57
	  },
	  {
		"Index": 1972,
		"Rank": 41,
		"Item": "NFT People #3041",
		"Score": 57
	  },
	  {
		"Index": 1973,
		"Rank": 41,
		"Item": "NFT People #3043",
		"Score": 57
	  },
	  {
		"Index": 1974,
		"Rank": 41,
		"Item": "NFT People #3050",
		"Score": 57
	  },
	  {
		"Index": 1975,
		"Rank": 41,
		"Item": "NFT People #3121",
		"Score": 57
	  },
	  {
		"Index": 1976,
		"Rank": 41,
		"Item": "NFT People #3126",
		"Score": 57
	  },
	  {
		"Index": 1977,
		"Rank": 41,
		"Item": "NFT People #3176",
		"Score": 57
	  },
	  {
		"Index": 1978,
		"Rank": 41,
		"Item": "NFT People #3180",
		"Score": 57
	  },
	  {
		"Index": 1979,
		"Rank": 41,
		"Item": "NFT People #3249",
		"Score": 57
	  },
	  {
		"Index": 1980,
		"Rank": 41,
		"Item": "NFT People #3272",
		"Score": 57
	  },
	  {
		"Index": 1981,
		"Rank": 41,
		"Item": "NFT People #3321",
		"Score": 57
	  },
	  {
		"Index": 1982,
		"Rank": 41,
		"Item": "NFT People #3349",
		"Score": 57
	  },
	  {
		"Index": 1983,
		"Rank": 41,
		"Item": "NFT People #3396",
		"Score": 57
	  },
	  {
		"Index": 1984,
		"Rank": 41,
		"Item": "NFT People #3397",
		"Score": 57
	  },
	  {
		"Index": 1985,
		"Rank": 41,
		"Item": "NFT People #3400",
		"Score": 57
	  },
	  {
		"Index": 1986,
		"Rank": 41,
		"Item": "NFT People #3462",
		"Score": 57
	  },
	  {
		"Index": 1987,
		"Rank": 41,
		"Item": "NFT People #3478",
		"Score": 57
	  },
	  {
		"Index": 1988,
		"Rank": 41,
		"Item": "NFT People #3577",
		"Score": 57
	  },
	  {
		"Index": 1989,
		"Rank": 41,
		"Item": "NFT People #3598",
		"Score": 57
	  },
	  {
		"Index": 1990,
		"Rank": 41,
		"Item": "NFT People #3607",
		"Score": 57
	  },
	  {
		"Index": 1991,
		"Rank": 41,
		"Item": "NFT People #3674",
		"Score": 57
	  },
	  {
		"Index": 1992,
		"Rank": 41,
		"Item": "NFT People #3693",
		"Score": 57
	  },
	  {
		"Index": 1993,
		"Rank": 41,
		"Item": "NFT People #3698",
		"Score": 57
	  },
	  {
		"Index": 1994,
		"Rank": 41,
		"Item": "NFT People #3710",
		"Score": 57
	  },
	  {
		"Index": 1995,
		"Rank": 41,
		"Item": "NFT People #3713",
		"Score": 57
	  },
	  {
		"Index": 1996,
		"Rank": 41,
		"Item": "NFT People #3725",
		"Score": 57
	  },
	  {
		"Index": 1997,
		"Rank": 41,
		"Item": "NFT People #3819",
		"Score": 57
	  },
	  {
		"Index": 1998,
		"Rank": 41,
		"Item": "NFT People #3826",
		"Score": 57
	  },
	  {
		"Index": 1999,
		"Rank": 41,
		"Item": "NFT People #3832",
		"Score": 57
	  },
	  {
		"Index": 2000,
		"Rank": 41,
		"Item": "NFT People #3837",
		"Score": 57
	  },
	  {
		"Index": 2001,
		"Rank": 41,
		"Item": "NFT People #3839",
		"Score": 57
	  },
	  {
		"Index": 2002,
		"Rank": 41,
		"Item": "NFT People #3851",
		"Score": 57
	  },
	  {
		"Index": 2003,
		"Rank": 41,
		"Item": "NFT People #3863",
		"Score": 57
	  },
	  {
		"Index": 2004,
		"Rank": 41,
		"Item": "NFT People #3912",
		"Score": 57
	  },
	  {
		"Index": 2005,
		"Rank": 41,
		"Item": "NFT People #3948",
		"Score": 57
	  },
	  {
		"Index": 2006,
		"Rank": 41,
		"Item": "NFT People #3951",
		"Score": 57
	  },
	  {
		"Index": 2007,
		"Rank": 41,
		"Item": "NFT People #3990",
		"Score": 57
	  },
	  {
		"Index": 2008,
		"Rank": 41,
		"Item": "NFT People #4010",
		"Score": 57
	  },
	  {
		"Index": 2009,
		"Rank": 41,
		"Item": "NFT People #4019",
		"Score": 57
	  },
	  {
		"Index": 2010,
		"Rank": 41,
		"Item": "NFT People #4039",
		"Score": 57
	  },
	  {
		"Index": 2011,
		"Rank": 41,
		"Item": "NFT People #4057",
		"Score": 57
	  },
	  {
		"Index": 2012,
		"Rank": 41,
		"Item": "NFT People #4065",
		"Score": 57
	  },
	  {
		"Index": 2013,
		"Rank": 41,
		"Item": "NFT People #4139",
		"Score": 57
	  },
	  {
		"Index": 2014,
		"Rank": 41,
		"Item": "NFT People #4223",
		"Score": 57
	  },
	  {
		"Index": 2015,
		"Rank": 41,
		"Item": "NFT People #4246",
		"Score": 57
	  },
	  {
		"Index": 2016,
		"Rank": 41,
		"Item": "NFT People #4274",
		"Score": 57
	  },
	  {
		"Index": 2017,
		"Rank": 41,
		"Item": "NFT People #4285",
		"Score": 57
	  },
	  {
		"Index": 2018,
		"Rank": 41,
		"Item": "NFT People #4330",
		"Score": 57
	  },
	  {
		"Index": 2019,
		"Rank": 41,
		"Item": "NFT People #4362",
		"Score": 57
	  },
	  {
		"Index": 2020,
		"Rank": 41,
		"Item": "NFT People #4462",
		"Score": 57
	  },
	  {
		"Index": 2021,
		"Rank": 41,
		"Item": "NFT People #4465",
		"Score": 57
	  },
	  {
		"Index": 2022,
		"Rank": 41,
		"Item": "NFT People #4574",
		"Score": 57
	  },
	  {
		"Index": 2023,
		"Rank": 41,
		"Item": "NFT People #4578",
		"Score": 57
	  },
	  {
		"Index": 2024,
		"Rank": 41,
		"Item": "NFT People #4591",
		"Score": 57
	  },
	  {
		"Index": 2025,
		"Rank": 41,
		"Item": "NFT People #4673",
		"Score": 57
	  },
	  {
		"Index": 2026,
		"Rank": 41,
		"Item": "NFT People #4675",
		"Score": 57
	  },
	  {
		"Index": 2027,
		"Rank": 41,
		"Item": "NFT People #4679",
		"Score": 57
	  },
	  {
		"Index": 2028,
		"Rank": 41,
		"Item": "NFT People #4692",
		"Score": 57
	  },
	  {
		"Index": 2029,
		"Rank": 41,
		"Item": "NFT People #4711",
		"Score": 57
	  },
	  {
		"Index": 2030,
		"Rank": 41,
		"Item": "NFT People #4807",
		"Score": 57
	  },
	  {
		"Index": 2031,
		"Rank": 41,
		"Item": "NFT People #4831",
		"Score": 57
	  },
	  {
		"Index": 2032,
		"Rank": 41,
		"Item": "NFT People #4854",
		"Score": 57
	  },
	  {
		"Index": 2033,
		"Rank": 41,
		"Item": "NFT People #4883",
		"Score": 57
	  },
	  {
		"Index": 2034,
		"Rank": 41,
		"Item": "NFT People #4892",
		"Score": 57
	  },
	  {
		"Index": 2035,
		"Rank": 41,
		"Item": "NFT People #4954",
		"Score": 57
	  },
	  {
		"Index": 2036,
		"Rank": 41,
		"Item": "NFT People #4978",
		"Score": 57
	  },
	  {
		"Index": 2037,
		"Rank": 41,
		"Item": "NFT People #4992",
		"Score": 57
	  },
	  {
		"Index": 2038,
		"Rank": 42,
		"Item": "NFT People #0099",
		"Score": 56
	  },
	  {
		"Index": 2039,
		"Rank": 42,
		"Item": "NFT People #0144",
		"Score": 56
	  },
	  {
		"Index": 2040,
		"Rank": 42,
		"Item": "NFT People #0178",
		"Score": 56
	  },
	  {
		"Index": 2041,
		"Rank": 42,
		"Item": "NFT People #0184",
		"Score": 56
	  },
	  {
		"Index": 2042,
		"Rank": 42,
		"Item": "NFT People #0209",
		"Score": 56
	  },
	  {
		"Index": 2043,
		"Rank": 42,
		"Item": "NFT People #0237",
		"Score": 56
	  },
	  {
		"Index": 2044,
		"Rank": 42,
		"Item": "NFT People #0271",
		"Score": 56
	  },
	  {
		"Index": 2045,
		"Rank": 42,
		"Item": "NFT People #0316",
		"Score": 56
	  },
	  {
		"Index": 2046,
		"Rank": 42,
		"Item": "NFT People #0389",
		"Score": 56
	  },
	  {
		"Index": 2047,
		"Rank": 42,
		"Item": "NFT People #0483",
		"Score": 56
	  },
	  {
		"Index": 2048,
		"Rank": 42,
		"Item": "NFT People #0506",
		"Score": 56
	  },
	  {
		"Index": 2049,
		"Rank": 42,
		"Item": "NFT People #0633",
		"Score": 56
	  },
	  {
		"Index": 2050,
		"Rank": 42,
		"Item": "NFT People #0672",
		"Score": 56
	  },
	  {
		"Index": 2051,
		"Rank": 42,
		"Item": "NFT People #0762",
		"Score": 56
	  },
	  {
		"Index": 2052,
		"Rank": 42,
		"Item": "NFT People #0769",
		"Score": 56
	  },
	  {
		"Index": 2053,
		"Rank": 42,
		"Item": "NFT People #0785",
		"Score": 56
	  },
	  {
		"Index": 2054,
		"Rank": 42,
		"Item": "NFT People #0856",
		"Score": 56
	  },
	  {
		"Index": 2055,
		"Rank": 42,
		"Item": "NFT People #0920",
		"Score": 56
	  },
	  {
		"Index": 2056,
		"Rank": 42,
		"Item": "NFT People #1170",
		"Score": 56
	  },
	  {
		"Index": 2057,
		"Rank": 42,
		"Item": "NFT People #1228",
		"Score": 56
	  },
	  {
		"Index": 2058,
		"Rank": 42,
		"Item": "NFT People #1383",
		"Score": 56
	  },
	  {
		"Index": 2059,
		"Rank": 42,
		"Item": "NFT People #1429",
		"Score": 56
	  },
	  {
		"Index": 2060,
		"Rank": 42,
		"Item": "NFT People #1540",
		"Score": 56
	  },
	  {
		"Index": 2061,
		"Rank": 42,
		"Item": "NFT People #1637",
		"Score": 56
	  },
	  {
		"Index": 2062,
		"Rank": 42,
		"Item": "NFT People #1680",
		"Score": 56
	  },
	  {
		"Index": 2063,
		"Rank": 42,
		"Item": "NFT People #1692",
		"Score": 56
	  },
	  {
		"Index": 2064,
		"Rank": 42,
		"Item": "NFT People #1721",
		"Score": 56
	  },
	  {
		"Index": 2065,
		"Rank": 42,
		"Item": "NFT People #1840",
		"Score": 56
	  },
	  {
		"Index": 2066,
		"Rank": 42,
		"Item": "NFT People #1981",
		"Score": 56
	  },
	  {
		"Index": 2067,
		"Rank": 42,
		"Item": "NFT People #1985",
		"Score": 56
	  },
	  {
		"Index": 2068,
		"Rank": 42,
		"Item": "NFT People #2206",
		"Score": 56
	  },
	  {
		"Index": 2069,
		"Rank": 42,
		"Item": "NFT People #2318",
		"Score": 56
	  },
	  {
		"Index": 2070,
		"Rank": 42,
		"Item": "NFT People #2371",
		"Score": 56
	  },
	  {
		"Index": 2071,
		"Rank": 42,
		"Item": "NFT People #2377",
		"Score": 56
	  },
	  {
		"Index": 2072,
		"Rank": 42,
		"Item": "NFT People #2379",
		"Score": 56
	  },
	  {
		"Index": 2073,
		"Rank": 42,
		"Item": "NFT People #2435",
		"Score": 56
	  },
	  {
		"Index": 2074,
		"Rank": 42,
		"Item": "NFT People #2504",
		"Score": 56
	  },
	  {
		"Index": 2075,
		"Rank": 42,
		"Item": "NFT People #2614",
		"Score": 56
	  },
	  {
		"Index": 2076,
		"Rank": 42,
		"Item": "NFT People #2636",
		"Score": 56
	  },
	  {
		"Index": 2077,
		"Rank": 42,
		"Item": "NFT People #2648",
		"Score": 56
	  },
	  {
		"Index": 2078,
		"Rank": 42,
		"Item": "NFT People #2650",
		"Score": 56
	  },
	  {
		"Index": 2079,
		"Rank": 42,
		"Item": "NFT People #2655",
		"Score": 56
	  },
	  {
		"Index": 2080,
		"Rank": 42,
		"Item": "NFT People #2683",
		"Score": 56
	  },
	  {
		"Index": 2081,
		"Rank": 42,
		"Item": "NFT People #2813",
		"Score": 56
	  },
	  {
		"Index": 2082,
		"Rank": 42,
		"Item": "NFT People #2819",
		"Score": 56
	  },
	  {
		"Index": 2083,
		"Rank": 42,
		"Item": "NFT People #2843",
		"Score": 56
	  },
	  {
		"Index": 2084,
		"Rank": 42,
		"Item": "NFT People #2859",
		"Score": 56
	  },
	  {
		"Index": 2085,
		"Rank": 42,
		"Item": "NFT People #2994",
		"Score": 56
	  },
	  {
		"Index": 2086,
		"Rank": 42,
		"Item": "NFT People #2997",
		"Score": 56
	  },
	  {
		"Index": 2087,
		"Rank": 42,
		"Item": "NFT People #3099",
		"Score": 56
	  },
	  {
		"Index": 2088,
		"Rank": 42,
		"Item": "NFT People #3104",
		"Score": 56
	  },
	  {
		"Index": 2089,
		"Rank": 42,
		"Item": "NFT People #3134",
		"Score": 56
	  },
	  {
		"Index": 2090,
		"Rank": 42,
		"Item": "NFT People #3154",
		"Score": 56
	  },
	  {
		"Index": 2091,
		"Rank": 42,
		"Item": "NFT People #3182",
		"Score": 56
	  },
	  {
		"Index": 2092,
		"Rank": 42,
		"Item": "NFT People #3209",
		"Score": 56
	  },
	  {
		"Index": 2093,
		"Rank": 42,
		"Item": "NFT People #3271",
		"Score": 56
	  },
	  {
		"Index": 2094,
		"Rank": 42,
		"Item": "NFT People #3276",
		"Score": 56
	  },
	  {
		"Index": 2095,
		"Rank": 42,
		"Item": "NFT People #3337",
		"Score": 56
	  },
	  {
		"Index": 2096,
		"Rank": 42,
		"Item": "NFT People #3370",
		"Score": 56
	  },
	  {
		"Index": 2097,
		"Rank": 42,
		"Item": "NFT People #3373",
		"Score": 56
	  },
	  {
		"Index": 2098,
		"Rank": 42,
		"Item": "NFT People #3402",
		"Score": 56
	  },
	  {
		"Index": 2099,
		"Rank": 42,
		"Item": "NFT People #3440",
		"Score": 56
	  },
	  {
		"Index": 2100,
		"Rank": 42,
		"Item": "NFT People #3446",
		"Score": 56
	  },
	  {
		"Index": 2101,
		"Rank": 42,
		"Item": "NFT People #3456",
		"Score": 56
	  },
	  {
		"Index": 2102,
		"Rank": 42,
		"Item": "NFT People #3479",
		"Score": 56
	  },
	  {
		"Index": 2103,
		"Rank": 42,
		"Item": "NFT People #3484",
		"Score": 56
	  },
	  {
		"Index": 2104,
		"Rank": 42,
		"Item": "NFT People #3503",
		"Score": 56
	  },
	  {
		"Index": 2105,
		"Rank": 42,
		"Item": "NFT People #3519",
		"Score": 56
	  },
	  {
		"Index": 2106,
		"Rank": 42,
		"Item": "NFT People #3541",
		"Score": 56
	  },
	  {
		"Index": 2107,
		"Rank": 42,
		"Item": "NFT People #3579",
		"Score": 56
	  },
	  {
		"Index": 2108,
		"Rank": 42,
		"Item": "NFT People #3653",
		"Score": 56
	  },
	  {
		"Index": 2109,
		"Rank": 42,
		"Item": "NFT People #3679",
		"Score": 56
	  },
	  {
		"Index": 2110,
		"Rank": 42,
		"Item": "NFT People #3784",
		"Score": 56
	  },
	  {
		"Index": 2111,
		"Rank": 42,
		"Item": "NFT People #3812",
		"Score": 56
	  },
	  {
		"Index": 2112,
		"Rank": 42,
		"Item": "NFT People #3856",
		"Score": 56
	  },
	  {
		"Index": 2113,
		"Rank": 42,
		"Item": "NFT People #3885",
		"Score": 56
	  },
	  {
		"Index": 2114,
		"Rank": 42,
		"Item": "NFT People #3950",
		"Score": 56
	  },
	  {
		"Index": 2115,
		"Rank": 42,
		"Item": "NFT People #3965",
		"Score": 56
	  },
	  {
		"Index": 2116,
		"Rank": 42,
		"Item": "NFT People #4003",
		"Score": 56
	  },
	  {
		"Index": 2117,
		"Rank": 42,
		"Item": "NFT People #4124",
		"Score": 56
	  },
	  {
		"Index": 2118,
		"Rank": 42,
		"Item": "NFT People #4137",
		"Score": 56
	  },
	  {
		"Index": 2119,
		"Rank": 42,
		"Item": "NFT People #4140",
		"Score": 56
	  },
	  {
		"Index": 2120,
		"Rank": 42,
		"Item": "NFT People #4268",
		"Score": 56
	  },
	  {
		"Index": 2121,
		"Rank": 42,
		"Item": "NFT People #4283",
		"Score": 56
	  },
	  {
		"Index": 2122,
		"Rank": 42,
		"Item": "NFT People #4357",
		"Score": 56
	  },
	  {
		"Index": 2123,
		"Rank": 42,
		"Item": "NFT People #4410",
		"Score": 56
	  },
	  {
		"Index": 2124,
		"Rank": 42,
		"Item": "NFT People #4438",
		"Score": 56
	  },
	  {
		"Index": 2125,
		"Rank": 42,
		"Item": "NFT People #4444",
		"Score": 56
	  },
	  {
		"Index": 2126,
		"Rank": 42,
		"Item": "NFT People #4587",
		"Score": 56
	  },
	  {
		"Index": 2127,
		"Rank": 42,
		"Item": "NFT People #4628",
		"Score": 56
	  },
	  {
		"Index": 2128,
		"Rank": 42,
		"Item": "NFT People #4700",
		"Score": 56
	  },
	  {
		"Index": 2129,
		"Rank": 42,
		"Item": "NFT People #4729",
		"Score": 56
	  },
	  {
		"Index": 2130,
		"Rank": 42,
		"Item": "NFT People #4763",
		"Score": 56
	  },
	  {
		"Index": 2131,
		"Rank": 43,
		"Item": "NFT People #0030",
		"Score": 55
	  },
	  {
		"Index": 2132,
		"Rank": 43,
		"Item": "NFT People #0062",
		"Score": 55
	  },
	  {
		"Index": 2133,
		"Rank": 43,
		"Item": "NFT People #0089",
		"Score": 55
	  },
	  {
		"Index": 2134,
		"Rank": 43,
		"Item": "NFT People #0103",
		"Score": 55
	  },
	  {
		"Index": 2135,
		"Rank": 43,
		"Item": "NFT People #0121",
		"Score": 55
	  },
	  {
		"Index": 2136,
		"Rank": 43,
		"Item": "NFT People #0204",
		"Score": 55
	  },
	  {
		"Index": 2137,
		"Rank": 43,
		"Item": "NFT People #0228",
		"Score": 55
	  },
	  {
		"Index": 2138,
		"Rank": 43,
		"Item": "NFT People #0251",
		"Score": 55
	  },
	  {
		"Index": 2139,
		"Rank": 43,
		"Item": "NFT People #0298",
		"Score": 55
	  },
	  {
		"Index": 2140,
		"Rank": 43,
		"Item": "NFT People #0308",
		"Score": 55
	  },
	  {
		"Index": 2141,
		"Rank": 43,
		"Item": "NFT People #0319",
		"Score": 55
	  },
	  {
		"Index": 2142,
		"Rank": 43,
		"Item": "NFT People #0326",
		"Score": 55
	  },
	  {
		"Index": 2143,
		"Rank": 43,
		"Item": "NFT People #0328",
		"Score": 55
	  },
	  {
		"Index": 2144,
		"Rank": 43,
		"Item": "NFT People #0334",
		"Score": 55
	  },
	  {
		"Index": 2145,
		"Rank": 43,
		"Item": "NFT People #0344",
		"Score": 55
	  },
	  {
		"Index": 2146,
		"Rank": 43,
		"Item": "NFT People #0393",
		"Score": 55
	  },
	  {
		"Index": 2147,
		"Rank": 43,
		"Item": "NFT People #0460",
		"Score": 55
	  },
	  {
		"Index": 2148,
		"Rank": 43,
		"Item": "NFT People #0477",
		"Score": 55
	  },
	  {
		"Index": 2149,
		"Rank": 43,
		"Item": "NFT People #0484",
		"Score": 55
	  },
	  {
		"Index": 2150,
		"Rank": 43,
		"Item": "NFT People #0485",
		"Score": 55
	  },
	  {
		"Index": 2151,
		"Rank": 43,
		"Item": "NFT People #0486",
		"Score": 55
	  },
	  {
		"Index": 2152,
		"Rank": 43,
		"Item": "NFT People #0504",
		"Score": 55
	  },
	  {
		"Index": 2153,
		"Rank": 43,
		"Item": "NFT People #0554",
		"Score": 55
	  },
	  {
		"Index": 2154,
		"Rank": 43,
		"Item": "NFT People #0562",
		"Score": 55
	  },
	  {
		"Index": 2155,
		"Rank": 43,
		"Item": "NFT People #0570",
		"Score": 55
	  },
	  {
		"Index": 2156,
		"Rank": 43,
		"Item": "NFT People #0588",
		"Score": 55
	  },
	  {
		"Index": 2157,
		"Rank": 43,
		"Item": "NFT People #0629",
		"Score": 55
	  },
	  {
		"Index": 2158,
		"Rank": 43,
		"Item": "NFT People #0716",
		"Score": 55
	  },
	  {
		"Index": 2159,
		"Rank": 43,
		"Item": "NFT People #0728",
		"Score": 55
	  },
	  {
		"Index": 2160,
		"Rank": 43,
		"Item": "NFT People #0731",
		"Score": 55
	  },
	  {
		"Index": 2161,
		"Rank": 43,
		"Item": "NFT People #0740",
		"Score": 55
	  },
	  {
		"Index": 2162,
		"Rank": 43,
		"Item": "NFT People #0742",
		"Score": 55
	  },
	  {
		"Index": 2163,
		"Rank": 43,
		"Item": "NFT People #0758",
		"Score": 55
	  },
	  {
		"Index": 2164,
		"Rank": 43,
		"Item": "NFT People #0763",
		"Score": 55
	  },
	  {
		"Index": 2165,
		"Rank": 43,
		"Item": "NFT People #0803",
		"Score": 55
	  },
	  {
		"Index": 2166,
		"Rank": 43,
		"Item": "NFT People #0805",
		"Score": 55
	  },
	  {
		"Index": 2167,
		"Rank": 43,
		"Item": "NFT People #0963",
		"Score": 55
	  },
	  {
		"Index": 2168,
		"Rank": 43,
		"Item": "NFT People #1028",
		"Score": 55
	  },
	  {
		"Index": 2169,
		"Rank": 43,
		"Item": "NFT People #1041",
		"Score": 55
	  },
	  {
		"Index": 2170,
		"Rank": 43,
		"Item": "NFT People #1045",
		"Score": 55
	  },
	  {
		"Index": 2171,
		"Rank": 43,
		"Item": "NFT People #1071",
		"Score": 55
	  },
	  {
		"Index": 2172,
		"Rank": 43,
		"Item": "NFT People #1131",
		"Score": 55
	  },
	  {
		"Index": 2173,
		"Rank": 43,
		"Item": "NFT People #1146",
		"Score": 55
	  },
	  {
		"Index": 2174,
		"Rank": 43,
		"Item": "NFT People #1147",
		"Score": 55
	  },
	  {
		"Index": 2175,
		"Rank": 43,
		"Item": "NFT People #1175",
		"Score": 55
	  },
	  {
		"Index": 2176,
		"Rank": 43,
		"Item": "NFT People #1183",
		"Score": 55
	  },
	  {
		"Index": 2177,
		"Rank": 43,
		"Item": "NFT People #1185",
		"Score": 55
	  },
	  {
		"Index": 2178,
		"Rank": 43,
		"Item": "NFT People #1205",
		"Score": 55
	  },
	  {
		"Index": 2179,
		"Rank": 43,
		"Item": "NFT People #1256",
		"Score": 55
	  },
	  {
		"Index": 2180,
		"Rank": 43,
		"Item": "NFT People #1293",
		"Score": 55
	  },
	  {
		"Index": 2181,
		"Rank": 43,
		"Item": "NFT People #1303",
		"Score": 55
	  },
	  {
		"Index": 2182,
		"Rank": 43,
		"Item": "NFT People #1313",
		"Score": 55
	  },
	  {
		"Index": 2183,
		"Rank": 43,
		"Item": "NFT People #1316",
		"Score": 55
	  },
	  {
		"Index": 2184,
		"Rank": 43,
		"Item": "NFT People #1367",
		"Score": 55
	  },
	  {
		"Index": 2185,
		"Rank": 43,
		"Item": "NFT People #1423",
		"Score": 55
	  },
	  {
		"Index": 2186,
		"Rank": 43,
		"Item": "NFT People #1494",
		"Score": 55
	  },
	  {
		"Index": 2187,
		"Rank": 43,
		"Item": "NFT People #1538",
		"Score": 55
	  },
	  {
		"Index": 2188,
		"Rank": 43,
		"Item": "NFT People #1539",
		"Score": 55
	  },
	  {
		"Index": 2189,
		"Rank": 43,
		"Item": "NFT People #1552",
		"Score": 55
	  },
	  {
		"Index": 2190,
		"Rank": 43,
		"Item": "NFT People #1620",
		"Score": 55
	  },
	  {
		"Index": 2191,
		"Rank": 43,
		"Item": "NFT People #1645",
		"Score": 55
	  },
	  {
		"Index": 2192,
		"Rank": 43,
		"Item": "NFT People #1660",
		"Score": 55
	  },
	  {
		"Index": 2193,
		"Rank": 43,
		"Item": "NFT People #1699",
		"Score": 55
	  },
	  {
		"Index": 2194,
		"Rank": 43,
		"Item": "NFT People #1711",
		"Score": 55
	  },
	  {
		"Index": 2195,
		"Rank": 43,
		"Item": "NFT People #1717",
		"Score": 55
	  },
	  {
		"Index": 2196,
		"Rank": 43,
		"Item": "NFT People #1755",
		"Score": 55
	  },
	  {
		"Index": 2197,
		"Rank": 43,
		"Item": "NFT People #1785",
		"Score": 55
	  },
	  {
		"Index": 2198,
		"Rank": 43,
		"Item": "NFT People #1799",
		"Score": 55
	  },
	  {
		"Index": 2199,
		"Rank": 43,
		"Item": "NFT People #1820",
		"Score": 55
	  },
	  {
		"Index": 2200,
		"Rank": 43,
		"Item": "NFT People #1838",
		"Score": 55
	  },
	  {
		"Index": 2201,
		"Rank": 43,
		"Item": "NFT People #1864",
		"Score": 55
	  },
	  {
		"Index": 2202,
		"Rank": 43,
		"Item": "NFT People #1938",
		"Score": 55
	  },
	  {
		"Index": 2203,
		"Rank": 43,
		"Item": "NFT People #1961",
		"Score": 55
	  },
	  {
		"Index": 2204,
		"Rank": 43,
		"Item": "NFT People #2014",
		"Score": 55
	  },
	  {
		"Index": 2205,
		"Rank": 43,
		"Item": "NFT People #2053",
		"Score": 55
	  },
	  {
		"Index": 2206,
		"Rank": 43,
		"Item": "NFT People #2061",
		"Score": 55
	  },
	  {
		"Index": 2207,
		"Rank": 43,
		"Item": "NFT People #2095",
		"Score": 55
	  },
	  {
		"Index": 2208,
		"Rank": 43,
		"Item": "NFT People #2124",
		"Score": 55
	  },
	  {
		"Index": 2209,
		"Rank": 43,
		"Item": "NFT People #2149",
		"Score": 55
	  },
	  {
		"Index": 2210,
		"Rank": 43,
		"Item": "NFT People #2155",
		"Score": 55
	  },
	  {
		"Index": 2211,
		"Rank": 43,
		"Item": "NFT People #2157",
		"Score": 55
	  },
	  {
		"Index": 2212,
		"Rank": 43,
		"Item": "NFT People #2180",
		"Score": 55
	  },
	  {
		"Index": 2213,
		"Rank": 43,
		"Item": "NFT People #2181",
		"Score": 55
	  },
	  {
		"Index": 2214,
		"Rank": 43,
		"Item": "NFT People #2200",
		"Score": 55
	  },
	  {
		"Index": 2215,
		"Rank": 43,
		"Item": "NFT People #2263",
		"Score": 55
	  },
	  {
		"Index": 2216,
		"Rank": 43,
		"Item": "NFT People #2334",
		"Score": 55
	  },
	  {
		"Index": 2217,
		"Rank": 43,
		"Item": "NFT People #2344",
		"Score": 55
	  },
	  {
		"Index": 2218,
		"Rank": 43,
		"Item": "NFT People #2383",
		"Score": 55
	  },
	  {
		"Index": 2219,
		"Rank": 43,
		"Item": "NFT People #2393",
		"Score": 55
	  },
	  {
		"Index": 2220,
		"Rank": 43,
		"Item": "NFT People #2408",
		"Score": 55
	  },
	  {
		"Index": 2221,
		"Rank": 43,
		"Item": "NFT People #2410",
		"Score": 55
	  },
	  {
		"Index": 2222,
		"Rank": 43,
		"Item": "NFT People #2457",
		"Score": 55
	  },
	  {
		"Index": 2223,
		"Rank": 43,
		"Item": "NFT People #2464",
		"Score": 55
	  },
	  {
		"Index": 2224,
		"Rank": 43,
		"Item": "NFT People #2466",
		"Score": 55
	  },
	  {
		"Index": 2225,
		"Rank": 43,
		"Item": "NFT People #2485",
		"Score": 55
	  },
	  {
		"Index": 2226,
		"Rank": 43,
		"Item": "NFT People #2502",
		"Score": 55
	  },
	  {
		"Index": 2227,
		"Rank": 43,
		"Item": "NFT People #2511",
		"Score": 55
	  },
	  {
		"Index": 2228,
		"Rank": 43,
		"Item": "NFT People #2536",
		"Score": 55
	  },
	  {
		"Index": 2229,
		"Rank": 43,
		"Item": "NFT People #2556",
		"Score": 55
	  },
	  {
		"Index": 2230,
		"Rank": 43,
		"Item": "NFT People #2558",
		"Score": 55
	  },
	  {
		"Index": 2231,
		"Rank": 43,
		"Item": "NFT People #2572",
		"Score": 55
	  },
	  {
		"Index": 2232,
		"Rank": 43,
		"Item": "NFT People #2583",
		"Score": 55
	  },
	  {
		"Index": 2233,
		"Rank": 43,
		"Item": "NFT People #2625",
		"Score": 55
	  },
	  {
		"Index": 2234,
		"Rank": 43,
		"Item": "NFT People #2626",
		"Score": 55
	  },
	  {
		"Index": 2235,
		"Rank": 43,
		"Item": "NFT People #2654",
		"Score": 55
	  },
	  {
		"Index": 2236,
		"Rank": 43,
		"Item": "NFT People #2691",
		"Score": 55
	  },
	  {
		"Index": 2237,
		"Rank": 43,
		"Item": "NFT People #2703",
		"Score": 55
	  },
	  {
		"Index": 2238,
		"Rank": 43,
		"Item": "NFT People #2727",
		"Score": 55
	  },
	  {
		"Index": 2239,
		"Rank": 43,
		"Item": "NFT People #2732",
		"Score": 55
	  },
	  {
		"Index": 2240,
		"Rank": 43,
		"Item": "NFT People #2743",
		"Score": 55
	  },
	  {
		"Index": 2241,
		"Rank": 43,
		"Item": "NFT People #2753",
		"Score": 55
	  },
	  {
		"Index": 2242,
		"Rank": 43,
		"Item": "NFT People #2810",
		"Score": 55
	  },
	  {
		"Index": 2243,
		"Rank": 43,
		"Item": "NFT People #2817",
		"Score": 55
	  },
	  {
		"Index": 2244,
		"Rank": 43,
		"Item": "NFT People #2841",
		"Score": 55
	  },
	  {
		"Index": 2245,
		"Rank": 43,
		"Item": "NFT People #2934",
		"Score": 55
	  },
	  {
		"Index": 2246,
		"Rank": 43,
		"Item": "NFT People #2956",
		"Score": 55
	  },
	  {
		"Index": 2247,
		"Rank": 43,
		"Item": "NFT People #2959",
		"Score": 55
	  },
	  {
		"Index": 2248,
		"Rank": 43,
		"Item": "NFT People #2962",
		"Score": 55
	  },
	  {
		"Index": 2249,
		"Rank": 43,
		"Item": "NFT People #2996",
		"Score": 55
	  },
	  {
		"Index": 2250,
		"Rank": 43,
		"Item": "NFT People #3005",
		"Score": 55
	  },
	  {
		"Index": 2251,
		"Rank": 43,
		"Item": "NFT People #3009",
		"Score": 55
	  },
	  {
		"Index": 2252,
		"Rank": 43,
		"Item": "NFT People #3065",
		"Score": 55
	  },
	  {
		"Index": 2253,
		"Rank": 43,
		"Item": "NFT People #3122",
		"Score": 55
	  },
	  {
		"Index": 2254,
		"Rank": 43,
		"Item": "NFT People #3193",
		"Score": 55
	  },
	  {
		"Index": 2255,
		"Rank": 43,
		"Item": "NFT People #3215",
		"Score": 55
	  },
	  {
		"Index": 2256,
		"Rank": 43,
		"Item": "NFT People #3222",
		"Score": 55
	  },
	  {
		"Index": 2257,
		"Rank": 43,
		"Item": "NFT People #3303",
		"Score": 55
	  },
	  {
		"Index": 2258,
		"Rank": 43,
		"Item": "NFT People #3309",
		"Score": 55
	  },
	  {
		"Index": 2259,
		"Rank": 43,
		"Item": "NFT People #3333",
		"Score": 55
	  },
	  {
		"Index": 2260,
		"Rank": 43,
		"Item": "NFT People #3374",
		"Score": 55
	  },
	  {
		"Index": 2261,
		"Rank": 43,
		"Item": "NFT People #3492",
		"Score": 55
	  },
	  {
		"Index": 2262,
		"Rank": 43,
		"Item": "NFT People #3504",
		"Score": 55
	  },
	  {
		"Index": 2263,
		"Rank": 43,
		"Item": "NFT People #3669",
		"Score": 55
	  },
	  {
		"Index": 2264,
		"Rank": 43,
		"Item": "NFT People #3690",
		"Score": 55
	  },
	  {
		"Index": 2265,
		"Rank": 43,
		"Item": "NFT People #3694",
		"Score": 55
	  },
	  {
		"Index": 2266,
		"Rank": 43,
		"Item": "NFT People #3706",
		"Score": 55
	  },
	  {
		"Index": 2267,
		"Rank": 43,
		"Item": "NFT People #3718",
		"Score": 55
	  },
	  {
		"Index": 2268,
		"Rank": 43,
		"Item": "NFT People #3730",
		"Score": 55
	  },
	  {
		"Index": 2269,
		"Rank": 43,
		"Item": "NFT People #3752",
		"Score": 55
	  },
	  {
		"Index": 2270,
		"Rank": 43,
		"Item": "NFT People #3775",
		"Score": 55
	  },
	  {
		"Index": 2271,
		"Rank": 43,
		"Item": "NFT People #3792",
		"Score": 55
	  },
	  {
		"Index": 2272,
		"Rank": 43,
		"Item": "NFT People #3802",
		"Score": 55
	  },
	  {
		"Index": 2273,
		"Rank": 43,
		"Item": "NFT People #3840",
		"Score": 55
	  },
	  {
		"Index": 2274,
		"Rank": 43,
		"Item": "NFT People #3852",
		"Score": 55
	  },
	  {
		"Index": 2275,
		"Rank": 43,
		"Item": "NFT People #3858",
		"Score": 55
	  },
	  {
		"Index": 2276,
		"Rank": 43,
		"Item": "NFT People #3906",
		"Score": 55
	  },
	  {
		"Index": 2277,
		"Rank": 43,
		"Item": "NFT People #3928",
		"Score": 55
	  },
	  {
		"Index": 2278,
		"Rank": 43,
		"Item": "NFT People #3957",
		"Score": 55
	  },
	  {
		"Index": 2279,
		"Rank": 43,
		"Item": "NFT People #4020",
		"Score": 55
	  },
	  {
		"Index": 2280,
		"Rank": 43,
		"Item": "NFT People #4063",
		"Score": 55
	  },
	  {
		"Index": 2281,
		"Rank": 43,
		"Item": "NFT People #4070",
		"Score": 55
	  },
	  {
		"Index": 2282,
		"Rank": 43,
		"Item": "NFT People #4100",
		"Score": 55
	  },
	  {
		"Index": 2283,
		"Rank": 43,
		"Item": "NFT People #4135",
		"Score": 55
	  },
	  {
		"Index": 2284,
		"Rank": 43,
		"Item": "NFT People #4149",
		"Score": 55
	  },
	  {
		"Index": 2285,
		"Rank": 43,
		"Item": "NFT People #4158",
		"Score": 55
	  },
	  {
		"Index": 2286,
		"Rank": 43,
		"Item": "NFT People #4183",
		"Score": 55
	  },
	  {
		"Index": 2287,
		"Rank": 43,
		"Item": "NFT People #4281",
		"Score": 55
	  },
	  {
		"Index": 2288,
		"Rank": 43,
		"Item": "NFT People #4317",
		"Score": 55
	  },
	  {
		"Index": 2289,
		"Rank": 43,
		"Item": "NFT People #4332",
		"Score": 55
	  },
	  {
		"Index": 2290,
		"Rank": 43,
		"Item": "NFT People #4352",
		"Score": 55
	  },
	  {
		"Index": 2291,
		"Rank": 43,
		"Item": "NFT People #4396",
		"Score": 55
	  },
	  {
		"Index": 2292,
		"Rank": 43,
		"Item": "NFT People #4420",
		"Score": 55
	  },
	  {
		"Index": 2293,
		"Rank": 43,
		"Item": "NFT People #4423",
		"Score": 55
	  },
	  {
		"Index": 2294,
		"Rank": 43,
		"Item": "NFT People #4473",
		"Score": 55
	  },
	  {
		"Index": 2295,
		"Rank": 43,
		"Item": "NFT People #4517",
		"Score": 55
	  },
	  {
		"Index": 2296,
		"Rank": 43,
		"Item": "NFT People #4538",
		"Score": 55
	  },
	  {
		"Index": 2297,
		"Rank": 43,
		"Item": "NFT People #4546",
		"Score": 55
	  },
	  {
		"Index": 2298,
		"Rank": 43,
		"Item": "NFT People #4550",
		"Score": 55
	  },
	  {
		"Index": 2299,
		"Rank": 43,
		"Item": "NFT People #4555",
		"Score": 55
	  },
	  {
		"Index": 2300,
		"Rank": 43,
		"Item": "NFT People #4572",
		"Score": 55
	  },
	  {
		"Index": 2301,
		"Rank": 43,
		"Item": "NFT People #4699",
		"Score": 55
	  },
	  {
		"Index": 2302,
		"Rank": 43,
		"Item": "NFT People #4703",
		"Score": 55
	  },
	  {
		"Index": 2303,
		"Rank": 43,
		"Item": "NFT People #4776",
		"Score": 55
	  },
	  {
		"Index": 2304,
		"Rank": 43,
		"Item": "NFT People #4805",
		"Score": 55
	  },
	  {
		"Index": 2305,
		"Rank": 43,
		"Item": "NFT People #4810",
		"Score": 55
	  },
	  {
		"Index": 2306,
		"Rank": 43,
		"Item": "NFT People #4819",
		"Score": 55
	  },
	  {
		"Index": 2307,
		"Rank": 43,
		"Item": "NFT People #4865",
		"Score": 55
	  },
	  {
		"Index": 2308,
		"Rank": 43,
		"Item": "NFT People #4947",
		"Score": 55
	  },
	  {
		"Index": 2309,
		"Rank": 44,
		"Item": "NFT People #0031",
		"Score": 54
	  },
	  {
		"Index": 2310,
		"Rank": 44,
		"Item": "NFT People #0056",
		"Score": 54
	  },
	  {
		"Index": 2311,
		"Rank": 44,
		"Item": "NFT People #0077",
		"Score": 54
	  },
	  {
		"Index": 2312,
		"Rank": 44,
		"Item": "NFT People #0094",
		"Score": 54
	  },
	  {
		"Index": 2313,
		"Rank": 44,
		"Item": "NFT People #0105",
		"Score": 54
	  },
	  {
		"Index": 2314,
		"Rank": 44,
		"Item": "NFT People #0133",
		"Score": 54
	  },
	  {
		"Index": 2315,
		"Rank": 44,
		"Item": "NFT People #0140",
		"Score": 54
	  },
	  {
		"Index": 2316,
		"Rank": 44,
		"Item": "NFT People #0143",
		"Score": 54
	  },
	  {
		"Index": 2317,
		"Rank": 44,
		"Item": "NFT People #0187",
		"Score": 54
	  },
	  {
		"Index": 2318,
		"Rank": 44,
		"Item": "NFT People #0190",
		"Score": 54
	  },
	  {
		"Index": 2319,
		"Rank": 44,
		"Item": "NFT People #0202",
		"Score": 54
	  },
	  {
		"Index": 2320,
		"Rank": 44,
		"Item": "NFT People #0220",
		"Score": 54
	  },
	  {
		"Index": 2321,
		"Rank": 44,
		"Item": "NFT People #0232",
		"Score": 54
	  },
	  {
		"Index": 2322,
		"Rank": 44,
		"Item": "NFT People #0234",
		"Score": 54
	  },
	  {
		"Index": 2323,
		"Rank": 44,
		"Item": "NFT People #0235",
		"Score": 54
	  },
	  {
		"Index": 2324,
		"Rank": 44,
		"Item": "NFT People #0335",
		"Score": 54
	  },
	  {
		"Index": 2325,
		"Rank": 44,
		"Item": "NFT People #0366",
		"Score": 54
	  },
	  {
		"Index": 2326,
		"Rank": 44,
		"Item": "NFT People #0400",
		"Score": 54
	  },
	  {
		"Index": 2327,
		"Rank": 44,
		"Item": "NFT People #0401",
		"Score": 54
	  },
	  {
		"Index": 2328,
		"Rank": 44,
		"Item": "NFT People #0427",
		"Score": 54
	  },
	  {
		"Index": 2329,
		"Rank": 44,
		"Item": "NFT People #0478",
		"Score": 54
	  },
	  {
		"Index": 2330,
		"Rank": 44,
		"Item": "NFT People #0507",
		"Score": 54
	  },
	  {
		"Index": 2331,
		"Rank": 44,
		"Item": "NFT People #0538",
		"Score": 54
	  },
	  {
		"Index": 2332,
		"Rank": 44,
		"Item": "NFT People #0601",
		"Score": 54
	  },
	  {
		"Index": 2333,
		"Rank": 44,
		"Item": "NFT People #0642",
		"Score": 54
	  },
	  {
		"Index": 2334,
		"Rank": 44,
		"Item": "NFT People #0662",
		"Score": 54
	  },
	  {
		"Index": 2335,
		"Rank": 44,
		"Item": "NFT People #0689",
		"Score": 54
	  },
	  {
		"Index": 2336,
		"Rank": 44,
		"Item": "NFT People #0695",
		"Score": 54
	  },
	  {
		"Index": 2337,
		"Rank": 44,
		"Item": "NFT People #0696",
		"Score": 54
	  },
	  {
		"Index": 2338,
		"Rank": 44,
		"Item": "NFT People #0710",
		"Score": 54
	  },
	  {
		"Index": 2339,
		"Rank": 44,
		"Item": "NFT People #0804",
		"Score": 54
	  },
	  {
		"Index": 2340,
		"Rank": 44,
		"Item": "NFT People #0848",
		"Score": 54
	  },
	  {
		"Index": 2341,
		"Rank": 44,
		"Item": "NFT People #0857",
		"Score": 54
	  },
	  {
		"Index": 2342,
		"Rank": 44,
		"Item": "NFT People #0883",
		"Score": 54
	  },
	  {
		"Index": 2343,
		"Rank": 44,
		"Item": "NFT People #0912",
		"Score": 54
	  },
	  {
		"Index": 2344,
		"Rank": 44,
		"Item": "NFT People #0930",
		"Score": 54
	  },
	  {
		"Index": 2345,
		"Rank": 44,
		"Item": "NFT People #0932",
		"Score": 54
	  },
	  {
		"Index": 2346,
		"Rank": 44,
		"Item": "NFT People #0955",
		"Score": 54
	  },
	  {
		"Index": 2347,
		"Rank": 44,
		"Item": "NFT People #0959",
		"Score": 54
	  },
	  {
		"Index": 2348,
		"Rank": 44,
		"Item": "NFT People #1000",
		"Score": 54
	  },
	  {
		"Index": 2349,
		"Rank": 44,
		"Item": "NFT People #1005",
		"Score": 54
	  },
	  {
		"Index": 2350,
		"Rank": 44,
		"Item": "NFT People #1019",
		"Score": 54
	  },
	  {
		"Index": 2351,
		"Rank": 44,
		"Item": "NFT People #1068",
		"Score": 54
	  },
	  {
		"Index": 2352,
		"Rank": 44,
		"Item": "NFT People #1078",
		"Score": 54
	  },
	  {
		"Index": 2353,
		"Rank": 44,
		"Item": "NFT People #1083",
		"Score": 54
	  },
	  {
		"Index": 2354,
		"Rank": 44,
		"Item": "NFT People #1091",
		"Score": 54
	  },
	  {
		"Index": 2355,
		"Rank": 44,
		"Item": "NFT People #1092",
		"Score": 54
	  },
	  {
		"Index": 2356,
		"Rank": 44,
		"Item": "NFT People #1097",
		"Score": 54
	  },
	  {
		"Index": 2357,
		"Rank": 44,
		"Item": "NFT People #1101",
		"Score": 54
	  },
	  {
		"Index": 2358,
		"Rank": 44,
		"Item": "NFT People #1184",
		"Score": 54
	  },
	  {
		"Index": 2359,
		"Rank": 44,
		"Item": "NFT People #1220",
		"Score": 54
	  },
	  {
		"Index": 2360,
		"Rank": 44,
		"Item": "NFT People #1222",
		"Score": 54
	  },
	  {
		"Index": 2361,
		"Rank": 44,
		"Item": "NFT People #1245",
		"Score": 54
	  },
	  {
		"Index": 2362,
		"Rank": 44,
		"Item": "NFT People #1267",
		"Score": 54
	  },
	  {
		"Index": 2363,
		"Rank": 44,
		"Item": "NFT People #1274",
		"Score": 54
	  },
	  {
		"Index": 2364,
		"Rank": 44,
		"Item": "NFT People #1298",
		"Score": 54
	  },
	  {
		"Index": 2365,
		"Rank": 44,
		"Item": "NFT People #1326",
		"Score": 54
	  },
	  {
		"Index": 2366,
		"Rank": 44,
		"Item": "NFT People #1331",
		"Score": 54
	  },
	  {
		"Index": 2367,
		"Rank": 44,
		"Item": "NFT People #1363",
		"Score": 54
	  },
	  {
		"Index": 2368,
		"Rank": 44,
		"Item": "NFT People #1390",
		"Score": 54
	  },
	  {
		"Index": 2369,
		"Rank": 44,
		"Item": "NFT People #1473",
		"Score": 54
	  },
	  {
		"Index": 2370,
		"Rank": 44,
		"Item": "NFT People #1492",
		"Score": 54
	  },
	  {
		"Index": 2371,
		"Rank": 44,
		"Item": "NFT People #1516",
		"Score": 54
	  },
	  {
		"Index": 2372,
		"Rank": 44,
		"Item": "NFT People #1520",
		"Score": 54
	  },
	  {
		"Index": 2373,
		"Rank": 44,
		"Item": "NFT People #1546",
		"Score": 54
	  },
	  {
		"Index": 2374,
		"Rank": 44,
		"Item": "NFT People #1590",
		"Score": 54
	  },
	  {
		"Index": 2375,
		"Rank": 44,
		"Item": "NFT People #1593",
		"Score": 54
	  },
	  {
		"Index": 2376,
		"Rank": 44,
		"Item": "NFT People #1617",
		"Score": 54
	  },
	  {
		"Index": 2377,
		"Rank": 44,
		"Item": "NFT People #1691",
		"Score": 54
	  },
	  {
		"Index": 2378,
		"Rank": 44,
		"Item": "NFT People #1693",
		"Score": 54
	  },
	  {
		"Index": 2379,
		"Rank": 44,
		"Item": "NFT People #1718",
		"Score": 54
	  },
	  {
		"Index": 2380,
		"Rank": 44,
		"Item": "NFT People #1733",
		"Score": 54
	  },
	  {
		"Index": 2381,
		"Rank": 44,
		"Item": "NFT People #1815",
		"Score": 54
	  },
	  {
		"Index": 2382,
		"Rank": 44,
		"Item": "NFT People #1821",
		"Score": 54
	  },
	  {
		"Index": 2383,
		"Rank": 44,
		"Item": "NFT People #1898",
		"Score": 54
	  },
	  {
		"Index": 2384,
		"Rank": 44,
		"Item": "NFT People #1902",
		"Score": 54
	  },
	  {
		"Index": 2385,
		"Rank": 44,
		"Item": "NFT People #1948",
		"Score": 54
	  },
	  {
		"Index": 2386,
		"Rank": 44,
		"Item": "NFT People #1965",
		"Score": 54
	  },
	  {
		"Index": 2387,
		"Rank": 44,
		"Item": "NFT People #1967",
		"Score": 54
	  },
	  {
		"Index": 2388,
		"Rank": 44,
		"Item": "NFT People #1975",
		"Score": 54
	  },
	  {
		"Index": 2389,
		"Rank": 44,
		"Item": "NFT People #1977",
		"Score": 54
	  },
	  {
		"Index": 2390,
		"Rank": 44,
		"Item": "NFT People #2019",
		"Score": 54
	  },
	  {
		"Index": 2391,
		"Rank": 44,
		"Item": "NFT People #2043",
		"Score": 54
	  },
	  {
		"Index": 2392,
		"Rank": 44,
		"Item": "NFT People #2068",
		"Score": 54
	  },
	  {
		"Index": 2393,
		"Rank": 44,
		"Item": "NFT People #2075",
		"Score": 54
	  },
	  {
		"Index": 2394,
		"Rank": 44,
		"Item": "NFT People #2107",
		"Score": 54
	  },
	  {
		"Index": 2395,
		"Rank": 44,
		"Item": "NFT People #2119",
		"Score": 54
	  },
	  {
		"Index": 2396,
		"Rank": 44,
		"Item": "NFT People #2126",
		"Score": 54
	  },
	  {
		"Index": 2397,
		"Rank": 44,
		"Item": "NFT People #2207",
		"Score": 54
	  },
	  {
		"Index": 2398,
		"Rank": 44,
		"Item": "NFT People #2285",
		"Score": 54
	  },
	  {
		"Index": 2399,
		"Rank": 44,
		"Item": "NFT People #2290",
		"Score": 54
	  },
	  {
		"Index": 2400,
		"Rank": 44,
		"Item": "NFT People #2340",
		"Score": 54
	  },
	  {
		"Index": 2401,
		"Rank": 44,
		"Item": "NFT People #2345",
		"Score": 54
	  },
	  {
		"Index": 2402,
		"Rank": 44,
		"Item": "NFT People #2349",
		"Score": 54
	  },
	  {
		"Index": 2403,
		"Rank": 44,
		"Item": "NFT People #2373",
		"Score": 54
	  },
	  {
		"Index": 2404,
		"Rank": 44,
		"Item": "NFT People #2401",
		"Score": 54
	  },
	  {
		"Index": 2405,
		"Rank": 44,
		"Item": "NFT People #2426",
		"Score": 54
	  },
	  {
		"Index": 2406,
		"Rank": 44,
		"Item": "NFT People #2526",
		"Score": 54
	  },
	  {
		"Index": 2407,
		"Rank": 44,
		"Item": "NFT People #2598",
		"Score": 54
	  },
	  {
		"Index": 2408,
		"Rank": 44,
		"Item": "NFT People #2622",
		"Score": 54
	  },
	  {
		"Index": 2409,
		"Rank": 44,
		"Item": "NFT People #2645",
		"Score": 54
	  },
	  {
		"Index": 2410,
		"Rank": 44,
		"Item": "NFT People #2717",
		"Score": 54
	  },
	  {
		"Index": 2411,
		"Rank": 44,
		"Item": "NFT People #2751",
		"Score": 54
	  },
	  {
		"Index": 2412,
		"Rank": 44,
		"Item": "NFT People #2788",
		"Score": 54
	  },
	  {
		"Index": 2413,
		"Rank": 44,
		"Item": "NFT People #2789",
		"Score": 54
	  },
	  {
		"Index": 2414,
		"Rank": 44,
		"Item": "NFT People #2872",
		"Score": 54
	  },
	  {
		"Index": 2415,
		"Rank": 44,
		"Item": "NFT People #2887",
		"Score": 54
	  },
	  {
		"Index": 2416,
		"Rank": 44,
		"Item": "NFT People #2904",
		"Score": 54
	  },
	  {
		"Index": 2417,
		"Rank": 44,
		"Item": "NFT People #2909",
		"Score": 54
	  },
	  {
		"Index": 2418,
		"Rank": 44,
		"Item": "NFT People #2953",
		"Score": 54
	  },
	  {
		"Index": 2419,
		"Rank": 44,
		"Item": "NFT People #2971",
		"Score": 54
	  },
	  {
		"Index": 2420,
		"Rank": 44,
		"Item": "NFT People #2990",
		"Score": 54
	  },
	  {
		"Index": 2421,
		"Rank": 44,
		"Item": "NFT People #2995",
		"Score": 54
	  },
	  {
		"Index": 2422,
		"Rank": 44,
		"Item": "NFT People #3006",
		"Score": 54
	  },
	  {
		"Index": 2423,
		"Rank": 44,
		"Item": "NFT People #3084",
		"Score": 54
	  },
	  {
		"Index": 2424,
		"Rank": 44,
		"Item": "NFT People #3086",
		"Score": 54
	  },
	  {
		"Index": 2425,
		"Rank": 44,
		"Item": "NFT People #3087",
		"Score": 54
	  },
	  {
		"Index": 2426,
		"Rank": 44,
		"Item": "NFT People #3095",
		"Score": 54
	  },
	  {
		"Index": 2427,
		"Rank": 44,
		"Item": "NFT People #3138",
		"Score": 54
	  },
	  {
		"Index": 2428,
		"Rank": 44,
		"Item": "NFT People #3159",
		"Score": 54
	  },
	  {
		"Index": 2429,
		"Rank": 44,
		"Item": "NFT People #3162",
		"Score": 54
	  },
	  {
		"Index": 2430,
		"Rank": 44,
		"Item": "NFT People #3169",
		"Score": 54
	  },
	  {
		"Index": 2431,
		"Rank": 44,
		"Item": "NFT People #3179",
		"Score": 54
	  },
	  {
		"Index": 2432,
		"Rank": 44,
		"Item": "NFT People #3203",
		"Score": 54
	  },
	  {
		"Index": 2433,
		"Rank": 44,
		"Item": "NFT People #3226",
		"Score": 54
	  },
	  {
		"Index": 2434,
		"Rank": 44,
		"Item": "NFT People #3230",
		"Score": 54
	  },
	  {
		"Index": 2435,
		"Rank": 44,
		"Item": "NFT People #3255",
		"Score": 54
	  },
	  {
		"Index": 2436,
		"Rank": 44,
		"Item": "NFT People #3293",
		"Score": 54
	  },
	  {
		"Index": 2437,
		"Rank": 44,
		"Item": "NFT People #3295",
		"Score": 54
	  },
	  {
		"Index": 2438,
		"Rank": 44,
		"Item": "NFT People #3322",
		"Score": 54
	  },
	  {
		"Index": 2439,
		"Rank": 44,
		"Item": "NFT People #3376",
		"Score": 54
	  },
	  {
		"Index": 2440,
		"Rank": 44,
		"Item": "NFT People #3381",
		"Score": 54
	  },
	  {
		"Index": 2441,
		"Rank": 44,
		"Item": "NFT People #3414",
		"Score": 54
	  },
	  {
		"Index": 2442,
		"Rank": 44,
		"Item": "NFT People #3428",
		"Score": 54
	  },
	  {
		"Index": 2443,
		"Rank": 44,
		"Item": "NFT People #3457",
		"Score": 54
	  },
	  {
		"Index": 2444,
		"Rank": 44,
		"Item": "NFT People #3474",
		"Score": 54
	  },
	  {
		"Index": 2445,
		"Rank": 44,
		"Item": "NFT People #3476",
		"Score": 54
	  },
	  {
		"Index": 2446,
		"Rank": 44,
		"Item": "NFT People #3542",
		"Score": 54
	  },
	  {
		"Index": 2447,
		"Rank": 44,
		"Item": "NFT People #3578",
		"Score": 54
	  },
	  {
		"Index": 2448,
		"Rank": 44,
		"Item": "NFT People #3611",
		"Score": 54
	  },
	  {
		"Index": 2449,
		"Rank": 44,
		"Item": "NFT People #3634",
		"Score": 54
	  },
	  {
		"Index": 2450,
		"Rank": 44,
		"Item": "NFT People #3636",
		"Score": 54
	  },
	  {
		"Index": 2451,
		"Rank": 44,
		"Item": "NFT People #3699",
		"Score": 54
	  },
	  {
		"Index": 2452,
		"Rank": 44,
		"Item": "NFT People #3723",
		"Score": 54
	  },
	  {
		"Index": 2453,
		"Rank": 44,
		"Item": "NFT People #3841",
		"Score": 54
	  },
	  {
		"Index": 2454,
		"Rank": 44,
		"Item": "NFT People #3884",
		"Score": 54
	  },
	  {
		"Index": 2455,
		"Rank": 44,
		"Item": "NFT People #3886",
		"Score": 54
	  },
	  {
		"Index": 2456,
		"Rank": 44,
		"Item": "NFT People #3888",
		"Score": 54
	  },
	  {
		"Index": 2457,
		"Rank": 44,
		"Item": "NFT People #3934",
		"Score": 54
	  },
	  {
		"Index": 2458,
		"Rank": 44,
		"Item": "NFT People #3963",
		"Score": 54
	  },
	  {
		"Index": 2459,
		"Rank": 44,
		"Item": "NFT People #3968",
		"Score": 54
	  },
	  {
		"Index": 2460,
		"Rank": 44,
		"Item": "NFT People #4005",
		"Score": 54
	  },
	  {
		"Index": 2461,
		"Rank": 44,
		"Item": "NFT People #4013",
		"Score": 54
	  },
	  {
		"Index": 2462,
		"Rank": 44,
		"Item": "NFT People #4052",
		"Score": 54
	  },
	  {
		"Index": 2463,
		"Rank": 44,
		"Item": "NFT People #4061",
		"Score": 54
	  },
	  {
		"Index": 2464,
		"Rank": 44,
		"Item": "NFT People #4119",
		"Score": 54
	  },
	  {
		"Index": 2465,
		"Rank": 44,
		"Item": "NFT People #4227",
		"Score": 54
	  },
	  {
		"Index": 2466,
		"Rank": 44,
		"Item": "NFT People #4254",
		"Score": 54
	  },
	  {
		"Index": 2467,
		"Rank": 44,
		"Item": "NFT People #4256",
		"Score": 54
	  },
	  {
		"Index": 2468,
		"Rank": 44,
		"Item": "NFT People #4276",
		"Score": 54
	  },
	  {
		"Index": 2469,
		"Rank": 44,
		"Item": "NFT People #4297",
		"Score": 54
	  },
	  {
		"Index": 2470,
		"Rank": 44,
		"Item": "NFT People #4319",
		"Score": 54
	  },
	  {
		"Index": 2471,
		"Rank": 44,
		"Item": "NFT People #4435",
		"Score": 54
	  },
	  {
		"Index": 2472,
		"Rank": 44,
		"Item": "NFT People #4450",
		"Score": 54
	  },
	  {
		"Index": 2473,
		"Rank": 44,
		"Item": "NFT People #4502",
		"Score": 54
	  },
	  {
		"Index": 2474,
		"Rank": 44,
		"Item": "NFT People #4554",
		"Score": 54
	  },
	  {
		"Index": 2475,
		"Rank": 44,
		"Item": "NFT People #4567",
		"Score": 54
	  },
	  {
		"Index": 2476,
		"Rank": 44,
		"Item": "NFT People #4613",
		"Score": 54
	  },
	  {
		"Index": 2477,
		"Rank": 44,
		"Item": "NFT People #4618",
		"Score": 54
	  },
	  {
		"Index": 2478,
		"Rank": 44,
		"Item": "NFT People #4627",
		"Score": 54
	  },
	  {
		"Index": 2479,
		"Rank": 44,
		"Item": "NFT People #4646",
		"Score": 54
	  },
	  {
		"Index": 2480,
		"Rank": 44,
		"Item": "NFT People #4739",
		"Score": 54
	  },
	  {
		"Index": 2481,
		"Rank": 44,
		"Item": "NFT People #4753",
		"Score": 54
	  },
	  {
		"Index": 2482,
		"Rank": 44,
		"Item": "NFT People #4760",
		"Score": 54
	  },
	  {
		"Index": 2483,
		"Rank": 44,
		"Item": "NFT People #4772",
		"Score": 54
	  },
	  {
		"Index": 2484,
		"Rank": 44,
		"Item": "NFT People #4780",
		"Score": 54
	  },
	  {
		"Index": 2485,
		"Rank": 44,
		"Item": "NFT People #4788",
		"Score": 54
	  },
	  {
		"Index": 2486,
		"Rank": 44,
		"Item": "NFT People #4809",
		"Score": 54
	  },
	  {
		"Index": 2487,
		"Rank": 44,
		"Item": "NFT People #4867",
		"Score": 54
	  },
	  {
		"Index": 2488,
		"Rank": 44,
		"Item": "NFT People #4885",
		"Score": 54
	  },
	  {
		"Index": 2489,
		"Rank": 44,
		"Item": "NFT People #4904",
		"Score": 54
	  },
	  {
		"Index": 2490,
		"Rank": 44,
		"Item": "NFT People #4915",
		"Score": 54
	  },
	  {
		"Index": 2491,
		"Rank": 44,
		"Item": "NFT People #5000",
		"Score": 54
	  },
	  {
		"Index": 2492,
		"Rank": 45,
		"Item": "NFT People #0026",
		"Score": 53
	  },
	  {
		"Index": 2493,
		"Rank": 45,
		"Item": "NFT People #0067",
		"Score": 53
	  },
	  {
		"Index": 2494,
		"Rank": 45,
		"Item": "NFT People #0181",
		"Score": 53
	  },
	  {
		"Index": 2495,
		"Rank": 45,
		"Item": "NFT People #0191",
		"Score": 53
	  },
	  {
		"Index": 2496,
		"Rank": 45,
		"Item": "NFT People #0208",
		"Score": 53
	  },
	  {
		"Index": 2497,
		"Rank": 45,
		"Item": "NFT People #0213",
		"Score": 53
	  },
	  {
		"Index": 2498,
		"Rank": 45,
		"Item": "NFT People #0231",
		"Score": 53
	  },
	  {
		"Index": 2499,
		"Rank": 45,
		"Item": "NFT People #0258",
		"Score": 53
	  },
	  {
		"Index": 2500,
		"Rank": 45,
		"Item": "NFT People #0259",
		"Score": 53
	  },
	  {
		"Index": 2501,
		"Rank": 45,
		"Item": "NFT People #0269",
		"Score": 53
	  },
	  {
		"Index": 2502,
		"Rank": 45,
		"Item": "NFT People #0311",
		"Score": 53
	  },
	  {
		"Index": 2503,
		"Rank": 45,
		"Item": "NFT People #0340",
		"Score": 53
	  },
	  {
		"Index": 2504,
		"Rank": 45,
		"Item": "NFT People #0355",
		"Score": 53
	  },
	  {
		"Index": 2505,
		"Rank": 45,
		"Item": "NFT People #0459",
		"Score": 53
	  },
	  {
		"Index": 2506,
		"Rank": 45,
		"Item": "NFT People #0528",
		"Score": 53
	  },
	  {
		"Index": 2507,
		"Rank": 45,
		"Item": "NFT People #0586",
		"Score": 53
	  },
	  {
		"Index": 2508,
		"Rank": 45,
		"Item": "NFT People #0637",
		"Score": 53
	  },
	  {
		"Index": 2509,
		"Rank": 45,
		"Item": "NFT People #0647",
		"Score": 53
	  },
	  {
		"Index": 2510,
		"Rank": 45,
		"Item": "NFT People #0668",
		"Score": 53
	  },
	  {
		"Index": 2511,
		"Rank": 45,
		"Item": "NFT People #0797",
		"Score": 53
	  },
	  {
		"Index": 2512,
		"Rank": 45,
		"Item": "NFT People #0809",
		"Score": 53
	  },
	  {
		"Index": 2513,
		"Rank": 45,
		"Item": "NFT People #0842",
		"Score": 53
	  },
	  {
		"Index": 2514,
		"Rank": 45,
		"Item": "NFT People #0866",
		"Score": 53
	  },
	  {
		"Index": 2515,
		"Rank": 45,
		"Item": "NFT People #0878",
		"Score": 53
	  },
	  {
		"Index": 2516,
		"Rank": 45,
		"Item": "NFT People #0957",
		"Score": 53
	  },
	  {
		"Index": 2517,
		"Rank": 45,
		"Item": "NFT People #1003",
		"Score": 53
	  },
	  {
		"Index": 2518,
		"Rank": 45,
		"Item": "NFT People #1036",
		"Score": 53
	  },
	  {
		"Index": 2519,
		"Rank": 45,
		"Item": "NFT People #1118",
		"Score": 53
	  },
	  {
		"Index": 2520,
		"Rank": 45,
		"Item": "NFT People #1157",
		"Score": 53
	  },
	  {
		"Index": 2521,
		"Rank": 45,
		"Item": "NFT People #1166",
		"Score": 53
	  },
	  {
		"Index": 2522,
		"Rank": 45,
		"Item": "NFT People #1167",
		"Score": 53
	  },
	  {
		"Index": 2523,
		"Rank": 45,
		"Item": "NFT People #1179",
		"Score": 53
	  },
	  {
		"Index": 2524,
		"Rank": 45,
		"Item": "NFT People #1278",
		"Score": 53
	  },
	  {
		"Index": 2525,
		"Rank": 45,
		"Item": "NFT People #1366",
		"Score": 53
	  },
	  {
		"Index": 2526,
		"Rank": 45,
		"Item": "NFT People #1384",
		"Score": 53
	  },
	  {
		"Index": 2527,
		"Rank": 45,
		"Item": "NFT People #1443",
		"Score": 53
	  },
	  {
		"Index": 2528,
		"Rank": 45,
		"Item": "NFT People #1444",
		"Score": 53
	  },
	  {
		"Index": 2529,
		"Rank": 45,
		"Item": "NFT People #1480",
		"Score": 53
	  },
	  {
		"Index": 2530,
		"Rank": 45,
		"Item": "NFT People #1537",
		"Score": 53
	  },
	  {
		"Index": 2531,
		"Rank": 45,
		"Item": "NFT People #1550",
		"Score": 53
	  },
	  {
		"Index": 2532,
		"Rank": 45,
		"Item": "NFT People #1578",
		"Score": 53
	  },
	  {
		"Index": 2533,
		"Rank": 45,
		"Item": "NFT People #1589",
		"Score": 53
	  },
	  {
		"Index": 2534,
		"Rank": 45,
		"Item": "NFT People #1672",
		"Score": 53
	  },
	  {
		"Index": 2535,
		"Rank": 45,
		"Item": "NFT People #1715",
		"Score": 53
	  },
	  {
		"Index": 2536,
		"Rank": 45,
		"Item": "NFT People #1758",
		"Score": 53
	  },
	  {
		"Index": 2537,
		"Rank": 45,
		"Item": "NFT People #1807",
		"Score": 53
	  },
	  {
		"Index": 2538,
		"Rank": 45,
		"Item": "NFT People #1851",
		"Score": 53
	  },
	  {
		"Index": 2539,
		"Rank": 45,
		"Item": "NFT People #1857",
		"Score": 53
	  },
	  {
		"Index": 2540,
		"Rank": 45,
		"Item": "NFT People #1905",
		"Score": 53
	  },
	  {
		"Index": 2541,
		"Rank": 45,
		"Item": "NFT People #1947",
		"Score": 53
	  },
	  {
		"Index": 2542,
		"Rank": 45,
		"Item": "NFT People #2137",
		"Score": 53
	  },
	  {
		"Index": 2543,
		"Rank": 45,
		"Item": "NFT People #2160",
		"Score": 53
	  },
	  {
		"Index": 2544,
		"Rank": 45,
		"Item": "NFT People #2162",
		"Score": 53
	  },
	  {
		"Index": 2545,
		"Rank": 45,
		"Item": "NFT People #2227",
		"Score": 53
	  },
	  {
		"Index": 2546,
		"Rank": 45,
		"Item": "NFT People #2240",
		"Score": 53
	  },
	  {
		"Index": 2547,
		"Rank": 45,
		"Item": "NFT People #2246",
		"Score": 53
	  },
	  {
		"Index": 2548,
		"Rank": 45,
		"Item": "NFT People #2320",
		"Score": 53
	  },
	  {
		"Index": 2549,
		"Rank": 45,
		"Item": "NFT People #2333",
		"Score": 53
	  },
	  {
		"Index": 2550,
		"Rank": 45,
		"Item": "NFT People #2339",
		"Score": 53
	  },
	  {
		"Index": 2551,
		"Rank": 45,
		"Item": "NFT People #2354",
		"Score": 53
	  },
	  {
		"Index": 2552,
		"Rank": 45,
		"Item": "NFT People #2374",
		"Score": 53
	  },
	  {
		"Index": 2553,
		"Rank": 45,
		"Item": "NFT People #2381",
		"Score": 53
	  },
	  {
		"Index": 2554,
		"Rank": 45,
		"Item": "NFT People #2381",
		"Score": 53
	  },
	  {
		"Index": 2555,
		"Rank": 45,
		"Item": "NFT People #2421",
		"Score": 53
	  },
	  {
		"Index": 2556,
		"Rank": 45,
		"Item": "NFT People #2441",
		"Score": 53
	  },
	  {
		"Index": 2557,
		"Rank": 45,
		"Item": "NFT People #2508",
		"Score": 53
	  },
	  {
		"Index": 2558,
		"Rank": 45,
		"Item": "NFT People #2537",
		"Score": 53
	  },
	  {
		"Index": 2559,
		"Rank": 45,
		"Item": "NFT People #2544",
		"Score": 53
	  },
	  {
		"Index": 2560,
		"Rank": 45,
		"Item": "NFT People #2547",
		"Score": 53
	  },
	  {
		"Index": 2561,
		"Rank": 45,
		"Item": "NFT People #2568",
		"Score": 53
	  },
	  {
		"Index": 2562,
		"Rank": 45,
		"Item": "NFT People #2580",
		"Score": 53
	  },
	  {
		"Index": 2563,
		"Rank": 45,
		"Item": "NFT People #2584",
		"Score": 53
	  },
	  {
		"Index": 2564,
		"Rank": 45,
		"Item": "NFT People #2586",
		"Score": 53
	  },
	  {
		"Index": 2565,
		"Rank": 45,
		"Item": "NFT People #2597",
		"Score": 53
	  },
	  {
		"Index": 2566,
		"Rank": 45,
		"Item": "NFT People #2660",
		"Score": 53
	  },
	  {
		"Index": 2567,
		"Rank": 45,
		"Item": "NFT People #2769",
		"Score": 53
	  },
	  {
		"Index": 2568,
		"Rank": 45,
		"Item": "NFT People #2777",
		"Score": 53
	  },
	  {
		"Index": 2569,
		"Rank": 45,
		"Item": "NFT People #2786",
		"Score": 53
	  },
	  {
		"Index": 2570,
		"Rank": 45,
		"Item": "NFT People #2821",
		"Score": 53
	  },
	  {
		"Index": 2571,
		"Rank": 45,
		"Item": "NFT People #2826",
		"Score": 53
	  },
	  {
		"Index": 2572,
		"Rank": 45,
		"Item": "NFT People #2830",
		"Score": 53
	  },
	  {
		"Index": 2573,
		"Rank": 45,
		"Item": "NFT People #2869",
		"Score": 53
	  },
	  {
		"Index": 2574,
		"Rank": 45,
		"Item": "NFT People #2897",
		"Score": 53
	  },
	  {
		"Index": 2575,
		"Rank": 45,
		"Item": "NFT People #2899",
		"Score": 53
	  },
	  {
		"Index": 2576,
		"Rank": 45,
		"Item": "NFT People #2961",
		"Score": 53
	  },
	  {
		"Index": 2577,
		"Rank": 45,
		"Item": "NFT People #3016",
		"Score": 53
	  },
	  {
		"Index": 2578,
		"Rank": 45,
		"Item": "NFT People #3223",
		"Score": 53
	  },
	  {
		"Index": 2579,
		"Rank": 45,
		"Item": "NFT People #3299",
		"Score": 53
	  },
	  {
		"Index": 2580,
		"Rank": 45,
		"Item": "NFT People #3348",
		"Score": 53
	  },
	  {
		"Index": 2581,
		"Rank": 45,
		"Item": "NFT People #3393",
		"Score": 53
	  },
	  {
		"Index": 2582,
		"Rank": 45,
		"Item": "NFT People #3416",
		"Score": 53
	  },
	  {
		"Index": 2583,
		"Rank": 45,
		"Item": "NFT People #3417",
		"Score": 53
	  },
	  {
		"Index": 2584,
		"Rank": 45,
		"Item": "NFT People #3485",
		"Score": 53
	  },
	  {
		"Index": 2585,
		"Rank": 45,
		"Item": "NFT People #3547",
		"Score": 53
	  },
	  {
		"Index": 2586,
		"Rank": 45,
		"Item": "NFT People #3555",
		"Score": 53
	  },
	  {
		"Index": 2587,
		"Rank": 45,
		"Item": "NFT People #3626",
		"Score": 53
	  },
	  {
		"Index": 2588,
		"Rank": 45,
		"Item": "NFT People #3641",
		"Score": 53
	  },
	  {
		"Index": 2589,
		"Rank": 45,
		"Item": "NFT People #3657",
		"Score": 53
	  },
	  {
		"Index": 2590,
		"Rank": 45,
		"Item": "NFT People #3732",
		"Score": 53
	  },
	  {
		"Index": 2591,
		"Rank": 45,
		"Item": "NFT People #3741",
		"Score": 53
	  },
	  {
		"Index": 2592,
		"Rank": 45,
		"Item": "NFT People #3765",
		"Score": 53
	  },
	  {
		"Index": 2593,
		"Rank": 45,
		"Item": "NFT People #3805",
		"Score": 53
	  },
	  {
		"Index": 2594,
		"Rank": 45,
		"Item": "NFT People #3892",
		"Score": 53
	  },
	  {
		"Index": 2595,
		"Rank": 45,
		"Item": "NFT People #3893",
		"Score": 53
	  },
	  {
		"Index": 2596,
		"Rank": 45,
		"Item": "NFT People #3988",
		"Score": 53
	  },
	  {
		"Index": 2597,
		"Rank": 45,
		"Item": "NFT People #4009",
		"Score": 53
	  },
	  {
		"Index": 2598,
		"Rank": 45,
		"Item": "NFT People #4038",
		"Score": 53
	  },
	  {
		"Index": 2599,
		"Rank": 45,
		"Item": "NFT People #4072",
		"Score": 53
	  },
	  {
		"Index": 2600,
		"Rank": 45,
		"Item": "NFT People #4098",
		"Score": 53
	  },
	  {
		"Index": 2601,
		"Rank": 45,
		"Item": "NFT People #4126",
		"Score": 53
	  },
	  {
		"Index": 2602,
		"Rank": 45,
		"Item": "NFT People #4129",
		"Score": 53
	  },
	  {
		"Index": 2603,
		"Rank": 45,
		"Item": "NFT People #4145",
		"Score": 53
	  },
	  {
		"Index": 2604,
		"Rank": 45,
		"Item": "NFT People #4166",
		"Score": 53
	  },
	  {
		"Index": 2605,
		"Rank": 45,
		"Item": "NFT People #4168",
		"Score": 53
	  },
	  {
		"Index": 2606,
		"Rank": 45,
		"Item": "NFT People #4176",
		"Score": 53
	  },
	  {
		"Index": 2607,
		"Rank": 45,
		"Item": "NFT People #4179",
		"Score": 53
	  },
	  {
		"Index": 2608,
		"Rank": 45,
		"Item": "NFT People #4182",
		"Score": 53
	  },
	  {
		"Index": 2609,
		"Rank": 45,
		"Item": "NFT People #4185",
		"Score": 53
	  },
	  {
		"Index": 2610,
		"Rank": 45,
		"Item": "NFT People #4212",
		"Score": 53
	  },
	  {
		"Index": 2611,
		"Rank": 45,
		"Item": "NFT People #4258",
		"Score": 53
	  },
	  {
		"Index": 2612,
		"Rank": 45,
		"Item": "NFT People #4261",
		"Score": 53
	  },
	  {
		"Index": 2613,
		"Rank": 45,
		"Item": "NFT People #4272",
		"Score": 53
	  },
	  {
		"Index": 2614,
		"Rank": 45,
		"Item": "NFT People #4340",
		"Score": 53
	  },
	  {
		"Index": 2615,
		"Rank": 45,
		"Item": "NFT People #4342",
		"Score": 53
	  },
	  {
		"Index": 2616,
		"Rank": 45,
		"Item": "NFT People #4381",
		"Score": 53
	  },
	  {
		"Index": 2617,
		"Rank": 45,
		"Item": "NFT People #4441",
		"Score": 53
	  },
	  {
		"Index": 2618,
		"Rank": 45,
		"Item": "NFT People #4619",
		"Score": 53
	  },
	  {
		"Index": 2619,
		"Rank": 45,
		"Item": "NFT People #4655",
		"Score": 53
	  },
	  {
		"Index": 2620,
		"Rank": 45,
		"Item": "NFT People #4684",
		"Score": 53
	  },
	  {
		"Index": 2621,
		"Rank": 45,
		"Item": "NFT People #4712",
		"Score": 53
	  },
	  {
		"Index": 2622,
		"Rank": 45,
		"Item": "NFT People #4717",
		"Score": 53
	  },
	  {
		"Index": 2623,
		"Rank": 45,
		"Item": "NFT People #4726",
		"Score": 53
	  },
	  {
		"Index": 2624,
		"Rank": 45,
		"Item": "NFT People #4769",
		"Score": 53
	  },
	  {
		"Index": 2625,
		"Rank": 45,
		"Item": "NFT People #4790",
		"Score": 53
	  },
	  {
		"Index": 2626,
		"Rank": 45,
		"Item": "NFT People #4792",
		"Score": 53
	  },
	  {
		"Index": 2627,
		"Rank": 45,
		"Item": "NFT People #4797",
		"Score": 53
	  },
	  {
		"Index": 2628,
		"Rank": 45,
		"Item": "NFT People #4838",
		"Score": 53
	  },
	  {
		"Index": 2629,
		"Rank": 45,
		"Item": "NFT People #4884",
		"Score": 53
	  },
	  {
		"Index": 2630,
		"Rank": 45,
		"Item": "NFT People #4911",
		"Score": 53
	  },
	  {
		"Index": 2631,
		"Rank": 45,
		"Item": "NFT People #4919",
		"Score": 53
	  },
	  {
		"Index": 2632,
		"Rank": 45,
		"Item": "NFT People #4990",
		"Score": 53
	  },
	  {
		"Index": 2633,
		"Rank": 46,
		"Item": "NFT People #0006",
		"Score": 52
	  },
	  {
		"Index": 2634,
		"Rank": 46,
		"Item": "NFT People #0010",
		"Score": 52
	  },
	  {
		"Index": 2635,
		"Rank": 46,
		"Item": "NFT People #0027",
		"Score": 52
	  },
	  {
		"Index": 2636,
		"Rank": 46,
		"Item": "NFT People #0061",
		"Score": 52
	  },
	  {
		"Index": 2637,
		"Rank": 46,
		"Item": "NFT People #0092",
		"Score": 52
	  },
	  {
		"Index": 2638,
		"Rank": 46,
		"Item": "NFT People #0128",
		"Score": 52
	  },
	  {
		"Index": 2639,
		"Rank": 46,
		"Item": "NFT People #0163",
		"Score": 52
	  },
	  {
		"Index": 2640,
		"Rank": 46,
		"Item": "NFT People #0182",
		"Score": 52
	  },
	  {
		"Index": 2641,
		"Rank": 46,
		"Item": "NFT People #0205",
		"Score": 52
	  },
	  {
		"Index": 2642,
		"Rank": 46,
		"Item": "NFT People #0212",
		"Score": 52
	  },
	  {
		"Index": 2643,
		"Rank": 46,
		"Item": "NFT People #0261",
		"Score": 52
	  },
	  {
		"Index": 2644,
		"Rank": 46,
		"Item": "NFT People #0272",
		"Score": 52
	  },
	  {
		"Index": 2645,
		"Rank": 46,
		"Item": "NFT People #0273",
		"Score": 52
	  },
	  {
		"Index": 2646,
		"Rank": 46,
		"Item": "NFT People #0293",
		"Score": 52
	  },
	  {
		"Index": 2647,
		"Rank": 46,
		"Item": "NFT People #0422",
		"Score": 52
	  },
	  {
		"Index": 2648,
		"Rank": 46,
		"Item": "NFT People #0535",
		"Score": 52
	  },
	  {
		"Index": 2649,
		"Rank": 46,
		"Item": "NFT People #0594",
		"Score": 52
	  },
	  {
		"Index": 2650,
		"Rank": 46,
		"Item": "NFT People #0650",
		"Score": 52
	  },
	  {
		"Index": 2651,
		"Rank": 46,
		"Item": "NFT People #0725",
		"Score": 52
	  },
	  {
		"Index": 2652,
		"Rank": 46,
		"Item": "NFT People #0795",
		"Score": 52
	  },
	  {
		"Index": 2653,
		"Rank": 46,
		"Item": "NFT People #0896",
		"Score": 52
	  },
	  {
		"Index": 2654,
		"Rank": 46,
		"Item": "NFT People #0981",
		"Score": 52
	  },
	  {
		"Index": 2655,
		"Rank": 46,
		"Item": "NFT People #0982",
		"Score": 52
	  },
	  {
		"Index": 2656,
		"Rank": 46,
		"Item": "NFT People #1052",
		"Score": 52
	  },
	  {
		"Index": 2657,
		"Rank": 46,
		"Item": "NFT People #1075",
		"Score": 52
	  },
	  {
		"Index": 2658,
		"Rank": 46,
		"Item": "NFT People #1153",
		"Score": 52
	  },
	  {
		"Index": 2659,
		"Rank": 46,
		"Item": "NFT People #1164",
		"Score": 52
	  },
	  {
		"Index": 2660,
		"Rank": 46,
		"Item": "NFT People #1189",
		"Score": 52
	  },
	  {
		"Index": 2661,
		"Rank": 46,
		"Item": "NFT People #1296",
		"Score": 52
	  },
	  {
		"Index": 2662,
		"Rank": 46,
		"Item": "NFT People #1324",
		"Score": 52
	  },
	  {
		"Index": 2663,
		"Rank": 46,
		"Item": "NFT People #1462",
		"Score": 52
	  },
	  {
		"Index": 2664,
		"Rank": 46,
		"Item": "NFT People #1567",
		"Score": 52
	  },
	  {
		"Index": 2665,
		"Rank": 46,
		"Item": "NFT People #1575",
		"Score": 52
	  },
	  {
		"Index": 2666,
		"Rank": 46,
		"Item": "NFT People #1583",
		"Score": 52
	  },
	  {
		"Index": 2667,
		"Rank": 46,
		"Item": "NFT People #1722",
		"Score": 52
	  },
	  {
		"Index": 2668,
		"Rank": 46,
		"Item": "NFT People #1763",
		"Score": 52
	  },
	  {
		"Index": 2669,
		"Rank": 46,
		"Item": "NFT People #1781",
		"Score": 52
	  },
	  {
		"Index": 2670,
		"Rank": 46,
		"Item": "NFT People #1830",
		"Score": 52
	  },
	  {
		"Index": 2671,
		"Rank": 46,
		"Item": "NFT People #1835",
		"Score": 52
	  },
	  {
		"Index": 2672,
		"Rank": 46,
		"Item": "NFT People #1922",
		"Score": 52
	  },
	  {
		"Index": 2673,
		"Rank": 46,
		"Item": "NFT People #1995",
		"Score": 52
	  },
	  {
		"Index": 2674,
		"Rank": 46,
		"Item": "NFT People #2117",
		"Score": 52
	  },
	  {
		"Index": 2675,
		"Rank": 46,
		"Item": "NFT People #2132",
		"Score": 52
	  },
	  {
		"Index": 2676,
		"Rank": 46,
		"Item": "NFT People #2177",
		"Score": 52
	  },
	  {
		"Index": 2677,
		"Rank": 46,
		"Item": "NFT People #2178",
		"Score": 52
	  },
	  {
		"Index": 2678,
		"Rank": 46,
		"Item": "NFT People #2199",
		"Score": 52
	  },
	  {
		"Index": 2679,
		"Rank": 46,
		"Item": "NFT People #2273",
		"Score": 52
	  },
	  {
		"Index": 2680,
		"Rank": 46,
		"Item": "NFT People #2314",
		"Score": 52
	  },
	  {
		"Index": 2681,
		"Rank": 46,
		"Item": "NFT People #2341",
		"Score": 52
	  },
	  {
		"Index": 2682,
		"Rank": 46,
		"Item": "NFT People #2372",
		"Score": 52
	  },
	  {
		"Index": 2683,
		"Rank": 46,
		"Item": "NFT People #2396",
		"Score": 52
	  },
	  {
		"Index": 2684,
		"Rank": 46,
		"Item": "NFT People #2436",
		"Score": 52
	  },
	  {
		"Index": 2685,
		"Rank": 46,
		"Item": "NFT People #2463",
		"Score": 52
	  },
	  {
		"Index": 2686,
		"Rank": 46,
		"Item": "NFT People #2519",
		"Score": 52
	  },
	  {
		"Index": 2687,
		"Rank": 46,
		"Item": "NFT People #2531",
		"Score": 52
	  },
	  {
		"Index": 2688,
		"Rank": 46,
		"Item": "NFT People #2548",
		"Score": 52
	  },
	  {
		"Index": 2689,
		"Rank": 46,
		"Item": "NFT People #2610",
		"Score": 52
	  },
	  {
		"Index": 2690,
		"Rank": 46,
		"Item": "NFT People #2705",
		"Score": 52
	  },
	  {
		"Index": 2691,
		"Rank": 46,
		"Item": "NFT People #2707",
		"Score": 52
	  },
	  {
		"Index": 2692,
		"Rank": 46,
		"Item": "NFT People #2711",
		"Score": 52
	  },
	  {
		"Index": 2693,
		"Rank": 46,
		"Item": "NFT People #2733",
		"Score": 52
	  },
	  {
		"Index": 2694,
		"Rank": 46,
		"Item": "NFT People #2792",
		"Score": 52
	  },
	  {
		"Index": 2695,
		"Rank": 46,
		"Item": "NFT People #2804",
		"Score": 52
	  },
	  {
		"Index": 2696,
		"Rank": 46,
		"Item": "NFT People #2816",
		"Score": 52
	  },
	  {
		"Index": 2697,
		"Rank": 46,
		"Item": "NFT People #2825",
		"Score": 52
	  },
	  {
		"Index": 2698,
		"Rank": 46,
		"Item": "NFT People #3133",
		"Score": 52
	  },
	  {
		"Index": 2699,
		"Rank": 46,
		"Item": "NFT People #3204",
		"Score": 52
	  },
	  {
		"Index": 2700,
		"Rank": 46,
		"Item": "NFT People #3279",
		"Score": 52
	  },
	  {
		"Index": 2701,
		"Rank": 46,
		"Item": "NFT People #3352",
		"Score": 52
	  },
	  {
		"Index": 2702,
		"Rank": 46,
		"Item": "NFT People #3364",
		"Score": 52
	  },
	  {
		"Index": 2703,
		"Rank": 46,
		"Item": "NFT People #3488",
		"Score": 52
	  },
	  {
		"Index": 2704,
		"Rank": 46,
		"Item": "NFT People #3540",
		"Score": 52
	  },
	  {
		"Index": 2705,
		"Rank": 46,
		"Item": "NFT People #3575",
		"Score": 52
	  },
	  {
		"Index": 2706,
		"Rank": 46,
		"Item": "NFT People #3651",
		"Score": 52
	  },
	  {
		"Index": 2707,
		"Rank": 46,
		"Item": "NFT People #3776",
		"Score": 52
	  },
	  {
		"Index": 2708,
		"Rank": 46,
		"Item": "NFT People #3807",
		"Score": 52
	  },
	  {
		"Index": 2709,
		"Rank": 46,
		"Item": "NFT People #3829",
		"Score": 52
	  },
	  {
		"Index": 2710,
		"Rank": 46,
		"Item": "NFT People #4006",
		"Score": 52
	  },
	  {
		"Index": 2711,
		"Rank": 46,
		"Item": "NFT People #4015",
		"Score": 52
	  },
	  {
		"Index": 2712,
		"Rank": 46,
		"Item": "NFT People #4058",
		"Score": 52
	  },
	  {
		"Index": 2713,
		"Rank": 46,
		"Item": "NFT People #4085",
		"Score": 52
	  },
	  {
		"Index": 2714,
		"Rank": 46,
		"Item": "NFT People #4088",
		"Score": 52
	  },
	  {
		"Index": 2715,
		"Rank": 46,
		"Item": "NFT People #4123",
		"Score": 52
	  },
	  {
		"Index": 2716,
		"Rank": 46,
		"Item": "NFT People #4156",
		"Score": 52
	  },
	  {
		"Index": 2717,
		"Rank": 46,
		"Item": "NFT People #4294",
		"Score": 52
	  },
	  {
		"Index": 2718,
		"Rank": 46,
		"Item": "NFT People #4313",
		"Score": 52
	  },
	  {
		"Index": 2719,
		"Rank": 46,
		"Item": "NFT People #4351",
		"Score": 52
	  },
	  {
		"Index": 2720,
		"Rank": 46,
		"Item": "NFT People #4466",
		"Score": 52
	  },
	  {
		"Index": 2721,
		"Rank": 46,
		"Item": "NFT People #4486",
		"Score": 52
	  },
	  {
		"Index": 2722,
		"Rank": 46,
		"Item": "NFT People #4563",
		"Score": 52
	  },
	  {
		"Index": 2723,
		"Rank": 46,
		"Item": "NFT People #4650",
		"Score": 52
	  },
	  {
		"Index": 2724,
		"Rank": 46,
		"Item": "NFT People #4720",
		"Score": 52
	  },
	  {
		"Index": 2725,
		"Rank": 46,
		"Item": "NFT People #4806",
		"Score": 52
	  },
	  {
		"Index": 2726,
		"Rank": 46,
		"Item": "NFT People #4822",
		"Score": 52
	  },
	  {
		"Index": 2727,
		"Rank": 46,
		"Item": "NFT People #4902",
		"Score": 52
	  },
	  {
		"Index": 2728,
		"Rank": 46,
		"Item": "NFT People #4910",
		"Score": 52
	  },
	  {
		"Index": 2729,
		"Rank": 46,
		"Item": "NFT People #4961",
		"Score": 52
	  },
	  {
		"Index": 2730,
		"Rank": 46,
		"Item": "NFT People #4983",
		"Score": 52
	  },
	  {
		"Index": 2731,
		"Rank": 47,
		"Item": "NFT People #0038",
		"Score": 51
	  },
	  {
		"Index": 2732,
		"Rank": 47,
		"Item": "NFT People #0080",
		"Score": 51
	  },
	  {
		"Index": 2733,
		"Rank": 47,
		"Item": "NFT People #0185",
		"Score": 51
	  },
	  {
		"Index": 2734,
		"Rank": 47,
		"Item": "NFT People #0214",
		"Score": 51
	  },
	  {
		"Index": 2735,
		"Rank": 47,
		"Item": "NFT People #0224",
		"Score": 51
	  },
	  {
		"Index": 2736,
		"Rank": 47,
		"Item": "NFT People #0229",
		"Score": 51
	  },
	  {
		"Index": 2737,
		"Rank": 47,
		"Item": "NFT People #0230",
		"Score": 51
	  },
	  {
		"Index": 2738,
		"Rank": 47,
		"Item": "NFT People #0309",
		"Score": 51
	  },
	  {
		"Index": 2739,
		"Rank": 47,
		"Item": "NFT People #0310",
		"Score": 51
	  },
	  {
		"Index": 2740,
		"Rank": 47,
		"Item": "NFT People #0324",
		"Score": 51
	  },
	  {
		"Index": 2741,
		"Rank": 47,
		"Item": "NFT People #0332",
		"Score": 51
	  },
	  {
		"Index": 2742,
		"Rank": 47,
		"Item": "NFT People #0336",
		"Score": 51
	  },
	  {
		"Index": 2743,
		"Rank": 47,
		"Item": "NFT People #0367",
		"Score": 51
	  },
	  {
		"Index": 2744,
		"Rank": 47,
		"Item": "NFT People #0369",
		"Score": 51
	  },
	  {
		"Index": 2745,
		"Rank": 47,
		"Item": "NFT People #0374",
		"Score": 51
	  },
	  {
		"Index": 2746,
		"Rank": 47,
		"Item": "NFT People #0445",
		"Score": 51
	  },
	  {
		"Index": 2747,
		"Rank": 47,
		"Item": "NFT People #0465",
		"Score": 51
	  },
	  {
		"Index": 2748,
		"Rank": 47,
		"Item": "NFT People #0489",
		"Score": 51
	  },
	  {
		"Index": 2749,
		"Rank": 47,
		"Item": "NFT People #0508",
		"Score": 51
	  },
	  {
		"Index": 2750,
		"Rank": 47,
		"Item": "NFT People #0567",
		"Score": 51
	  },
	  {
		"Index": 2751,
		"Rank": 47,
		"Item": "NFT People #0575",
		"Score": 51
	  },
	  {
		"Index": 2752,
		"Rank": 47,
		"Item": "NFT People #0624",
		"Score": 51
	  },
	  {
		"Index": 2753,
		"Rank": 47,
		"Item": "NFT People #0691",
		"Score": 51
	  },
	  {
		"Index": 2754,
		"Rank": 47,
		"Item": "NFT People #0733",
		"Score": 51
	  },
	  {
		"Index": 2755,
		"Rank": 47,
		"Item": "NFT People #0753",
		"Score": 51
	  },
	  {
		"Index": 2756,
		"Rank": 47,
		"Item": "NFT People #0800",
		"Score": 51
	  },
	  {
		"Index": 2757,
		"Rank": 47,
		"Item": "NFT People #0827",
		"Score": 51
	  },
	  {
		"Index": 2758,
		"Rank": 47,
		"Item": "NFT People #0904",
		"Score": 51
	  },
	  {
		"Index": 2759,
		"Rank": 47,
		"Item": "NFT People #0999",
		"Score": 51
	  },
	  {
		"Index": 2760,
		"Rank": 47,
		"Item": "NFT People #1006",
		"Score": 51
	  },
	  {
		"Index": 2761,
		"Rank": 47,
		"Item": "NFT People #1022",
		"Score": 51
	  },
	  {
		"Index": 2762,
		"Rank": 47,
		"Item": "NFT People #1062",
		"Score": 51
	  },
	  {
		"Index": 2763,
		"Rank": 47,
		"Item": "NFT People #1096",
		"Score": 51
	  },
	  {
		"Index": 2764,
		"Rank": 47,
		"Item": "NFT People #1104",
		"Score": 51
	  },
	  {
		"Index": 2765,
		"Rank": 47,
		"Item": "NFT People #1110",
		"Score": 51
	  },
	  {
		"Index": 2766,
		"Rank": 47,
		"Item": "NFT People #1158",
		"Score": 51
	  },
	  {
		"Index": 2767,
		"Rank": 47,
		"Item": "NFT People #1165",
		"Score": 51
	  },
	  {
		"Index": 2768,
		"Rank": 47,
		"Item": "NFT People #1225",
		"Score": 51
	  },
	  {
		"Index": 2769,
		"Rank": 47,
		"Item": "NFT People #1227",
		"Score": 51
	  },
	  {
		"Index": 2770,
		"Rank": 47,
		"Item": "NFT People #1260",
		"Score": 51
	  },
	  {
		"Index": 2771,
		"Rank": 47,
		"Item": "NFT People #1357",
		"Score": 51
	  },
	  {
		"Index": 2772,
		"Rank": 47,
		"Item": "NFT People #1379",
		"Score": 51
	  },
	  {
		"Index": 2773,
		"Rank": 47,
		"Item": "NFT People #1401",
		"Score": 51
	  },
	  {
		"Index": 2774,
		"Rank": 47,
		"Item": "NFT People #1466",
		"Score": 51
	  },
	  {
		"Index": 2775,
		"Rank": 47,
		"Item": "NFT People #1475",
		"Score": 51
	  },
	  {
		"Index": 2776,
		"Rank": 47,
		"Item": "NFT People #1497",
		"Score": 51
	  },
	  {
		"Index": 2777,
		"Rank": 47,
		"Item": "NFT People #1519",
		"Score": 51
	  },
	  {
		"Index": 2778,
		"Rank": 47,
		"Item": "NFT People #1541",
		"Score": 51
	  },
	  {
		"Index": 2779,
		"Rank": 47,
		"Item": "NFT People #1561",
		"Score": 51
	  },
	  {
		"Index": 2780,
		"Rank": 47,
		"Item": "NFT People #1586",
		"Score": 51
	  },
	  {
		"Index": 2781,
		"Rank": 47,
		"Item": "NFT People #1602",
		"Score": 51
	  },
	  {
		"Index": 2782,
		"Rank": 47,
		"Item": "NFT People #1624",
		"Score": 51
	  },
	  {
		"Index": 2783,
		"Rank": 47,
		"Item": "NFT People #1669",
		"Score": 51
	  },
	  {
		"Index": 2784,
		"Rank": 47,
		"Item": "NFT People #1688",
		"Score": 51
	  },
	  {
		"Index": 2785,
		"Rank": 47,
		"Item": "NFT People #1704",
		"Score": 51
	  },
	  {
		"Index": 2786,
		"Rank": 47,
		"Item": "NFT People #1728",
		"Score": 51
	  },
	  {
		"Index": 2787,
		"Rank": 47,
		"Item": "NFT People #1738",
		"Score": 51
	  },
	  {
		"Index": 2788,
		"Rank": 47,
		"Item": "NFT People #1750",
		"Score": 51
	  },
	  {
		"Index": 2789,
		"Rank": 47,
		"Item": "NFT People #1791",
		"Score": 51
	  },
	  {
		"Index": 2790,
		"Rank": 47,
		"Item": "NFT People #1873",
		"Score": 51
	  },
	  {
		"Index": 2791,
		"Rank": 47,
		"Item": "NFT People #1893",
		"Score": 51
	  },
	  {
		"Index": 2792,
		"Rank": 47,
		"Item": "NFT People #1925",
		"Score": 51
	  },
	  {
		"Index": 2793,
		"Rank": 47,
		"Item": "NFT People #2007",
		"Score": 51
	  },
	  {
		"Index": 2794,
		"Rank": 47,
		"Item": "NFT People #2071",
		"Score": 51
	  },
	  {
		"Index": 2795,
		"Rank": 47,
		"Item": "NFT People #2106",
		"Score": 51
	  },
	  {
		"Index": 2796,
		"Rank": 47,
		"Item": "NFT People #2113",
		"Score": 51
	  },
	  {
		"Index": 2797,
		"Rank": 47,
		"Item": "NFT People #2154",
		"Score": 51
	  },
	  {
		"Index": 2798,
		"Rank": 47,
		"Item": "NFT People #2283",
		"Score": 51
	  },
	  {
		"Index": 2799,
		"Rank": 47,
		"Item": "NFT People #2293",
		"Score": 51
	  },
	  {
		"Index": 2800,
		"Rank": 47,
		"Item": "NFT People #2317",
		"Score": 51
	  },
	  {
		"Index": 2801,
		"Rank": 47,
		"Item": "NFT People #2357",
		"Score": 51
	  },
	  {
		"Index": 2802,
		"Rank": 47,
		"Item": "NFT People #2360",
		"Score": 51
	  },
	  {
		"Index": 2803,
		"Rank": 47,
		"Item": "NFT People #2424",
		"Score": 51
	  },
	  {
		"Index": 2804,
		"Rank": 47,
		"Item": "NFT People #2439",
		"Score": 51
	  },
	  {
		"Index": 2805,
		"Rank": 47,
		"Item": "NFT People #2458",
		"Score": 51
	  },
	  {
		"Index": 2806,
		"Rank": 47,
		"Item": "NFT People #2492",
		"Score": 51
	  },
	  {
		"Index": 2807,
		"Rank": 47,
		"Item": "NFT People #2528",
		"Score": 51
	  },
	  {
		"Index": 2808,
		"Rank": 47,
		"Item": "NFT People #2532",
		"Score": 51
	  },
	  {
		"Index": 2809,
		"Rank": 47,
		"Item": "NFT People #2571",
		"Score": 51
	  },
	  {
		"Index": 2810,
		"Rank": 47,
		"Item": "NFT People #2667",
		"Score": 51
	  },
	  {
		"Index": 2811,
		"Rank": 47,
		"Item": "NFT People #2698",
		"Score": 51
	  },
	  {
		"Index": 2812,
		"Rank": 47,
		"Item": "NFT People #2739",
		"Score": 51
	  },
	  {
		"Index": 2813,
		"Rank": 47,
		"Item": "NFT People #2773",
		"Score": 51
	  },
	  {
		"Index": 2814,
		"Rank": 47,
		"Item": "NFT People #2798",
		"Score": 51
	  },
	  {
		"Index": 2815,
		"Rank": 47,
		"Item": "NFT People #2828",
		"Score": 51
	  },
	  {
		"Index": 2816,
		"Rank": 47,
		"Item": "NFT People #2946",
		"Score": 51
	  },
	  {
		"Index": 2817,
		"Rank": 47,
		"Item": "NFT People #3056",
		"Score": 51
	  },
	  {
		"Index": 2818,
		"Rank": 47,
		"Item": "NFT People #3061",
		"Score": 51
	  },
	  {
		"Index": 2819,
		"Rank": 47,
		"Item": "NFT People #3083",
		"Score": 51
	  },
	  {
		"Index": 2820,
		"Rank": 47,
		"Item": "NFT People #3090",
		"Score": 51
	  },
	  {
		"Index": 2821,
		"Rank": 47,
		"Item": "NFT People #3131",
		"Score": 51
	  },
	  {
		"Index": 2822,
		"Rank": 47,
		"Item": "NFT People #3200",
		"Score": 51
	  },
	  {
		"Index": 2823,
		"Rank": 47,
		"Item": "NFT People #3224",
		"Score": 51
	  },
	  {
		"Index": 2824,
		"Rank": 47,
		"Item": "NFT People #3227",
		"Score": 51
	  },
	  {
		"Index": 2825,
		"Rank": 47,
		"Item": "NFT People #3248",
		"Score": 51
	  },
	  {
		"Index": 2826,
		"Rank": 47,
		"Item": "NFT People #3285",
		"Score": 51
	  },
	  {
		"Index": 2827,
		"Rank": 47,
		"Item": "NFT People #3314",
		"Score": 51
	  },
	  {
		"Index": 2828,
		"Rank": 47,
		"Item": "NFT People #3343",
		"Score": 51
	  },
	  {
		"Index": 2829,
		"Rank": 47,
		"Item": "NFT People #3387",
		"Score": 51
	  },
	  {
		"Index": 2830,
		"Rank": 47,
		"Item": "NFT People #3408",
		"Score": 51
	  },
	  {
		"Index": 2831,
		"Rank": 47,
		"Item": "NFT People #3466",
		"Score": 51
	  },
	  {
		"Index": 2832,
		"Rank": 47,
		"Item": "NFT People #3501",
		"Score": 51
	  },
	  {
		"Index": 2833,
		"Rank": 47,
		"Item": "NFT People #3537",
		"Score": 51
	  },
	  {
		"Index": 2834,
		"Rank": 47,
		"Item": "NFT People #3615",
		"Score": 51
	  },
	  {
		"Index": 2835,
		"Rank": 47,
		"Item": "NFT People #3621",
		"Score": 51
	  },
	  {
		"Index": 2836,
		"Rank": 47,
		"Item": "NFT People #3646",
		"Score": 51
	  },
	  {
		"Index": 2837,
		"Rank": 47,
		"Item": "NFT People #3665",
		"Score": 51
	  },
	  {
		"Index": 2838,
		"Rank": 47,
		"Item": "NFT People #3715",
		"Score": 51
	  },
	  {
		"Index": 2839,
		"Rank": 47,
		"Item": "NFT People #3731",
		"Score": 51
	  },
	  {
		"Index": 2840,
		"Rank": 47,
		"Item": "NFT People #3785",
		"Score": 51
	  },
	  {
		"Index": 2841,
		"Rank": 47,
		"Item": "NFT People #3800",
		"Score": 51
	  },
	  {
		"Index": 2842,
		"Rank": 47,
		"Item": "NFT People #3801",
		"Score": 51
	  },
	  {
		"Index": 2843,
		"Rank": 47,
		"Item": "NFT People #3809",
		"Score": 51
	  },
	  {
		"Index": 2844,
		"Rank": 47,
		"Item": "NFT People #3821",
		"Score": 51
	  },
	  {
		"Index": 2845,
		"Rank": 47,
		"Item": "NFT People #3827",
		"Score": 51
	  },
	  {
		"Index": 2846,
		"Rank": 47,
		"Item": "NFT People #3843",
		"Score": 51
	  },
	  {
		"Index": 2847,
		"Rank": 47,
		"Item": "NFT People #3867",
		"Score": 51
	  },
	  {
		"Index": 2848,
		"Rank": 47,
		"Item": "NFT People #3879",
		"Score": 51
	  },
	  {
		"Index": 2849,
		"Rank": 47,
		"Item": "NFT People #3938",
		"Score": 51
	  },
	  {
		"Index": 2850,
		"Rank": 47,
		"Item": "NFT People #3976",
		"Score": 51
	  },
	  {
		"Index": 2851,
		"Rank": 47,
		"Item": "NFT People #4087",
		"Score": 51
	  },
	  {
		"Index": 2852,
		"Rank": 47,
		"Item": "NFT People #4094",
		"Score": 51
	  },
	  {
		"Index": 2853,
		"Rank": 47,
		"Item": "NFT People #4155",
		"Score": 51
	  },
	  {
		"Index": 2854,
		"Rank": 47,
		"Item": "NFT People #4181",
		"Score": 51
	  },
	  {
		"Index": 2855,
		"Rank": 47,
		"Item": "NFT People #4290",
		"Score": 51
	  },
	  {
		"Index": 2856,
		"Rank": 47,
		"Item": "NFT People #4298",
		"Score": 51
	  },
	  {
		"Index": 2857,
		"Rank": 47,
		"Item": "NFT People #4437",
		"Score": 51
	  },
	  {
		"Index": 2858,
		"Rank": 47,
		"Item": "NFT People #4447",
		"Score": 51
	  },
	  {
		"Index": 2859,
		"Rank": 47,
		"Item": "NFT People #4452",
		"Score": 51
	  },
	  {
		"Index": 2860,
		"Rank": 47,
		"Item": "NFT People #4468",
		"Score": 51
	  },
	  {
		"Index": 2861,
		"Rank": 47,
		"Item": "NFT People #4475",
		"Score": 51
	  },
	  {
		"Index": 2862,
		"Rank": 47,
		"Item": "NFT People #4485",
		"Score": 51
	  },
	  {
		"Index": 2863,
		"Rank": 47,
		"Item": "NFT People #4529",
		"Score": 51
	  },
	  {
		"Index": 2864,
		"Rank": 47,
		"Item": "NFT People #4553",
		"Score": 51
	  },
	  {
		"Index": 2865,
		"Rank": 47,
		"Item": "NFT People #4609",
		"Score": 51
	  },
	  {
		"Index": 2866,
		"Rank": 47,
		"Item": "NFT People #4636",
		"Score": 51
	  },
	  {
		"Index": 2867,
		"Rank": 47,
		"Item": "NFT People #4677",
		"Score": 51
	  },
	  {
		"Index": 2868,
		"Rank": 47,
		"Item": "NFT People #4695",
		"Score": 51
	  },
	  {
		"Index": 2869,
		"Rank": 47,
		"Item": "NFT People #4697",
		"Score": 51
	  },
	  {
		"Index": 2870,
		"Rank": 47,
		"Item": "NFT People #4799",
		"Score": 51
	  },
	  {
		"Index": 2871,
		"Rank": 47,
		"Item": "NFT People #4858",
		"Score": 51
	  },
	  {
		"Index": 2872,
		"Rank": 47,
		"Item": "NFT People #4873",
		"Score": 51
	  },
	  {
		"Index": 2873,
		"Rank": 47,
		"Item": "NFT People #4875",
		"Score": 51
	  },
	  {
		"Index": 2874,
		"Rank": 47,
		"Item": "NFT People #4959",
		"Score": 51
	  },
	  {
		"Index": 2875,
		"Rank": 47,
		"Item": "NFT People #4968",
		"Score": 51
	  },
	  {
		"Index": 2876,
		"Rank": 48,
		"Item": "NFT People #0043",
		"Score": 50
	  },
	  {
		"Index": 2877,
		"Rank": 48,
		"Item": "NFT People #0051",
		"Score": 50
	  },
	  {
		"Index": 2878,
		"Rank": 48,
		"Item": "NFT People #0076",
		"Score": 50
	  },
	  {
		"Index": 2879,
		"Rank": 48,
		"Item": "NFT People #0096",
		"Score": 50
	  },
	  {
		"Index": 2880,
		"Rank": 48,
		"Item": "NFT People #0119",
		"Score": 50
	  },
	  {
		"Index": 2881,
		"Rank": 48,
		"Item": "NFT People #0167",
		"Score": 50
	  },
	  {
		"Index": 2882,
		"Rank": 48,
		"Item": "NFT People #0169",
		"Score": 50
	  },
	  {
		"Index": 2883,
		"Rank": 48,
		"Item": "NFT People #0171",
		"Score": 50
	  },
	  {
		"Index": 2884,
		"Rank": 48,
		"Item": "NFT People #0188",
		"Score": 50
	  },
	  {
		"Index": 2885,
		"Rank": 48,
		"Item": "NFT People #0233",
		"Score": 50
	  },
	  {
		"Index": 2886,
		"Rank": 48,
		"Item": "NFT People #0278",
		"Score": 50
	  },
	  {
		"Index": 2887,
		"Rank": 48,
		"Item": "NFT People #0323",
		"Score": 50
	  },
	  {
		"Index": 2888,
		"Rank": 48,
		"Item": "NFT People #0352",
		"Score": 50
	  },
	  {
		"Index": 2889,
		"Rank": 48,
		"Item": "NFT People #0353",
		"Score": 50
	  },
	  {
		"Index": 2890,
		"Rank": 48,
		"Item": "NFT People #0354",
		"Score": 50
	  },
	  {
		"Index": 2891,
		"Rank": 48,
		"Item": "NFT People #0356",
		"Score": 50
	  },
	  {
		"Index": 2892,
		"Rank": 48,
		"Item": "NFT People #0398",
		"Score": 50
	  },
	  {
		"Index": 2893,
		"Rank": 48,
		"Item": "NFT People #0435",
		"Score": 50
	  },
	  {
		"Index": 2894,
		"Rank": 48,
		"Item": "NFT People #0447",
		"Score": 50
	  },
	  {
		"Index": 2895,
		"Rank": 48,
		"Item": "NFT People #0458",
		"Score": 50
	  },
	  {
		"Index": 2896,
		"Rank": 48,
		"Item": "NFT People #0463",
		"Score": 50
	  },
	  {
		"Index": 2897,
		"Rank": 48,
		"Item": "NFT People #0529",
		"Score": 50
	  },
	  {
		"Index": 2898,
		"Rank": 48,
		"Item": "NFT People #0548",
		"Score": 50
	  },
	  {
		"Index": 2899,
		"Rank": 48,
		"Item": "NFT People #0551",
		"Score": 50
	  },
	  {
		"Index": 2900,
		"Rank": 48,
		"Item": "NFT People #0556",
		"Score": 50
	  },
	  {
		"Index": 2901,
		"Rank": 48,
		"Item": "NFT People #0568",
		"Score": 50
	  },
	  {
		"Index": 2902,
		"Rank": 48,
		"Item": "NFT People #0593",
		"Score": 50
	  },
	  {
		"Index": 2903,
		"Rank": 48,
		"Item": "NFT People #0643",
		"Score": 50
	  },
	  {
		"Index": 2904,
		"Rank": 48,
		"Item": "NFT People #0660",
		"Score": 50
	  },
	  {
		"Index": 2905,
		"Rank": 48,
		"Item": "NFT People #0663",
		"Score": 50
	  },
	  {
		"Index": 2906,
		"Rank": 48,
		"Item": "NFT People #0667",
		"Score": 50
	  },
	  {
		"Index": 2907,
		"Rank": 48,
		"Item": "NFT People #0747",
		"Score": 50
	  },
	  {
		"Index": 2908,
		"Rank": 48,
		"Item": "NFT People #0811",
		"Score": 50
	  },
	  {
		"Index": 2909,
		"Rank": 48,
		"Item": "NFT People #0824",
		"Score": 50
	  },
	  {
		"Index": 2910,
		"Rank": 48,
		"Item": "NFT People #0880",
		"Score": 50
	  },
	  {
		"Index": 2911,
		"Rank": 48,
		"Item": "NFT People #0889",
		"Score": 50
	  },
	  {
		"Index": 2912,
		"Rank": 48,
		"Item": "NFT People #0893",
		"Score": 50
	  },
	  {
		"Index": 2913,
		"Rank": 48,
		"Item": "NFT People #0989",
		"Score": 50
	  },
	  {
		"Index": 2914,
		"Rank": 48,
		"Item": "NFT People #1012",
		"Score": 50
	  },
	  {
		"Index": 2915,
		"Rank": 48,
		"Item": "NFT People #1051",
		"Score": 50
	  },
	  {
		"Index": 2916,
		"Rank": 48,
		"Item": "NFT People #1063",
		"Score": 50
	  },
	  {
		"Index": 2917,
		"Rank": 48,
		"Item": "NFT People #1073",
		"Score": 50
	  },
	  {
		"Index": 2918,
		"Rank": 48,
		"Item": "NFT People #1079",
		"Score": 50
	  },
	  {
		"Index": 2919,
		"Rank": 48,
		"Item": "NFT People #1088",
		"Score": 50
	  },
	  {
		"Index": 2920,
		"Rank": 48,
		"Item": "NFT People #1117",
		"Score": 50
	  },
	  {
		"Index": 2921,
		"Rank": 48,
		"Item": "NFT People #1133",
		"Score": 50
	  },
	  {
		"Index": 2922,
		"Rank": 48,
		"Item": "NFT People #1140",
		"Score": 50
	  },
	  {
		"Index": 2923,
		"Rank": 48,
		"Item": "NFT People #1276",
		"Score": 50
	  },
	  {
		"Index": 2924,
		"Rank": 48,
		"Item": "NFT People #1315",
		"Score": 50
	  },
	  {
		"Index": 2925,
		"Rank": 48,
		"Item": "NFT People #1336",
		"Score": 50
	  },
	  {
		"Index": 2926,
		"Rank": 48,
		"Item": "NFT People #1365",
		"Score": 50
	  },
	  {
		"Index": 2927,
		"Rank": 48,
		"Item": "NFT People #1485",
		"Score": 50
	  },
	  {
		"Index": 2928,
		"Rank": 48,
		"Item": "NFT People #1502",
		"Score": 50
	  },
	  {
		"Index": 2929,
		"Rank": 48,
		"Item": "NFT People #1607",
		"Score": 50
	  },
	  {
		"Index": 2930,
		"Rank": 48,
		"Item": "NFT People #1629",
		"Score": 50
	  },
	  {
		"Index": 2931,
		"Rank": 48,
		"Item": "NFT People #1666",
		"Score": 50
	  },
	  {
		"Index": 2932,
		"Rank": 48,
		"Item": "NFT People #1714",
		"Score": 50
	  },
	  {
		"Index": 2933,
		"Rank": 48,
		"Item": "NFT People #1756",
		"Score": 50
	  },
	  {
		"Index": 2934,
		"Rank": 48,
		"Item": "NFT People #1771",
		"Score": 50
	  },
	  {
		"Index": 2935,
		"Rank": 48,
		"Item": "NFT People #1773",
		"Score": 50
	  },
	  {
		"Index": 2936,
		"Rank": 48,
		"Item": "NFT People #1808",
		"Score": 50
	  },
	  {
		"Index": 2937,
		"Rank": 48,
		"Item": "NFT People #1818",
		"Score": 50
	  },
	  {
		"Index": 2938,
		"Rank": 48,
		"Item": "NFT People #1822",
		"Score": 50
	  },
	  {
		"Index": 2939,
		"Rank": 48,
		"Item": "NFT People #1831",
		"Score": 50
	  },
	  {
		"Index": 2940,
		"Rank": 48,
		"Item": "NFT People #1858",
		"Score": 50
	  },
	  {
		"Index": 2941,
		"Rank": 48,
		"Item": "NFT People #1876",
		"Score": 50
	  },
	  {
		"Index": 2942,
		"Rank": 48,
		"Item": "NFT People #1891",
		"Score": 50
	  },
	  {
		"Index": 2943,
		"Rank": 48,
		"Item": "NFT People #1910",
		"Score": 50
	  },
	  {
		"Index": 2944,
		"Rank": 48,
		"Item": "NFT People #1934",
		"Score": 50
	  },
	  {
		"Index": 2945,
		"Rank": 48,
		"Item": "NFT People #2003",
		"Score": 50
	  },
	  {
		"Index": 2946,
		"Rank": 48,
		"Item": "NFT People #2013",
		"Score": 50
	  },
	  {
		"Index": 2947,
		"Rank": 48,
		"Item": "NFT People #2057",
		"Score": 50
	  },
	  {
		"Index": 2948,
		"Rank": 48,
		"Item": "NFT People #2064",
		"Score": 50
	  },
	  {
		"Index": 2949,
		"Rank": 48,
		"Item": "NFT People #2067",
		"Score": 50
	  },
	  {
		"Index": 2950,
		"Rank": 48,
		"Item": "NFT People #2134",
		"Score": 50
	  },
	  {
		"Index": 2951,
		"Rank": 48,
		"Item": "NFT People #2138",
		"Score": 50
	  },
	  {
		"Index": 2952,
		"Rank": 48,
		"Item": "NFT People #2229",
		"Score": 50
	  },
	  {
		"Index": 2953,
		"Rank": 48,
		"Item": "NFT People #2238",
		"Score": 50
	  },
	  {
		"Index": 2954,
		"Rank": 48,
		"Item": "NFT People #2256",
		"Score": 50
	  },
	  {
		"Index": 2955,
		"Rank": 48,
		"Item": "NFT People #2271",
		"Score": 50
	  },
	  {
		"Index": 2956,
		"Rank": 48,
		"Item": "NFT People #2301",
		"Score": 50
	  },
	  {
		"Index": 2957,
		"Rank": 48,
		"Item": "NFT People #2335",
		"Score": 50
	  },
	  {
		"Index": 2958,
		"Rank": 48,
		"Item": "NFT People #2362",
		"Score": 50
	  },
	  {
		"Index": 2959,
		"Rank": 48,
		"Item": "NFT People #2403",
		"Score": 50
	  },
	  {
		"Index": 2960,
		"Rank": 48,
		"Item": "NFT People #2427",
		"Score": 50
	  },
	  {
		"Index": 2961,
		"Rank": 48,
		"Item": "NFT People #2446",
		"Score": 50
	  },
	  {
		"Index": 2962,
		"Rank": 48,
		"Item": "NFT People #2468",
		"Score": 50
	  },
	  {
		"Index": 2963,
		"Rank": 48,
		"Item": "NFT People #2509",
		"Score": 50
	  },
	  {
		"Index": 2964,
		"Rank": 48,
		"Item": "NFT People #2604",
		"Score": 50
	  },
	  {
		"Index": 2965,
		"Rank": 48,
		"Item": "NFT People #2637",
		"Score": 50
	  },
	  {
		"Index": 2966,
		"Rank": 48,
		"Item": "NFT People #2674",
		"Score": 50
	  },
	  {
		"Index": 2967,
		"Rank": 48,
		"Item": "NFT People #2701",
		"Score": 50
	  },
	  {
		"Index": 2968,
		"Rank": 48,
		"Item": "NFT People #2762",
		"Score": 50
	  },
	  {
		"Index": 2969,
		"Rank": 48,
		"Item": "NFT People #2780",
		"Score": 50
	  },
	  {
		"Index": 2970,
		"Rank": 48,
		"Item": "NFT People #2808",
		"Score": 50
	  },
	  {
		"Index": 2971,
		"Rank": 48,
		"Item": "NFT People #2875",
		"Score": 50
	  },
	  {
		"Index": 2972,
		"Rank": 48,
		"Item": "NFT People #2958",
		"Score": 50
	  },
	  {
		"Index": 2973,
		"Rank": 48,
		"Item": "NFT People #2980",
		"Score": 50
	  },
	  {
		"Index": 2974,
		"Rank": 48,
		"Item": "NFT People #3008",
		"Score": 50
	  },
	  {
		"Index": 2975,
		"Rank": 48,
		"Item": "NFT People #3022",
		"Score": 50
	  },
	  {
		"Index": 2976,
		"Rank": 48,
		"Item": "NFT People #3036",
		"Score": 50
	  },
	  {
		"Index": 2977,
		"Rank": 48,
		"Item": "NFT People #3100",
		"Score": 50
	  },
	  {
		"Index": 2978,
		"Rank": 48,
		"Item": "NFT People #3124",
		"Score": 50
	  },
	  {
		"Index": 2979,
		"Rank": 48,
		"Item": "NFT People #3175",
		"Score": 50
	  },
	  {
		"Index": 2980,
		"Rank": 48,
		"Item": "NFT People #3198",
		"Score": 50
	  },
	  {
		"Index": 2981,
		"Rank": 48,
		"Item": "NFT People #3219",
		"Score": 50
	  },
	  {
		"Index": 2982,
		"Rank": 48,
		"Item": "NFT People #3334",
		"Score": 50
	  },
	  {
		"Index": 2983,
		"Rank": 48,
		"Item": "NFT People #3338",
		"Score": 50
	  },
	  {
		"Index": 2984,
		"Rank": 48,
		"Item": "NFT People #3403",
		"Score": 50
	  },
	  {
		"Index": 2985,
		"Rank": 48,
		"Item": "NFT People #3448",
		"Score": 50
	  },
	  {
		"Index": 2986,
		"Rank": 48,
		"Item": "NFT People #3495",
		"Score": 50
	  },
	  {
		"Index": 2987,
		"Rank": 48,
		"Item": "NFT People #3515",
		"Score": 50
	  },
	  {
		"Index": 2988,
		"Rank": 48,
		"Item": "NFT People #3608",
		"Score": 50
	  },
	  {
		"Index": 2989,
		"Rank": 48,
		"Item": "NFT People #3648",
		"Score": 50
	  },
	  {
		"Index": 2990,
		"Rank": 48,
		"Item": "NFT People #3682",
		"Score": 50
	  },
	  {
		"Index": 2991,
		"Rank": 48,
		"Item": "NFT People #3705",
		"Score": 50
	  },
	  {
		"Index": 2992,
		"Rank": 48,
		"Item": "NFT People #3787",
		"Score": 50
	  },
	  {
		"Index": 2993,
		"Rank": 48,
		"Item": "NFT People #3818",
		"Score": 50
	  },
	  {
		"Index": 2994,
		"Rank": 48,
		"Item": "NFT People #3876",
		"Score": 50
	  },
	  {
		"Index": 2995,
		"Rank": 48,
		"Item": "NFT People #3962",
		"Score": 50
	  },
	  {
		"Index": 2996,
		"Rank": 48,
		"Item": "NFT People #3964",
		"Score": 50
	  },
	  {
		"Index": 2997,
		"Rank": 48,
		"Item": "NFT People #3994",
		"Score": 50
	  },
	  {
		"Index": 2998,
		"Rank": 48,
		"Item": "NFT People #4068",
		"Score": 50
	  },
	  {
		"Index": 2999,
		"Rank": 48,
		"Item": "NFT People #4236",
		"Score": 50
	  },
	  {
		"Index": 3000,
		"Rank": 48,
		"Item": "NFT People #4279",
		"Score": 50
	  },
	  {
		"Index": 3001,
		"Rank": 48,
		"Item": "NFT People #4291",
		"Score": 50
	  },
	  {
		"Index": 3002,
		"Rank": 48,
		"Item": "NFT People #4312",
		"Score": 50
	  },
	  {
		"Index": 3003,
		"Rank": 48,
		"Item": "NFT People #4347",
		"Score": 50
	  },
	  {
		"Index": 3004,
		"Rank": 48,
		"Item": "NFT People #4358",
		"Score": 50
	  },
	  {
		"Index": 3005,
		"Rank": 48,
		"Item": "NFT People #4374",
		"Score": 50
	  },
	  {
		"Index": 3006,
		"Rank": 48,
		"Item": "NFT People #4388",
		"Score": 50
	  },
	  {
		"Index": 3007,
		"Rank": 48,
		"Item": "NFT People #4458",
		"Score": 50
	  },
	  {
		"Index": 3008,
		"Rank": 48,
		"Item": "NFT People #4537",
		"Score": 50
	  },
	  {
		"Index": 3009,
		"Rank": 48,
		"Item": "NFT People #4565",
		"Score": 50
	  },
	  {
		"Index": 3010,
		"Rank": 48,
		"Item": "NFT People #4573",
		"Score": 50
	  },
	  {
		"Index": 3011,
		"Rank": 48,
		"Item": "NFT People #4601",
		"Score": 50
	  },
	  {
		"Index": 3012,
		"Rank": 48,
		"Item": "NFT People #4604",
		"Score": 50
	  },
	  {
		"Index": 3013,
		"Rank": 48,
		"Item": "NFT People #4606",
		"Score": 50
	  },
	  {
		"Index": 3014,
		"Rank": 48,
		"Item": "NFT People #4617",
		"Score": 50
	  },
	  {
		"Index": 3015,
		"Rank": 48,
		"Item": "NFT People #4624",
		"Score": 50
	  },
	  {
		"Index": 3016,
		"Rank": 48,
		"Item": "NFT People #4629",
		"Score": 50
	  },
	  {
		"Index": 3017,
		"Rank": 48,
		"Item": "NFT People #4648",
		"Score": 50
	  },
	  {
		"Index": 3018,
		"Rank": 48,
		"Item": "NFT People #4656",
		"Score": 50
	  },
	  {
		"Index": 3019,
		"Rank": 48,
		"Item": "NFT People #4688",
		"Score": 50
	  },
	  {
		"Index": 3020,
		"Rank": 48,
		"Item": "NFT People #4706",
		"Score": 50
	  },
	  {
		"Index": 3021,
		"Rank": 48,
		"Item": "NFT People #4708",
		"Score": 50
	  },
	  {
		"Index": 3022,
		"Rank": 48,
		"Item": "NFT People #4715",
		"Score": 50
	  },
	  {
		"Index": 3023,
		"Rank": 48,
		"Item": "NFT People #4774",
		"Score": 50
	  },
	  {
		"Index": 3024,
		"Rank": 48,
		"Item": "NFT People #4823",
		"Score": 50
	  },
	  {
		"Index": 3025,
		"Rank": 48,
		"Item": "NFT People #4837",
		"Score": 50
	  },
	  {
		"Index": 3026,
		"Rank": 48,
		"Item": "NFT People #4849",
		"Score": 50
	  },
	  {
		"Index": 3027,
		"Rank": 48,
		"Item": "NFT People #4872",
		"Score": 50
	  },
	  {
		"Index": 3028,
		"Rank": 48,
		"Item": "NFT People #4903",
		"Score": 50
	  },
	  {
		"Index": 3029,
		"Rank": 48,
		"Item": "NFT People #4936",
		"Score": 50
	  },
	  {
		"Index": 3030,
		"Rank": 48,
		"Item": "NFT People #4976",
		"Score": 50
	  },
	  {
		"Index": 3031,
		"Rank": 49,
		"Item": "NFT People #0008",
		"Score": 49
	  },
	  {
		"Index": 3032,
		"Rank": 49,
		"Item": "NFT People #0016",
		"Score": 49
	  },
	  {
		"Index": 3033,
		"Rank": 49,
		"Item": "NFT People #0054",
		"Score": 49
	  },
	  {
		"Index": 3034,
		"Rank": 49,
		"Item": "NFT People #0120",
		"Score": 49
	  },
	  {
		"Index": 3035,
		"Rank": 49,
		"Item": "NFT People #0161",
		"Score": 49
	  },
	  {
		"Index": 3036,
		"Rank": 49,
		"Item": "NFT People #0166",
		"Score": 49
	  },
	  {
		"Index": 3037,
		"Rank": 49,
		"Item": "NFT People #0170",
		"Score": 49
	  },
	  {
		"Index": 3038,
		"Rank": 49,
		"Item": "NFT People #0183",
		"Score": 49
	  },
	  {
		"Index": 3039,
		"Rank": 49,
		"Item": "NFT People #0288",
		"Score": 49
	  },
	  {
		"Index": 3040,
		"Rank": 49,
		"Item": "NFT People #0291",
		"Score": 49
	  },
	  {
		"Index": 3041,
		"Rank": 49,
		"Item": "NFT People #0295",
		"Score": 49
	  },
	  {
		"Index": 3042,
		"Rank": 49,
		"Item": "NFT People #0351",
		"Score": 49
	  },
	  {
		"Index": 3043,
		"Rank": 49,
		"Item": "NFT People #0363",
		"Score": 49
	  },
	  {
		"Index": 3044,
		"Rank": 49,
		"Item": "NFT People #0454",
		"Score": 49
	  },
	  {
		"Index": 3045,
		"Rank": 49,
		"Item": "NFT People #0545",
		"Score": 49
	  },
	  {
		"Index": 3046,
		"Rank": 49,
		"Item": "NFT People #0571",
		"Score": 49
	  },
	  {
		"Index": 3047,
		"Rank": 49,
		"Item": "NFT People #0572",
		"Score": 49
	  },
	  {
		"Index": 3048,
		"Rank": 49,
		"Item": "NFT People #0634",
		"Score": 49
	  },
	  {
		"Index": 3049,
		"Rank": 49,
		"Item": "NFT People #0646",
		"Score": 49
	  },
	  {
		"Index": 3050,
		"Rank": 49,
		"Item": "NFT People #0656",
		"Score": 49
	  },
	  {
		"Index": 3051,
		"Rank": 49,
		"Item": "NFT People #0669",
		"Score": 49
	  },
	  {
		"Index": 3052,
		"Rank": 49,
		"Item": "NFT People #0678",
		"Score": 49
	  },
	  {
		"Index": 3053,
		"Rank": 49,
		"Item": "NFT People #0692",
		"Score": 49
	  },
	  {
		"Index": 3054,
		"Rank": 49,
		"Item": "NFT People #0765",
		"Score": 49
	  },
	  {
		"Index": 3055,
		"Rank": 49,
		"Item": "NFT People #0768",
		"Score": 49
	  },
	  {
		"Index": 3056,
		"Rank": 49,
		"Item": "NFT People #0781",
		"Score": 49
	  },
	  {
		"Index": 3057,
		"Rank": 49,
		"Item": "NFT People #0865",
		"Score": 49
	  },
	  {
		"Index": 3058,
		"Rank": 49,
		"Item": "NFT People #0879",
		"Score": 49
	  },
	  {
		"Index": 3059,
		"Rank": 49,
		"Item": "NFT People #0882",
		"Score": 49
	  },
	  {
		"Index": 3060,
		"Rank": 49,
		"Item": "NFT People #0887",
		"Score": 49
	  },
	  {
		"Index": 3061,
		"Rank": 49,
		"Item": "NFT People #0910",
		"Score": 49
	  },
	  {
		"Index": 3062,
		"Rank": 49,
		"Item": "NFT People #0928",
		"Score": 49
	  },
	  {
		"Index": 3063,
		"Rank": 49,
		"Item": "NFT People #0965",
		"Score": 49
	  },
	  {
		"Index": 3064,
		"Rank": 49,
		"Item": "NFT People #0967",
		"Score": 49
	  },
	  {
		"Index": 3065,
		"Rank": 49,
		"Item": "NFT People #0973",
		"Score": 49
	  },
	  {
		"Index": 3066,
		"Rank": 49,
		"Item": "NFT People #0979",
		"Score": 49
	  },
	  {
		"Index": 3067,
		"Rank": 49,
		"Item": "NFT People #1018",
		"Score": 49
	  },
	  {
		"Index": 3068,
		"Rank": 49,
		"Item": "NFT People #1040",
		"Score": 49
	  },
	  {
		"Index": 3069,
		"Rank": 49,
		"Item": "NFT People #1123",
		"Score": 49
	  },
	  {
		"Index": 3070,
		"Rank": 49,
		"Item": "NFT People #1130",
		"Score": 49
	  },
	  {
		"Index": 3071,
		"Rank": 49,
		"Item": "NFT People #1190",
		"Score": 49
	  },
	  {
		"Index": 3072,
		"Rank": 49,
		"Item": "NFT People #1197",
		"Score": 49
	  },
	  {
		"Index": 3073,
		"Rank": 49,
		"Item": "NFT People #1217",
		"Score": 49
	  },
	  {
		"Index": 3074,
		"Rank": 49,
		"Item": "NFT People #1251",
		"Score": 49
	  },
	  {
		"Index": 3075,
		"Rank": 49,
		"Item": "NFT People #1272",
		"Score": 49
	  },
	  {
		"Index": 3076,
		"Rank": 49,
		"Item": "NFT People #1288",
		"Score": 49
	  },
	  {
		"Index": 3077,
		"Rank": 49,
		"Item": "NFT People #1300",
		"Score": 49
	  },
	  {
		"Index": 3078,
		"Rank": 49,
		"Item": "NFT People #1346",
		"Score": 49
	  },
	  {
		"Index": 3079,
		"Rank": 49,
		"Item": "NFT People #1354",
		"Score": 49
	  },
	  {
		"Index": 3080,
		"Rank": 49,
		"Item": "NFT People #1369",
		"Score": 49
	  },
	  {
		"Index": 3081,
		"Rank": 49,
		"Item": "NFT People #1391",
		"Score": 49
	  },
	  {
		"Index": 3082,
		"Rank": 49,
		"Item": "NFT People #1396",
		"Score": 49
	  },
	  {
		"Index": 3083,
		"Rank": 49,
		"Item": "NFT People #1431",
		"Score": 49
	  },
	  {
		"Index": 3084,
		"Rank": 49,
		"Item": "NFT People #1465",
		"Score": 49
	  },
	  {
		"Index": 3085,
		"Rank": 49,
		"Item": "NFT People #1486",
		"Score": 49
	  },
	  {
		"Index": 3086,
		"Rank": 49,
		"Item": "NFT People #1542",
		"Score": 49
	  },
	  {
		"Index": 3087,
		"Rank": 49,
		"Item": "NFT People #1609",
		"Score": 49
	  },
	  {
		"Index": 3088,
		"Rank": 49,
		"Item": "NFT People #1611",
		"Score": 49
	  },
	  {
		"Index": 3089,
		"Rank": 49,
		"Item": "NFT People #1642",
		"Score": 49
	  },
	  {
		"Index": 3090,
		"Rank": 49,
		"Item": "NFT People #1647",
		"Score": 49
	  },
	  {
		"Index": 3091,
		"Rank": 49,
		"Item": "NFT People #1662",
		"Score": 49
	  },
	  {
		"Index": 3092,
		"Rank": 49,
		"Item": "NFT People #1695",
		"Score": 49
	  },
	  {
		"Index": 3093,
		"Rank": 49,
		"Item": "NFT People #1731",
		"Score": 49
	  },
	  {
		"Index": 3094,
		"Rank": 49,
		"Item": "NFT People #1766",
		"Score": 49
	  },
	  {
		"Index": 3095,
		"Rank": 49,
		"Item": "NFT People #1793",
		"Score": 49
	  },
	  {
		"Index": 3096,
		"Rank": 49,
		"Item": "NFT People #1810",
		"Score": 49
	  },
	  {
		"Index": 3097,
		"Rank": 49,
		"Item": "NFT People #1812",
		"Score": 49
	  },
	  {
		"Index": 3098,
		"Rank": 49,
		"Item": "NFT People #1894",
		"Score": 49
	  },
	  {
		"Index": 3099,
		"Rank": 49,
		"Item": "NFT People #1939",
		"Score": 49
	  },
	  {
		"Index": 3100,
		"Rank": 49,
		"Item": "NFT People #1976",
		"Score": 49
	  },
	  {
		"Index": 3101,
		"Rank": 49,
		"Item": "NFT People #1983",
		"Score": 49
	  },
	  {
		"Index": 3102,
		"Rank": 49,
		"Item": "NFT People #1990",
		"Score": 49
	  },
	  {
		"Index": 3103,
		"Rank": 49,
		"Item": "NFT People #2050",
		"Score": 49
	  },
	  {
		"Index": 3104,
		"Rank": 49,
		"Item": "NFT People #2070",
		"Score": 49
	  },
	  {
		"Index": 3105,
		"Rank": 49,
		"Item": "NFT People #2076",
		"Score": 49
	  },
	  {
		"Index": 3106,
		"Rank": 49,
		"Item": "NFT People #2084",
		"Score": 49
	  },
	  {
		"Index": 3107,
		"Rank": 49,
		"Item": "NFT People #2086",
		"Score": 49
	  },
	  {
		"Index": 3108,
		"Rank": 49,
		"Item": "NFT People #2098",
		"Score": 49
	  },
	  {
		"Index": 3109,
		"Rank": 49,
		"Item": "NFT People #2105",
		"Score": 49
	  },
	  {
		"Index": 3110,
		"Rank": 49,
		"Item": "NFT People #2145",
		"Score": 49
	  },
	  {
		"Index": 3111,
		"Rank": 49,
		"Item": "NFT People #2236",
		"Score": 49
	  },
	  {
		"Index": 3112,
		"Rank": 49,
		"Item": "NFT People #2280",
		"Score": 49
	  },
	  {
		"Index": 3113,
		"Rank": 49,
		"Item": "NFT People #2291",
		"Score": 49
	  },
	  {
		"Index": 3114,
		"Rank": 49,
		"Item": "NFT People #2296",
		"Score": 49
	  },
	  {
		"Index": 3115,
		"Rank": 49,
		"Item": "NFT People #2304",
		"Score": 49
	  },
	  {
		"Index": 3116,
		"Rank": 49,
		"Item": "NFT People #2328",
		"Score": 49
	  },
	  {
		"Index": 3117,
		"Rank": 49,
		"Item": "NFT People #2363",
		"Score": 49
	  },
	  {
		"Index": 3118,
		"Rank": 49,
		"Item": "NFT People #2365",
		"Score": 49
	  },
	  {
		"Index": 3119,
		"Rank": 49,
		"Item": "NFT People #2395",
		"Score": 49
	  },
	  {
		"Index": 3120,
		"Rank": 49,
		"Item": "NFT People #2430",
		"Score": 49
	  },
	  {
		"Index": 3121,
		"Rank": 49,
		"Item": "NFT People #2451",
		"Score": 49
	  },
	  {
		"Index": 3122,
		"Rank": 49,
		"Item": "NFT People #2460",
		"Score": 49
	  },
	  {
		"Index": 3123,
		"Rank": 49,
		"Item": "NFT People #2462",
		"Score": 49
	  },
	  {
		"Index": 3124,
		"Rank": 49,
		"Item": "NFT People #2475",
		"Score": 49
	  },
	  {
		"Index": 3125,
		"Rank": 49,
		"Item": "NFT People #2478",
		"Score": 49
	  },
	  {
		"Index": 3126,
		"Rank": 49,
		"Item": "NFT People #2488",
		"Score": 49
	  },
	  {
		"Index": 3127,
		"Rank": 49,
		"Item": "NFT People #2501",
		"Score": 49
	  },
	  {
		"Index": 3128,
		"Rank": 49,
		"Item": "NFT People #2564",
		"Score": 49
	  },
	  {
		"Index": 3129,
		"Rank": 49,
		"Item": "NFT People #2606",
		"Score": 49
	  },
	  {
		"Index": 3130,
		"Rank": 49,
		"Item": "NFT People #2607",
		"Score": 49
	  },
	  {
		"Index": 3131,
		"Rank": 49,
		"Item": "NFT People #2708",
		"Score": 49
	  },
	  {
		"Index": 3132,
		"Rank": 49,
		"Item": "NFT People #2721",
		"Score": 49
	  },
	  {
		"Index": 3133,
		"Rank": 49,
		"Item": "NFT People #2754",
		"Score": 49
	  },
	  {
		"Index": 3134,
		"Rank": 49,
		"Item": "NFT People #2758",
		"Score": 49
	  },
	  {
		"Index": 3135,
		"Rank": 49,
		"Item": "NFT People #2779",
		"Score": 49
	  },
	  {
		"Index": 3136,
		"Rank": 49,
		"Item": "NFT People #2781",
		"Score": 49
	  },
	  {
		"Index": 3137,
		"Rank": 49,
		"Item": "NFT People #2811",
		"Score": 49
	  },
	  {
		"Index": 3138,
		"Rank": 49,
		"Item": "NFT People #2820",
		"Score": 49
	  },
	  {
		"Index": 3139,
		"Rank": 49,
		"Item": "NFT People #2895",
		"Score": 49
	  },
	  {
		"Index": 3140,
		"Rank": 49,
		"Item": "NFT People #2915",
		"Score": 49
	  },
	  {
		"Index": 3141,
		"Rank": 49,
		"Item": "NFT People #2918",
		"Score": 49
	  },
	  {
		"Index": 3142,
		"Rank": 49,
		"Item": "NFT People #2919",
		"Score": 49
	  },
	  {
		"Index": 3143,
		"Rank": 49,
		"Item": "NFT People #2924",
		"Score": 49
	  },
	  {
		"Index": 3144,
		"Rank": 49,
		"Item": "NFT People #2927",
		"Score": 49
	  },
	  {
		"Index": 3145,
		"Rank": 49,
		"Item": "NFT People #2939",
		"Score": 49
	  },
	  {
		"Index": 3146,
		"Rank": 49,
		"Item": "NFT People #2982",
		"Score": 49
	  },
	  {
		"Index": 3147,
		"Rank": 49,
		"Item": "NFT People #2986",
		"Score": 49
	  },
	  {
		"Index": 3148,
		"Rank": 49,
		"Item": "NFT People #3026",
		"Score": 49
	  },
	  {
		"Index": 3149,
		"Rank": 49,
		"Item": "NFT People #3028",
		"Score": 49
	  },
	  {
		"Index": 3150,
		"Rank": 49,
		"Item": "NFT People #3045",
		"Score": 49
	  },
	  {
		"Index": 3151,
		"Rank": 49,
		"Item": "NFT People #3049",
		"Score": 49
	  },
	  {
		"Index": 3152,
		"Rank": 49,
		"Item": "NFT People #3057",
		"Score": 49
	  },
	  {
		"Index": 3153,
		"Rank": 49,
		"Item": "NFT People #3062",
		"Score": 49
	  },
	  {
		"Index": 3154,
		"Rank": 49,
		"Item": "NFT People #3142",
		"Score": 49
	  },
	  {
		"Index": 3155,
		"Rank": 49,
		"Item": "NFT People #3163",
		"Score": 49
	  },
	  {
		"Index": 3156,
		"Rank": 49,
		"Item": "NFT People #3171",
		"Score": 49
	  },
	  {
		"Index": 3157,
		"Rank": 49,
		"Item": "NFT People #3201",
		"Score": 49
	  },
	  {
		"Index": 3158,
		"Rank": 49,
		"Item": "NFT People #3273",
		"Score": 49
	  },
	  {
		"Index": 3159,
		"Rank": 49,
		"Item": "NFT People #3286",
		"Score": 49
	  },
	  {
		"Index": 3160,
		"Rank": 49,
		"Item": "NFT People #3300",
		"Score": 49
	  },
	  {
		"Index": 3161,
		"Rank": 49,
		"Item": "NFT People #3318",
		"Score": 49
	  },
	  {
		"Index": 3162,
		"Rank": 49,
		"Item": "NFT People #3362",
		"Score": 49
	  },
	  {
		"Index": 3163,
		"Rank": 49,
		"Item": "NFT People #3382",
		"Score": 49
	  },
	  {
		"Index": 3164,
		"Rank": 49,
		"Item": "NFT People #3390",
		"Score": 49
	  },
	  {
		"Index": 3165,
		"Rank": 49,
		"Item": "NFT People #3498",
		"Score": 49
	  },
	  {
		"Index": 3166,
		"Rank": 49,
		"Item": "NFT People #3530",
		"Score": 49
	  },
	  {
		"Index": 3167,
		"Rank": 49,
		"Item": "NFT People #3604",
		"Score": 49
	  },
	  {
		"Index": 3168,
		"Rank": 49,
		"Item": "NFT People #3613",
		"Score": 49
	  },
	  {
		"Index": 3169,
		"Rank": 49,
		"Item": "NFT People #3633",
		"Score": 49
	  },
	  {
		"Index": 3170,
		"Rank": 49,
		"Item": "NFT People #3650",
		"Score": 49
	  },
	  {
		"Index": 3171,
		"Rank": 49,
		"Item": "NFT People #3709",
		"Score": 49
	  },
	  {
		"Index": 3172,
		"Rank": 49,
		"Item": "NFT People #3777",
		"Score": 49
	  },
	  {
		"Index": 3173,
		"Rank": 49,
		"Item": "NFT People #3814",
		"Score": 49
	  },
	  {
		"Index": 3174,
		"Rank": 49,
		"Item": "NFT People #3984",
		"Score": 49
	  },
	  {
		"Index": 3175,
		"Rank": 49,
		"Item": "NFT People #4001",
		"Score": 49
	  },
	  {
		"Index": 3176,
		"Rank": 49,
		"Item": "NFT People #4030",
		"Score": 49
	  },
	  {
		"Index": 3177,
		"Rank": 49,
		"Item": "NFT People #4046",
		"Score": 49
	  },
	  {
		"Index": 3178,
		"Rank": 49,
		"Item": "NFT People #4164",
		"Score": 49
	  },
	  {
		"Index": 3179,
		"Rank": 49,
		"Item": "NFT People #4172",
		"Score": 49
	  },
	  {
		"Index": 3180,
		"Rank": 49,
		"Item": "NFT People #4250",
		"Score": 49
	  },
	  {
		"Index": 3181,
		"Rank": 49,
		"Item": "NFT People #4262",
		"Score": 49
	  },
	  {
		"Index": 3182,
		"Rank": 49,
		"Item": "NFT People #4386",
		"Score": 49
	  },
	  {
		"Index": 3183,
		"Rank": 49,
		"Item": "NFT People #4463",
		"Score": 49
	  },
	  {
		"Index": 3184,
		"Rank": 49,
		"Item": "NFT People #4497",
		"Score": 49
	  },
	  {
		"Index": 3185,
		"Rank": 49,
		"Item": "NFT People #4533",
		"Score": 49
	  },
	  {
		"Index": 3186,
		"Rank": 49,
		"Item": "NFT People #4665",
		"Score": 49
	  },
	  {
		"Index": 3187,
		"Rank": 49,
		"Item": "NFT People #4685",
		"Score": 49
	  },
	  {
		"Index": 3188,
		"Rank": 49,
		"Item": "NFT People #4754",
		"Score": 49
	  },
	  {
		"Index": 3189,
		"Rank": 49,
		"Item": "NFT People #4767",
		"Score": 49
	  },
	  {
		"Index": 3190,
		"Rank": 49,
		"Item": "NFT People #4864",
		"Score": 49
	  },
	  {
		"Index": 3191,
		"Rank": 49,
		"Item": "NFT People #4871",
		"Score": 49
	  },
	  {
		"Index": 3192,
		"Rank": 49,
		"Item": "NFT People #4882",
		"Score": 49
	  },
	  {
		"Index": 3193,
		"Rank": 49,
		"Item": "NFT People #4932",
		"Score": 49
	  },
	  {
		"Index": 3194,
		"Rank": 49,
		"Item": "NFT People #4932",
		"Score": 49
	  },
	  {
		"Index": 3195,
		"Rank": 49,
		"Item": "NFT People #4982",
		"Score": 49
	  },
	  {
		"Index": 3196,
		"Rank": 50,
		"Item": "NFT People #0017",
		"Score": 48
	  },
	  {
		"Index": 3197,
		"Rank": 50,
		"Item": "NFT People #0160",
		"Score": 48
	  },
	  {
		"Index": 3198,
		"Rank": 50,
		"Item": "NFT People #0239",
		"Score": 48
	  },
	  {
		"Index": 3199,
		"Rank": 50,
		"Item": "NFT People #0325",
		"Score": 48
	  },
	  {
		"Index": 3200,
		"Rank": 50,
		"Item": "NFT People #0345",
		"Score": 48
	  },
	  {
		"Index": 3201,
		"Rank": 50,
		"Item": "NFT People #0443",
		"Score": 48
	  },
	  {
		"Index": 3202,
		"Rank": 50,
		"Item": "NFT People #0577",
		"Score": 48
	  },
	  {
		"Index": 3203,
		"Rank": 50,
		"Item": "NFT People #0777",
		"Score": 48
	  },
	  {
		"Index": 3204,
		"Rank": 50,
		"Item": "NFT People #0818",
		"Score": 48
	  },
	  {
		"Index": 3205,
		"Rank": 50,
		"Item": "NFT People #0828",
		"Score": 48
	  },
	  {
		"Index": 3206,
		"Rank": 50,
		"Item": "NFT People #0873",
		"Score": 48
	  },
	  {
		"Index": 3207,
		"Rank": 50,
		"Item": "NFT People #0876",
		"Score": 48
	  },
	  {
		"Index": 3208,
		"Rank": 50,
		"Item": "NFT People #0890",
		"Score": 48
	  },
	  {
		"Index": 3209,
		"Rank": 50,
		"Item": "NFT People #0940",
		"Score": 48
	  },
	  {
		"Index": 3210,
		"Rank": 50,
		"Item": "NFT People #1048",
		"Score": 48
	  },
	  {
		"Index": 3211,
		"Rank": 50,
		"Item": "NFT People #1100",
		"Score": 48
	  },
	  {
		"Index": 3212,
		"Rank": 50,
		"Item": "NFT People #1312",
		"Score": 48
	  },
	  {
		"Index": 3213,
		"Rank": 50,
		"Item": "NFT People #1399",
		"Score": 48
	  },
	  {
		"Index": 3214,
		"Rank": 50,
		"Item": "NFT People #1417",
		"Score": 48
	  },
	  {
		"Index": 3215,
		"Rank": 50,
		"Item": "NFT People #1450",
		"Score": 48
	  },
	  {
		"Index": 3216,
		"Rank": 50,
		"Item": "NFT People #1514",
		"Score": 48
	  },
	  {
		"Index": 3217,
		"Rank": 50,
		"Item": "NFT People #1517",
		"Score": 48
	  },
	  {
		"Index": 3218,
		"Rank": 50,
		"Item": "NFT People #1524",
		"Score": 48
	  },
	  {
		"Index": 3219,
		"Rank": 50,
		"Item": "NFT People #1597",
		"Score": 48
	  },
	  {
		"Index": 3220,
		"Rank": 50,
		"Item": "NFT People #1768",
		"Score": 48
	  },
	  {
		"Index": 3221,
		"Rank": 50,
		"Item": "NFT People #1777",
		"Score": 48
	  },
	  {
		"Index": 3222,
		"Rank": 50,
		"Item": "NFT People #1852",
		"Score": 48
	  },
	  {
		"Index": 3223,
		"Rank": 50,
		"Item": "NFT People #1877",
		"Score": 48
	  },
	  {
		"Index": 3224,
		"Rank": 50,
		"Item": "NFT People #2024",
		"Score": 48
	  },
	  {
		"Index": 3225,
		"Rank": 50,
		"Item": "NFT People #2164",
		"Score": 48
	  },
	  {
		"Index": 3226,
		"Rank": 50,
		"Item": "NFT People #2226",
		"Score": 48
	  },
	  {
		"Index": 3227,
		"Rank": 50,
		"Item": "NFT People #2456",
		"Score": 48
	  },
	  {
		"Index": 3228,
		"Rank": 50,
		"Item": "NFT People #2697",
		"Score": 48
	  },
	  {
		"Index": 3229,
		"Rank": 50,
		"Item": "NFT People #2730",
		"Score": 48
	  },
	  {
		"Index": 3230,
		"Rank": 50,
		"Item": "NFT People #2782",
		"Score": 48
	  },
	  {
		"Index": 3231,
		"Rank": 50,
		"Item": "NFT People #2844",
		"Score": 48
	  },
	  {
		"Index": 3232,
		"Rank": 50,
		"Item": "NFT People #2925",
		"Score": 48
	  },
	  {
		"Index": 3233,
		"Rank": 50,
		"Item": "NFT People #2950",
		"Score": 48
	  },
	  {
		"Index": 3234,
		"Rank": 50,
		"Item": "NFT People #2977",
		"Score": 48
	  },
	  {
		"Index": 3235,
		"Rank": 50,
		"Item": "NFT People #2981",
		"Score": 48
	  },
	  {
		"Index": 3236,
		"Rank": 50,
		"Item": "NFT People #3024",
		"Score": 48
	  },
	  {
		"Index": 3237,
		"Rank": 50,
		"Item": "NFT People #3031",
		"Score": 48
	  },
	  {
		"Index": 3238,
		"Rank": 50,
		"Item": "NFT People #3152",
		"Score": 48
	  },
	  {
		"Index": 3239,
		"Rank": 50,
		"Item": "NFT People #3183",
		"Score": 48
	  },
	  {
		"Index": 3240,
		"Rank": 50,
		"Item": "NFT People #3275",
		"Score": 48
	  },
	  {
		"Index": 3241,
		"Rank": 50,
		"Item": "NFT People #3282",
		"Score": 48
	  },
	  {
		"Index": 3242,
		"Rank": 50,
		"Item": "NFT People #3296",
		"Score": 48
	  },
	  {
		"Index": 3243,
		"Rank": 50,
		"Item": "NFT People #3453",
		"Score": 48
	  },
	  {
		"Index": 3244,
		"Rank": 50,
		"Item": "NFT People #3510",
		"Score": 48
	  },
	  {
		"Index": 3245,
		"Rank": 50,
		"Item": "NFT People #3588",
		"Score": 48
	  },
	  {
		"Index": 3246,
		"Rank": 50,
		"Item": "NFT People #3748",
		"Score": 48
	  },
	  {
		"Index": 3247,
		"Rank": 50,
		"Item": "NFT People #3770",
		"Score": 48
	  },
	  {
		"Index": 3248,
		"Rank": 50,
		"Item": "NFT People #3771",
		"Score": 48
	  },
	  {
		"Index": 3249,
		"Rank": 50,
		"Item": "NFT People #3822",
		"Score": 48
	  },
	  {
		"Index": 3250,
		"Rank": 50,
		"Item": "NFT People #3854",
		"Score": 48
	  },
	  {
		"Index": 3251,
		"Rank": 50,
		"Item": "NFT People #3869",
		"Score": 48
	  },
	  {
		"Index": 3252,
		"Rank": 50,
		"Item": "NFT People #4011",
		"Score": 48
	  },
	  {
		"Index": 3253,
		"Rank": 50,
		"Item": "NFT People #4018",
		"Score": 48
	  },
	  {
		"Index": 3254,
		"Rank": 50,
		"Item": "NFT People #4144",
		"Score": 48
	  },
	  {
		"Index": 3255,
		"Rank": 50,
		"Item": "NFT People #4322",
		"Score": 48
	  },
	  {
		"Index": 3256,
		"Rank": 50,
		"Item": "NFT People #4422",
		"Score": 48
	  },
	  {
		"Index": 3257,
		"Rank": 50,
		"Item": "NFT People #4443",
		"Score": 48
	  },
	  {
		"Index": 3258,
		"Rank": 50,
		"Item": "NFT People #4490",
		"Score": 48
	  },
	  {
		"Index": 3259,
		"Rank": 50,
		"Item": "NFT People #4491",
		"Score": 48
	  },
	  {
		"Index": 3260,
		"Rank": 50,
		"Item": "NFT People #4524",
		"Score": 48
	  },
	  {
		"Index": 3261,
		"Rank": 50,
		"Item": "NFT People #4534",
		"Score": 48
	  },
	  {
		"Index": 3262,
		"Rank": 50,
		"Item": "NFT People #4564",
		"Score": 48
	  },
	  {
		"Index": 3263,
		"Rank": 50,
		"Item": "NFT People #4568",
		"Score": 48
	  },
	  {
		"Index": 3264,
		"Rank": 50,
		"Item": "NFT People #4886",
		"Score": 48
	  },
	  {
		"Index": 3265,
		"Rank": 50,
		"Item": "NFT People #4933",
		"Score": 48
	  },
	  {
		"Index": 3266,
		"Rank": 50,
		"Item": "NFT People #4933",
		"Score": 48
	  },
	  {
		"Index": 3267,
		"Rank": 50,
		"Item": "NFT People #4960",
		"Score": 48
	  },
	  {
		"Index": 3268,
		"Rank": 51,
		"Item": "NFT People #0004",
		"Score": 47
	  },
	  {
		"Index": 3269,
		"Rank": 51,
		"Item": "NFT People #0037",
		"Score": 47
	  },
	  {
		"Index": 3270,
		"Rank": 51,
		"Item": "NFT People #0050",
		"Score": 47
	  },
	  {
		"Index": 3271,
		"Rank": 51,
		"Item": "NFT People #0115",
		"Score": 47
	  },
	  {
		"Index": 3272,
		"Rank": 51,
		"Item": "NFT People #0116",
		"Score": 47
	  },
	  {
		"Index": 3273,
		"Rank": 51,
		"Item": "NFT People #0148",
		"Score": 47
	  },
	  {
		"Index": 3274,
		"Rank": 51,
		"Item": "NFT People #0176",
		"Score": 47
	  },
	  {
		"Index": 3275,
		"Rank": 51,
		"Item": "NFT People #0177",
		"Score": 47
	  },
	  {
		"Index": 3276,
		"Rank": 51,
		"Item": "NFT People #0210",
		"Score": 47
	  },
	  {
		"Index": 3277,
		"Rank": 51,
		"Item": "NFT People #0267",
		"Score": 47
	  },
	  {
		"Index": 3278,
		"Rank": 51,
		"Item": "NFT People #0338",
		"Score": 47
	  },
	  {
		"Index": 3279,
		"Rank": 51,
		"Item": "NFT People #0347",
		"Score": 47
	  },
	  {
		"Index": 3280,
		"Rank": 51,
		"Item": "NFT People #0391",
		"Score": 47
	  },
	  {
		"Index": 3281,
		"Rank": 51,
		"Item": "NFT People #0417",
		"Score": 47
	  },
	  {
		"Index": 3282,
		"Rank": 51,
		"Item": "NFT People #0421",
		"Score": 47
	  },
	  {
		"Index": 3283,
		"Rank": 51,
		"Item": "NFT People #0468",
		"Score": 47
	  },
	  {
		"Index": 3284,
		"Rank": 51,
		"Item": "NFT People #0475",
		"Score": 47
	  },
	  {
		"Index": 3285,
		"Rank": 51,
		"Item": "NFT People #0547",
		"Score": 47
	  },
	  {
		"Index": 3286,
		"Rank": 51,
		"Item": "NFT People #0549",
		"Score": 47
	  },
	  {
		"Index": 3287,
		"Rank": 51,
		"Item": "NFT People #0553",
		"Score": 47
	  },
	  {
		"Index": 3288,
		"Rank": 51,
		"Item": "NFT People #0555",
		"Score": 47
	  },
	  {
		"Index": 3289,
		"Rank": 51,
		"Item": "NFT People #0620",
		"Score": 47
	  },
	  {
		"Index": 3290,
		"Rank": 51,
		"Item": "NFT People #0626",
		"Score": 47
	  },
	  {
		"Index": 3291,
		"Rank": 51,
		"Item": "NFT People #0723",
		"Score": 47
	  },
	  {
		"Index": 3292,
		"Rank": 51,
		"Item": "NFT People #0754",
		"Score": 47
	  },
	  {
		"Index": 3293,
		"Rank": 51,
		"Item": "NFT People #0755",
		"Score": 47
	  },
	  {
		"Index": 3294,
		"Rank": 51,
		"Item": "NFT People #0761",
		"Score": 47
	  },
	  {
		"Index": 3295,
		"Rank": 51,
		"Item": "NFT People #0787",
		"Score": 47
	  },
	  {
		"Index": 3296,
		"Rank": 51,
		"Item": "NFT People #0808",
		"Score": 47
	  },
	  {
		"Index": 3297,
		"Rank": 51,
		"Item": "NFT People #0810",
		"Score": 47
	  },
	  {
		"Index": 3298,
		"Rank": 51,
		"Item": "NFT People #0839",
		"Score": 47
	  },
	  {
		"Index": 3299,
		"Rank": 51,
		"Item": "NFT People #0907",
		"Score": 47
	  },
	  {
		"Index": 3300,
		"Rank": 51,
		"Item": "NFT People #0935",
		"Score": 47
	  },
	  {
		"Index": 3301,
		"Rank": 51,
		"Item": "NFT People #0944",
		"Score": 47
	  },
	  {
		"Index": 3302,
		"Rank": 51,
		"Item": "NFT People #0968",
		"Score": 47
	  },
	  {
		"Index": 3303,
		"Rank": 51,
		"Item": "NFT People #0977",
		"Score": 47
	  },
	  {
		"Index": 3304,
		"Rank": 51,
		"Item": "NFT People #1025",
		"Score": 47
	  },
	  {
		"Index": 3305,
		"Rank": 51,
		"Item": "NFT People #1032",
		"Score": 47
	  },
	  {
		"Index": 3306,
		"Rank": 51,
		"Item": "NFT People #1093",
		"Score": 47
	  },
	  {
		"Index": 3307,
		"Rank": 51,
		"Item": "NFT People #1142",
		"Score": 47
	  },
	  {
		"Index": 3308,
		"Rank": 51,
		"Item": "NFT People #1168",
		"Score": 47
	  },
	  {
		"Index": 3309,
		"Rank": 51,
		"Item": "NFT People #1203",
		"Score": 47
	  },
	  {
		"Index": 3310,
		"Rank": 51,
		"Item": "NFT People #1236",
		"Score": 47
	  },
	  {
		"Index": 3311,
		"Rank": 51,
		"Item": "NFT People #1268",
		"Score": 47
	  },
	  {
		"Index": 3312,
		"Rank": 51,
		"Item": "NFT People #1282",
		"Score": 47
	  },
	  {
		"Index": 3313,
		"Rank": 51,
		"Item": "NFT People #1317",
		"Score": 47
	  },
	  {
		"Index": 3314,
		"Rank": 51,
		"Item": "NFT People #1319",
		"Score": 47
	  },
	  {
		"Index": 3315,
		"Rank": 51,
		"Item": "NFT People #1322",
		"Score": 47
	  },
	  {
		"Index": 3316,
		"Rank": 51,
		"Item": "NFT People #1355",
		"Score": 47
	  },
	  {
		"Index": 3317,
		"Rank": 51,
		"Item": "NFT People #1404",
		"Score": 47
	  },
	  {
		"Index": 3318,
		"Rank": 51,
		"Item": "NFT People #1419",
		"Score": 47
	  },
	  {
		"Index": 3319,
		"Rank": 51,
		"Item": "NFT People #1452",
		"Score": 47
	  },
	  {
		"Index": 3320,
		"Rank": 51,
		"Item": "NFT People #1521",
		"Score": 47
	  },
	  {
		"Index": 3321,
		"Rank": 51,
		"Item": "NFT People #1569",
		"Score": 47
	  },
	  {
		"Index": 3322,
		"Rank": 51,
		"Item": "NFT People #1626",
		"Score": 47
	  },
	  {
		"Index": 3323,
		"Rank": 51,
		"Item": "NFT People #1639",
		"Score": 47
	  },
	  {
		"Index": 3324,
		"Rank": 51,
		"Item": "NFT People #1648",
		"Score": 47
	  },
	  {
		"Index": 3325,
		"Rank": 51,
		"Item": "NFT People #1657",
		"Score": 47
	  },
	  {
		"Index": 3326,
		"Rank": 51,
		"Item": "NFT People #1664",
		"Score": 47
	  },
	  {
		"Index": 3327,
		"Rank": 51,
		"Item": "NFT People #1696",
		"Score": 47
	  },
	  {
		"Index": 3328,
		"Rank": 51,
		"Item": "NFT People #1741",
		"Score": 47
	  },
	  {
		"Index": 3329,
		"Rank": 51,
		"Item": "NFT People #1742",
		"Score": 47
	  },
	  {
		"Index": 3330,
		"Rank": 51,
		"Item": "NFT People #1749",
		"Score": 47
	  },
	  {
		"Index": 3331,
		"Rank": 51,
		"Item": "NFT People #1760",
		"Score": 47
	  },
	  {
		"Index": 3332,
		"Rank": 51,
		"Item": "NFT People #1795",
		"Score": 47
	  },
	  {
		"Index": 3333,
		"Rank": 51,
		"Item": "NFT People #1843",
		"Score": 47
	  },
	  {
		"Index": 3334,
		"Rank": 51,
		"Item": "NFT People #1908",
		"Score": 47
	  },
	  {
		"Index": 3335,
		"Rank": 51,
		"Item": "NFT People #1958",
		"Score": 47
	  },
	  {
		"Index": 3336,
		"Rank": 51,
		"Item": "NFT People #2028",
		"Score": 47
	  },
	  {
		"Index": 3337,
		"Rank": 51,
		"Item": "NFT People #2079",
		"Score": 47
	  },
	  {
		"Index": 3338,
		"Rank": 51,
		"Item": "NFT People #2112",
		"Score": 47
	  },
	  {
		"Index": 3339,
		"Rank": 51,
		"Item": "NFT People #2115",
		"Score": 47
	  },
	  {
		"Index": 3340,
		"Rank": 51,
		"Item": "NFT People #2140",
		"Score": 47
	  },
	  {
		"Index": 3341,
		"Rank": 51,
		"Item": "NFT People #2169",
		"Score": 47
	  },
	  {
		"Index": 3342,
		"Rank": 51,
		"Item": "NFT People #2267",
		"Score": 47
	  },
	  {
		"Index": 3343,
		"Rank": 51,
		"Item": "NFT People #2277",
		"Score": 47
	  },
	  {
		"Index": 3344,
		"Rank": 51,
		"Item": "NFT People #2358",
		"Score": 47
	  },
	  {
		"Index": 3345,
		"Rank": 51,
		"Item": "NFT People #2359",
		"Score": 47
	  },
	  {
		"Index": 3346,
		"Rank": 51,
		"Item": "NFT People #2443",
		"Score": 47
	  },
	  {
		"Index": 3347,
		"Rank": 51,
		"Item": "NFT People #2469",
		"Score": 47
	  },
	  {
		"Index": 3348,
		"Rank": 51,
		"Item": "NFT People #2471",
		"Score": 47
	  },
	  {
		"Index": 3349,
		"Rank": 51,
		"Item": "NFT People #2479",
		"Score": 47
	  },
	  {
		"Index": 3350,
		"Rank": 51,
		"Item": "NFT People #2533",
		"Score": 47
	  },
	  {
		"Index": 3351,
		"Rank": 51,
		"Item": "NFT People #2570",
		"Score": 47
	  },
	  {
		"Index": 3352,
		"Rank": 51,
		"Item": "NFT People #2589",
		"Score": 47
	  },
	  {
		"Index": 3353,
		"Rank": 51,
		"Item": "NFT People #2641",
		"Score": 47
	  },
	  {
		"Index": 3354,
		"Rank": 51,
		"Item": "NFT People #2678",
		"Score": 47
	  },
	  {
		"Index": 3355,
		"Rank": 51,
		"Item": "NFT People #2693",
		"Score": 47
	  },
	  {
		"Index": 3356,
		"Rank": 51,
		"Item": "NFT People #2706",
		"Score": 47
	  },
	  {
		"Index": 3357,
		"Rank": 51,
		"Item": "NFT People #2726",
		"Score": 47
	  },
	  {
		"Index": 3358,
		"Rank": 51,
		"Item": "NFT People #2729",
		"Score": 47
	  },
	  {
		"Index": 3359,
		"Rank": 51,
		"Item": "NFT People #2763",
		"Score": 47
	  },
	  {
		"Index": 3360,
		"Rank": 51,
		"Item": "NFT People #2829",
		"Score": 47
	  },
	  {
		"Index": 3361,
		"Rank": 51,
		"Item": "NFT People #2943",
		"Score": 47
	  },
	  {
		"Index": 3362,
		"Rank": 51,
		"Item": "NFT People #2969",
		"Score": 47
	  },
	  {
		"Index": 3363,
		"Rank": 51,
		"Item": "NFT People #3014",
		"Score": 47
	  },
	  {
		"Index": 3364,
		"Rank": 51,
		"Item": "NFT People #3052",
		"Score": 47
	  },
	  {
		"Index": 3365,
		"Rank": 51,
		"Item": "NFT People #3096",
		"Score": 47
	  },
	  {
		"Index": 3366,
		"Rank": 51,
		"Item": "NFT People #3111",
		"Score": 47
	  },
	  {
		"Index": 3367,
		"Rank": 51,
		"Item": "NFT People #3143",
		"Score": 47
	  },
	  {
		"Index": 3368,
		"Rank": 51,
		"Item": "NFT People #3221",
		"Score": 47
	  },
	  {
		"Index": 3369,
		"Rank": 51,
		"Item": "NFT People #3257",
		"Score": 47
	  },
	  {
		"Index": 3370,
		"Rank": 51,
		"Item": "NFT People #3298",
		"Score": 47
	  },
	  {
		"Index": 3371,
		"Rank": 51,
		"Item": "NFT People #3369",
		"Score": 47
	  },
	  {
		"Index": 3372,
		"Rank": 51,
		"Item": "NFT People #3398",
		"Score": 47
	  },
	  {
		"Index": 3373,
		"Rank": 51,
		"Item": "NFT People #3418",
		"Score": 47
	  },
	  {
		"Index": 3374,
		"Rank": 51,
		"Item": "NFT People #3486",
		"Score": 47
	  },
	  {
		"Index": 3375,
		"Rank": 51,
		"Item": "NFT People #3490",
		"Score": 47
	  },
	  {
		"Index": 3376,
		"Rank": 51,
		"Item": "NFT People #3529",
		"Score": 47
	  },
	  {
		"Index": 3377,
		"Rank": 51,
		"Item": "NFT People #3533",
		"Score": 47
	  },
	  {
		"Index": 3378,
		"Rank": 51,
		"Item": "NFT People #3580",
		"Score": 47
	  },
	  {
		"Index": 3379,
		"Rank": 51,
		"Item": "NFT People #3584",
		"Score": 47
	  },
	  {
		"Index": 3380,
		"Rank": 51,
		"Item": "NFT People #3599",
		"Score": 47
	  },
	  {
		"Index": 3381,
		"Rank": 51,
		"Item": "NFT People #3670",
		"Score": 47
	  },
	  {
		"Index": 3382,
		"Rank": 51,
		"Item": "NFT People #3688",
		"Score": 47
	  },
	  {
		"Index": 3383,
		"Rank": 51,
		"Item": "NFT People #3695",
		"Score": 47
	  },
	  {
		"Index": 3384,
		"Rank": 51,
		"Item": "NFT People #3722",
		"Score": 47
	  },
	  {
		"Index": 3385,
		"Rank": 51,
		"Item": "NFT People #3744",
		"Score": 47
	  },
	  {
		"Index": 3386,
		"Rank": 51,
		"Item": "NFT People #3758",
		"Score": 47
	  },
	  {
		"Index": 3387,
		"Rank": 51,
		"Item": "NFT People #3761",
		"Score": 47
	  },
	  {
		"Index": 3388,
		"Rank": 51,
		"Item": "NFT People #3895",
		"Score": 47
	  },
	  {
		"Index": 3389,
		"Rank": 51,
		"Item": "NFT People #3946",
		"Score": 47
	  },
	  {
		"Index": 3390,
		"Rank": 51,
		"Item": "NFT People #3966",
		"Score": 47
	  },
	  {
		"Index": 3391,
		"Rank": 51,
		"Item": "NFT People #3995",
		"Score": 47
	  },
	  {
		"Index": 3392,
		"Rank": 51,
		"Item": "NFT People #4082",
		"Score": 47
	  },
	  {
		"Index": 3393,
		"Rank": 51,
		"Item": "NFT People #4103",
		"Score": 47
	  },
	  {
		"Index": 3394,
		"Rank": 51,
		"Item": "NFT People #4188",
		"Score": 47
	  },
	  {
		"Index": 3395,
		"Rank": 51,
		"Item": "NFT People #4217",
		"Score": 47
	  },
	  {
		"Index": 3396,
		"Rank": 51,
		"Item": "NFT People #4275",
		"Score": 47
	  },
	  {
		"Index": 3397,
		"Rank": 51,
		"Item": "NFT People #4292",
		"Score": 47
	  },
	  {
		"Index": 3398,
		"Rank": 51,
		"Item": "NFT People #4356",
		"Score": 47
	  },
	  {
		"Index": 3399,
		"Rank": 51,
		"Item": "NFT People #4364",
		"Score": 47
	  },
	  {
		"Index": 3400,
		"Rank": 51,
		"Item": "NFT People #4439",
		"Score": 47
	  },
	  {
		"Index": 3401,
		"Rank": 51,
		"Item": "NFT People #4469",
		"Score": 47
	  },
	  {
		"Index": 3402,
		"Rank": 51,
		"Item": "NFT People #4481",
		"Score": 47
	  },
	  {
		"Index": 3403,
		"Rank": 51,
		"Item": "NFT People #4518",
		"Score": 47
	  },
	  {
		"Index": 3404,
		"Rank": 51,
		"Item": "NFT People #4549",
		"Score": 47
	  },
	  {
		"Index": 3405,
		"Rank": 51,
		"Item": "NFT People #4593",
		"Score": 47
	  },
	  {
		"Index": 3406,
		"Rank": 51,
		"Item": "NFT People #4651",
		"Score": 47
	  },
	  {
		"Index": 3407,
		"Rank": 51,
		"Item": "NFT People #4794",
		"Score": 47
	  },
	  {
		"Index": 3408,
		"Rank": 51,
		"Item": "NFT People #4824",
		"Score": 47
	  },
	  {
		"Index": 3409,
		"Rank": 51,
		"Item": "NFT People #4912",
		"Score": 47
	  },
	  {
		"Index": 3410,
		"Rank": 51,
		"Item": "NFT People #4930",
		"Score": 47
	  },
	  {
		"Index": 3411,
		"Rank": 51,
		"Item": "NFT People #4937",
		"Score": 47
	  },
	  {
		"Index": 3412,
		"Rank": 51,
		"Item": "NFT People #4939",
		"Score": 47
	  },
	  {
		"Index": 3413,
		"Rank": 51,
		"Item": "NFT People #4948",
		"Score": 47
	  },
	  {
		"Index": 3414,
		"Rank": 51,
		"Item": "NFT People #4952",
		"Score": 47
	  },
	  {
		"Index": 3415,
		"Rank": 52,
		"Item": "NFT People #0018",
		"Score": 46
	  },
	  {
		"Index": 3416,
		"Rank": 52,
		"Item": "NFT People #0046",
		"Score": 46
	  },
	  {
		"Index": 3417,
		"Rank": 52,
		"Item": "NFT People #0075",
		"Score": 46
	  },
	  {
		"Index": 3418,
		"Rank": 52,
		"Item": "NFT People #0123",
		"Score": 46
	  },
	  {
		"Index": 3419,
		"Rank": 52,
		"Item": "NFT People #0164",
		"Score": 46
	  },
	  {
		"Index": 3420,
		"Rank": 52,
		"Item": "NFT People #0180",
		"Score": 46
	  },
	  {
		"Index": 3421,
		"Rank": 52,
		"Item": "NFT People #0222",
		"Score": 46
	  },
	  {
		"Index": 3422,
		"Rank": 52,
		"Item": "NFT People #0297",
		"Score": 46
	  },
	  {
		"Index": 3423,
		"Rank": 52,
		"Item": "NFT People #0303",
		"Score": 46
	  },
	  {
		"Index": 3424,
		"Rank": 52,
		"Item": "NFT People #0361",
		"Score": 46
	  },
	  {
		"Index": 3425,
		"Rank": 52,
		"Item": "NFT People #0440",
		"Score": 46
	  },
	  {
		"Index": 3426,
		"Rank": 52,
		"Item": "NFT People #0446",
		"Score": 46
	  },
	  {
		"Index": 3427,
		"Rank": 52,
		"Item": "NFT People #0450",
		"Score": 46
	  },
	  {
		"Index": 3428,
		"Rank": 52,
		"Item": "NFT People #0521",
		"Score": 46
	  },
	  {
		"Index": 3429,
		"Rank": 52,
		"Item": "NFT People #0559",
		"Score": 46
	  },
	  {
		"Index": 3430,
		"Rank": 52,
		"Item": "NFT People #0560",
		"Score": 46
	  },
	  {
		"Index": 3431,
		"Rank": 52,
		"Item": "NFT People #0563",
		"Score": 46
	  },
	  {
		"Index": 3432,
		"Rank": 52,
		"Item": "NFT People #0604",
		"Score": 46
	  },
	  {
		"Index": 3433,
		"Rank": 52,
		"Item": "NFT People #0606",
		"Score": 46
	  },
	  {
		"Index": 3434,
		"Rank": 52,
		"Item": "NFT People #0607",
		"Score": 46
	  },
	  {
		"Index": 3435,
		"Rank": 52,
		"Item": "NFT People #0640",
		"Score": 46
	  },
	  {
		"Index": 3436,
		"Rank": 52,
		"Item": "NFT People #0679",
		"Score": 46
	  },
	  {
		"Index": 3437,
		"Rank": 52,
		"Item": "NFT People #0722",
		"Score": 46
	  },
	  {
		"Index": 3438,
		"Rank": 52,
		"Item": "NFT People #0749",
		"Score": 46
	  },
	  {
		"Index": 3439,
		"Rank": 52,
		"Item": "NFT People #0822",
		"Score": 46
	  },
	  {
		"Index": 3440,
		"Rank": 52,
		"Item": "NFT People #0877",
		"Score": 46
	  },
	  {
		"Index": 3441,
		"Rank": 52,
		"Item": "NFT People #0894",
		"Score": 46
	  },
	  {
		"Index": 3442,
		"Rank": 52,
		"Item": "NFT People #0913",
		"Score": 46
	  },
	  {
		"Index": 3443,
		"Rank": 52,
		"Item": "NFT People #0993",
		"Score": 46
	  },
	  {
		"Index": 3444,
		"Rank": 52,
		"Item": "NFT People #1061",
		"Score": 46
	  },
	  {
		"Index": 3445,
		"Rank": 52,
		"Item": "NFT People #1069",
		"Score": 46
	  },
	  {
		"Index": 3446,
		"Rank": 52,
		"Item": "NFT People #1171",
		"Score": 46
	  },
	  {
		"Index": 3447,
		"Rank": 52,
		"Item": "NFT People #1172",
		"Score": 46
	  },
	  {
		"Index": 3448,
		"Rank": 52,
		"Item": "NFT People #1193",
		"Score": 46
	  },
	  {
		"Index": 3449,
		"Rank": 52,
		"Item": "NFT People #1327",
		"Score": 46
	  },
	  {
		"Index": 3450,
		"Rank": 52,
		"Item": "NFT People #1414",
		"Score": 46
	  },
	  {
		"Index": 3451,
		"Rank": 52,
		"Item": "NFT People #1447",
		"Score": 46
	  },
	  {
		"Index": 3452,
		"Rank": 52,
		"Item": "NFT People #1585",
		"Score": 46
	  },
	  {
		"Index": 3453,
		"Rank": 52,
		"Item": "NFT People #1628",
		"Score": 46
	  },
	  {
		"Index": 3454,
		"Rank": 52,
		"Item": "NFT People #1630",
		"Score": 46
	  },
	  {
		"Index": 3455,
		"Rank": 52,
		"Item": "NFT People #1634",
		"Score": 46
	  },
	  {
		"Index": 3456,
		"Rank": 52,
		"Item": "NFT People #1679",
		"Score": 46
	  },
	  {
		"Index": 3457,
		"Rank": 52,
		"Item": "NFT People #1703",
		"Score": 46
	  },
	  {
		"Index": 3458,
		"Rank": 52,
		"Item": "NFT People #1767",
		"Score": 46
	  },
	  {
		"Index": 3459,
		"Rank": 52,
		"Item": "NFT People #1803",
		"Score": 46
	  },
	  {
		"Index": 3460,
		"Rank": 52,
		"Item": "NFT People #1847",
		"Score": 46
	  },
	  {
		"Index": 3461,
		"Rank": 52,
		"Item": "NFT People #1853",
		"Score": 46
	  },
	  {
		"Index": 3462,
		"Rank": 52,
		"Item": "NFT People #1868",
		"Score": 46
	  },
	  {
		"Index": 3463,
		"Rank": 52,
		"Item": "NFT People #1885",
		"Score": 46
	  },
	  {
		"Index": 3464,
		"Rank": 52,
		"Item": "NFT People #1984",
		"Score": 46
	  },
	  {
		"Index": 3465,
		"Rank": 52,
		"Item": "NFT People #2037",
		"Score": 46
	  },
	  {
		"Index": 3466,
		"Rank": 52,
		"Item": "NFT People #2055",
		"Score": 46
	  },
	  {
		"Index": 3467,
		"Rank": 52,
		"Item": "NFT People #2080",
		"Score": 46
	  },
	  {
		"Index": 3468,
		"Rank": 52,
		"Item": "NFT People #2083",
		"Score": 46
	  },
	  {
		"Index": 3469,
		"Rank": 52,
		"Item": "NFT People #2131",
		"Score": 46
	  },
	  {
		"Index": 3470,
		"Rank": 52,
		"Item": "NFT People #2147",
		"Score": 46
	  },
	  {
		"Index": 3471,
		"Rank": 52,
		"Item": "NFT People #2156",
		"Score": 46
	  },
	  {
		"Index": 3472,
		"Rank": 52,
		"Item": "NFT People #2269",
		"Score": 46
	  },
	  {
		"Index": 3473,
		"Rank": 52,
		"Item": "NFT People #2270",
		"Score": 46
	  },
	  {
		"Index": 3474,
		"Rank": 52,
		"Item": "NFT People #2336",
		"Score": 46
	  },
	  {
		"Index": 3475,
		"Rank": 52,
		"Item": "NFT People #2375",
		"Score": 46
	  },
	  {
		"Index": 3476,
		"Rank": 52,
		"Item": "NFT People #2432",
		"Score": 46
	  },
	  {
		"Index": 3477,
		"Rank": 52,
		"Item": "NFT People #2434",
		"Score": 46
	  },
	  {
		"Index": 3478,
		"Rank": 52,
		"Item": "NFT People #2496",
		"Score": 46
	  },
	  {
		"Index": 3479,
		"Rank": 52,
		"Item": "NFT People #2520",
		"Score": 46
	  },
	  {
		"Index": 3480,
		"Rank": 52,
		"Item": "NFT People #2545",
		"Score": 46
	  },
	  {
		"Index": 3481,
		"Rank": 52,
		"Item": "NFT People #2550",
		"Score": 46
	  },
	  {
		"Index": 3482,
		"Rank": 52,
		"Item": "NFT People #2557",
		"Score": 46
	  },
	  {
		"Index": 3483,
		"Rank": 52,
		"Item": "NFT People #2602",
		"Score": 46
	  },
	  {
		"Index": 3484,
		"Rank": 52,
		"Item": "NFT People #2630",
		"Score": 46
	  },
	  {
		"Index": 3485,
		"Rank": 52,
		"Item": "NFT People #2665",
		"Score": 46
	  },
	  {
		"Index": 3486,
		"Rank": 52,
		"Item": "NFT People #2682",
		"Score": 46
	  },
	  {
		"Index": 3487,
		"Rank": 52,
		"Item": "NFT People #2738",
		"Score": 46
	  },
	  {
		"Index": 3488,
		"Rank": 52,
		"Item": "NFT People #2802",
		"Score": 46
	  },
	  {
		"Index": 3489,
		"Rank": 52,
		"Item": "NFT People #2850",
		"Score": 46
	  },
	  {
		"Index": 3490,
		"Rank": 52,
		"Item": "NFT People #2853",
		"Score": 46
	  },
	  {
		"Index": 3491,
		"Rank": 52,
		"Item": "NFT People #2907",
		"Score": 46
	  },
	  {
		"Index": 3492,
		"Rank": 52,
		"Item": "NFT People #2931",
		"Score": 46
	  },
	  {
		"Index": 3493,
		"Rank": 52,
		"Item": "NFT People #2938",
		"Score": 46
	  },
	  {
		"Index": 3494,
		"Rank": 52,
		"Item": "NFT People #3039",
		"Score": 46
	  },
	  {
		"Index": 3495,
		"Rank": 52,
		"Item": "NFT People #3070",
		"Score": 46
	  },
	  {
		"Index": 3496,
		"Rank": 52,
		"Item": "NFT People #3072",
		"Score": 46
	  },
	  {
		"Index": 3497,
		"Rank": 52,
		"Item": "NFT People #3157",
		"Score": 46
	  },
	  {
		"Index": 3498,
		"Rank": 52,
		"Item": "NFT People #3167",
		"Score": 46
	  },
	  {
		"Index": 3499,
		"Rank": 52,
		"Item": "NFT People #3233",
		"Score": 46
	  },
	  {
		"Index": 3500,
		"Rank": 52,
		"Item": "NFT People #3238",
		"Score": 46
	  },
	  {
		"Index": 3501,
		"Rank": 52,
		"Item": "NFT People #3339",
		"Score": 46
	  },
	  {
		"Index": 3502,
		"Rank": 52,
		"Item": "NFT People #3420",
		"Score": 46
	  },
	  {
		"Index": 3503,
		"Rank": 52,
		"Item": "NFT People #3426",
		"Score": 46
	  },
	  {
		"Index": 3504,
		"Rank": 52,
		"Item": "NFT People #3460",
		"Score": 46
	  },
	  {
		"Index": 3505,
		"Rank": 52,
		"Item": "NFT People #3464",
		"Score": 46
	  },
	  {
		"Index": 3506,
		"Rank": 52,
		"Item": "NFT People #3491",
		"Score": 46
	  },
	  {
		"Index": 3507,
		"Rank": 52,
		"Item": "NFT People #3509",
		"Score": 46
	  },
	  {
		"Index": 3508,
		"Rank": 52,
		"Item": "NFT People #3525",
		"Score": 46
	  },
	  {
		"Index": 3509,
		"Rank": 52,
		"Item": "NFT People #3610",
		"Score": 46
	  },
	  {
		"Index": 3510,
		"Rank": 52,
		"Item": "NFT People #3625",
		"Score": 46
	  },
	  {
		"Index": 3511,
		"Rank": 52,
		"Item": "NFT People #3632",
		"Score": 46
	  },
	  {
		"Index": 3512,
		"Rank": 52,
		"Item": "NFT People #3806",
		"Score": 46
	  },
	  {
		"Index": 3513,
		"Rank": 52,
		"Item": "NFT People #3848",
		"Score": 46
	  },
	  {
		"Index": 3514,
		"Rank": 52,
		"Item": "NFT People #3849",
		"Score": 46
	  },
	  {
		"Index": 3515,
		"Rank": 52,
		"Item": "NFT People #3865",
		"Score": 46
	  },
	  {
		"Index": 3516,
		"Rank": 52,
		"Item": "NFT People #3998",
		"Score": 46
	  },
	  {
		"Index": 3517,
		"Rank": 52,
		"Item": "NFT People #4069",
		"Score": 46
	  },
	  {
		"Index": 3518,
		"Rank": 52,
		"Item": "NFT People #4109",
		"Score": 46
	  },
	  {
		"Index": 3519,
		"Rank": 52,
		"Item": "NFT People #4141",
		"Score": 46
	  },
	  {
		"Index": 3520,
		"Rank": 52,
		"Item": "NFT People #4151",
		"Score": 46
	  },
	  {
		"Index": 3521,
		"Rank": 52,
		"Item": "NFT People #4171",
		"Score": 46
	  },
	  {
		"Index": 3522,
		"Rank": 52,
		"Item": "NFT People #4271",
		"Score": 46
	  },
	  {
		"Index": 3523,
		"Rank": 52,
		"Item": "NFT People #4314",
		"Score": 46
	  },
	  {
		"Index": 3524,
		"Rank": 52,
		"Item": "NFT People #4327",
		"Score": 46
	  },
	  {
		"Index": 3525,
		"Rank": 52,
		"Item": "NFT People #4379",
		"Score": 46
	  },
	  {
		"Index": 3526,
		"Rank": 52,
		"Item": "NFT People #4392",
		"Score": 46
	  },
	  {
		"Index": 3527,
		"Rank": 52,
		"Item": "NFT People #4406",
		"Score": 46
	  },
	  {
		"Index": 3528,
		"Rank": 52,
		"Item": "NFT People #4416",
		"Score": 46
	  },
	  {
		"Index": 3529,
		"Rank": 52,
		"Item": "NFT People #4471",
		"Score": 46
	  },
	  {
		"Index": 3530,
		"Rank": 52,
		"Item": "NFT People #4498",
		"Score": 46
	  },
	  {
		"Index": 3531,
		"Rank": 52,
		"Item": "NFT People #4514",
		"Score": 46
	  },
	  {
		"Index": 3532,
		"Rank": 52,
		"Item": "NFT People #4566",
		"Score": 46
	  },
	  {
		"Index": 3533,
		"Rank": 52,
		"Item": "NFT People #4576",
		"Score": 46
	  },
	  {
		"Index": 3534,
		"Rank": 52,
		"Item": "NFT People #4605",
		"Score": 46
	  },
	  {
		"Index": 3535,
		"Rank": 52,
		"Item": "NFT People #4612",
		"Score": 46
	  },
	  {
		"Index": 3536,
		"Rank": 52,
		"Item": "NFT People #4632",
		"Score": 46
	  },
	  {
		"Index": 3537,
		"Rank": 52,
		"Item": "NFT People #4641",
		"Score": 46
	  },
	  {
		"Index": 3538,
		"Rank": 52,
		"Item": "NFT People #4667",
		"Score": 46
	  },
	  {
		"Index": 3539,
		"Rank": 52,
		"Item": "NFT People #4741",
		"Score": 46
	  },
	  {
		"Index": 3540,
		"Rank": 52,
		"Item": "NFT People #4826",
		"Score": 46
	  },
	  {
		"Index": 3541,
		"Rank": 52,
		"Item": "NFT People #4868",
		"Score": 46
	  },
	  {
		"Index": 3542,
		"Rank": 52,
		"Item": "NFT People #4907",
		"Score": 46
	  },
	  {
		"Index": 3543,
		"Rank": 52,
		"Item": "NFT People #4914",
		"Score": 46
	  },
	  {
		"Index": 3544,
		"Rank": 52,
		"Item": "NFT People #4917",
		"Score": 46
	  },
	  {
		"Index": 3545,
		"Rank": 52,
		"Item": "NFT People #4918",
		"Score": 46
	  },
	  {
		"Index": 3546,
		"Rank": 52,
		"Item": "NFT People #4941",
		"Score": 46
	  },
	  {
		"Index": 3547,
		"Rank": 52,
		"Item": "NFT People #4946",
		"Score": 46
	  },
	  {
		"Index": 3548,
		"Rank": 52,
		"Item": "NFT People #4949",
		"Score": 46
	  },
	  {
		"Index": 3549,
		"Rank": 52,
		"Item": "NFT People #4950",
		"Score": 46
	  },
	  {
		"Index": 3550,
		"Rank": 52,
		"Item": "NFT People #4999",
		"Score": 46
	  },
	  {
		"Index": 3551,
		"Rank": 53,
		"Item": "NFT People #0058",
		"Score": 45
	  },
	  {
		"Index": 3552,
		"Rank": 53,
		"Item": "NFT People #0078",
		"Score": 45
	  },
	  {
		"Index": 3553,
		"Rank": 53,
		"Item": "NFT People #0124",
		"Score": 45
	  },
	  {
		"Index": 3554,
		"Rank": 53,
		"Item": "NFT People #0137",
		"Score": 45
	  },
	  {
		"Index": 3555,
		"Rank": 53,
		"Item": "NFT People #0150",
		"Score": 45
	  },
	  {
		"Index": 3556,
		"Rank": 53,
		"Item": "NFT People #0249",
		"Score": 45
	  },
	  {
		"Index": 3557,
		"Rank": 53,
		"Item": "NFT People #0275",
		"Score": 45
	  },
	  {
		"Index": 3558,
		"Rank": 53,
		"Item": "NFT People #0358",
		"Score": 45
	  },
	  {
		"Index": 3559,
		"Rank": 53,
		"Item": "NFT People #0387",
		"Score": 45
	  },
	  {
		"Index": 3560,
		"Rank": 53,
		"Item": "NFT People #0407",
		"Score": 45
	  },
	  {
		"Index": 3561,
		"Rank": 53,
		"Item": "NFT People #0420",
		"Score": 45
	  },
	  {
		"Index": 3562,
		"Rank": 53,
		"Item": "NFT People #0452",
		"Score": 45
	  },
	  {
		"Index": 3563,
		"Rank": 53,
		"Item": "NFT People #0476",
		"Score": 45
	  },
	  {
		"Index": 3564,
		"Rank": 53,
		"Item": "NFT People #0493",
		"Score": 45
	  },
	  {
		"Index": 3565,
		"Rank": 53,
		"Item": "NFT People #0514",
		"Score": 45
	  },
	  {
		"Index": 3566,
		"Rank": 53,
		"Item": "NFT People #0536",
		"Score": 45
	  },
	  {
		"Index": 3567,
		"Rank": 53,
		"Item": "NFT People #0627",
		"Score": 45
	  },
	  {
		"Index": 3568,
		"Rank": 53,
		"Item": "NFT People #0645",
		"Score": 45
	  },
	  {
		"Index": 3569,
		"Rank": 53,
		"Item": "NFT People #0649",
		"Score": 45
	  },
	  {
		"Index": 3570,
		"Rank": 53,
		"Item": "NFT People #0826",
		"Score": 45
	  },
	  {
		"Index": 3571,
		"Rank": 53,
		"Item": "NFT People #0853",
		"Score": 45
	  },
	  {
		"Index": 3572,
		"Rank": 53,
		"Item": "NFT People #0885",
		"Score": 45
	  },
	  {
		"Index": 3573,
		"Rank": 53,
		"Item": "NFT People #0946",
		"Score": 45
	  },
	  {
		"Index": 3574,
		"Rank": 53,
		"Item": "NFT People #1059",
		"Score": 45
	  },
	  {
		"Index": 3575,
		"Rank": 53,
		"Item": "NFT People #1081",
		"Score": 45
	  },
	  {
		"Index": 3576,
		"Rank": 53,
		"Item": "NFT People #1116",
		"Score": 45
	  },
	  {
		"Index": 3577,
		"Rank": 53,
		"Item": "NFT People #1216",
		"Score": 45
	  },
	  {
		"Index": 3578,
		"Rank": 53,
		"Item": "NFT People #1233",
		"Score": 45
	  },
	  {
		"Index": 3579,
		"Rank": 53,
		"Item": "NFT People #1243",
		"Score": 45
	  },
	  {
		"Index": 3580,
		"Rank": 53,
		"Item": "NFT People #1438",
		"Score": 45
	  },
	  {
		"Index": 3581,
		"Rank": 53,
		"Item": "NFT People #1531",
		"Score": 45
	  },
	  {
		"Index": 3582,
		"Rank": 53,
		"Item": "NFT People #1543",
		"Score": 45
	  },
	  {
		"Index": 3583,
		"Rank": 53,
		"Item": "NFT People #1580",
		"Score": 45
	  },
	  {
		"Index": 3584,
		"Rank": 53,
		"Item": "NFT People #1651",
		"Score": 45
	  },
	  {
		"Index": 3585,
		"Rank": 53,
		"Item": "NFT People #1652",
		"Score": 45
	  },
	  {
		"Index": 3586,
		"Rank": 53,
		"Item": "NFT People #1659",
		"Score": 45
	  },
	  {
		"Index": 3587,
		"Rank": 53,
		"Item": "NFT People #1677",
		"Score": 45
	  },
	  {
		"Index": 3588,
		"Rank": 53,
		"Item": "NFT People #1765",
		"Score": 45
	  },
	  {
		"Index": 3589,
		"Rank": 53,
		"Item": "NFT People #1770",
		"Score": 45
	  },
	  {
		"Index": 3590,
		"Rank": 53,
		"Item": "NFT People #1871",
		"Score": 45
	  },
	  {
		"Index": 3591,
		"Rank": 53,
		"Item": "NFT People #1918",
		"Score": 45
	  },
	  {
		"Index": 3592,
		"Rank": 53,
		"Item": "NFT People #1953",
		"Score": 45
	  },
	  {
		"Index": 3593,
		"Rank": 53,
		"Item": "NFT People #1970",
		"Score": 45
	  },
	  {
		"Index": 3594,
		"Rank": 53,
		"Item": "NFT People #2081",
		"Score": 45
	  },
	  {
		"Index": 3595,
		"Rank": 53,
		"Item": "NFT People #2100",
		"Score": 45
	  },
	  {
		"Index": 3596,
		"Rank": 53,
		"Item": "NFT People #2120",
		"Score": 45
	  },
	  {
		"Index": 3597,
		"Rank": 53,
		"Item": "NFT People #2122",
		"Score": 45
	  },
	  {
		"Index": 3598,
		"Rank": 53,
		"Item": "NFT People #2153",
		"Score": 45
	  },
	  {
		"Index": 3599,
		"Rank": 53,
		"Item": "NFT People #2234",
		"Score": 45
	  },
	  {
		"Index": 3600,
		"Rank": 53,
		"Item": "NFT People #2241",
		"Score": 45
	  },
	  {
		"Index": 3601,
		"Rank": 53,
		"Item": "NFT People #2406",
		"Score": 45
	  },
	  {
		"Index": 3602,
		"Rank": 53,
		"Item": "NFT People #2438",
		"Score": 45
	  },
	  {
		"Index": 3603,
		"Rank": 53,
		"Item": "NFT People #2450",
		"Score": 45
	  },
	  {
		"Index": 3604,
		"Rank": 53,
		"Item": "NFT People #2503",
		"Score": 45
	  },
	  {
		"Index": 3605,
		"Rank": 53,
		"Item": "NFT People #2552",
		"Score": 45
	  },
	  {
		"Index": 3606,
		"Rank": 53,
		"Item": "NFT People #2575",
		"Score": 45
	  },
	  {
		"Index": 3607,
		"Rank": 53,
		"Item": "NFT People #2670",
		"Score": 45
	  },
	  {
		"Index": 3608,
		"Rank": 53,
		"Item": "NFT People #2679",
		"Score": 45
	  },
	  {
		"Index": 3609,
		"Rank": 53,
		"Item": "NFT People #2716",
		"Score": 45
	  },
	  {
		"Index": 3610,
		"Rank": 53,
		"Item": "NFT People #2720",
		"Score": 45
	  },
	  {
		"Index": 3611,
		"Rank": 53,
		"Item": "NFT People #2809",
		"Score": 45
	  },
	  {
		"Index": 3612,
		"Rank": 53,
		"Item": "NFT People #2889",
		"Score": 45
	  },
	  {
		"Index": 3613,
		"Rank": 53,
		"Item": "NFT People #2892",
		"Score": 45
	  },
	  {
		"Index": 3614,
		"Rank": 53,
		"Item": "NFT People #2893",
		"Score": 45
	  },
	  {
		"Index": 3615,
		"Rank": 53,
		"Item": "NFT People #2901",
		"Score": 45
	  },
	  {
		"Index": 3616,
		"Rank": 53,
		"Item": "NFT People #2935",
		"Score": 45
	  },
	  {
		"Index": 3617,
		"Rank": 53,
		"Item": "NFT People #2991",
		"Score": 45
	  },
	  {
		"Index": 3618,
		"Rank": 53,
		"Item": "NFT People #3145",
		"Score": 45
	  },
	  {
		"Index": 3619,
		"Rank": 53,
		"Item": "NFT People #3155",
		"Score": 45
	  },
	  {
		"Index": 3620,
		"Rank": 53,
		"Item": "NFT People #3228",
		"Score": 45
	  },
	  {
		"Index": 3621,
		"Rank": 53,
		"Item": "NFT People #3231",
		"Score": 45
	  },
	  {
		"Index": 3622,
		"Rank": 53,
		"Item": "NFT People #3234",
		"Score": 45
	  },
	  {
		"Index": 3623,
		"Rank": 53,
		"Item": "NFT People #3292",
		"Score": 45
	  },
	  {
		"Index": 3624,
		"Rank": 53,
		"Item": "NFT People #3330",
		"Score": 45
	  },
	  {
		"Index": 3625,
		"Rank": 53,
		"Item": "NFT People #3363",
		"Score": 45
	  },
	  {
		"Index": 3626,
		"Rank": 53,
		"Item": "NFT People #3392",
		"Score": 45
	  },
	  {
		"Index": 3627,
		"Rank": 53,
		"Item": "NFT People #3406",
		"Score": 45
	  },
	  {
		"Index": 3628,
		"Rank": 53,
		"Item": "NFT People #3439",
		"Score": 45
	  },
	  {
		"Index": 3629,
		"Rank": 53,
		"Item": "NFT People #3563",
		"Score": 45
	  },
	  {
		"Index": 3630,
		"Rank": 53,
		"Item": "NFT People #3568",
		"Score": 45
	  },
	  {
		"Index": 3631,
		"Rank": 53,
		"Item": "NFT People #3603",
		"Score": 45
	  },
	  {
		"Index": 3632,
		"Rank": 53,
		"Item": "NFT People #3637",
		"Score": 45
	  },
	  {
		"Index": 3633,
		"Rank": 53,
		"Item": "NFT People #3652",
		"Score": 45
	  },
	  {
		"Index": 3634,
		"Rank": 53,
		"Item": "NFT People #3655",
		"Score": 45
	  },
	  {
		"Index": 3635,
		"Rank": 53,
		"Item": "NFT People #3680",
		"Score": 45
	  },
	  {
		"Index": 3636,
		"Rank": 53,
		"Item": "NFT People #3689",
		"Score": 45
	  },
	  {
		"Index": 3637,
		"Rank": 53,
		"Item": "NFT People #3717",
		"Score": 45
	  },
	  {
		"Index": 3638,
		"Rank": 53,
		"Item": "NFT People #3728",
		"Score": 45
	  },
	  {
		"Index": 3639,
		"Rank": 53,
		"Item": "NFT People #3750",
		"Score": 45
	  },
	  {
		"Index": 3640,
		"Rank": 53,
		"Item": "NFT People #3769",
		"Score": 45
	  },
	  {
		"Index": 3641,
		"Rank": 53,
		"Item": "NFT People #3794",
		"Score": 45
	  },
	  {
		"Index": 3642,
		"Rank": 53,
		"Item": "NFT People #3855",
		"Score": 45
	  },
	  {
		"Index": 3643,
		"Rank": 53,
		"Item": "NFT People #3866",
		"Score": 45
	  },
	  {
		"Index": 3644,
		"Rank": 53,
		"Item": "NFT People #3890",
		"Score": 45
	  },
	  {
		"Index": 3645,
		"Rank": 53,
		"Item": "NFT People #3901",
		"Score": 45
	  },
	  {
		"Index": 3646,
		"Rank": 53,
		"Item": "NFT People #3902",
		"Score": 45
	  },
	  {
		"Index": 3647,
		"Rank": 53,
		"Item": "NFT People #3929",
		"Score": 45
	  },
	  {
		"Index": 3648,
		"Rank": 53,
		"Item": "NFT People #3958",
		"Score": 45
	  },
	  {
		"Index": 3649,
		"Rank": 53,
		"Item": "NFT People #3986",
		"Score": 45
	  },
	  {
		"Index": 3650,
		"Rank": 53,
		"Item": "NFT People #4079",
		"Score": 45
	  },
	  {
		"Index": 3651,
		"Rank": 53,
		"Item": "NFT People #4104",
		"Score": 45
	  },
	  {
		"Index": 3652,
		"Rank": 53,
		"Item": "NFT People #4114",
		"Score": 45
	  },
	  {
		"Index": 3653,
		"Rank": 53,
		"Item": "NFT People #4128",
		"Score": 45
	  },
	  {
		"Index": 3654,
		"Rank": 53,
		"Item": "NFT People #4131",
		"Score": 45
	  },
	  {
		"Index": 3655,
		"Rank": 53,
		"Item": "NFT People #4169",
		"Score": 45
	  },
	  {
		"Index": 3656,
		"Rank": 53,
		"Item": "NFT People #4199",
		"Score": 45
	  },
	  {
		"Index": 3657,
		"Rank": 53,
		"Item": "NFT People #4215",
		"Score": 45
	  },
	  {
		"Index": 3658,
		"Rank": 53,
		"Item": "NFT People #4238",
		"Score": 45
	  },
	  {
		"Index": 3659,
		"Rank": 53,
		"Item": "NFT People #4280",
		"Score": 45
	  },
	  {
		"Index": 3660,
		"Rank": 53,
		"Item": "NFT People #4308",
		"Score": 45
	  },
	  {
		"Index": 3661,
		"Rank": 53,
		"Item": "NFT People #4375",
		"Score": 45
	  },
	  {
		"Index": 3662,
		"Rank": 53,
		"Item": "NFT People #4397",
		"Score": 45
	  },
	  {
		"Index": 3663,
		"Rank": 53,
		"Item": "NFT People #4479",
		"Score": 45
	  },
	  {
		"Index": 3664,
		"Rank": 53,
		"Item": "NFT People #4483",
		"Score": 45
	  },
	  {
		"Index": 3665,
		"Rank": 53,
		"Item": "NFT People #4503",
		"Score": 45
	  },
	  {
		"Index": 3666,
		"Rank": 53,
		"Item": "NFT People #4515",
		"Score": 45
	  },
	  {
		"Index": 3667,
		"Rank": 53,
		"Item": "NFT People #4556",
		"Score": 45
	  },
	  {
		"Index": 3668,
		"Rank": 53,
		"Item": "NFT People #4783",
		"Score": 45
	  },
	  {
		"Index": 3669,
		"Rank": 53,
		"Item": "NFT People #4787",
		"Score": 45
	  },
	  {
		"Index": 3670,
		"Rank": 53,
		"Item": "NFT People #4852",
		"Score": 45
	  },
	  {
		"Index": 3671,
		"Rank": 53,
		"Item": "NFT People #4861",
		"Score": 45
	  },
	  {
		"Index": 3672,
		"Rank": 53,
		"Item": "NFT People #4878",
		"Score": 45
	  },
	  {
		"Index": 3673,
		"Rank": 53,
		"Item": "NFT People #4888",
		"Score": 45
	  },
	  {
		"Index": 3674,
		"Rank": 53,
		"Item": "NFT People #4921",
		"Score": 45
	  },
	  {
		"Index": 3675,
		"Rank": 53,
		"Item": "NFT People #4974",
		"Score": 45
	  },
	  {
		"Index": 3676,
		"Rank": 53,
		"Item": "NFT People #4997",
		"Score": 45
	  },
	  {
		"Index": 3677,
		"Rank": 54,
		"Item": "NFT People #0154",
		"Score": 44
	  },
	  {
		"Index": 3678,
		"Rank": 54,
		"Item": "NFT People #0156",
		"Score": 44
	  },
	  {
		"Index": 3679,
		"Rank": 54,
		"Item": "NFT People #0196",
		"Score": 44
	  },
	  {
		"Index": 3680,
		"Rank": 54,
		"Item": "NFT People #0467",
		"Score": 44
	  },
	  {
		"Index": 3681,
		"Rank": 54,
		"Item": "NFT People #0574",
		"Score": 44
	  },
	  {
		"Index": 3682,
		"Rank": 54,
		"Item": "NFT People #0616",
		"Score": 44
	  },
	  {
		"Index": 3683,
		"Rank": 54,
		"Item": "NFT People #0619",
		"Score": 44
	  },
	  {
		"Index": 3684,
		"Rank": 54,
		"Item": "NFT People #0685",
		"Score": 44
	  },
	  {
		"Index": 3685,
		"Rank": 54,
		"Item": "NFT People #0801",
		"Score": 44
	  },
	  {
		"Index": 3686,
		"Rank": 54,
		"Item": "NFT People #0897",
		"Score": 44
	  },
	  {
		"Index": 3687,
		"Rank": 54,
		"Item": "NFT People #0903",
		"Score": 44
	  },
	  {
		"Index": 3688,
		"Rank": 54,
		"Item": "NFT People #0909",
		"Score": 44
	  },
	  {
		"Index": 3689,
		"Rank": 54,
		"Item": "NFT People #1030",
		"Score": 44
	  },
	  {
		"Index": 3690,
		"Rank": 54,
		"Item": "NFT People #1035",
		"Score": 44
	  },
	  {
		"Index": 3691,
		"Rank": 54,
		"Item": "NFT People #1089",
		"Score": 44
	  },
	  {
		"Index": 3692,
		"Rank": 54,
		"Item": "NFT People #1136",
		"Score": 44
	  },
	  {
		"Index": 3693,
		"Rank": 54,
		"Item": "NFT People #1294",
		"Score": 44
	  },
	  {
		"Index": 3694,
		"Rank": 54,
		"Item": "NFT People #1340",
		"Score": 44
	  },
	  {
		"Index": 3695,
		"Rank": 54,
		"Item": "NFT People #1402",
		"Score": 44
	  },
	  {
		"Index": 3696,
		"Rank": 54,
		"Item": "NFT People #1456",
		"Score": 44
	  },
	  {
		"Index": 3697,
		"Rank": 54,
		"Item": "NFT People #1472",
		"Score": 44
	  },
	  {
		"Index": 3698,
		"Rank": 54,
		"Item": "NFT People #1523",
		"Score": 44
	  },
	  {
		"Index": 3699,
		"Rank": 54,
		"Item": "NFT People #1551",
		"Score": 44
	  },
	  {
		"Index": 3700,
		"Rank": 54,
		"Item": "NFT People #1564",
		"Score": 44
	  },
	  {
		"Index": 3701,
		"Rank": 54,
		"Item": "NFT People #1579",
		"Score": 44
	  },
	  {
		"Index": 3702,
		"Rank": 54,
		"Item": "NFT People #1700",
		"Score": 44
	  },
	  {
		"Index": 3703,
		"Rank": 54,
		"Item": "NFT People #1764",
		"Score": 44
	  },
	  {
		"Index": 3704,
		"Rank": 54,
		"Item": "NFT People #1867",
		"Score": 44
	  },
	  {
		"Index": 3705,
		"Rank": 54,
		"Item": "NFT People #1907",
		"Score": 44
	  },
	  {
		"Index": 3706,
		"Rank": 54,
		"Item": "NFT People #2000",
		"Score": 44
	  },
	  {
		"Index": 3707,
		"Rank": 54,
		"Item": "NFT People #2225",
		"Score": 44
	  },
	  {
		"Index": 3708,
		"Rank": 54,
		"Item": "NFT People #2268",
		"Score": 44
	  },
	  {
		"Index": 3709,
		"Rank": 54,
		"Item": "NFT People #2272",
		"Score": 44
	  },
	  {
		"Index": 3710,
		"Rank": 54,
		"Item": "NFT People #2287",
		"Score": 44
	  },
	  {
		"Index": 3711,
		"Rank": 54,
		"Item": "NFT People #2310",
		"Score": 44
	  },
	  {
		"Index": 3712,
		"Rank": 54,
		"Item": "NFT People #2389",
		"Score": 44
	  },
	  {
		"Index": 3713,
		"Rank": 54,
		"Item": "NFT People #2560",
		"Score": 44
	  },
	  {
		"Index": 3714,
		"Rank": 54,
		"Item": "NFT People #2563",
		"Score": 44
	  },
	  {
		"Index": 3715,
		"Rank": 54,
		"Item": "NFT People #2822",
		"Score": 44
	  },
	  {
		"Index": 3716,
		"Rank": 54,
		"Item": "NFT People #2838",
		"Score": 44
	  },
	  {
		"Index": 3717,
		"Rank": 54,
		"Item": "NFT People #2882",
		"Score": 44
	  },
	  {
		"Index": 3718,
		"Rank": 54,
		"Item": "NFT People #2906",
		"Score": 44
	  },
	  {
		"Index": 3719,
		"Rank": 54,
		"Item": "NFT People #3246",
		"Score": 44
	  },
	  {
		"Index": 3720,
		"Rank": 54,
		"Item": "NFT People #3263",
		"Score": 44
	  },
	  {
		"Index": 3721,
		"Rank": 54,
		"Item": "NFT People #3278",
		"Score": 44
	  },
	  {
		"Index": 3722,
		"Rank": 54,
		"Item": "NFT People #3346",
		"Score": 44
	  },
	  {
		"Index": 3723,
		"Rank": 54,
		"Item": "NFT People #3356",
		"Score": 44
	  },
	  {
		"Index": 3724,
		"Rank": 54,
		"Item": "NFT People #3399",
		"Score": 44
	  },
	  {
		"Index": 3725,
		"Rank": 54,
		"Item": "NFT People #3459",
		"Score": 44
	  },
	  {
		"Index": 3726,
		"Rank": 54,
		"Item": "NFT People #3489",
		"Score": 44
	  },
	  {
		"Index": 3727,
		"Rank": 54,
		"Item": "NFT People #3493",
		"Score": 44
	  },
	  {
		"Index": 3728,
		"Rank": 54,
		"Item": "NFT People #3531",
		"Score": 44
	  },
	  {
		"Index": 3729,
		"Rank": 54,
		"Item": "NFT People #3696",
		"Score": 44
	  },
	  {
		"Index": 3730,
		"Rank": 54,
		"Item": "NFT People #3788",
		"Score": 44
	  },
	  {
		"Index": 3731,
		"Rank": 54,
		"Item": "NFT People #3898",
		"Score": 44
	  },
	  {
		"Index": 3732,
		"Rank": 54,
		"Item": "NFT People #3910",
		"Score": 44
	  },
	  {
		"Index": 3733,
		"Rank": 54,
		"Item": "NFT People #3921",
		"Score": 44
	  },
	  {
		"Index": 3734,
		"Rank": 54,
		"Item": "NFT People #3970",
		"Score": 44
	  },
	  {
		"Index": 3735,
		"Rank": 54,
		"Item": "NFT People #3999",
		"Score": 44
	  },
	  {
		"Index": 3736,
		"Rank": 54,
		"Item": "NFT People #4047",
		"Score": 44
	  },
	  {
		"Index": 3737,
		"Rank": 54,
		"Item": "NFT People #4112",
		"Score": 44
	  },
	  {
		"Index": 3738,
		"Rank": 54,
		"Item": "NFT People #4196",
		"Score": 44
	  },
	  {
		"Index": 3739,
		"Rank": 54,
		"Item": "NFT People #4219",
		"Score": 44
	  },
	  {
		"Index": 3740,
		"Rank": 54,
		"Item": "NFT People #4267",
		"Score": 44
	  },
	  {
		"Index": 3741,
		"Rank": 54,
		"Item": "NFT People #4431",
		"Score": 44
	  },
	  {
		"Index": 3742,
		"Rank": 54,
		"Item": "NFT People #4608",
		"Score": 44
	  },
	  {
		"Index": 3743,
		"Rank": 54,
		"Item": "NFT People #4686",
		"Score": 44
	  },
	  {
		"Index": 3744,
		"Rank": 54,
		"Item": "NFT People #4719",
		"Score": 44
	  },
	  {
		"Index": 3745,
		"Rank": 54,
		"Item": "NFT People #4722",
		"Score": 44
	  },
	  {
		"Index": 3746,
		"Rank": 54,
		"Item": "NFT People #4745",
		"Score": 44
	  },
	  {
		"Index": 3747,
		"Rank": 54,
		"Item": "NFT People #4773",
		"Score": 44
	  },
	  {
		"Index": 3748,
		"Rank": 54,
		"Item": "NFT People #4836",
		"Score": 44
	  },
	  {
		"Index": 3749,
		"Rank": 54,
		"Item": "NFT People #4963",
		"Score": 44
	  },
	  {
		"Index": 3750,
		"Rank": 54,
		"Item": "NFT People #4986",
		"Score": 44
	  },
	  {
		"Index": 3751,
		"Rank": 55,
		"Item": "NFT People #0129",
		"Score": 43
	  },
	  {
		"Index": 3752,
		"Rank": 55,
		"Item": "NFT People #0189",
		"Score": 43
	  },
	  {
		"Index": 3753,
		"Rank": 55,
		"Item": "NFT People #0241",
		"Score": 43
	  },
	  {
		"Index": 3754,
		"Rank": 55,
		"Item": "NFT People #0243",
		"Score": 43
	  },
	  {
		"Index": 3755,
		"Rank": 55,
		"Item": "NFT People #0262",
		"Score": 43
	  },
	  {
		"Index": 3756,
		"Rank": 55,
		"Item": "NFT People #0285",
		"Score": 43
	  },
	  {
		"Index": 3757,
		"Rank": 55,
		"Item": "NFT People #0396",
		"Score": 43
	  },
	  {
		"Index": 3758,
		"Rank": 55,
		"Item": "NFT People #0408",
		"Score": 43
	  },
	  {
		"Index": 3759,
		"Rank": 55,
		"Item": "NFT People #0423",
		"Score": 43
	  },
	  {
		"Index": 3760,
		"Rank": 55,
		"Item": "NFT People #0482",
		"Score": 43
	  },
	  {
		"Index": 3761,
		"Rank": 55,
		"Item": "NFT People #0550",
		"Score": 43
	  },
	  {
		"Index": 3762,
		"Rank": 55,
		"Item": "NFT People #0599",
		"Score": 43
	  },
	  {
		"Index": 3763,
		"Rank": 55,
		"Item": "NFT People #0687",
		"Score": 43
	  },
	  {
		"Index": 3764,
		"Rank": 55,
		"Item": "NFT People #0739",
		"Score": 43
	  },
	  {
		"Index": 3765,
		"Rank": 55,
		"Item": "NFT People #0751",
		"Score": 43
	  },
	  {
		"Index": 3766,
		"Rank": 55,
		"Item": "NFT People #0780",
		"Score": 43
	  },
	  {
		"Index": 3767,
		"Rank": 55,
		"Item": "NFT People #0793",
		"Score": 43
	  },
	  {
		"Index": 3768,
		"Rank": 55,
		"Item": "NFT People #0823",
		"Score": 43
	  },
	  {
		"Index": 3769,
		"Rank": 55,
		"Item": "NFT People #0841",
		"Score": 43
	  },
	  {
		"Index": 3770,
		"Rank": 55,
		"Item": "NFT People #0858",
		"Score": 43
	  },
	  {
		"Index": 3771,
		"Rank": 55,
		"Item": "NFT People #0914",
		"Score": 43
	  },
	  {
		"Index": 3772,
		"Rank": 55,
		"Item": "NFT People #0926",
		"Score": 43
	  },
	  {
		"Index": 3773,
		"Rank": 55,
		"Item": "NFT People #0961",
		"Score": 43
	  },
	  {
		"Index": 3774,
		"Rank": 55,
		"Item": "NFT People #1060",
		"Score": 43
	  },
	  {
		"Index": 3775,
		"Rank": 55,
		"Item": "NFT People #1080",
		"Score": 43
	  },
	  {
		"Index": 3776,
		"Rank": 55,
		"Item": "NFT People #1095",
		"Score": 43
	  },
	  {
		"Index": 3777,
		"Rank": 55,
		"Item": "NFT People #1178",
		"Score": 43
	  },
	  {
		"Index": 3778,
		"Rank": 55,
		"Item": "NFT People #1207",
		"Score": 43
	  },
	  {
		"Index": 3779,
		"Rank": 55,
		"Item": "NFT People #1218",
		"Score": 43
	  },
	  {
		"Index": 3780,
		"Rank": 55,
		"Item": "NFT People #1249",
		"Score": 43
	  },
	  {
		"Index": 3781,
		"Rank": 55,
		"Item": "NFT People #1264",
		"Score": 43
	  },
	  {
		"Index": 3782,
		"Rank": 55,
		"Item": "NFT People #1308",
		"Score": 43
	  },
	  {
		"Index": 3783,
		"Rank": 55,
		"Item": "NFT People #1364",
		"Score": 43
	  },
	  {
		"Index": 3784,
		"Rank": 55,
		"Item": "NFT People #1397",
		"Score": 43
	  },
	  {
		"Index": 3785,
		"Rank": 55,
		"Item": "NFT People #1496",
		"Score": 43
	  },
	  {
		"Index": 3786,
		"Rank": 55,
		"Item": "NFT People #1518",
		"Score": 43
	  },
	  {
		"Index": 3787,
		"Rank": 55,
		"Item": "NFT People #1534",
		"Score": 43
	  },
	  {
		"Index": 3788,
		"Rank": 55,
		"Item": "NFT People #1571",
		"Score": 43
	  },
	  {
		"Index": 3789,
		"Rank": 55,
		"Item": "NFT People #1622",
		"Score": 43
	  },
	  {
		"Index": 3790,
		"Rank": 55,
		"Item": "NFT People #1631",
		"Score": 43
	  },
	  {
		"Index": 3791,
		"Rank": 55,
		"Item": "NFT People #1641",
		"Score": 43
	  },
	  {
		"Index": 3792,
		"Rank": 55,
		"Item": "NFT People #1751",
		"Score": 43
	  },
	  {
		"Index": 3793,
		"Rank": 55,
		"Item": "NFT People #1761",
		"Score": 43
	  },
	  {
		"Index": 3794,
		"Rank": 55,
		"Item": "NFT People #1802",
		"Score": 43
	  },
	  {
		"Index": 3795,
		"Rank": 55,
		"Item": "NFT People #1814",
		"Score": 43
	  },
	  {
		"Index": 3796,
		"Rank": 55,
		"Item": "NFT People #1874",
		"Score": 43
	  },
	  {
		"Index": 3797,
		"Rank": 55,
		"Item": "NFT People #1909",
		"Score": 43
	  },
	  {
		"Index": 3798,
		"Rank": 55,
		"Item": "NFT People #1916",
		"Score": 43
	  },
	  {
		"Index": 3799,
		"Rank": 55,
		"Item": "NFT People #1943",
		"Score": 43
	  },
	  {
		"Index": 3800,
		"Rank": 55,
		"Item": "NFT People #2069",
		"Score": 43
	  },
	  {
		"Index": 3801,
		"Rank": 55,
		"Item": "NFT People #2129",
		"Score": 43
	  },
	  {
		"Index": 3802,
		"Rank": 55,
		"Item": "NFT People #2197",
		"Score": 43
	  },
	  {
		"Index": 3803,
		"Rank": 55,
		"Item": "NFT People #2201",
		"Score": 43
	  },
	  {
		"Index": 3804,
		"Rank": 55,
		"Item": "NFT People #2327",
		"Score": 43
	  },
	  {
		"Index": 3805,
		"Rank": 55,
		"Item": "NFT People #2338",
		"Score": 43
	  },
	  {
		"Index": 3806,
		"Rank": 55,
		"Item": "NFT People #2367",
		"Score": 43
	  },
	  {
		"Index": 3807,
		"Rank": 55,
		"Item": "NFT People #2370",
		"Score": 43
	  },
	  {
		"Index": 3808,
		"Rank": 55,
		"Item": "NFT People #2384",
		"Score": 43
	  },
	  {
		"Index": 3809,
		"Rank": 55,
		"Item": "NFT People #2404",
		"Score": 43
	  },
	  {
		"Index": 3810,
		"Rank": 55,
		"Item": "NFT People #2433",
		"Score": 43
	  },
	  {
		"Index": 3811,
		"Rank": 55,
		"Item": "NFT People #2593",
		"Score": 43
	  },
	  {
		"Index": 3812,
		"Rank": 55,
		"Item": "NFT People #2663",
		"Score": 43
	  },
	  {
		"Index": 3813,
		"Rank": 55,
		"Item": "NFT People #2688",
		"Score": 43
	  },
	  {
		"Index": 3814,
		"Rank": 55,
		"Item": "NFT People #2713",
		"Score": 43
	  },
	  {
		"Index": 3815,
		"Rank": 55,
		"Item": "NFT People #2719",
		"Score": 43
	  },
	  {
		"Index": 3816,
		"Rank": 55,
		"Item": "NFT People #2734",
		"Score": 43
	  },
	  {
		"Index": 3817,
		"Rank": 55,
		"Item": "NFT People #2749",
		"Score": 43
	  },
	  {
		"Index": 3818,
		"Rank": 55,
		"Item": "NFT People #2761",
		"Score": 43
	  },
	  {
		"Index": 3819,
		"Rank": 55,
		"Item": "NFT People #2845",
		"Score": 43
	  },
	  {
		"Index": 3820,
		"Rank": 55,
		"Item": "NFT People #2877",
		"Score": 43
	  },
	  {
		"Index": 3821,
		"Rank": 55,
		"Item": "NFT People #2979",
		"Score": 43
	  },
	  {
		"Index": 3822,
		"Rank": 55,
		"Item": "NFT People #3089",
		"Score": 43
	  },
	  {
		"Index": 3823,
		"Rank": 55,
		"Item": "NFT People #3110",
		"Score": 43
	  },
	  {
		"Index": 3824,
		"Rank": 55,
		"Item": "NFT People #3130",
		"Score": 43
	  },
	  {
		"Index": 3825,
		"Rank": 55,
		"Item": "NFT People #3229",
		"Score": 43
	  },
	  {
		"Index": 3826,
		"Rank": 55,
		"Item": "NFT People #3274",
		"Score": 43
	  },
	  {
		"Index": 3827,
		"Rank": 55,
		"Item": "NFT People #3411",
		"Score": 43
	  },
	  {
		"Index": 3828,
		"Rank": 55,
		"Item": "NFT People #3463",
		"Score": 43
	  },
	  {
		"Index": 3829,
		"Rank": 55,
		"Item": "NFT People #3497",
		"Score": 43
	  },
	  {
		"Index": 3830,
		"Rank": 55,
		"Item": "NFT People #3505",
		"Score": 43
	  },
	  {
		"Index": 3831,
		"Rank": 55,
		"Item": "NFT People #3528",
		"Score": 43
	  },
	  {
		"Index": 3832,
		"Rank": 55,
		"Item": "NFT People #3602",
		"Score": 43
	  },
	  {
		"Index": 3833,
		"Rank": 55,
		"Item": "NFT People #3622",
		"Score": 43
	  },
	  {
		"Index": 3834,
		"Rank": 55,
		"Item": "NFT People #3658",
		"Score": 43
	  },
	  {
		"Index": 3835,
		"Rank": 55,
		"Item": "NFT People #3712",
		"Score": 43
	  },
	  {
		"Index": 3836,
		"Rank": 55,
		"Item": "NFT People #3791",
		"Score": 43
	  },
	  {
		"Index": 3837,
		"Rank": 55,
		"Item": "NFT People #3882",
		"Score": 43
	  },
	  {
		"Index": 3838,
		"Rank": 55,
		"Item": "NFT People #3897",
		"Score": 43
	  },
	  {
		"Index": 3839,
		"Rank": 55,
		"Item": "NFT People #3932",
		"Score": 43
	  },
	  {
		"Index": 3840,
		"Rank": 55,
		"Item": "NFT People #3945",
		"Score": 43
	  },
	  {
		"Index": 3841,
		"Rank": 55,
		"Item": "NFT People #3959",
		"Score": 43
	  },
	  {
		"Index": 3842,
		"Rank": 55,
		"Item": "NFT People #4014",
		"Score": 43
	  },
	  {
		"Index": 3843,
		"Rank": 55,
		"Item": "NFT People #4073",
		"Score": 43
	  },
	  {
		"Index": 3844,
		"Rank": 55,
		"Item": "NFT People #4091",
		"Score": 43
	  },
	  {
		"Index": 3845,
		"Rank": 55,
		"Item": "NFT People #4101",
		"Score": 43
	  },
	  {
		"Index": 3846,
		"Rank": 55,
		"Item": "NFT People #4108",
		"Score": 43
	  },
	  {
		"Index": 3847,
		"Rank": 55,
		"Item": "NFT People #4191",
		"Score": 43
	  },
	  {
		"Index": 3848,
		"Rank": 55,
		"Item": "NFT People #4203",
		"Score": 43
	  },
	  {
		"Index": 3849,
		"Rank": 55,
		"Item": "NFT People #4235",
		"Score": 43
	  },
	  {
		"Index": 3850,
		"Rank": 55,
		"Item": "NFT People #4339",
		"Score": 43
	  },
	  {
		"Index": 3851,
		"Rank": 55,
		"Item": "NFT People #4508",
		"Score": 43
	  },
	  {
		"Index": 3852,
		"Rank": 55,
		"Item": "NFT People #4545",
		"Score": 43
	  },
	  {
		"Index": 3853,
		"Rank": 55,
		"Item": "NFT People #4571",
		"Score": 43
	  },
	  {
		"Index": 3854,
		"Rank": 55,
		"Item": "NFT People #4588",
		"Score": 43
	  },
	  {
		"Index": 3855,
		"Rank": 55,
		"Item": "NFT People #4598",
		"Score": 43
	  },
	  {
		"Index": 3856,
		"Rank": 55,
		"Item": "NFT People #4611",
		"Score": 43
	  },
	  {
		"Index": 3857,
		"Rank": 55,
		"Item": "NFT People #4635",
		"Score": 43
	  },
	  {
		"Index": 3858,
		"Rank": 55,
		"Item": "NFT People #4683",
		"Score": 43
	  },
	  {
		"Index": 3859,
		"Rank": 55,
		"Item": "NFT People #4737",
		"Score": 43
	  },
	  {
		"Index": 3860,
		"Rank": 55,
		"Item": "NFT People #4748",
		"Score": 43
	  },
	  {
		"Index": 3861,
		"Rank": 55,
		"Item": "NFT People #4757",
		"Score": 43
	  },
	  {
		"Index": 3862,
		"Rank": 55,
		"Item": "NFT People #4777",
		"Score": 43
	  },
	  {
		"Index": 3863,
		"Rank": 55,
		"Item": "NFT People #4829",
		"Score": 43
	  },
	  {
		"Index": 3864,
		"Rank": 55,
		"Item": "NFT People #4853",
		"Score": 43
	  },
	  {
		"Index": 3865,
		"Rank": 55,
		"Item": "NFT People #4857",
		"Score": 43
	  },
	  {
		"Index": 3866,
		"Rank": 55,
		"Item": "NFT People #4965",
		"Score": 43
	  },
	  {
		"Index": 3867,
		"Rank": 56,
		"Item": "NFT People #0015",
		"Score": 42
	  },
	  {
		"Index": 3868,
		"Rank": 56,
		"Item": "NFT People #0020",
		"Score": 42
	  },
	  {
		"Index": 3869,
		"Rank": 56,
		"Item": "NFT People #0082",
		"Score": 42
	  },
	  {
		"Index": 3870,
		"Rank": 56,
		"Item": "NFT People #0135",
		"Score": 42
	  },
	  {
		"Index": 3871,
		"Rank": 56,
		"Item": "NFT People #0142",
		"Score": 42
	  },
	  {
		"Index": 3872,
		"Rank": 56,
		"Item": "NFT People #0151",
		"Score": 42
	  },
	  {
		"Index": 3873,
		"Rank": 56,
		"Item": "NFT People #0199",
		"Score": 42
	  },
	  {
		"Index": 3874,
		"Rank": 56,
		"Item": "NFT People #0223",
		"Score": 42
	  },
	  {
		"Index": 3875,
		"Rank": 56,
		"Item": "NFT People #0245",
		"Score": 42
	  },
	  {
		"Index": 3876,
		"Rank": 56,
		"Item": "NFT People #0306",
		"Score": 42
	  },
	  {
		"Index": 3877,
		"Rank": 56,
		"Item": "NFT People #0321",
		"Score": 42
	  },
	  {
		"Index": 3878,
		"Rank": 56,
		"Item": "NFT People #0438",
		"Score": 42
	  },
	  {
		"Index": 3879,
		"Rank": 56,
		"Item": "NFT People #0479",
		"Score": 42
	  },
	  {
		"Index": 3880,
		"Rank": 56,
		"Item": "NFT People #0488",
		"Score": 42
	  },
	  {
		"Index": 3881,
		"Rank": 56,
		"Item": "NFT People #0496",
		"Score": 42
	  },
	  {
		"Index": 3882,
		"Rank": 56,
		"Item": "NFT People #0565",
		"Score": 42
	  },
	  {
		"Index": 3883,
		"Rank": 56,
		"Item": "NFT People #0603",
		"Score": 42
	  },
	  {
		"Index": 3884,
		"Rank": 56,
		"Item": "NFT People #0613",
		"Score": 42
	  },
	  {
		"Index": 3885,
		"Rank": 56,
		"Item": "NFT People #0651",
		"Score": 42
	  },
	  {
		"Index": 3886,
		"Rank": 56,
		"Item": "NFT People #0666",
		"Score": 42
	  },
	  {
		"Index": 3887,
		"Rank": 56,
		"Item": "NFT People #0670",
		"Score": 42
	  },
	  {
		"Index": 3888,
		"Rank": 56,
		"Item": "NFT People #0708",
		"Score": 42
	  },
	  {
		"Index": 3889,
		"Rank": 56,
		"Item": "NFT People #0745",
		"Score": 42
	  },
	  {
		"Index": 3890,
		"Rank": 56,
		"Item": "NFT People #0874",
		"Score": 42
	  },
	  {
		"Index": 3891,
		"Rank": 56,
		"Item": "NFT People #0884",
		"Score": 42
	  },
	  {
		"Index": 3892,
		"Rank": 56,
		"Item": "NFT People #0916",
		"Score": 42
	  },
	  {
		"Index": 3893,
		"Rank": 56,
		"Item": "NFT People #0994",
		"Score": 42
	  },
	  {
		"Index": 3894,
		"Rank": 56,
		"Item": "NFT People #1010",
		"Score": 42
	  },
	  {
		"Index": 3895,
		"Rank": 56,
		"Item": "NFT People #1017",
		"Score": 42
	  },
	  {
		"Index": 3896,
		"Rank": 56,
		"Item": "NFT People #1039",
		"Score": 42
	  },
	  {
		"Index": 3897,
		"Rank": 56,
		"Item": "NFT People #1084",
		"Score": 42
	  },
	  {
		"Index": 3898,
		"Rank": 56,
		"Item": "NFT People #1085",
		"Score": 42
	  },
	  {
		"Index": 3899,
		"Rank": 56,
		"Item": "NFT People #1152",
		"Score": 42
	  },
	  {
		"Index": 3900,
		"Rank": 56,
		"Item": "NFT People #1187",
		"Score": 42
	  },
	  {
		"Index": 3901,
		"Rank": 56,
		"Item": "NFT People #1192",
		"Score": 42
	  },
	  {
		"Index": 3902,
		"Rank": 56,
		"Item": "NFT People #1194",
		"Score": 42
	  },
	  {
		"Index": 3903,
		"Rank": 56,
		"Item": "NFT People #1261",
		"Score": 42
	  },
	  {
		"Index": 3904,
		"Rank": 56,
		"Item": "NFT People #1286",
		"Score": 42
	  },
	  {
		"Index": 3905,
		"Rank": 56,
		"Item": "NFT People #1290",
		"Score": 42
	  },
	  {
		"Index": 3906,
		"Rank": 56,
		"Item": "NFT People #1295",
		"Score": 42
	  },
	  {
		"Index": 3907,
		"Rank": 56,
		"Item": "NFT People #1311",
		"Score": 42
	  },
	  {
		"Index": 3908,
		"Rank": 56,
		"Item": "NFT People #1341",
		"Score": 42
	  },
	  {
		"Index": 3909,
		"Rank": 56,
		"Item": "NFT People #1378",
		"Score": 42
	  },
	  {
		"Index": 3910,
		"Rank": 56,
		"Item": "NFT People #1449",
		"Score": 42
	  },
	  {
		"Index": 3911,
		"Rank": 56,
		"Item": "NFT People #1464",
		"Score": 42
	  },
	  {
		"Index": 3912,
		"Rank": 56,
		"Item": "NFT People #1559",
		"Score": 42
	  },
	  {
		"Index": 3913,
		"Rank": 56,
		"Item": "NFT People #1636",
		"Score": 42
	  },
	  {
		"Index": 3914,
		"Rank": 56,
		"Item": "NFT People #1676",
		"Score": 42
	  },
	  {
		"Index": 3915,
		"Rank": 56,
		"Item": "NFT People #1726",
		"Score": 42
	  },
	  {
		"Index": 3916,
		"Rank": 56,
		"Item": "NFT People #1747",
		"Score": 42
	  },
	  {
		"Index": 3917,
		"Rank": 56,
		"Item": "NFT People #1796",
		"Score": 42
	  },
	  {
		"Index": 3918,
		"Rank": 56,
		"Item": "NFT People #1801",
		"Score": 42
	  },
	  {
		"Index": 3919,
		"Rank": 56,
		"Item": "NFT People #1823",
		"Score": 42
	  },
	  {
		"Index": 3920,
		"Rank": 56,
		"Item": "NFT People #1844",
		"Score": 42
	  },
	  {
		"Index": 3921,
		"Rank": 56,
		"Item": "NFT People #1929",
		"Score": 42
	  },
	  {
		"Index": 3922,
		"Rank": 56,
		"Item": "NFT People #1964",
		"Score": 42
	  },
	  {
		"Index": 3923,
		"Rank": 56,
		"Item": "NFT People #1980",
		"Score": 42
	  },
	  {
		"Index": 3924,
		"Rank": 56,
		"Item": "NFT People #1989",
		"Score": 42
	  },
	  {
		"Index": 3925,
		"Rank": 56,
		"Item": "NFT People #1996",
		"Score": 42
	  },
	  {
		"Index": 3926,
		"Rank": 56,
		"Item": "NFT People #1998",
		"Score": 42
	  },
	  {
		"Index": 3927,
		"Rank": 56,
		"Item": "NFT People #2011",
		"Score": 42
	  },
	  {
		"Index": 3928,
		"Rank": 56,
		"Item": "NFT People #2012",
		"Score": 42
	  },
	  {
		"Index": 3929,
		"Rank": 56,
		"Item": "NFT People #2101",
		"Score": 42
	  },
	  {
		"Index": 3930,
		"Rank": 56,
		"Item": "NFT People #2213",
		"Score": 42
	  },
	  {
		"Index": 3931,
		"Rank": 56,
		"Item": "NFT People #2216",
		"Score": 42
	  },
	  {
		"Index": 3932,
		"Rank": 56,
		"Item": "NFT People #2242",
		"Score": 42
	  },
	  {
		"Index": 3933,
		"Rank": 56,
		"Item": "NFT People #2316",
		"Score": 42
	  },
	  {
		"Index": 3934,
		"Rank": 56,
		"Item": "NFT People #2323",
		"Score": 42
	  },
	  {
		"Index": 3935,
		"Rank": 56,
		"Item": "NFT People #2355",
		"Score": 42
	  },
	  {
		"Index": 3936,
		"Rank": 56,
		"Item": "NFT People #2364",
		"Score": 42
	  },
	  {
		"Index": 3937,
		"Rank": 56,
		"Item": "NFT People #2407",
		"Score": 42
	  },
	  {
		"Index": 3938,
		"Rank": 56,
		"Item": "NFT People #2411",
		"Score": 42
	  },
	  {
		"Index": 3939,
		"Rank": 56,
		"Item": "NFT People #2418",
		"Score": 42
	  },
	  {
		"Index": 3940,
		"Rank": 56,
		"Item": "NFT People #2429",
		"Score": 42
	  },
	  {
		"Index": 3941,
		"Rank": 56,
		"Item": "NFT People #2431",
		"Score": 42
	  },
	  {
		"Index": 3942,
		"Rank": 56,
		"Item": "NFT People #2465",
		"Score": 42
	  },
	  {
		"Index": 3943,
		"Rank": 56,
		"Item": "NFT People #2484",
		"Score": 42
	  },
	  {
		"Index": 3944,
		"Rank": 56,
		"Item": "NFT People #2500",
		"Score": 42
	  },
	  {
		"Index": 3945,
		"Rank": 56,
		"Item": "NFT People #2507",
		"Score": 42
	  },
	  {
		"Index": 3946,
		"Rank": 56,
		"Item": "NFT People #2516",
		"Score": 42
	  },
	  {
		"Index": 3947,
		"Rank": 56,
		"Item": "NFT People #2643",
		"Score": 42
	  },
	  {
		"Index": 3948,
		"Rank": 56,
		"Item": "NFT People #2653",
		"Score": 42
	  },
	  {
		"Index": 3949,
		"Rank": 56,
		"Item": "NFT People #2675",
		"Score": 42
	  },
	  {
		"Index": 3950,
		"Rank": 56,
		"Item": "NFT People #2677",
		"Score": 42
	  },
	  {
		"Index": 3951,
		"Rank": 56,
		"Item": "NFT People #2687",
		"Score": 42
	  },
	  {
		"Index": 3952,
		"Rank": 56,
		"Item": "NFT People #2748",
		"Score": 42
	  },
	  {
		"Index": 3953,
		"Rank": 56,
		"Item": "NFT People #2750",
		"Score": 42
	  },
	  {
		"Index": 3954,
		"Rank": 56,
		"Item": "NFT People #2760",
		"Score": 42
	  },
	  {
		"Index": 3955,
		"Rank": 56,
		"Item": "NFT People #2775",
		"Score": 42
	  },
	  {
		"Index": 3956,
		"Rank": 56,
		"Item": "NFT People #2824",
		"Score": 42
	  },
	  {
		"Index": 3957,
		"Rank": 56,
		"Item": "NFT People #2849",
		"Score": 42
	  },
	  {
		"Index": 3958,
		"Rank": 56,
		"Item": "NFT People #2908",
		"Score": 42
	  },
	  {
		"Index": 3959,
		"Rank": 56,
		"Item": "NFT People #2921",
		"Score": 42
	  },
	  {
		"Index": 3960,
		"Rank": 56,
		"Item": "NFT People #3004",
		"Score": 42
	  },
	  {
		"Index": 3961,
		"Rank": 56,
		"Item": "NFT People #3066",
		"Score": 42
	  },
	  {
		"Index": 3962,
		"Rank": 56,
		"Item": "NFT People #3079",
		"Score": 42
	  },
	  {
		"Index": 3963,
		"Rank": 56,
		"Item": "NFT People #3161",
		"Score": 42
	  },
	  {
		"Index": 3964,
		"Rank": 56,
		"Item": "NFT People #3172",
		"Score": 42
	  },
	  {
		"Index": 3965,
		"Rank": 56,
		"Item": "NFT People #3199",
		"Score": 42
	  },
	  {
		"Index": 3966,
		"Rank": 56,
		"Item": "NFT People #3213",
		"Score": 42
	  },
	  {
		"Index": 3967,
		"Rank": 56,
		"Item": "NFT People #3214",
		"Score": 42
	  },
	  {
		"Index": 3968,
		"Rank": 56,
		"Item": "NFT People #3281",
		"Score": 42
	  },
	  {
		"Index": 3969,
		"Rank": 56,
		"Item": "NFT People #3432",
		"Score": 42
	  },
	  {
		"Index": 3970,
		"Rank": 56,
		"Item": "NFT People #3521",
		"Score": 42
	  },
	  {
		"Index": 3971,
		"Rank": 56,
		"Item": "NFT People #3526",
		"Score": 42
	  },
	  {
		"Index": 3972,
		"Rank": 56,
		"Item": "NFT People #3564",
		"Score": 42
	  },
	  {
		"Index": 3973,
		"Rank": 56,
		"Item": "NFT People #3570",
		"Score": 42
	  },
	  {
		"Index": 3974,
		"Rank": 56,
		"Item": "NFT People #3647",
		"Score": 42
	  },
	  {
		"Index": 3975,
		"Rank": 56,
		"Item": "NFT People #3708",
		"Score": 42
	  },
	  {
		"Index": 3976,
		"Rank": 56,
		"Item": "NFT People #3711",
		"Score": 42
	  },
	  {
		"Index": 3977,
		"Rank": 56,
		"Item": "NFT People #3727",
		"Score": 42
	  },
	  {
		"Index": 3978,
		"Rank": 56,
		"Item": "NFT People #3746",
		"Score": 42
	  },
	  {
		"Index": 3979,
		"Rank": 56,
		"Item": "NFT People #3781",
		"Score": 42
	  },
	  {
		"Index": 3980,
		"Rank": 56,
		"Item": "NFT People #3797",
		"Score": 42
	  },
	  {
		"Index": 3981,
		"Rank": 56,
		"Item": "NFT People #3828",
		"Score": 42
	  },
	  {
		"Index": 3982,
		"Rank": 56,
		"Item": "NFT People #3830",
		"Score": 42
	  },
	  {
		"Index": 3983,
		"Rank": 56,
		"Item": "NFT People #3923",
		"Score": 42
	  },
	  {
		"Index": 3984,
		"Rank": 56,
		"Item": "NFT People #3927",
		"Score": 42
	  },
	  {
		"Index": 3985,
		"Rank": 56,
		"Item": "NFT People #3969",
		"Score": 42
	  },
	  {
		"Index": 3986,
		"Rank": 56,
		"Item": "NFT People #4004",
		"Score": 42
	  },
	  {
		"Index": 3987,
		"Rank": 56,
		"Item": "NFT People #4008",
		"Score": 42
	  },
	  {
		"Index": 3988,
		"Rank": 56,
		"Item": "NFT People #4150",
		"Score": 42
	  },
	  {
		"Index": 3989,
		"Rank": 56,
		"Item": "NFT People #4206",
		"Score": 42
	  },
	  {
		"Index": 3990,
		"Rank": 56,
		"Item": "NFT People #4216",
		"Score": 42
	  },
	  {
		"Index": 3991,
		"Rank": 56,
		"Item": "NFT People #4220",
		"Score": 42
	  },
	  {
		"Index": 3992,
		"Rank": 56,
		"Item": "NFT People #4240",
		"Score": 42
	  },
	  {
		"Index": 3993,
		"Rank": 56,
		"Item": "NFT People #4277",
		"Score": 42
	  },
	  {
		"Index": 3994,
		"Rank": 56,
		"Item": "NFT People #4295",
		"Score": 42
	  },
	  {
		"Index": 3995,
		"Rank": 56,
		"Item": "NFT People #4310",
		"Score": 42
	  },
	  {
		"Index": 3996,
		"Rank": 56,
		"Item": "NFT People #4315",
		"Score": 42
	  },
	  {
		"Index": 3997,
		"Rank": 56,
		"Item": "NFT People #4377",
		"Score": 42
	  },
	  {
		"Index": 3998,
		"Rank": 56,
		"Item": "NFT People #4417",
		"Score": 42
	  },
	  {
		"Index": 3999,
		"Rank": 56,
		"Item": "NFT People #4427",
		"Score": 42
	  },
	  {
		"Index": 4000,
		"Rank": 56,
		"Item": "NFT People #4453",
		"Score": 42
	  },
	  {
		"Index": 4001,
		"Rank": 56,
		"Item": "NFT People #4536",
		"Score": 42
	  },
	  {
		"Index": 4002,
		"Rank": 56,
		"Item": "NFT People #4575",
		"Score": 42
	  },
	  {
		"Index": 4003,
		"Rank": 56,
		"Item": "NFT People #4626",
		"Score": 42
	  },
	  {
		"Index": 4004,
		"Rank": 56,
		"Item": "NFT People #4657",
		"Score": 42
	  },
	  {
		"Index": 4005,
		"Rank": 56,
		"Item": "NFT People #4727",
		"Score": 42
	  },
	  {
		"Index": 4006,
		"Rank": 56,
		"Item": "NFT People #4779",
		"Score": 42
	  },
	  {
		"Index": 4007,
		"Rank": 56,
		"Item": "NFT People #4845",
		"Score": 42
	  },
	  {
		"Index": 4008,
		"Rank": 56,
		"Item": "NFT People #4913",
		"Score": 42
	  },
	  {
		"Index": 4009,
		"Rank": 56,
		"Item": "NFT People #4923",
		"Score": 42
	  },
	  {
		"Index": 4010,
		"Rank": 56,
		"Item": "NFT People #4964",
		"Score": 42
	  },
	  {
		"Index": 4011,
		"Rank": 56,
		"Item": "NFT People #4989",
		"Score": 42
	  },
	  {
		"Index": 4012,
		"Rank": 57,
		"Item": "NFT People #0118",
		"Score": 41
	  },
	  {
		"Index": 4013,
		"Rank": 57,
		"Item": "NFT People #0248",
		"Score": 41
	  },
	  {
		"Index": 4014,
		"Rank": 57,
		"Item": "NFT People #0266",
		"Score": 41
	  },
	  {
		"Index": 4015,
		"Rank": 57,
		"Item": "NFT People #0284",
		"Score": 41
	  },
	  {
		"Index": 4016,
		"Rank": 57,
		"Item": "NFT People #0791",
		"Score": 41
	  },
	  {
		"Index": 4017,
		"Rank": 57,
		"Item": "NFT People #0892",
		"Score": 41
	  },
	  {
		"Index": 4018,
		"Rank": 57,
		"Item": "NFT People #1038",
		"Score": 41
	  },
	  {
		"Index": 4019,
		"Rank": 57,
		"Item": "NFT People #1094",
		"Score": 41
	  },
	  {
		"Index": 4020,
		"Rank": 57,
		"Item": "NFT People #1156",
		"Score": 41
	  },
	  {
		"Index": 4021,
		"Rank": 57,
		"Item": "NFT People #1350",
		"Score": 41
	  },
	  {
		"Index": 4022,
		"Rank": 57,
		"Item": "NFT People #1395",
		"Score": 41
	  },
	  {
		"Index": 4023,
		"Rank": 57,
		"Item": "NFT People #1437",
		"Score": 41
	  },
	  {
		"Index": 4024,
		"Rank": 57,
		"Item": "NFT People #1562",
		"Score": 41
	  },
	  {
		"Index": 4025,
		"Rank": 57,
		"Item": "NFT People #1683",
		"Score": 41
	  },
	  {
		"Index": 4026,
		"Rank": 57,
		"Item": "NFT People #1706",
		"Score": 41
	  },
	  {
		"Index": 4027,
		"Rank": 57,
		"Item": "NFT People #1800",
		"Score": 41
	  },
	  {
		"Index": 4028,
		"Rank": 57,
		"Item": "NFT People #1845",
		"Score": 41
	  },
	  {
		"Index": 4029,
		"Rank": 57,
		"Item": "NFT People #1940",
		"Score": 41
	  },
	  {
		"Index": 4030,
		"Rank": 57,
		"Item": "NFT People #2150",
		"Score": 41
	  },
	  {
		"Index": 4031,
		"Rank": 57,
		"Item": "NFT People #2186",
		"Score": 41
	  },
	  {
		"Index": 4032,
		"Rank": 57,
		"Item": "NFT People #2224",
		"Score": 41
	  },
	  {
		"Index": 4033,
		"Rank": 57,
		"Item": "NFT People #2366",
		"Score": 41
	  },
	  {
		"Index": 4034,
		"Rank": 57,
		"Item": "NFT People #2489",
		"Score": 41
	  },
	  {
		"Index": 4035,
		"Rank": 57,
		"Item": "NFT People #2525",
		"Score": 41
	  },
	  {
		"Index": 4036,
		"Rank": 57,
		"Item": "NFT People #2669",
		"Score": 41
	  },
	  {
		"Index": 4037,
		"Rank": 57,
		"Item": "NFT People #2765",
		"Score": 41
	  },
	  {
		"Index": 4038,
		"Rank": 57,
		"Item": "NFT People #2949",
		"Score": 41
	  },
	  {
		"Index": 4039,
		"Rank": 57,
		"Item": "NFT People #2972",
		"Score": 41
	  },
	  {
		"Index": 4040,
		"Rank": 57,
		"Item": "NFT People #2984",
		"Score": 41
	  },
	  {
		"Index": 4041,
		"Rank": 57,
		"Item": "NFT People #2989",
		"Score": 41
	  },
	  {
		"Index": 4042,
		"Rank": 57,
		"Item": "NFT People #3081",
		"Score": 41
	  },
	  {
		"Index": 4043,
		"Rank": 57,
		"Item": "NFT People #3140",
		"Score": 41
	  },
	  {
		"Index": 4044,
		"Rank": 57,
		"Item": "NFT People #3166",
		"Score": 41
	  },
	  {
		"Index": 4045,
		"Rank": 57,
		"Item": "NFT People #3258",
		"Score": 41
	  },
	  {
		"Index": 4046,
		"Rank": 57,
		"Item": "NFT People #3306",
		"Score": 41
	  },
	  {
		"Index": 4047,
		"Rank": 57,
		"Item": "NFT People #3532",
		"Score": 41
	  },
	  {
		"Index": 4048,
		"Rank": 57,
		"Item": "NFT People #3757",
		"Score": 41
	  },
	  {
		"Index": 4049,
		"Rank": 57,
		"Item": "NFT People #3793",
		"Score": 41
	  },
	  {
		"Index": 4050,
		"Rank": 57,
		"Item": "NFT People #3933",
		"Score": 41
	  },
	  {
		"Index": 4051,
		"Rank": 57,
		"Item": "NFT People #4404",
		"Score": 41
	  },
	  {
		"Index": 4052,
		"Rank": 57,
		"Item": "NFT People #4409",
		"Score": 41
	  },
	  {
		"Index": 4053,
		"Rank": 57,
		"Item": "NFT People #4436",
		"Score": 41
	  },
	  {
		"Index": 4054,
		"Rank": 57,
		"Item": "NFT People #4446",
		"Score": 41
	  },
	  {
		"Index": 4055,
		"Rank": 57,
		"Item": "NFT People #4581",
		"Score": 41
	  },
	  {
		"Index": 4056,
		"Rank": 57,
		"Item": "NFT People #4592",
		"Score": 41
	  },
	  {
		"Index": 4057,
		"Rank": 57,
		"Item": "NFT People #4634",
		"Score": 41
	  },
	  {
		"Index": 4058,
		"Rank": 57,
		"Item": "NFT People #4710",
		"Score": 41
	  },
	  {
		"Index": 4059,
		"Rank": 57,
		"Item": "NFT People #4850",
		"Score": 41
	  },
	  {
		"Index": 4060,
		"Rank": 57,
		"Item": "NFT People #4877",
		"Score": 41
	  },
	  {
		"Index": 4061,
		"Rank": 57,
		"Item": "NFT People #4928",
		"Score": 41
	  },
	  {
		"Index": 4062,
		"Rank": 58,
		"Item": "NFT People #0091",
		"Score": 40
	  },
	  {
		"Index": 4063,
		"Rank": 58,
		"Item": "NFT People #0109",
		"Score": 40
	  },
	  {
		"Index": 4064,
		"Rank": 58,
		"Item": "NFT People #0136",
		"Score": 40
	  },
	  {
		"Index": 4065,
		"Rank": 58,
		"Item": "NFT People #0175",
		"Score": 40
	  },
	  {
		"Index": 4066,
		"Rank": 58,
		"Item": "NFT People #0406",
		"Score": 40
	  },
	  {
		"Index": 4067,
		"Rank": 58,
		"Item": "NFT People #0426",
		"Score": 40
	  },
	  {
		"Index": 4068,
		"Rank": 58,
		"Item": "NFT People #0466",
		"Score": 40
	  },
	  {
		"Index": 4069,
		"Rank": 58,
		"Item": "NFT People #0481",
		"Score": 40
	  },
	  {
		"Index": 4070,
		"Rank": 58,
		"Item": "NFT People #0532",
		"Score": 40
	  },
	  {
		"Index": 4071,
		"Rank": 58,
		"Item": "NFT People #0539",
		"Score": 40
	  },
	  {
		"Index": 4072,
		"Rank": 58,
		"Item": "NFT People #0552",
		"Score": 40
	  },
	  {
		"Index": 4073,
		"Rank": 58,
		"Item": "NFT People #0557",
		"Score": 40
	  },
	  {
		"Index": 4074,
		"Rank": 58,
		"Item": "NFT People #0558",
		"Score": 40
	  },
	  {
		"Index": 4075,
		"Rank": 58,
		"Item": "NFT People #0578",
		"Score": 40
	  },
	  {
		"Index": 4076,
		"Rank": 58,
		"Item": "NFT People #0621",
		"Score": 40
	  },
	  {
		"Index": 4077,
		"Rank": 58,
		"Item": "NFT People #0673",
		"Score": 40
	  },
	  {
		"Index": 4078,
		"Rank": 58,
		"Item": "NFT People #0705",
		"Score": 40
	  },
	  {
		"Index": 4079,
		"Rank": 58,
		"Item": "NFT People #0706",
		"Score": 40
	  },
	  {
		"Index": 4080,
		"Rank": 58,
		"Item": "NFT People #0760",
		"Score": 40
	  },
	  {
		"Index": 4081,
		"Rank": 58,
		"Item": "NFT People #0767",
		"Score": 40
	  },
	  {
		"Index": 4082,
		"Rank": 58,
		"Item": "NFT People #0829",
		"Score": 40
	  },
	  {
		"Index": 4083,
		"Rank": 58,
		"Item": "NFT People #0927",
		"Score": 40
	  },
	  {
		"Index": 4084,
		"Rank": 58,
		"Item": "NFT People #1055",
		"Score": 40
	  },
	  {
		"Index": 4085,
		"Rank": 58,
		"Item": "NFT People #1200",
		"Score": 40
	  },
	  {
		"Index": 4086,
		"Rank": 58,
		"Item": "NFT People #1221",
		"Score": 40
	  },
	  {
		"Index": 4087,
		"Rank": 58,
		"Item": "NFT People #1318",
		"Score": 40
	  },
	  {
		"Index": 4088,
		"Rank": 58,
		"Item": "NFT People #1332",
		"Score": 40
	  },
	  {
		"Index": 4089,
		"Rank": 58,
		"Item": "NFT People #1352",
		"Score": 40
	  },
	  {
		"Index": 4090,
		"Rank": 58,
		"Item": "NFT People #1380",
		"Score": 40
	  },
	  {
		"Index": 4091,
		"Rank": 58,
		"Item": "NFT People #1393",
		"Score": 40
	  },
	  {
		"Index": 4092,
		"Rank": 58,
		"Item": "NFT People #1424",
		"Score": 40
	  },
	  {
		"Index": 4093,
		"Rank": 58,
		"Item": "NFT People #1468",
		"Score": 40
	  },
	  {
		"Index": 4094,
		"Rank": 58,
		"Item": "NFT People #1499",
		"Score": 40
	  },
	  {
		"Index": 4095,
		"Rank": 58,
		"Item": "NFT People #1509",
		"Score": 40
	  },
	  {
		"Index": 4096,
		"Rank": 58,
		"Item": "NFT People #1511",
		"Score": 40
	  },
	  {
		"Index": 4097,
		"Rank": 58,
		"Item": "NFT People #1545",
		"Score": 40
	  },
	  {
		"Index": 4098,
		"Rank": 58,
		"Item": "NFT People #1587",
		"Score": 40
	  },
	  {
		"Index": 4099,
		"Rank": 58,
		"Item": "NFT People #1684",
		"Score": 40
	  },
	  {
		"Index": 4100,
		"Rank": 58,
		"Item": "NFT People #1725",
		"Score": 40
	  },
	  {
		"Index": 4101,
		"Rank": 58,
		"Item": "NFT People #1769",
		"Score": 40
	  },
	  {
		"Index": 4102,
		"Rank": 58,
		"Item": "NFT People #1817",
		"Score": 40
	  },
	  {
		"Index": 4103,
		"Rank": 58,
		"Item": "NFT People #1833",
		"Score": 40
	  },
	  {
		"Index": 4104,
		"Rank": 58,
		"Item": "NFT People #1889",
		"Score": 40
	  },
	  {
		"Index": 4105,
		"Rank": 58,
		"Item": "NFT People #1926",
		"Score": 40
	  },
	  {
		"Index": 4106,
		"Rank": 58,
		"Item": "NFT People #1960",
		"Score": 40
	  },
	  {
		"Index": 4107,
		"Rank": 58,
		"Item": "NFT People #2056",
		"Score": 40
	  },
	  {
		"Index": 4108,
		"Rank": 58,
		"Item": "NFT People #2099",
		"Score": 40
	  },
	  {
		"Index": 4109,
		"Rank": 58,
		"Item": "NFT People #2146",
		"Score": 40
	  },
	  {
		"Index": 4110,
		"Rank": 58,
		"Item": "NFT People #2209",
		"Score": 40
	  },
	  {
		"Index": 4111,
		"Rank": 58,
		"Item": "NFT People #2284",
		"Score": 40
	  },
	  {
		"Index": 4112,
		"Rank": 58,
		"Item": "NFT People #2311",
		"Score": 40
	  },
	  {
		"Index": 4113,
		"Rank": 58,
		"Item": "NFT People #2388",
		"Score": 40
	  },
	  {
		"Index": 4114,
		"Rank": 58,
		"Item": "NFT People #2397",
		"Score": 40
	  },
	  {
		"Index": 4115,
		"Rank": 58,
		"Item": "NFT People #2449",
		"Score": 40
	  },
	  {
		"Index": 4116,
		"Rank": 58,
		"Item": "NFT People #2497",
		"Score": 40
	  },
	  {
		"Index": 4117,
		"Rank": 58,
		"Item": "NFT People #2522",
		"Score": 40
	  },
	  {
		"Index": 4118,
		"Rank": 58,
		"Item": "NFT People #2628",
		"Score": 40
	  },
	  {
		"Index": 4119,
		"Rank": 58,
		"Item": "NFT People #2672",
		"Score": 40
	  },
	  {
		"Index": 4120,
		"Rank": 58,
		"Item": "NFT People #2685",
		"Score": 40
	  },
	  {
		"Index": 4121,
		"Rank": 58,
		"Item": "NFT People #2686",
		"Score": 40
	  },
	  {
		"Index": 4122,
		"Rank": 58,
		"Item": "NFT People #2793",
		"Score": 40
	  },
	  {
		"Index": 4123,
		"Rank": 58,
		"Item": "NFT People #2796",
		"Score": 40
	  },
	  {
		"Index": 4124,
		"Rank": 58,
		"Item": "NFT People #2805",
		"Score": 40
	  },
	  {
		"Index": 4125,
		"Rank": 58,
		"Item": "NFT People #2992",
		"Score": 40
	  },
	  {
		"Index": 4126,
		"Rank": 58,
		"Item": "NFT People #3063",
		"Score": 40
	  },
	  {
		"Index": 4127,
		"Rank": 58,
		"Item": "NFT People #3076",
		"Score": 40
	  },
	  {
		"Index": 4128,
		"Rank": 58,
		"Item": "NFT People #3091",
		"Score": 40
	  },
	  {
		"Index": 4129,
		"Rank": 58,
		"Item": "NFT People #3119",
		"Score": 40
	  },
	  {
		"Index": 4130,
		"Rank": 58,
		"Item": "NFT People #3137",
		"Score": 40
	  },
	  {
		"Index": 4131,
		"Rank": 58,
		"Item": "NFT People #3150",
		"Score": 40
	  },
	  {
		"Index": 4132,
		"Rank": 58,
		"Item": "NFT People #3153",
		"Score": 40
	  },
	  {
		"Index": 4133,
		"Rank": 58,
		"Item": "NFT People #3211",
		"Score": 40
	  },
	  {
		"Index": 4134,
		"Rank": 58,
		"Item": "NFT People #3240",
		"Score": 40
	  },
	  {
		"Index": 4135,
		"Rank": 58,
		"Item": "NFT People #3353",
		"Score": 40
	  },
	  {
		"Index": 4136,
		"Rank": 58,
		"Item": "NFT People #3368",
		"Score": 40
	  },
	  {
		"Index": 4137,
		"Rank": 58,
		"Item": "NFT People #3383",
		"Score": 40
	  },
	  {
		"Index": 4138,
		"Rank": 58,
		"Item": "NFT People #3435",
		"Score": 40
	  },
	  {
		"Index": 4139,
		"Rank": 58,
		"Item": "NFT People #3461",
		"Score": 40
	  },
	  {
		"Index": 4140,
		"Rank": 58,
		"Item": "NFT People #3581",
		"Score": 40
	  },
	  {
		"Index": 4141,
		"Rank": 58,
		"Item": "NFT People #3628",
		"Score": 40
	  },
	  {
		"Index": 4142,
		"Rank": 58,
		"Item": "NFT People #3686",
		"Score": 40
	  },
	  {
		"Index": 4143,
		"Rank": 58,
		"Item": "NFT People #3740",
		"Score": 40
	  },
	  {
		"Index": 4144,
		"Rank": 58,
		"Item": "NFT People #3764",
		"Score": 40
	  },
	  {
		"Index": 4145,
		"Rank": 58,
		"Item": "NFT People #3864",
		"Score": 40
	  },
	  {
		"Index": 4146,
		"Rank": 58,
		"Item": "NFT People #4023",
		"Score": 40
	  },
	  {
		"Index": 4147,
		"Rank": 58,
		"Item": "NFT People #4028",
		"Score": 40
	  },
	  {
		"Index": 4148,
		"Rank": 58,
		"Item": "NFT People #4033",
		"Score": 40
	  },
	  {
		"Index": 4149,
		"Rank": 58,
		"Item": "NFT People #4059",
		"Score": 40
	  },
	  {
		"Index": 4150,
		"Rank": 58,
		"Item": "NFT People #4163",
		"Score": 40
	  },
	  {
		"Index": 4151,
		"Rank": 58,
		"Item": "NFT People #4173",
		"Score": 40
	  },
	  {
		"Index": 4152,
		"Rank": 58,
		"Item": "NFT People #4175",
		"Score": 40
	  },
	  {
		"Index": 4153,
		"Rank": 58,
		"Item": "NFT People #4187",
		"Score": 40
	  },
	  {
		"Index": 4154,
		"Rank": 58,
		"Item": "NFT People #4197",
		"Score": 40
	  },
	  {
		"Index": 4155,
		"Rank": 58,
		"Item": "NFT People #4228",
		"Score": 40
	  },
	  {
		"Index": 4156,
		"Rank": 58,
		"Item": "NFT People #4302",
		"Score": 40
	  },
	  {
		"Index": 4157,
		"Rank": 58,
		"Item": "NFT People #4369",
		"Score": 40
	  },
	  {
		"Index": 4158,
		"Rank": 58,
		"Item": "NFT People #4403",
		"Score": 40
	  },
	  {
		"Index": 4159,
		"Rank": 58,
		"Item": "NFT People #4551",
		"Score": 40
	  },
	  {
		"Index": 4160,
		"Rank": 58,
		"Item": "NFT People #4558",
		"Score": 40
	  },
	  {
		"Index": 4161,
		"Rank": 58,
		"Item": "NFT People #4562",
		"Score": 40
	  },
	  {
		"Index": 4162,
		"Rank": 58,
		"Item": "NFT People #4585",
		"Score": 40
	  },
	  {
		"Index": 4163,
		"Rank": 58,
		"Item": "NFT People #4691",
		"Score": 40
	  },
	  {
		"Index": 4164,
		"Rank": 58,
		"Item": "NFT People #4709",
		"Score": 40
	  },
	  {
		"Index": 4165,
		"Rank": 58,
		"Item": "NFT People #4728",
		"Score": 40
	  },
	  {
		"Index": 4166,
		"Rank": 58,
		"Item": "NFT People #4775",
		"Score": 40
	  },
	  {
		"Index": 4167,
		"Rank": 58,
		"Item": "NFT People #4827",
		"Score": 40
	  },
	  {
		"Index": 4168,
		"Rank": 58,
		"Item": "NFT People #4927",
		"Score": 40
	  },
	  {
		"Index": 4169,
		"Rank": 58,
		"Item": "NFT People #4934",
		"Score": 40
	  },
	  {
		"Index": 4170,
		"Rank": 59,
		"Item": "NFT People #0216",
		"Score": 39
	  },
	  {
		"Index": 4171,
		"Rank": 59,
		"Item": "NFT People #0263",
		"Score": 39
	  },
	  {
		"Index": 4172,
		"Rank": 59,
		"Item": "NFT People #0270",
		"Score": 39
	  },
	  {
		"Index": 4173,
		"Rank": 59,
		"Item": "NFT People #0276",
		"Score": 39
	  },
	  {
		"Index": 4174,
		"Rank": 59,
		"Item": "NFT People #0346",
		"Score": 39
	  },
	  {
		"Index": 4175,
		"Rank": 59,
		"Item": "NFT People #0414",
		"Score": 39
	  },
	  {
		"Index": 4176,
		"Rank": 59,
		"Item": "NFT People #0480",
		"Score": 39
	  },
	  {
		"Index": 4177,
		"Rank": 59,
		"Item": "NFT People #0520",
		"Score": 39
	  },
	  {
		"Index": 4178,
		"Rank": 59,
		"Item": "NFT People #0543",
		"Score": 39
	  },
	  {
		"Index": 4179,
		"Rank": 59,
		"Item": "NFT People #0579",
		"Score": 39
	  },
	  {
		"Index": 4180,
		"Rank": 59,
		"Item": "NFT People #0653",
		"Score": 39
	  },
	  {
		"Index": 4181,
		"Rank": 59,
		"Item": "NFT People #0714",
		"Score": 39
	  },
	  {
		"Index": 4182,
		"Rank": 59,
		"Item": "NFT People #0721",
		"Score": 39
	  },
	  {
		"Index": 4183,
		"Rank": 59,
		"Item": "NFT People #0776",
		"Score": 39
	  },
	  {
		"Index": 4184,
		"Rank": 59,
		"Item": "NFT People #0825",
		"Score": 39
	  },
	  {
		"Index": 4185,
		"Rank": 59,
		"Item": "NFT People #0900",
		"Score": 39
	  },
	  {
		"Index": 4186,
		"Rank": 59,
		"Item": "NFT People #0901",
		"Score": 39
	  },
	  {
		"Index": 4187,
		"Rank": 59,
		"Item": "NFT People #0924",
		"Score": 39
	  },
	  {
		"Index": 4188,
		"Rank": 59,
		"Item": "NFT People #1049",
		"Score": 39
	  },
	  {
		"Index": 4189,
		"Rank": 59,
		"Item": "NFT People #1056",
		"Score": 39
	  },
	  {
		"Index": 4190,
		"Rank": 59,
		"Item": "NFT People #1057",
		"Score": 39
	  },
	  {
		"Index": 4191,
		"Rank": 59,
		"Item": "NFT People #1099",
		"Score": 39
	  },
	  {
		"Index": 4192,
		"Rank": 59,
		"Item": "NFT People #1112",
		"Score": 39
	  },
	  {
		"Index": 4193,
		"Rank": 59,
		"Item": "NFT People #1177",
		"Score": 39
	  },
	  {
		"Index": 4194,
		"Rank": 59,
		"Item": "NFT People #1181",
		"Score": 39
	  },
	  {
		"Index": 4195,
		"Rank": 59,
		"Item": "NFT People #1198",
		"Score": 39
	  },
	  {
		"Index": 4196,
		"Rank": 59,
		"Item": "NFT People #1211",
		"Score": 39
	  },
	  {
		"Index": 4197,
		"Rank": 59,
		"Item": "NFT People #1246",
		"Score": 39
	  },
	  {
		"Index": 4198,
		"Rank": 59,
		"Item": "NFT People #1254",
		"Score": 39
	  },
	  {
		"Index": 4199,
		"Rank": 59,
		"Item": "NFT People #1283",
		"Score": 39
	  },
	  {
		"Index": 4200,
		"Rank": 59,
		"Item": "NFT People #1287",
		"Score": 39
	  },
	  {
		"Index": 4201,
		"Rank": 59,
		"Item": "NFT People #1471",
		"Score": 39
	  },
	  {
		"Index": 4202,
		"Rank": 59,
		"Item": "NFT People #1510",
		"Score": 39
	  },
	  {
		"Index": 4203,
		"Rank": 59,
		"Item": "NFT People #1627",
		"Score": 39
	  },
	  {
		"Index": 4204,
		"Rank": 59,
		"Item": "NFT People #1687",
		"Score": 39
	  },
	  {
		"Index": 4205,
		"Rank": 59,
		"Item": "NFT People #1708",
		"Score": 39
	  },
	  {
		"Index": 4206,
		"Rank": 59,
		"Item": "NFT People #1709",
		"Score": 39
	  },
	  {
		"Index": 4207,
		"Rank": 59,
		"Item": "NFT People #2006",
		"Score": 39
	  },
	  {
		"Index": 4208,
		"Rank": 59,
		"Item": "NFT People #2031",
		"Score": 39
	  },
	  {
		"Index": 4209,
		"Rank": 59,
		"Item": "NFT People #2073",
		"Score": 39
	  },
	  {
		"Index": 4210,
		"Rank": 59,
		"Item": "NFT People #2109",
		"Score": 39
	  },
	  {
		"Index": 4211,
		"Rank": 59,
		"Item": "NFT People #2133",
		"Score": 39
	  },
	  {
		"Index": 4212,
		"Rank": 59,
		"Item": "NFT People #2205",
		"Score": 39
	  },
	  {
		"Index": 4213,
		"Rank": 59,
		"Item": "NFT People #2239",
		"Score": 39
	  },
	  {
		"Index": 4214,
		"Rank": 59,
		"Item": "NFT People #2308",
		"Score": 39
	  },
	  {
		"Index": 4215,
		"Rank": 59,
		"Item": "NFT People #2346",
		"Score": 39
	  },
	  {
		"Index": 4216,
		"Rank": 59,
		"Item": "NFT People #2467",
		"Score": 39
	  },
	  {
		"Index": 4217,
		"Rank": 59,
		"Item": "NFT People #2538",
		"Score": 39
	  },
	  {
		"Index": 4218,
		"Rank": 59,
		"Item": "NFT People #2638",
		"Score": 39
	  },
	  {
		"Index": 4219,
		"Rank": 59,
		"Item": "NFT People #2745",
		"Score": 39
	  },
	  {
		"Index": 4220,
		"Rank": 59,
		"Item": "NFT People #2783",
		"Score": 39
	  },
	  {
		"Index": 4221,
		"Rank": 59,
		"Item": "NFT People #2833",
		"Score": 39
	  },
	  {
		"Index": 4222,
		"Rank": 59,
		"Item": "NFT People #2900",
		"Score": 39
	  },
	  {
		"Index": 4223,
		"Rank": 59,
		"Item": "NFT People #2905",
		"Score": 39
	  },
	  {
		"Index": 4224,
		"Rank": 59,
		"Item": "NFT People #2975",
		"Score": 39
	  },
	  {
		"Index": 4225,
		"Rank": 59,
		"Item": "NFT People #3010",
		"Score": 39
	  },
	  {
		"Index": 4226,
		"Rank": 59,
		"Item": "NFT People #3053",
		"Score": 39
	  },
	  {
		"Index": 4227,
		"Rank": 59,
		"Item": "NFT People #3068",
		"Score": 39
	  },
	  {
		"Index": 4228,
		"Rank": 59,
		"Item": "NFT People #3136",
		"Score": 39
	  },
	  {
		"Index": 4229,
		"Rank": 59,
		"Item": "NFT People #3160",
		"Score": 39
	  },
	  {
		"Index": 4230,
		"Rank": 59,
		"Item": "NFT People #3256",
		"Score": 39
	  },
	  {
		"Index": 4231,
		"Rank": 59,
		"Item": "NFT People #3444",
		"Score": 39
	  },
	  {
		"Index": 4232,
		"Rank": 59,
		"Item": "NFT People #3452",
		"Score": 39
	  },
	  {
		"Index": 4233,
		"Rank": 59,
		"Item": "NFT People #3472",
		"Score": 39
	  },
	  {
		"Index": 4234,
		"Rank": 59,
		"Item": "NFT People #3629",
		"Score": 39
	  },
	  {
		"Index": 4235,
		"Rank": 59,
		"Item": "NFT People #3747",
		"Score": 39
	  },
	  {
		"Index": 4236,
		"Rank": 59,
		"Item": "NFT People #3894",
		"Score": 39
	  },
	  {
		"Index": 4237,
		"Rank": 59,
		"Item": "NFT People #3925",
		"Score": 39
	  },
	  {
		"Index": 4238,
		"Rank": 59,
		"Item": "NFT People #4071",
		"Score": 39
	  },
	  {
		"Index": 4239,
		"Rank": 59,
		"Item": "NFT People #4081",
		"Score": 39
	  },
	  {
		"Index": 4240,
		"Rank": 59,
		"Item": "NFT People #4117",
		"Score": 39
	  },
	  {
		"Index": 4241,
		"Rank": 59,
		"Item": "NFT People #4170",
		"Score": 39
	  },
	  {
		"Index": 4242,
		"Rank": 59,
		"Item": "NFT People #4320",
		"Score": 39
	  },
	  {
		"Index": 4243,
		"Rank": 59,
		"Item": "NFT People #4363",
		"Score": 39
	  },
	  {
		"Index": 4244,
		"Rank": 59,
		"Item": "NFT People #4488",
		"Score": 39
	  },
	  {
		"Index": 4245,
		"Rank": 59,
		"Item": "NFT People #4523",
		"Score": 39
	  },
	  {
		"Index": 4246,
		"Rank": 59,
		"Item": "NFT People #4532",
		"Score": 39
	  },
	  {
		"Index": 4247,
		"Rank": 59,
		"Item": "NFT People #4540",
		"Score": 39
	  },
	  {
		"Index": 4248,
		"Rank": 59,
		"Item": "NFT People #4541",
		"Score": 39
	  },
	  {
		"Index": 4249,
		"Rank": 59,
		"Item": "NFT People #4542",
		"Score": 39
	  },
	  {
		"Index": 4250,
		"Rank": 59,
		"Item": "NFT People #4659",
		"Score": 39
	  },
	  {
		"Index": 4251,
		"Rank": 59,
		"Item": "NFT People #4698",
		"Score": 39
	  },
	  {
		"Index": 4252,
		"Rank": 59,
		"Item": "NFT People #4721",
		"Score": 39
	  },
	  {
		"Index": 4253,
		"Rank": 59,
		"Item": "NFT People #4825",
		"Score": 39
	  },
	  {
		"Index": 4254,
		"Rank": 59,
		"Item": "NFT People #4835",
		"Score": 39
	  },
	  {
		"Index": 4255,
		"Rank": 59,
		"Item": "NFT People #4848",
		"Score": 39
	  },
	  {
		"Index": 4256,
		"Rank": 59,
		"Item": "NFT People #4880",
		"Score": 39
	  },
	  {
		"Index": 4257,
		"Rank": 59,
		"Item": "NFT People #4896",
		"Score": 39
	  },
	  {
		"Index": 4258,
		"Rank": 59,
		"Item": "NFT People #4926",
		"Score": 39
	  },
	  {
		"Index": 4259,
		"Rank": 59,
		"Item": "NFT People #4962",
		"Score": 39
	  },
	  {
		"Index": 4260,
		"Rank": 60,
		"Item": "NFT People #0032",
		"Score": 38
	  },
	  {
		"Index": 4261,
		"Rank": 60,
		"Item": "NFT People #0055",
		"Score": 38
	  },
	  {
		"Index": 4262,
		"Rank": 60,
		"Item": "NFT People #0141",
		"Score": 38
	  },
	  {
		"Index": 4263,
		"Rank": 60,
		"Item": "NFT People #0145",
		"Score": 38
	  },
	  {
		"Index": 4264,
		"Rank": 60,
		"Item": "NFT People #0193",
		"Score": 38
	  },
	  {
		"Index": 4265,
		"Rank": 60,
		"Item": "NFT People #0227",
		"Score": 38
	  },
	  {
		"Index": 4266,
		"Rank": 60,
		"Item": "NFT People #0305",
		"Score": 38
	  },
	  {
		"Index": 4267,
		"Rank": 60,
		"Item": "NFT People #0314",
		"Score": 38
	  },
	  {
		"Index": 4268,
		"Rank": 60,
		"Item": "NFT People #0343",
		"Score": 38
	  },
	  {
		"Index": 4269,
		"Rank": 60,
		"Item": "NFT People #0365",
		"Score": 38
	  },
	  {
		"Index": 4270,
		"Rank": 60,
		"Item": "NFT People #0412",
		"Score": 38
	  },
	  {
		"Index": 4271,
		"Rank": 60,
		"Item": "NFT People #0472",
		"Score": 38
	  },
	  {
		"Index": 4272,
		"Rank": 60,
		"Item": "NFT People #0525",
		"Score": 38
	  },
	  {
		"Index": 4273,
		"Rank": 60,
		"Item": "NFT People #0540",
		"Score": 38
	  },
	  {
		"Index": 4274,
		"Rank": 60,
		"Item": "NFT People #0561",
		"Score": 38
	  },
	  {
		"Index": 4275,
		"Rank": 60,
		"Item": "NFT People #0628",
		"Score": 38
	  },
	  {
		"Index": 4276,
		"Rank": 60,
		"Item": "NFT People #0682",
		"Score": 38
	  },
	  {
		"Index": 4277,
		"Rank": 60,
		"Item": "NFT People #0744",
		"Score": 38
	  },
	  {
		"Index": 4278,
		"Rank": 60,
		"Item": "NFT People #0770",
		"Score": 38
	  },
	  {
		"Index": 4279,
		"Rank": 60,
		"Item": "NFT People #0771",
		"Score": 38
	  },
	  {
		"Index": 4280,
		"Rank": 60,
		"Item": "NFT People #0806",
		"Score": 38
	  },
	  {
		"Index": 4281,
		"Rank": 60,
		"Item": "NFT People #0843",
		"Score": 38
	  },
	  {
		"Index": 4282,
		"Rank": 60,
		"Item": "NFT People #0915",
		"Score": 38
	  },
	  {
		"Index": 4283,
		"Rank": 60,
		"Item": "NFT People #0922",
		"Score": 38
	  },
	  {
		"Index": 4284,
		"Rank": 60,
		"Item": "NFT People #0960",
		"Score": 38
	  },
	  {
		"Index": 4285,
		"Rank": 60,
		"Item": "NFT People #0995",
		"Score": 38
	  },
	  {
		"Index": 4286,
		"Rank": 60,
		"Item": "NFT People #1151",
		"Score": 38
	  },
	  {
		"Index": 4287,
		"Rank": 60,
		"Item": "NFT People #1600",
		"Score": 38
	  },
	  {
		"Index": 4288,
		"Rank": 60,
		"Item": "NFT People #1646",
		"Score": 38
	  },
	  {
		"Index": 4289,
		"Rank": 60,
		"Item": "NFT People #1665",
		"Score": 38
	  },
	  {
		"Index": 4290,
		"Rank": 60,
		"Item": "NFT People #1668",
		"Score": 38
	  },
	  {
		"Index": 4291,
		"Rank": 60,
		"Item": "NFT People #1681",
		"Score": 38
	  },
	  {
		"Index": 4292,
		"Rank": 60,
		"Item": "NFT People #1719",
		"Score": 38
	  },
	  {
		"Index": 4293,
		"Rank": 60,
		"Item": "NFT People #1746",
		"Score": 38
	  },
	  {
		"Index": 4294,
		"Rank": 60,
		"Item": "NFT People #1776",
		"Score": 38
	  },
	  {
		"Index": 4295,
		"Rank": 60,
		"Item": "NFT People #1942",
		"Score": 38
	  },
	  {
		"Index": 4296,
		"Rank": 60,
		"Item": "NFT People #1951",
		"Score": 38
	  },
	  {
		"Index": 4297,
		"Rank": 60,
		"Item": "NFT People #1966",
		"Score": 38
	  },
	  {
		"Index": 4298,
		"Rank": 60,
		"Item": "NFT People #2021",
		"Score": 38
	  },
	  {
		"Index": 4299,
		"Rank": 60,
		"Item": "NFT People #2038",
		"Score": 38
	  },
	  {
		"Index": 4300,
		"Rank": 60,
		"Item": "NFT People #2072",
		"Score": 38
	  },
	  {
		"Index": 4301,
		"Rank": 60,
		"Item": "NFT People #2103",
		"Score": 38
	  },
	  {
		"Index": 4302,
		"Rank": 60,
		"Item": "NFT People #2193",
		"Score": 38
	  },
	  {
		"Index": 4303,
		"Rank": 60,
		"Item": "NFT People #2527",
		"Score": 38
	  },
	  {
		"Index": 4304,
		"Rank": 60,
		"Item": "NFT People #2559",
		"Score": 38
	  },
	  {
		"Index": 4305,
		"Rank": 60,
		"Item": "NFT People #2631",
		"Score": 38
	  },
	  {
		"Index": 4306,
		"Rank": 60,
		"Item": "NFT People #2700",
		"Score": 38
	  },
	  {
		"Index": 4307,
		"Rank": 60,
		"Item": "NFT People #2723",
		"Score": 38
	  },
	  {
		"Index": 4308,
		"Rank": 60,
		"Item": "NFT People #2724",
		"Score": 38
	  },
	  {
		"Index": 4309,
		"Rank": 60,
		"Item": "NFT People #2768",
		"Score": 38
	  },
	  {
		"Index": 4310,
		"Rank": 60,
		"Item": "NFT People #2812",
		"Score": 38
	  },
	  {
		"Index": 4311,
		"Rank": 60,
		"Item": "NFT People #2947",
		"Score": 38
	  },
	  {
		"Index": 4312,
		"Rank": 60,
		"Item": "NFT People #2999",
		"Score": 38
	  },
	  {
		"Index": 4313,
		"Rank": 60,
		"Item": "NFT People #3003",
		"Score": 38
	  },
	  {
		"Index": 4314,
		"Rank": 60,
		"Item": "NFT People #3112",
		"Score": 38
	  },
	  {
		"Index": 4315,
		"Rank": 60,
		"Item": "NFT People #3120",
		"Score": 38
	  },
	  {
		"Index": 4316,
		"Rank": 60,
		"Item": "NFT People #3123",
		"Score": 38
	  },
	  {
		"Index": 4317,
		"Rank": 60,
		"Item": "NFT People #3197",
		"Score": 38
	  },
	  {
		"Index": 4318,
		"Rank": 60,
		"Item": "NFT People #3236",
		"Score": 38
	  },
	  {
		"Index": 4319,
		"Rank": 60,
		"Item": "NFT People #3407",
		"Score": 38
	  },
	  {
		"Index": 4320,
		"Rank": 60,
		"Item": "NFT People #3477",
		"Score": 38
	  },
	  {
		"Index": 4321,
		"Rank": 60,
		"Item": "NFT People #3496",
		"Score": 38
	  },
	  {
		"Index": 4322,
		"Rank": 60,
		"Item": "NFT People #3661",
		"Score": 38
	  },
	  {
		"Index": 4323,
		"Rank": 60,
		"Item": "NFT People #3685",
		"Score": 38
	  },
	  {
		"Index": 4324,
		"Rank": 60,
		"Item": "NFT People #3692",
		"Score": 38
	  },
	  {
		"Index": 4325,
		"Rank": 60,
		"Item": "NFT People #3701",
		"Score": 38
	  },
	  {
		"Index": 4326,
		"Rank": 60,
		"Item": "NFT People #3887",
		"Score": 38
	  },
	  {
		"Index": 4327,
		"Rank": 60,
		"Item": "NFT People #3907",
		"Score": 38
	  },
	  {
		"Index": 4328,
		"Rank": 60,
		"Item": "NFT People #3909",
		"Score": 38
	  },
	  {
		"Index": 4329,
		"Rank": 60,
		"Item": "NFT People #3917",
		"Score": 38
	  },
	  {
		"Index": 4330,
		"Rank": 60,
		"Item": "NFT People #3993",
		"Score": 38
	  },
	  {
		"Index": 4331,
		"Rank": 60,
		"Item": "NFT People #4029",
		"Score": 38
	  },
	  {
		"Index": 4332,
		"Rank": 60,
		"Item": "NFT People #4111",
		"Score": 38
	  },
	  {
		"Index": 4333,
		"Rank": 60,
		"Item": "NFT People #4232",
		"Score": 38
	  },
	  {
		"Index": 4334,
		"Rank": 60,
		"Item": "NFT People #4264",
		"Score": 38
	  },
	  {
		"Index": 4335,
		"Rank": 60,
		"Item": "NFT People #4266",
		"Score": 38
	  },
	  {
		"Index": 4336,
		"Rank": 60,
		"Item": "NFT People #4286",
		"Score": 38
	  },
	  {
		"Index": 4337,
		"Rank": 60,
		"Item": "NFT People #4344",
		"Score": 38
	  },
	  {
		"Index": 4338,
		"Rank": 60,
		"Item": "NFT People #4402",
		"Score": 38
	  },
	  {
		"Index": 4339,
		"Rank": 60,
		"Item": "NFT People #4415",
		"Score": 38
	  },
	  {
		"Index": 4340,
		"Rank": 60,
		"Item": "NFT People #4480",
		"Score": 38
	  },
	  {
		"Index": 4341,
		"Rank": 60,
		"Item": "NFT People #4499",
		"Score": 38
	  },
	  {
		"Index": 4342,
		"Rank": 60,
		"Item": "NFT People #4526",
		"Score": 38
	  },
	  {
		"Index": 4343,
		"Rank": 60,
		"Item": "NFT People #4602",
		"Score": 38
	  },
	  {
		"Index": 4344,
		"Rank": 60,
		"Item": "NFT People #4642",
		"Score": 38
	  },
	  {
		"Index": 4345,
		"Rank": 60,
		"Item": "NFT People #4713",
		"Score": 38
	  },
	  {
		"Index": 4346,
		"Rank": 60,
		"Item": "NFT People #4743",
		"Score": 38
	  },
	  {
		"Index": 4347,
		"Rank": 60,
		"Item": "NFT People #4804",
		"Score": 38
	  },
	  {
		"Index": 4348,
		"Rank": 60,
		"Item": "NFT People #4966",
		"Score": 38
	  },
	  {
		"Index": 4349,
		"Rank": 61,
		"Item": "NFT People #0072",
		"Score": 37
	  },
	  {
		"Index": 4350,
		"Rank": 61,
		"Item": "NFT People #0240",
		"Score": 37
	  },
	  {
		"Index": 4351,
		"Rank": 61,
		"Item": "NFT People #0382",
		"Score": 37
	  },
	  {
		"Index": 4352,
		"Rank": 61,
		"Item": "NFT People #0471",
		"Score": 37
	  },
	  {
		"Index": 4353,
		"Rank": 61,
		"Item": "NFT People #0987",
		"Score": 37
	  },
	  {
		"Index": 4354,
		"Rank": 61,
		"Item": "NFT People #1297",
		"Score": 37
	  },
	  {
		"Index": 4355,
		"Rank": 61,
		"Item": "NFT People #1305",
		"Score": 37
	  },
	  {
		"Index": 4356,
		"Rank": 61,
		"Item": "NFT People #1328",
		"Score": 37
	  },
	  {
		"Index": 4357,
		"Rank": 61,
		"Item": "NFT People #1344",
		"Score": 37
	  },
	  {
		"Index": 4358,
		"Rank": 61,
		"Item": "NFT People #1349",
		"Score": 37
	  },
	  {
		"Index": 4359,
		"Rank": 61,
		"Item": "NFT People #1359",
		"Score": 37
	  },
	  {
		"Index": 4360,
		"Rank": 61,
		"Item": "NFT People #1387",
		"Score": 37
	  },
	  {
		"Index": 4361,
		"Rank": 61,
		"Item": "NFT People #1724",
		"Score": 37
	  },
	  {
		"Index": 4362,
		"Rank": 61,
		"Item": "NFT People #1774",
		"Score": 37
	  },
	  {
		"Index": 4363,
		"Rank": 61,
		"Item": "NFT People #1787",
		"Score": 37
	  },
	  {
		"Index": 4364,
		"Rank": 61,
		"Item": "NFT People #1836",
		"Score": 37
	  },
	  {
		"Index": 4365,
		"Rank": 61,
		"Item": "NFT People #1906",
		"Score": 37
	  },
	  {
		"Index": 4366,
		"Rank": 61,
		"Item": "NFT People #1962",
		"Score": 37
	  },
	  {
		"Index": 4367,
		"Rank": 61,
		"Item": "NFT People #2499",
		"Score": 37
	  },
	  {
		"Index": 4368,
		"Rank": 61,
		"Item": "NFT People #2540",
		"Score": 37
	  },
	  {
		"Index": 4369,
		"Rank": 61,
		"Item": "NFT People #2603",
		"Score": 37
	  },
	  {
		"Index": 4370,
		"Rank": 61,
		"Item": "NFT People #2884",
		"Score": 37
	  },
	  {
		"Index": 4371,
		"Rank": 61,
		"Item": "NFT People #2885",
		"Score": 37
	  },
	  {
		"Index": 4372,
		"Rank": 61,
		"Item": "NFT People #3021",
		"Score": 37
	  },
	  {
		"Index": 4373,
		"Rank": 61,
		"Item": "NFT People #3147",
		"Score": 37
	  },
	  {
		"Index": 4374,
		"Rank": 61,
		"Item": "NFT People #3232",
		"Score": 37
	  },
	  {
		"Index": 4375,
		"Rank": 61,
		"Item": "NFT People #3244",
		"Score": 37
	  },
	  {
		"Index": 4376,
		"Rank": 61,
		"Item": "NFT People #3342",
		"Score": 37
	  },
	  {
		"Index": 4377,
		"Rank": 61,
		"Item": "NFT People #3421",
		"Score": 37
	  },
	  {
		"Index": 4378,
		"Rank": 61,
		"Item": "NFT People #3560",
		"Score": 37
	  },
	  {
		"Index": 4379,
		"Rank": 61,
		"Item": "NFT People #3660",
		"Score": 37
	  },
	  {
		"Index": 4380,
		"Rank": 61,
		"Item": "NFT People #3664",
		"Score": 37
	  },
	  {
		"Index": 4381,
		"Rank": 61,
		"Item": "NFT People #3817",
		"Score": 37
	  },
	  {
		"Index": 4382,
		"Rank": 61,
		"Item": "NFT People #3845",
		"Score": 37
	  },
	  {
		"Index": 4383,
		"Rank": 61,
		"Item": "NFT People #3937",
		"Score": 37
	  },
	  {
		"Index": 4384,
		"Rank": 61,
		"Item": "NFT People #3944",
		"Score": 37
	  },
	  {
		"Index": 4385,
		"Rank": 61,
		"Item": "NFT People #3952",
		"Score": 37
	  },
	  {
		"Index": 4386,
		"Rank": 61,
		"Item": "NFT People #4106",
		"Score": 37
	  },
	  {
		"Index": 4387,
		"Rank": 61,
		"Item": "NFT People #4167",
		"Score": 37
	  },
	  {
		"Index": 4388,
		"Rank": 61,
		"Item": "NFT People #4440",
		"Score": 37
	  },
	  {
		"Index": 4389,
		"Rank": 61,
		"Item": "NFT People #4647",
		"Score": 37
	  },
	  {
		"Index": 4390,
		"Rank": 61,
		"Item": "NFT People #4676",
		"Score": 37
	  },
	  {
		"Index": 4391,
		"Rank": 61,
		"Item": "NFT People #4705",
		"Score": 37
	  },
	  {
		"Index": 4392,
		"Rank": 62,
		"Item": "NFT People #0007",
		"Score": 36
	  },
	  {
		"Index": 4393,
		"Rank": 62,
		"Item": "NFT People #0023",
		"Score": 36
	  },
	  {
		"Index": 4394,
		"Rank": 62,
		"Item": "NFT People #0290",
		"Score": 36
	  },
	  {
		"Index": 4395,
		"Rank": 62,
		"Item": "NFT People #0299",
		"Score": 36
	  },
	  {
		"Index": 4396,
		"Rank": 62,
		"Item": "NFT People #0342",
		"Score": 36
	  },
	  {
		"Index": 4397,
		"Rank": 62,
		"Item": "NFT People #0428",
		"Score": 36
	  },
	  {
		"Index": 4398,
		"Rank": 62,
		"Item": "NFT People #0461",
		"Score": 36
	  },
	  {
		"Index": 4399,
		"Rank": 62,
		"Item": "NFT People #0487",
		"Score": 36
	  },
	  {
		"Index": 4400,
		"Rank": 62,
		"Item": "NFT People #0677",
		"Score": 36
	  },
	  {
		"Index": 4401,
		"Rank": 62,
		"Item": "NFT People #0686",
		"Score": 36
	  },
	  {
		"Index": 4402,
		"Rank": 62,
		"Item": "NFT People #0851",
		"Score": 36
	  },
	  {
		"Index": 4403,
		"Rank": 62,
		"Item": "NFT People #0938",
		"Score": 36
	  },
	  {
		"Index": 4404,
		"Rank": 62,
		"Item": "NFT People #0970",
		"Score": 36
	  },
	  {
		"Index": 4405,
		"Rank": 62,
		"Item": "NFT People #1015",
		"Score": 36
	  },
	  {
		"Index": 4406,
		"Rank": 62,
		"Item": "NFT People #1195",
		"Score": 36
	  },
	  {
		"Index": 4407,
		"Rank": 62,
		"Item": "NFT People #1215",
		"Score": 36
	  },
	  {
		"Index": 4408,
		"Rank": 62,
		"Item": "NFT People #1266",
		"Score": 36
	  },
	  {
		"Index": 4409,
		"Rank": 62,
		"Item": "NFT People #1307",
		"Score": 36
	  },
	  {
		"Index": 4410,
		"Rank": 62,
		"Item": "NFT People #1335",
		"Score": 36
	  },
	  {
		"Index": 4411,
		"Rank": 62,
		"Item": "NFT People #1338",
		"Score": 36
	  },
	  {
		"Index": 4412,
		"Rank": 62,
		"Item": "NFT People #1386",
		"Score": 36
	  },
	  {
		"Index": 4413,
		"Rank": 62,
		"Item": "NFT People #1425",
		"Score": 36
	  },
	  {
		"Index": 4414,
		"Rank": 62,
		"Item": "NFT People #1656",
		"Score": 36
	  },
	  {
		"Index": 4415,
		"Rank": 62,
		"Item": "NFT People #1957",
		"Score": 36
	  },
	  {
		"Index": 4416,
		"Rank": 62,
		"Item": "NFT People #2082",
		"Score": 36
	  },
	  {
		"Index": 4417,
		"Rank": 62,
		"Item": "NFT People #2088",
		"Score": 36
	  },
	  {
		"Index": 4418,
		"Rank": 62,
		"Item": "NFT People #2097",
		"Score": 36
	  },
	  {
		"Index": 4419,
		"Rank": 62,
		"Item": "NFT People #2173",
		"Score": 36
	  },
	  {
		"Index": 4420,
		"Rank": 62,
		"Item": "NFT People #2182",
		"Score": 36
	  },
	  {
		"Index": 4421,
		"Rank": 62,
		"Item": "NFT People #2202",
		"Score": 36
	  },
	  {
		"Index": 4422,
		"Rank": 62,
		"Item": "NFT People #2281",
		"Score": 36
	  },
	  {
		"Index": 4423,
		"Rank": 62,
		"Item": "NFT People #2353",
		"Score": 36
	  },
	  {
		"Index": 4424,
		"Rank": 62,
		"Item": "NFT People #2440",
		"Score": 36
	  },
	  {
		"Index": 4425,
		"Rank": 62,
		"Item": "NFT People #2505",
		"Score": 36
	  },
	  {
		"Index": 4426,
		"Rank": 62,
		"Item": "NFT People #2649",
		"Score": 36
	  },
	  {
		"Index": 4427,
		"Rank": 62,
		"Item": "NFT People #2784",
		"Score": 36
	  },
	  {
		"Index": 4428,
		"Rank": 62,
		"Item": "NFT People #2795",
		"Score": 36
	  },
	  {
		"Index": 4429,
		"Rank": 62,
		"Item": "NFT People #2848",
		"Score": 36
	  },
	  {
		"Index": 4430,
		"Rank": 62,
		"Item": "NFT People #2894",
		"Score": 36
	  },
	  {
		"Index": 4431,
		"Rank": 62,
		"Item": "NFT People #2932",
		"Score": 36
	  },
	  {
		"Index": 4432,
		"Rank": 62,
		"Item": "NFT People #2941",
		"Score": 36
	  },
	  {
		"Index": 4433,
		"Rank": 62,
		"Item": "NFT People #2944",
		"Score": 36
	  },
	  {
		"Index": 4434,
		"Rank": 62,
		"Item": "NFT People #3025",
		"Score": 36
	  },
	  {
		"Index": 4435,
		"Rank": 62,
		"Item": "NFT People #3046",
		"Score": 36
	  },
	  {
		"Index": 4436,
		"Rank": 62,
		"Item": "NFT People #3054",
		"Score": 36
	  },
	  {
		"Index": 4437,
		"Rank": 62,
		"Item": "NFT People #3125",
		"Score": 36
	  },
	  {
		"Index": 4438,
		"Rank": 62,
		"Item": "NFT People #3184",
		"Score": 36
	  },
	  {
		"Index": 4439,
		"Rank": 62,
		"Item": "NFT People #3331",
		"Score": 36
	  },
	  {
		"Index": 4440,
		"Rank": 62,
		"Item": "NFT People #3375",
		"Score": 36
	  },
	  {
		"Index": 4441,
		"Rank": 62,
		"Item": "NFT People #3434",
		"Score": 36
	  },
	  {
		"Index": 4442,
		"Rank": 62,
		"Item": "NFT People #3475",
		"Score": 36
	  },
	  {
		"Index": 4443,
		"Rank": 62,
		"Item": "NFT People #3482",
		"Score": 36
	  },
	  {
		"Index": 4444,
		"Rank": 62,
		"Item": "NFT People #3576",
		"Score": 36
	  },
	  {
		"Index": 4445,
		"Rank": 62,
		"Item": "NFT People #3623",
		"Score": 36
	  },
	  {
		"Index": 4446,
		"Rank": 62,
		"Item": "NFT People #3683",
		"Score": 36
	  },
	  {
		"Index": 4447,
		"Rank": 62,
		"Item": "NFT People #3766",
		"Score": 36
	  },
	  {
		"Index": 4448,
		"Rank": 62,
		"Item": "NFT People #3847",
		"Score": 36
	  },
	  {
		"Index": 4449,
		"Rank": 62,
		"Item": "NFT People #3904",
		"Score": 36
	  },
	  {
		"Index": 4450,
		"Rank": 62,
		"Item": "NFT People #3913",
		"Score": 36
	  },
	  {
		"Index": 4451,
		"Rank": 62,
		"Item": "NFT People #4017",
		"Score": 36
	  },
	  {
		"Index": 4452,
		"Rank": 62,
		"Item": "NFT People #4127",
		"Score": 36
	  },
	  {
		"Index": 4453,
		"Rank": 62,
		"Item": "NFT People #4237",
		"Score": 36
	  },
	  {
		"Index": 4454,
		"Rank": 62,
		"Item": "NFT People #4273",
		"Score": 36
	  },
	  {
		"Index": 4455,
		"Rank": 62,
		"Item": "NFT People #4385",
		"Score": 36
	  },
	  {
		"Index": 4456,
		"Rank": 62,
		"Item": "NFT People #4387",
		"Score": 36
	  },
	  {
		"Index": 4457,
		"Rank": 62,
		"Item": "NFT People #4535",
		"Score": 36
	  },
	  {
		"Index": 4458,
		"Rank": 62,
		"Item": "NFT People #4640",
		"Score": 36
	  },
	  {
		"Index": 4459,
		"Rank": 62,
		"Item": "NFT People #4707",
		"Score": 36
	  },
	  {
		"Index": 4460,
		"Rank": 62,
		"Item": "NFT People #4782",
		"Score": 36
	  },
	  {
		"Index": 4461,
		"Rank": 62,
		"Item": "NFT People #4897",
		"Score": 36
	  },
	  {
		"Index": 4462,
		"Rank": 62,
		"Item": "NFT People #4996",
		"Score": 36
	  },
	  {
		"Index": 4463,
		"Rank": 63,
		"Item": "NFT People #0021",
		"Score": 35
	  },
	  {
		"Index": 4464,
		"Rank": 63,
		"Item": "NFT People #0100",
		"Score": 35
	  },
	  {
		"Index": 4465,
		"Rank": 63,
		"Item": "NFT People #0102",
		"Score": 35
	  },
	  {
		"Index": 4466,
		"Rank": 63,
		"Item": "NFT People #0315",
		"Score": 35
	  },
	  {
		"Index": 4467,
		"Rank": 63,
		"Item": "NFT People #0373",
		"Score": 35
	  },
	  {
		"Index": 4468,
		"Rank": 63,
		"Item": "NFT People #0390",
		"Score": 35
	  },
	  {
		"Index": 4469,
		"Rank": 63,
		"Item": "NFT People #0405",
		"Score": 35
	  },
	  {
		"Index": 4470,
		"Rank": 63,
		"Item": "NFT People #0474",
		"Score": 35
	  },
	  {
		"Index": 4471,
		"Rank": 63,
		"Item": "NFT People #0533",
		"Score": 35
	  },
	  {
		"Index": 4472,
		"Rank": 63,
		"Item": "NFT People #0573",
		"Score": 35
	  },
	  {
		"Index": 4473,
		"Rank": 63,
		"Item": "NFT People #0592",
		"Score": 35
	  },
	  {
		"Index": 4474,
		"Rank": 63,
		"Item": "NFT People #0630",
		"Score": 35
	  },
	  {
		"Index": 4475,
		"Rank": 63,
		"Item": "NFT People #0638",
		"Score": 35
	  },
	  {
		"Index": 4476,
		"Rank": 63,
		"Item": "NFT People #0734",
		"Score": 35
	  },
	  {
		"Index": 4477,
		"Rank": 63,
		"Item": "NFT People #0775",
		"Score": 35
	  },
	  {
		"Index": 4478,
		"Rank": 63,
		"Item": "NFT People #0812",
		"Score": 35
	  },
	  {
		"Index": 4479,
		"Rank": 63,
		"Item": "NFT People #0860",
		"Score": 35
	  },
	  {
		"Index": 4480,
		"Rank": 63,
		"Item": "NFT People #1031",
		"Score": 35
	  },
	  {
		"Index": 4481,
		"Rank": 63,
		"Item": "NFT People #1033",
		"Score": 35
	  },
	  {
		"Index": 4482,
		"Rank": 63,
		"Item": "NFT People #1053",
		"Score": 35
	  },
	  {
		"Index": 4483,
		"Rank": 63,
		"Item": "NFT People #1090",
		"Score": 35
	  },
	  {
		"Index": 4484,
		"Rank": 63,
		"Item": "NFT People #1201",
		"Score": 35
	  },
	  {
		"Index": 4485,
		"Rank": 63,
		"Item": "NFT People #1234",
		"Score": 35
	  },
	  {
		"Index": 4486,
		"Rank": 63,
		"Item": "NFT People #1237",
		"Score": 35
	  },
	  {
		"Index": 4487,
		"Rank": 63,
		"Item": "NFT People #1241",
		"Score": 35
	  },
	  {
		"Index": 4488,
		"Rank": 63,
		"Item": "NFT People #1535",
		"Score": 35
	  },
	  {
		"Index": 4489,
		"Rank": 63,
		"Item": "NFT People #1544",
		"Score": 35
	  },
	  {
		"Index": 4490,
		"Rank": 63,
		"Item": "NFT People #1549",
		"Score": 35
	  },
	  {
		"Index": 4491,
		"Rank": 63,
		"Item": "NFT People #1604",
		"Score": 35
	  },
	  {
		"Index": 4492,
		"Rank": 63,
		"Item": "NFT People #1640",
		"Score": 35
	  },
	  {
		"Index": 4493,
		"Rank": 63,
		"Item": "NFT People #1730",
		"Score": 35
	  },
	  {
		"Index": 4494,
		"Rank": 63,
		"Item": "NFT People #1779",
		"Score": 35
	  },
	  {
		"Index": 4495,
		"Rank": 63,
		"Item": "NFT People #1811",
		"Score": 35
	  },
	  {
		"Index": 4496,
		"Rank": 63,
		"Item": "NFT People #1842",
		"Score": 35
	  },
	  {
		"Index": 4497,
		"Rank": 63,
		"Item": "NFT People #1866",
		"Score": 35
	  },
	  {
		"Index": 4498,
		"Rank": 63,
		"Item": "NFT People #1987",
		"Score": 35
	  },
	  {
		"Index": 4499,
		"Rank": 63,
		"Item": "NFT People #2198",
		"Score": 35
	  },
	  {
		"Index": 4500,
		"Rank": 63,
		"Item": "NFT People #2382",
		"Score": 35
	  },
	  {
		"Index": 4501,
		"Rank": 63,
		"Item": "NFT People #2448",
		"Score": 35
	  },
	  {
		"Index": 4502,
		"Rank": 63,
		"Item": "NFT People #2470",
		"Score": 35
	  },
	  {
		"Index": 4503,
		"Rank": 63,
		"Item": "NFT People #2561",
		"Score": 35
	  },
	  {
		"Index": 4504,
		"Rank": 63,
		"Item": "NFT People #2596",
		"Score": 35
	  },
	  {
		"Index": 4505,
		"Rank": 63,
		"Item": "NFT People #2725",
		"Score": 35
	  },
	  {
		"Index": 4506,
		"Rank": 63,
		"Item": "NFT People #2746",
		"Score": 35
	  },
	  {
		"Index": 4507,
		"Rank": 63,
		"Item": "NFT People #2860",
		"Score": 35
	  },
	  {
		"Index": 4508,
		"Rank": 63,
		"Item": "NFT People #2891",
		"Score": 35
	  },
	  {
		"Index": 4509,
		"Rank": 63,
		"Item": "NFT People #2985",
		"Score": 35
	  },
	  {
		"Index": 4510,
		"Rank": 63,
		"Item": "NFT People #3033",
		"Score": 35
	  },
	  {
		"Index": 4511,
		"Rank": 63,
		"Item": "NFT People #3117",
		"Score": 35
	  },
	  {
		"Index": 4512,
		"Rank": 63,
		"Item": "NFT People #3305",
		"Score": 35
	  },
	  {
		"Index": 4513,
		"Rank": 63,
		"Item": "NFT People #3332",
		"Score": 35
	  },
	  {
		"Index": 4514,
		"Rank": 63,
		"Item": "NFT People #3354",
		"Score": 35
	  },
	  {
		"Index": 4515,
		"Rank": 63,
		"Item": "NFT People #3395",
		"Score": 35
	  },
	  {
		"Index": 4516,
		"Rank": 63,
		"Item": "NFT People #3441",
		"Score": 35
	  },
	  {
		"Index": 4517,
		"Rank": 63,
		"Item": "NFT People #3443",
		"Score": 35
	  },
	  {
		"Index": 4518,
		"Rank": 63,
		"Item": "NFT People #3536",
		"Score": 35
	  },
	  {
		"Index": 4519,
		"Rank": 63,
		"Item": "NFT People #3585",
		"Score": 35
	  },
	  {
		"Index": 4520,
		"Rank": 63,
		"Item": "NFT People #3956",
		"Score": 35
	  },
	  {
		"Index": 4521,
		"Rank": 63,
		"Item": "NFT People #3973",
		"Score": 35
	  },
	  {
		"Index": 4522,
		"Rank": 63,
		"Item": "NFT People #4040",
		"Score": 35
	  },
	  {
		"Index": 4523,
		"Rank": 63,
		"Item": "NFT People #4076",
		"Score": 35
	  },
	  {
		"Index": 4524,
		"Rank": 63,
		"Item": "NFT People #4077",
		"Score": 35
	  },
	  {
		"Index": 4525,
		"Rank": 63,
		"Item": "NFT People #4162",
		"Score": 35
	  },
	  {
		"Index": 4526,
		"Rank": 63,
		"Item": "NFT People #4218",
		"Score": 35
	  },
	  {
		"Index": 4527,
		"Rank": 63,
		"Item": "NFT People #4329",
		"Score": 35
	  },
	  {
		"Index": 4528,
		"Rank": 63,
		"Item": "NFT People #4391",
		"Score": 35
	  },
	  {
		"Index": 4529,
		"Rank": 63,
		"Item": "NFT People #4393",
		"Score": 35
	  },
	  {
		"Index": 4530,
		"Rank": 63,
		"Item": "NFT People #4459",
		"Score": 35
	  },
	  {
		"Index": 4531,
		"Rank": 63,
		"Item": "NFT People #4516",
		"Score": 35
	  },
	  {
		"Index": 4532,
		"Rank": 63,
		"Item": "NFT People #4594",
		"Score": 35
	  },
	  {
		"Index": 4533,
		"Rank": 63,
		"Item": "NFT People #4834",
		"Score": 35
	  },
	  {
		"Index": 4534,
		"Rank": 63,
		"Item": "NFT People #4920",
		"Score": 35
	  },
	  {
		"Index": 4535,
		"Rank": 64,
		"Item": "NFT People #0083",
		"Score": 34
	  },
	  {
		"Index": 4536,
		"Rank": 64,
		"Item": "NFT People #0155",
		"Score": 34
	  },
	  {
		"Index": 4537,
		"Rank": 64,
		"Item": "NFT People #0219",
		"Score": 34
	  },
	  {
		"Index": 4538,
		"Rank": 64,
		"Item": "NFT People #0464",
		"Score": 34
	  },
	  {
		"Index": 4539,
		"Rank": 64,
		"Item": "NFT People #0490",
		"Score": 34
	  },
	  {
		"Index": 4540,
		"Rank": 64,
		"Item": "NFT People #0503",
		"Score": 34
	  },
	  {
		"Index": 4541,
		"Rank": 64,
		"Item": "NFT People #0582",
		"Score": 34
	  },
	  {
		"Index": 4542,
		"Rank": 64,
		"Item": "NFT People #0608",
		"Score": 34
	  },
	  {
		"Index": 4543,
		"Rank": 64,
		"Item": "NFT People #0684",
		"Score": 34
	  },
	  {
		"Index": 4544,
		"Rank": 64,
		"Item": "NFT People #0699",
		"Score": 34
	  },
	  {
		"Index": 4545,
		"Rank": 64,
		"Item": "NFT People #0712",
		"Score": 34
	  },
	  {
		"Index": 4546,
		"Rank": 64,
		"Item": "NFT People #0802",
		"Score": 34
	  },
	  {
		"Index": 4547,
		"Rank": 64,
		"Item": "NFT People #0836",
		"Score": 34
	  },
	  {
		"Index": 4548,
		"Rank": 64,
		"Item": "NFT People #0849",
		"Score": 34
	  },
	  {
		"Index": 4549,
		"Rank": 64,
		"Item": "NFT People #0962",
		"Score": 34
	  },
	  {
		"Index": 4550,
		"Rank": 64,
		"Item": "NFT People #1027",
		"Score": 34
	  },
	  {
		"Index": 4551,
		"Rank": 64,
		"Item": "NFT People #1114",
		"Score": 34
	  },
	  {
		"Index": 4552,
		"Rank": 64,
		"Item": "NFT People #1122",
		"Score": 34
	  },
	  {
		"Index": 4553,
		"Rank": 64,
		"Item": "NFT People #1129",
		"Score": 34
	  },
	  {
		"Index": 4554,
		"Rank": 64,
		"Item": "NFT People #1339",
		"Score": 34
	  },
	  {
		"Index": 4555,
		"Rank": 64,
		"Item": "NFT People #1406",
		"Score": 34
	  },
	  {
		"Index": 4556,
		"Rank": 64,
		"Item": "NFT People #1411",
		"Score": 34
	  },
	  {
		"Index": 4557,
		"Rank": 64,
		"Item": "NFT People #1478",
		"Score": 34
	  },
	  {
		"Index": 4558,
		"Rank": 64,
		"Item": "NFT People #1505",
		"Score": 34
	  },
	  {
		"Index": 4559,
		"Rank": 64,
		"Item": "NFT People #1506",
		"Score": 34
	  },
	  {
		"Index": 4560,
		"Rank": 64,
		"Item": "NFT People #1661",
		"Score": 34
	  },
	  {
		"Index": 4561,
		"Rank": 64,
		"Item": "NFT People #1675",
		"Score": 34
	  },
	  {
		"Index": 4562,
		"Rank": 64,
		"Item": "NFT People #1740",
		"Score": 34
	  },
	  {
		"Index": 4563,
		"Rank": 64,
		"Item": "NFT People #1789",
		"Score": 34
	  },
	  {
		"Index": 4564,
		"Rank": 64,
		"Item": "NFT People #1806",
		"Score": 34
	  },
	  {
		"Index": 4565,
		"Rank": 64,
		"Item": "NFT People #1881",
		"Score": 34
	  },
	  {
		"Index": 4566,
		"Rank": 64,
		"Item": "NFT People #1968",
		"Score": 34
	  },
	  {
		"Index": 4567,
		"Rank": 64,
		"Item": "NFT People #2222",
		"Score": 34
	  },
	  {
		"Index": 4568,
		"Rank": 64,
		"Item": "NFT People #2578",
		"Score": 34
	  },
	  {
		"Index": 4569,
		"Rank": 64,
		"Item": "NFT People #2620",
		"Score": 34
	  },
	  {
		"Index": 4570,
		"Rank": 64,
		"Item": "NFT People #2646",
		"Score": 34
	  },
	  {
		"Index": 4571,
		"Rank": 64,
		"Item": "NFT People #2740",
		"Score": 34
	  },
	  {
		"Index": 4572,
		"Rank": 64,
		"Item": "NFT People #2752",
		"Score": 34
	  },
	  {
		"Index": 4573,
		"Rank": 64,
		"Item": "NFT People #2836",
		"Score": 34
	  },
	  {
		"Index": 4574,
		"Rank": 64,
		"Item": "NFT People #2951",
		"Score": 34
	  },
	  {
		"Index": 4575,
		"Rank": 64,
		"Item": "NFT People #3048",
		"Score": 34
	  },
	  {
		"Index": 4576,
		"Rank": 64,
		"Item": "NFT People #3115",
		"Score": 34
	  },
	  {
		"Index": 4577,
		"Rank": 64,
		"Item": "NFT People #3317",
		"Score": 34
	  },
	  {
		"Index": 4578,
		"Rank": 64,
		"Item": "NFT People #3335",
		"Score": 34
	  },
	  {
		"Index": 4579,
		"Rank": 64,
		"Item": "NFT People #3635",
		"Score": 34
	  },
	  {
		"Index": 4580,
		"Rank": 64,
		"Item": "NFT People #3703",
		"Score": 34
	  },
	  {
		"Index": 4581,
		"Rank": 64,
		"Item": "NFT People #3737",
		"Score": 34
	  },
	  {
		"Index": 4582,
		"Rank": 64,
		"Item": "NFT People #3754",
		"Score": 34
	  },
	  {
		"Index": 4583,
		"Rank": 64,
		"Item": "NFT People #3774",
		"Score": 34
	  },
	  {
		"Index": 4584,
		"Rank": 64,
		"Item": "NFT People #3943",
		"Score": 34
	  },
	  {
		"Index": 4585,
		"Rank": 64,
		"Item": "NFT People #3987",
		"Score": 34
	  },
	  {
		"Index": 4586,
		"Rank": 64,
		"Item": "NFT People #4025",
		"Score": 34
	  },
	  {
		"Index": 4587,
		"Rank": 64,
		"Item": "NFT People #4035",
		"Score": 34
	  },
	  {
		"Index": 4588,
		"Rank": 64,
		"Item": "NFT People #4037",
		"Score": 34
	  },
	  {
		"Index": 4589,
		"Rank": 64,
		"Item": "NFT People #4086",
		"Score": 34
	  },
	  {
		"Index": 4590,
		"Rank": 64,
		"Item": "NFT People #4154",
		"Score": 34
	  },
	  {
		"Index": 4591,
		"Rank": 64,
		"Item": "NFT People #4157",
		"Score": 34
	  },
	  {
		"Index": 4592,
		"Rank": 64,
		"Item": "NFT People #4221",
		"Score": 34
	  },
	  {
		"Index": 4593,
		"Rank": 64,
		"Item": "NFT People #4289",
		"Score": 34
	  },
	  {
		"Index": 4594,
		"Rank": 64,
		"Item": "NFT People #4343",
		"Score": 34
	  },
	  {
		"Index": 4595,
		"Rank": 64,
		"Item": "NFT People #4445",
		"Score": 34
	  },
	  {
		"Index": 4596,
		"Rank": 64,
		"Item": "NFT People #4504",
		"Score": 34
	  },
	  {
		"Index": 4597,
		"Rank": 64,
		"Item": "NFT People #4510",
		"Score": 34
	  },
	  {
		"Index": 4598,
		"Rank": 64,
		"Item": "NFT People #4531",
		"Score": 34
	  },
	  {
		"Index": 4599,
		"Rank": 64,
		"Item": "NFT People #4645",
		"Score": 34
	  },
	  {
		"Index": 4600,
		"Rank": 64,
		"Item": "NFT People #4678",
		"Score": 34
	  },
	  {
		"Index": 4601,
		"Rank": 64,
		"Item": "NFT People #4701",
		"Score": 34
	  },
	  {
		"Index": 4602,
		"Rank": 64,
		"Item": "NFT People #4723",
		"Score": 34
	  },
	  {
		"Index": 4603,
		"Rank": 64,
		"Item": "NFT People #4816",
		"Score": 34
	  },
	  {
		"Index": 4604,
		"Rank": 64,
		"Item": "NFT People #4839",
		"Score": 34
	  },
	  {
		"Index": 4605,
		"Rank": 64,
		"Item": "NFT People #4855",
		"Score": 34
	  },
	  {
		"Index": 4606,
		"Rank": 65,
		"Item": "NFT People #0348",
		"Score": 33
	  },
	  {
		"Index": 4607,
		"Rank": 65,
		"Item": "NFT People #0625",
		"Score": 33
	  },
	  {
		"Index": 4608,
		"Rank": 65,
		"Item": "NFT People #0657",
		"Score": 33
	  },
	  {
		"Index": 4609,
		"Rank": 65,
		"Item": "NFT People #0936",
		"Score": 33
	  },
	  {
		"Index": 4610,
		"Rank": 65,
		"Item": "NFT People #0939",
		"Score": 33
	  },
	  {
		"Index": 4611,
		"Rank": 65,
		"Item": "NFT People #0942",
		"Score": 33
	  },
	  {
		"Index": 4612,
		"Rank": 65,
		"Item": "NFT People #1525",
		"Score": 33
	  },
	  {
		"Index": 4613,
		"Rank": 65,
		"Item": "NFT People #2253",
		"Score": 33
	  },
	  {
		"Index": 4614,
		"Rank": 65,
		"Item": "NFT People #2278",
		"Score": 33
	  },
	  {
		"Index": 4615,
		"Rank": 65,
		"Item": "NFT People #2282",
		"Score": 33
	  },
	  {
		"Index": 4616,
		"Rank": 65,
		"Item": "NFT People #2599",
		"Score": 33
	  },
	  {
		"Index": 4617,
		"Rank": 65,
		"Item": "NFT People #2692",
		"Score": 33
	  },
	  {
		"Index": 4618,
		"Rank": 65,
		"Item": "NFT People #2855",
		"Score": 33
	  },
	  {
		"Index": 4619,
		"Rank": 65,
		"Item": "NFT People #2945",
		"Score": 33
	  },
	  {
		"Index": 4620,
		"Rank": 65,
		"Item": "NFT People #3262",
		"Score": 33
	  },
	  {
		"Index": 4621,
		"Rank": 65,
		"Item": "NFT People #3360",
		"Score": 33
	  },
	  {
		"Index": 4622,
		"Rank": 65,
		"Item": "NFT People #3419",
		"Score": 33
	  },
	  {
		"Index": 4623,
		"Rank": 65,
		"Item": "NFT People #3524",
		"Score": 33
	  },
	  {
		"Index": 4624,
		"Rank": 65,
		"Item": "NFT People #3609",
		"Score": 33
	  },
	  {
		"Index": 4625,
		"Rank": 65,
		"Item": "NFT People #3702",
		"Score": 33
	  },
	  {
		"Index": 4626,
		"Rank": 65,
		"Item": "NFT People #3798",
		"Score": 33
	  },
	  {
		"Index": 4627,
		"Rank": 65,
		"Item": "NFT People #3844",
		"Score": 33
	  },
	  {
		"Index": 4628,
		"Rank": 65,
		"Item": "NFT People #4193",
		"Score": 33
	  },
	  {
		"Index": 4629,
		"Rank": 65,
		"Item": "NFT People #4389",
		"Score": 33
	  },
	  {
		"Index": 4630,
		"Rank": 65,
		"Item": "NFT People #4559",
		"Score": 33
	  },
	  {
		"Index": 4631,
		"Rank": 65,
		"Item": "NFT People #4577",
		"Score": 33
	  },
	  {
		"Index": 4632,
		"Rank": 65,
		"Item": "NFT People #4590",
		"Score": 33
	  },
	  {
		"Index": 4633,
		"Rank": 65,
		"Item": "NFT People #4638",
		"Score": 33
	  },
	  {
		"Index": 4634,
		"Rank": 65,
		"Item": "NFT People #4718",
		"Score": 33
	  },
	  {
		"Index": 4635,
		"Rank": 65,
		"Item": "NFT People #4814",
		"Score": 33
	  },
	  {
		"Index": 4636,
		"Rank": 65,
		"Item": "NFT People #4859",
		"Score": 33
	  },
	  {
		"Index": 4637,
		"Rank": 66,
		"Item": "NFT People #0042",
		"Score": 32
	  },
	  {
		"Index": 4638,
		"Rank": 66,
		"Item": "NFT People #0052",
		"Score": 32
	  },
	  {
		"Index": 4639,
		"Rank": 66,
		"Item": "NFT People #0112",
		"Score": 32
	  },
	  {
		"Index": 4640,
		"Rank": 66,
		"Item": "NFT People #0149",
		"Score": 32
	  },
	  {
		"Index": 4641,
		"Rank": 66,
		"Item": "NFT People #0194",
		"Score": 32
	  },
	  {
		"Index": 4642,
		"Rank": 66,
		"Item": "NFT People #0289",
		"Score": 32
	  },
	  {
		"Index": 4643,
		"Rank": 66,
		"Item": "NFT People #0449",
		"Score": 32
	  },
	  {
		"Index": 4644,
		"Rank": 66,
		"Item": "NFT People #0794",
		"Score": 32
	  },
	  {
		"Index": 4645,
		"Rank": 66,
		"Item": "NFT People #0844",
		"Score": 32
	  },
	  {
		"Index": 4646,
		"Rank": 66,
		"Item": "NFT People #0846",
		"Score": 32
	  },
	  {
		"Index": 4647,
		"Rank": 66,
		"Item": "NFT People #1103",
		"Score": 32
	  },
	  {
		"Index": 4648,
		"Rank": 66,
		"Item": "NFT People #1306",
		"Score": 32
	  },
	  {
		"Index": 4649,
		"Rank": 66,
		"Item": "NFT People #1573",
		"Score": 32
	  },
	  {
		"Index": 4650,
		"Rank": 66,
		"Item": "NFT People #2258",
		"Score": 32
	  },
	  {
		"Index": 4651,
		"Rank": 66,
		"Item": "NFT People #2498",
		"Score": 32
	  },
	  {
		"Index": 4652,
		"Rank": 66,
		"Item": "NFT People #2523",
		"Score": 32
	  },
	  {
		"Index": 4653,
		"Rank": 66,
		"Item": "NFT People #2609",
		"Score": 32
	  },
	  {
		"Index": 4654,
		"Rank": 66,
		"Item": "NFT People #2815",
		"Score": 32
	  },
	  {
		"Index": 4655,
		"Rank": 66,
		"Item": "NFT People #2883",
		"Score": 32
	  },
	  {
		"Index": 4656,
		"Rank": 66,
		"Item": "NFT People #2890",
		"Score": 32
	  },
	  {
		"Index": 4657,
		"Rank": 66,
		"Item": "NFT People #2920",
		"Score": 32
	  },
	  {
		"Index": 4658,
		"Rank": 66,
		"Item": "NFT People #3141",
		"Score": 32
	  },
	  {
		"Index": 4659,
		"Rank": 66,
		"Item": "NFT People #3205",
		"Score": 32
	  },
	  {
		"Index": 4660,
		"Rank": 66,
		"Item": "NFT People #3389",
		"Score": 32
	  },
	  {
		"Index": 4661,
		"Rank": 66,
		"Item": "NFT People #3451",
		"Score": 32
	  },
	  {
		"Index": 4662,
		"Rank": 66,
		"Item": "NFT People #3483",
		"Score": 32
	  },
	  {
		"Index": 4663,
		"Rank": 66,
		"Item": "NFT People #3508",
		"Score": 32
	  },
	  {
		"Index": 4664,
		"Rank": 66,
		"Item": "NFT People #3550",
		"Score": 32
	  },
	  {
		"Index": 4665,
		"Rank": 66,
		"Item": "NFT People #3571",
		"Score": 32
	  },
	  {
		"Index": 4666,
		"Rank": 66,
		"Item": "NFT People #3582",
		"Score": 32
	  },
	  {
		"Index": 4667,
		"Rank": 66,
		"Item": "NFT People #3594",
		"Score": 32
	  },
	  {
		"Index": 4668,
		"Rank": 66,
		"Item": "NFT People #4042",
		"Score": 32
	  },
	  {
		"Index": 4669,
		"Rank": 66,
		"Item": "NFT People #4102",
		"Score": 32
	  },
	  {
		"Index": 4670,
		"Rank": 66,
		"Item": "NFT People #4248",
		"Score": 32
	  },
	  {
		"Index": 4671,
		"Rank": 66,
		"Item": "NFT People #4324",
		"Score": 32
	  },
	  {
		"Index": 4672,
		"Rank": 66,
		"Item": "NFT People #4361",
		"Score": 32
	  },
	  {
		"Index": 4673,
		"Rank": 66,
		"Item": "NFT People #4660",
		"Score": 32
	  },
	  {
		"Index": 4674,
		"Rank": 66,
		"Item": "NFT People #4671",
		"Score": 32
	  },
	  {
		"Index": 4675,
		"Rank": 66,
		"Item": "NFT People #4680",
		"Score": 32
	  },
	  {
		"Index": 4676,
		"Rank": 66,
		"Item": "NFT People #4755",
		"Score": 32
	  },
	  {
		"Index": 4677,
		"Rank": 66,
		"Item": "NFT People #4957",
		"Score": 32
	  },
	  {
		"Index": 4678,
		"Rank": 67,
		"Item": "NFT People #0036",
		"Score": 31
	  },
	  {
		"Index": 4679,
		"Rank": 67,
		"Item": "NFT People #0047",
		"Score": 31
	  },
	  {
		"Index": 4680,
		"Rank": 67,
		"Item": "NFT People #0084",
		"Score": 31
	  },
	  {
		"Index": 4681,
		"Rank": 67,
		"Item": "NFT People #0111",
		"Score": 31
	  },
	  {
		"Index": 4682,
		"Rank": 67,
		"Item": "NFT People #0337",
		"Score": 31
	  },
	  {
		"Index": 4683,
		"Rank": 67,
		"Item": "NFT People #0690",
		"Score": 31
	  },
	  {
		"Index": 4684,
		"Rank": 67,
		"Item": "NFT People #0724",
		"Score": 31
	  },
	  {
		"Index": 4685,
		"Rank": 67,
		"Item": "NFT People #0929",
		"Score": 31
	  },
	  {
		"Index": 4686,
		"Rank": 67,
		"Item": "NFT People #1191",
		"Score": 31
	  },
	  {
		"Index": 4687,
		"Rank": 67,
		"Item": "NFT People #1469",
		"Score": 31
	  },
	  {
		"Index": 4688,
		"Rank": 67,
		"Item": "NFT People #1576",
		"Score": 31
	  },
	  {
		"Index": 4689,
		"Rank": 67,
		"Item": "NFT People #1903",
		"Score": 31
	  },
	  {
		"Index": 4690,
		"Rank": 67,
		"Item": "NFT People #1923",
		"Score": 31
	  },
	  {
		"Index": 4691,
		"Rank": 67,
		"Item": "NFT People #2163",
		"Score": 31
	  },
	  {
		"Index": 4692,
		"Rank": 67,
		"Item": "NFT People #2191",
		"Score": 31
	  },
	  {
		"Index": 4693,
		"Rank": 67,
		"Item": "NFT People #2251",
		"Score": 31
	  },
	  {
		"Index": 4694,
		"Rank": 67,
		"Item": "NFT People #2292",
		"Score": 31
	  },
	  {
		"Index": 4695,
		"Rank": 67,
		"Item": "NFT People #2562",
		"Score": 31
	  },
	  {
		"Index": 4696,
		"Rank": 67,
		"Item": "NFT People #2731",
		"Score": 31
	  },
	  {
		"Index": 4697,
		"Rank": 67,
		"Item": "NFT People #2837",
		"Score": 31
	  },
	  {
		"Index": 4698,
		"Rank": 67,
		"Item": "NFT People #2873",
		"Score": 31
	  },
	  {
		"Index": 4699,
		"Rank": 67,
		"Item": "NFT People #3058",
		"Score": 31
	  },
	  {
		"Index": 4700,
		"Rank": 67,
		"Item": "NFT People #3108",
		"Score": 31
	  },
	  {
		"Index": 4701,
		"Rank": 67,
		"Item": "NFT People #3329",
		"Score": 31
	  },
	  {
		"Index": 4702,
		"Rank": 67,
		"Item": "NFT People #3410",
		"Score": 31
	  },
	  {
		"Index": 4703,
		"Rank": 67,
		"Item": "NFT People #3423",
		"Score": 31
	  },
	  {
		"Index": 4704,
		"Rank": 67,
		"Item": "NFT People #3644",
		"Score": 31
	  },
	  {
		"Index": 4705,
		"Rank": 67,
		"Item": "NFT People #3714",
		"Score": 31
	  },
	  {
		"Index": 4706,
		"Rank": 67,
		"Item": "NFT People #3729",
		"Score": 31
	  },
	  {
		"Index": 4707,
		"Rank": 67,
		"Item": "NFT People #3733",
		"Score": 31
	  },
	  {
		"Index": 4708,
		"Rank": 67,
		"Item": "NFT People #3850",
		"Score": 31
	  },
	  {
		"Index": 4709,
		"Rank": 67,
		"Item": "NFT People #3919",
		"Score": 31
	  },
	  {
		"Index": 4710,
		"Rank": 67,
		"Item": "NFT People #4043",
		"Score": 31
	  },
	  {
		"Index": 4711,
		"Rank": 67,
		"Item": "NFT People #4107",
		"Score": 31
	  },
	  {
		"Index": 4712,
		"Rank": 67,
		"Item": "NFT People #4146",
		"Score": 31
	  },
	  {
		"Index": 4713,
		"Rank": 67,
		"Item": "NFT People #4148",
		"Score": 31
	  },
	  {
		"Index": 4714,
		"Rank": 67,
		"Item": "NFT People #4161",
		"Score": 31
	  },
	  {
		"Index": 4715,
		"Rank": 67,
		"Item": "NFT People #4211",
		"Score": 31
	  },
	  {
		"Index": 4716,
		"Rank": 67,
		"Item": "NFT People #4213",
		"Score": 31
	  },
	  {
		"Index": 4717,
		"Rank": 67,
		"Item": "NFT People #4399",
		"Score": 31
	  },
	  {
		"Index": 4718,
		"Rank": 67,
		"Item": "NFT People #4474",
		"Score": 31
	  },
	  {
		"Index": 4719,
		"Rank": 67,
		"Item": "NFT People #4484",
		"Score": 31
	  },
	  {
		"Index": 4720,
		"Rank": 67,
		"Item": "NFT People #4521",
		"Score": 31
	  },
	  {
		"Index": 4721,
		"Rank": 67,
		"Item": "NFT People #4528",
		"Score": 31
	  },
	  {
		"Index": 4722,
		"Rank": 67,
		"Item": "NFT People #4690",
		"Score": 31
	  },
	  {
		"Index": 4723,
		"Rank": 68,
		"Item": "NFT People #0012",
		"Score": 30
	  },
	  {
		"Index": 4724,
		"Rank": 68,
		"Item": "NFT People #0260",
		"Score": 30
	  },
	  {
		"Index": 4725,
		"Rank": 68,
		"Item": "NFT People #0861",
		"Score": 30
	  },
	  {
		"Index": 4726,
		"Rank": 68,
		"Item": "NFT People #1223",
		"Score": 30
	  },
	  {
		"Index": 4727,
		"Rank": 68,
		"Item": "NFT People #1547",
		"Score": 30
	  },
	  {
		"Index": 4728,
		"Rank": 68,
		"Item": "NFT People #1930",
		"Score": 30
	  },
	  {
		"Index": 4729,
		"Rank": 68,
		"Item": "NFT People #2266",
		"Score": 30
	  },
	  {
		"Index": 4730,
		"Rank": 68,
		"Item": "NFT People #2300",
		"Score": 30
	  },
	  {
		"Index": 4731,
		"Rank": 68,
		"Item": "NFT People #2585",
		"Score": 30
	  },
	  {
		"Index": 4732,
		"Rank": 68,
		"Item": "NFT People #2744",
		"Score": 30
	  },
	  {
		"Index": 4733,
		"Rank": 68,
		"Item": "NFT People #3078",
		"Score": 30
	  },
	  {
		"Index": 4734,
		"Rank": 68,
		"Item": "NFT People #3245",
		"Score": 30
	  },
	  {
		"Index": 4735,
		"Rank": 68,
		"Item": "NFT People #3673",
		"Score": 30
	  },
	  {
		"Index": 4736,
		"Rank": 68,
		"Item": "NFT People #4118",
		"Score": 30
	  },
	  {
		"Index": 4737,
		"Rank": 68,
		"Item": "NFT People #4287",
		"Score": 30
	  },
	  {
		"Index": 4738,
		"Rank": 68,
		"Item": "NFT People #4972",
		"Score": 30
	  },
	  {
		"Index": 4739,
		"Rank": 69,
		"Item": "NFT People #0003",
		"Score": 29
	  },
	  {
		"Index": 4740,
		"Rank": 69,
		"Item": "NFT People #0388",
		"Score": 29
	  },
	  {
		"Index": 4741,
		"Rank": 69,
		"Item": "NFT People #0448",
		"Score": 29
	  },
	  {
		"Index": 4742,
		"Rank": 69,
		"Item": "NFT People #0451",
		"Score": 29
	  },
	  {
		"Index": 4743,
		"Rank": 69,
		"Item": "NFT People #0527",
		"Score": 29
	  },
	  {
		"Index": 4744,
		"Rank": 69,
		"Item": "NFT People #0534",
		"Score": 29
	  },
	  {
		"Index": 4745,
		"Rank": 69,
		"Item": "NFT People #0615",
		"Score": 29
	  },
	  {
		"Index": 4746,
		"Rank": 69,
		"Item": "NFT People #0622",
		"Score": 29
	  },
	  {
		"Index": 4747,
		"Rank": 69,
		"Item": "NFT People #0700",
		"Score": 29
	  },
	  {
		"Index": 4748,
		"Rank": 69,
		"Item": "NFT People #0859",
		"Score": 29
	  },
	  {
		"Index": 4749,
		"Rank": 69,
		"Item": "NFT People #0934",
		"Score": 29
	  },
	  {
		"Index": 4750,
		"Rank": 69,
		"Item": "NFT People #1050",
		"Score": 29
	  },
	  {
		"Index": 4751,
		"Rank": 69,
		"Item": "NFT People #1124",
		"Score": 29
	  },
	  {
		"Index": 4752,
		"Rank": 69,
		"Item": "NFT People #1280",
		"Score": 29
	  },
	  {
		"Index": 4753,
		"Rank": 69,
		"Item": "NFT People #1309",
		"Score": 29
	  },
	  {
		"Index": 4754,
		"Rank": 69,
		"Item": "NFT People #1455",
		"Score": 29
	  },
	  {
		"Index": 4755,
		"Rank": 69,
		"Item": "NFT People #1512",
		"Score": 29
	  },
	  {
		"Index": 4756,
		"Rank": 69,
		"Item": "NFT People #1653",
		"Score": 29
	  },
	  {
		"Index": 4757,
		"Rank": 69,
		"Item": "NFT People #1786",
		"Score": 29
	  },
	  {
		"Index": 4758,
		"Rank": 69,
		"Item": "NFT People #1896",
		"Score": 29
	  },
	  {
		"Index": 4759,
		"Rank": 69,
		"Item": "NFT People #2041",
		"Score": 29
	  },
	  {
		"Index": 4760,
		"Rank": 69,
		"Item": "NFT People #2139",
		"Score": 29
	  },
	  {
		"Index": 4761,
		"Rank": 69,
		"Item": "NFT People #2337",
		"Score": 29
	  },
	  {
		"Index": 4762,
		"Rank": 69,
		"Item": "NFT People #2814",
		"Score": 29
	  },
	  {
		"Index": 4763,
		"Rank": 69,
		"Item": "NFT People #2857",
		"Score": 29
	  },
	  {
		"Index": 4764,
		"Rank": 69,
		"Item": "NFT People #2923",
		"Score": 29
	  },
	  {
		"Index": 4765,
		"Rank": 69,
		"Item": "NFT People #3127",
		"Score": 29
	  },
	  {
		"Index": 4766,
		"Rank": 69,
		"Item": "NFT People #3191",
		"Score": 29
	  },
	  {
		"Index": 4767,
		"Rank": 69,
		"Item": "NFT People #3684",
		"Score": 29
	  },
	  {
		"Index": 4768,
		"Rank": 69,
		"Item": "NFT People #4160",
		"Score": 29
	  },
	  {
		"Index": 4769,
		"Rank": 69,
		"Item": "NFT People #4233",
		"Score": 29
	  },
	  {
		"Index": 4770,
		"Rank": 69,
		"Item": "NFT People #4243",
		"Score": 29
	  },
	  {
		"Index": 4771,
		"Rank": 69,
		"Item": "NFT People #4326",
		"Score": 29
	  },
	  {
		"Index": 4772,
		"Rank": 69,
		"Item": "NFT People #4331",
		"Score": 29
	  },
	  {
		"Index": 4773,
		"Rank": 69,
		"Item": "NFT People #4400",
		"Score": 29
	  },
	  {
		"Index": 4774,
		"Rank": 69,
		"Item": "NFT People #4467",
		"Score": 29
	  },
	  {
		"Index": 4775,
		"Rank": 69,
		"Item": "NFT People #4725",
		"Score": 29
	  },
	  {
		"Index": 4776,
		"Rank": 69,
		"Item": "NFT People #4731",
		"Score": 29
	  },
	  {
		"Index": 4777,
		"Rank": 69,
		"Item": "NFT People #4740",
		"Score": 29
	  },
	  {
		"Index": 4778,
		"Rank": 69,
		"Item": "NFT People #4994",
		"Score": 29
	  },
	  {
		"Index": 4779,
		"Rank": 70,
		"Item": "NFT People #0122",
		"Score": 28
	  },
	  {
		"Index": 4780,
		"Rank": 70,
		"Item": "NFT People #0134",
		"Score": 28
	  },
	  {
		"Index": 4781,
		"Rank": 70,
		"Item": "NFT People #0226",
		"Score": 28
	  },
	  {
		"Index": 4782,
		"Rank": 70,
		"Item": "NFT People #0602",
		"Score": 28
	  },
	  {
		"Index": 4783,
		"Rank": 70,
		"Item": "NFT People #0863",
		"Score": 28
	  },
	  {
		"Index": 4784,
		"Rank": 70,
		"Item": "NFT People #1173",
		"Score": 28
	  },
	  {
		"Index": 4785,
		"Rank": 70,
		"Item": "NFT People #1252",
		"Score": 28
	  },
	  {
		"Index": 4786,
		"Rank": 70,
		"Item": "NFT People #1686",
		"Score": 28
	  },
	  {
		"Index": 4787,
		"Rank": 70,
		"Item": "NFT People #1732",
		"Score": 28
	  },
	  {
		"Index": 4788,
		"Rank": 70,
		"Item": "NFT People #1869",
		"Score": 28
	  },
	  {
		"Index": 4789,
		"Rank": 70,
		"Item": "NFT People #2090",
		"Score": 28
	  },
	  {
		"Index": 4790,
		"Rank": 70,
		"Item": "NFT People #2141",
		"Score": 28
	  },
	  {
		"Index": 4791,
		"Rank": 70,
		"Item": "NFT People #2185",
		"Score": 28
	  },
	  {
		"Index": 4792,
		"Rank": 70,
		"Item": "NFT People #2249",
		"Score": 28
	  },
	  {
		"Index": 4793,
		"Rank": 70,
		"Item": "NFT People #2491",
		"Score": 28
	  },
	  {
		"Index": 4794,
		"Rank": 70,
		"Item": "NFT People #2524",
		"Score": 28
	  },
	  {
		"Index": 4795,
		"Rank": 70,
		"Item": "NFT People #2600",
		"Score": 28
	  },
	  {
		"Index": 4796,
		"Rank": 70,
		"Item": "NFT People #2771",
		"Score": 28
	  },
	  {
		"Index": 4797,
		"Rank": 70,
		"Item": "NFT People #2858",
		"Score": 28
	  },
	  {
		"Index": 4798,
		"Rank": 70,
		"Item": "NFT People #2868",
		"Score": 28
	  },
	  {
		"Index": 4799,
		"Rank": 70,
		"Item": "NFT People #3012",
		"Score": 28
	  },
	  {
		"Index": 4800,
		"Rank": 70,
		"Item": "NFT People #3239",
		"Score": 28
	  },
	  {
		"Index": 4801,
		"Rank": 70,
		"Item": "NFT People #3283",
		"Score": 28
	  },
	  {
		"Index": 4802,
		"Rank": 70,
		"Item": "NFT People #3551",
		"Score": 28
	  },
	  {
		"Index": 4803,
		"Rank": 70,
		"Item": "NFT People #3767",
		"Score": 28
	  },
	  {
		"Index": 4804,
		"Rank": 70,
		"Item": "NFT People #3790",
		"Score": 28
	  },
	  {
		"Index": 4805,
		"Rank": 70,
		"Item": "NFT People #4078",
		"Score": 28
	  },
	  {
		"Index": 4806,
		"Rank": 70,
		"Item": "NFT People #4301",
		"Score": 28
	  },
	  {
		"Index": 4807,
		"Rank": 70,
		"Item": "NFT People #4840",
		"Score": 28
	  },
	  {
		"Index": 4808,
		"Rank": 70,
		"Item": "NFT People #4890",
		"Score": 28
	  },
	  {
		"Index": 4809,
		"Rank": 70,
		"Item": "NFT People #4916",
		"Score": 28
	  },
	  {
		"Index": 4810,
		"Rank": 70,
		"Item": "NFT People #4975",
		"Score": 28
	  },
	  {
		"Index": 4811,
		"Rank": 70,
		"Item": "NFT People #4987",
		"Score": 28
	  },
	  {
		"Index": 4812,
		"Rank": 71,
		"Item": "NFT People #0492",
		"Score": 27
	  },
	  {
		"Index": 4813,
		"Rank": 71,
		"Item": "NFT People #0782",
		"Score": 27
	  },
	  {
		"Index": 4814,
		"Rank": 71,
		"Item": "NFT People #1066",
		"Score": 27
	  },
	  {
		"Index": 4815,
		"Rank": 71,
		"Item": "NFT People #1115",
		"Score": 27
	  },
	  {
		"Index": 4816,
		"Rank": 71,
		"Item": "NFT People #1548",
		"Score": 27
	  },
	  {
		"Index": 4817,
		"Rank": 71,
		"Item": "NFT People #1560",
		"Score": 27
	  },
	  {
		"Index": 4818,
		"Rank": 71,
		"Item": "NFT People #1615",
		"Score": 27
	  },
	  {
		"Index": 4819,
		"Rank": 71,
		"Item": "NFT People #2044",
		"Score": 27
	  },
	  {
		"Index": 4820,
		"Rank": 71,
		"Item": "NFT People #2194",
		"Score": 27
	  },
	  {
		"Index": 4821,
		"Rank": 71,
		"Item": "NFT People #2250",
		"Score": 27
	  },
	  {
		"Index": 4822,
		"Rank": 71,
		"Item": "NFT People #2325",
		"Score": 27
	  },
	  {
		"Index": 4823,
		"Rank": 71,
		"Item": "NFT People #2347",
		"Score": 27
	  },
	  {
		"Index": 4824,
		"Rank": 71,
		"Item": "NFT People #2352",
		"Score": 27
	  },
	  {
		"Index": 4825,
		"Rank": 71,
		"Item": "NFT People #2595",
		"Score": 27
	  },
	  {
		"Index": 4826,
		"Rank": 71,
		"Item": "NFT People #2735",
		"Score": 27
	  },
	  {
		"Index": 4827,
		"Rank": 71,
		"Item": "NFT People #2866",
		"Score": 27
	  },
	  {
		"Index": 4828,
		"Rank": 71,
		"Item": "NFT People #2914",
		"Score": 27
	  },
	  {
		"Index": 4829,
		"Rank": 71,
		"Item": "NFT People #3270",
		"Score": 27
	  },
	  {
		"Index": 4830,
		"Rank": 71,
		"Item": "NFT People #3379",
		"Score": 27
	  },
	  {
		"Index": 4831,
		"Rank": 71,
		"Item": "NFT People #3468",
		"Score": 27
	  },
	  {
		"Index": 4832,
		"Rank": 71,
		"Item": "NFT People #3745",
		"Score": 27
	  },
	  {
		"Index": 4833,
		"Rank": 71,
		"Item": "NFT People #3778",
		"Score": 27
	  },
	  {
		"Index": 4834,
		"Rank": 71,
		"Item": "NFT People #3833",
		"Score": 27
	  },
	  {
		"Index": 4835,
		"Rank": 71,
		"Item": "NFT People #3926",
		"Score": 27
	  },
	  {
		"Index": 4836,
		"Rank": 71,
		"Item": "NFT People #4099",
		"Score": 27
	  },
	  {
		"Index": 4837,
		"Rank": 71,
		"Item": "NFT People #4394",
		"Score": 27
	  },
	  {
		"Index": 4838,
		"Rank": 71,
		"Item": "NFT People #4419",
		"Score": 27
	  },
	  {
		"Index": 4839,
		"Rank": 71,
		"Item": "NFT People #4507",
		"Score": 27
	  },
	  {
		"Index": 4840,
		"Rank": 71,
		"Item": "NFT People #4580",
		"Score": 27
	  },
	  {
		"Index": 4841,
		"Rank": 71,
		"Item": "NFT People #4621",
		"Score": 27
	  },
	  {
		"Index": 4842,
		"Rank": 71,
		"Item": "NFT People #4693",
		"Score": 27
	  },
	  {
		"Index": 4843,
		"Rank": 71,
		"Item": "NFT People #4744",
		"Score": 27
	  },
	  {
		"Index": 4844,
		"Rank": 71,
		"Item": "NFT People #4762",
		"Score": 27
	  },
	  {
		"Index": 4845,
		"Rank": 71,
		"Item": "NFT People #4995",
		"Score": 27
	  },
	  {
		"Index": 4846,
		"Rank": 71,
		"Item": "NFT People #4998",
		"Score": 27
	  },
	  {
		"Index": 4847,
		"Rank": 72,
		"Item": "NFT People #0469",
		"Score": 26
	  },
	  {
		"Index": 4848,
		"Rank": 72,
		"Item": "NFT People #1231",
		"Score": 26
	  },
	  {
		"Index": 4849,
		"Rank": 72,
		"Item": "NFT People #1588",
		"Score": 26
	  },
	  {
		"Index": 4850,
		"Rank": 72,
		"Item": "NFT People #1608",
		"Score": 26
	  },
	  {
		"Index": 4851,
		"Rank": 72,
		"Item": "NFT People #1707",
		"Score": 26
	  },
	  {
		"Index": 4852,
		"Rank": 72,
		"Item": "NFT People #3212",
		"Score": 26
	  },
	  {
		"Index": 4853,
		"Rank": 72,
		"Item": "NFT People #3250",
		"Score": 26
	  },
	  {
		"Index": 4854,
		"Rank": 72,
		"Item": "NFT People #3371",
		"Score": 26
	  },
	  {
		"Index": 4855,
		"Rank": 72,
		"Item": "NFT People #3922",
		"Score": 26
	  },
	  {
		"Index": 4856,
		"Rank": 72,
		"Item": "NFT People #4096",
		"Score": 26
	  },
	  {
		"Index": 4857,
		"Rank": 72,
		"Item": "NFT People #4597",
		"Score": 26
	  },
	  {
		"Index": 4858,
		"Rank": 73,
		"Item": "NFT People #0126",
		"Score": 25
	  },
	  {
		"Index": 4859,
		"Rank": 73,
		"Item": "NFT People #0383",
		"Score": 25
	  },
	  {
		"Index": 4860,
		"Rank": 73,
		"Item": "NFT People #0542",
		"Score": 25
	  },
	  {
		"Index": 4861,
		"Rank": 73,
		"Item": "NFT People #0948",
		"Score": 25
	  },
	  {
		"Index": 4862,
		"Rank": 73,
		"Item": "NFT People #1247",
		"Score": 25
	  },
	  {
		"Index": 4863,
		"Rank": 73,
		"Item": "NFT People #1292",
		"Score": 25
	  },
	  {
		"Index": 4864,
		"Rank": 73,
		"Item": "NFT People #2321",
		"Score": 25
	  },
	  {
		"Index": 4865,
		"Rank": 73,
		"Item": "NFT People #2412",
		"Score": 25
	  },
	  {
		"Index": 4866,
		"Rank": 73,
		"Item": "NFT People #2842",
		"Score": 25
	  },
	  {
		"Index": 4867,
		"Rank": 73,
		"Item": "NFT People #3173",
		"Score": 25
	  },
	  {
		"Index": 4868,
		"Rank": 73,
		"Item": "NFT People #3287",
		"Score": 25
	  },
	  {
		"Index": 4869,
		"Rank": 73,
		"Item": "NFT People #3294",
		"Score": 25
	  },
	  {
		"Index": 4870,
		"Rank": 73,
		"Item": "NFT People #3562",
		"Score": 25
	  },
	  {
		"Index": 4871,
		"Rank": 73,
		"Item": "NFT People #3596",
		"Score": 25
	  },
	  {
		"Index": 4872,
		"Rank": 73,
		"Item": "NFT People #3700",
		"Score": 25
	  },
	  {
		"Index": 4873,
		"Rank": 73,
		"Item": "NFT People #4066",
		"Score": 25
	  },
	  {
		"Index": 4874,
		"Rank": 73,
		"Item": "NFT People #4245",
		"Score": 25
	  },
	  {
		"Index": 4875,
		"Rank": 73,
		"Item": "NFT People #4278",
		"Score": 25
	  },
	  {
		"Index": 4876,
		"Rank": 73,
		"Item": "NFT People #4544",
		"Score": 25
	  },
	  {
		"Index": 4877,
		"Rank": 73,
		"Item": "NFT People #4633",
		"Score": 25
	  },
	  {
		"Index": 4878,
		"Rank": 73,
		"Item": "NFT People #4669",
		"Score": 25
	  },
	  {
		"Index": 4879,
		"Rank": 73,
		"Item": "NFT People #4784",
		"Score": 25
	  },
	  {
		"Index": 4880,
		"Rank": 73,
		"Item": "NFT People #4821",
		"Score": 25
	  },
	  {
		"Index": 4881,
		"Rank": 73,
		"Item": "NFT People #4844",
		"Score": 25
	  },
	  {
		"Index": 4882,
		"Rank": 74,
		"Item": "NFT People #0179",
		"Score": 24
	  },
	  {
		"Index": 4883,
		"Rank": 74,
		"Item": "NFT People #0277",
		"Score": 24
	  },
	  {
		"Index": 4884,
		"Rank": 74,
		"Item": "NFT People #0362",
		"Score": 24
	  },
	  {
		"Index": 4885,
		"Rank": 74,
		"Item": "NFT People #1302",
		"Score": 24
	  },
	  {
		"Index": 4886,
		"Rank": 74,
		"Item": "NFT People #1394",
		"Score": 24
	  },
	  {
		"Index": 4887,
		"Rank": 74,
		"Item": "NFT People #1448",
		"Score": 24
	  },
	  {
		"Index": 4888,
		"Rank": 74,
		"Item": "NFT People #1526",
		"Score": 24
	  },
	  {
		"Index": 4889,
		"Rank": 74,
		"Item": "NFT People #1528",
		"Score": 24
	  },
	  {
		"Index": 4890,
		"Rank": 74,
		"Item": "NFT People #1553",
		"Score": 24
	  },
	  {
		"Index": 4891,
		"Rank": 74,
		"Item": "NFT People #1663",
		"Score": 24
	  },
	  {
		"Index": 4892,
		"Rank": 74,
		"Item": "NFT People #1790",
		"Score": 24
	  },
	  {
		"Index": 4893,
		"Rank": 74,
		"Item": "NFT People #1992",
		"Score": 24
	  },
	  {
		"Index": 4894,
		"Rank": 74,
		"Item": "NFT People #2474",
		"Score": 24
	  },
	  {
		"Index": 4895,
		"Rank": 74,
		"Item": "NFT People #2590",
		"Score": 24
	  },
	  {
		"Index": 4896,
		"Rank": 74,
		"Item": "NFT People #2801",
		"Score": 24
	  },
	  {
		"Index": 4897,
		"Rank": 74,
		"Item": "NFT People #3320",
		"Score": 24
	  },
	  {
		"Index": 4898,
		"Rank": 74,
		"Item": "NFT People #3535",
		"Score": 24
	  },
	  {
		"Index": 4899,
		"Rank": 74,
		"Item": "NFT People #3815",
		"Score": 24
	  },
	  {
		"Index": 4900,
		"Rank": 74,
		"Item": "NFT People #3825",
		"Score": 24
	  },
	  {
		"Index": 4901,
		"Rank": 74,
		"Item": "NFT People #3883",
		"Score": 24
	  },
	  {
		"Index": 4902,
		"Rank": 74,
		"Item": "NFT People #3941",
		"Score": 24
	  },
	  {
		"Index": 4903,
		"Rank": 74,
		"Item": "NFT People #4184",
		"Score": 24
	  },
	  {
		"Index": 4904,
		"Rank": 74,
		"Item": "NFT People #4190",
		"Score": 24
	  },
	  {
		"Index": 4905,
		"Rank": 74,
		"Item": "NFT People #4734",
		"Score": 24
	  },
	  {
		"Index": 4906,
		"Rank": 75,
		"Item": "NFT People #0153",
		"Score": 23
	  },
	  {
		"Index": 4907,
		"Rank": 75,
		"Item": "NFT People #0307",
		"Score": 23
	  },
	  {
		"Index": 4908,
		"Rank": 75,
		"Item": "NFT People #0341",
		"Score": 23
	  },
	  {
		"Index": 4909,
		"Rank": 75,
		"Item": "NFT People #0544",
		"Score": 23
	  },
	  {
		"Index": 4910,
		"Rank": 75,
		"Item": "NFT People #0757",
		"Score": 23
	  },
	  {
		"Index": 4911,
		"Rank": 75,
		"Item": "NFT People #0919",
		"Score": 23
	  },
	  {
		"Index": 4912,
		"Rank": 75,
		"Item": "NFT People #0943",
		"Score": 23
	  },
	  {
		"Index": 4913,
		"Rank": 75,
		"Item": "NFT People #0983",
		"Score": 23
	  },
	  {
		"Index": 4914,
		"Rank": 75,
		"Item": "NFT People #1330",
		"Score": 23
	  },
	  {
		"Index": 4915,
		"Rank": 75,
		"Item": "NFT People #1361",
		"Score": 23
	  },
	  {
		"Index": 4916,
		"Rank": 75,
		"Item": "NFT People #1841",
		"Score": 23
	  },
	  {
		"Index": 4917,
		"Rank": 75,
		"Item": "NFT People #1963",
		"Score": 23
	  },
	  {
		"Index": 4918,
		"Rank": 75,
		"Item": "NFT People #2017",
		"Score": 23
	  },
	  {
		"Index": 4919,
		"Rank": 75,
		"Item": "NFT People #2714",
		"Score": 23
	  },
	  {
		"Index": 4920,
		"Rank": 75,
		"Item": "NFT People #2864",
		"Score": 23
	  },
	  {
		"Index": 4921,
		"Rank": 75,
		"Item": "NFT People #3311",
		"Score": 23
	  },
	  {
		"Index": 4922,
		"Rank": 75,
		"Item": "NFT People #3672",
		"Score": 23
	  },
	  {
		"Index": 4923,
		"Rank": 75,
		"Item": "NFT People #3914",
		"Score": 23
	  },
	  {
		"Index": 4924,
		"Rank": 75,
		"Item": "NFT People #4012",
		"Score": 23
	  },
	  {
		"Index": 4925,
		"Rank": 75,
		"Item": "NFT People #4092",
		"Score": 23
	  },
	  {
		"Index": 4926,
		"Rank": 76,
		"Item": "NFT People #0537",
		"Score": 22
	  },
	  {
		"Index": 4927,
		"Rank": 76,
		"Item": "NFT People #0590",
		"Score": 22
	  },
	  {
		"Index": 4928,
		"Rank": 76,
		"Item": "NFT People #0847",
		"Score": 22
	  },
	  {
		"Index": 4929,
		"Rank": 76,
		"Item": "NFT People #1705",
		"Score": 22
	  },
	  {
		"Index": 4930,
		"Rank": 76,
		"Item": "NFT People #3310",
		"Score": 22
	  },
	  {
		"Index": 4931,
		"Rank": 76,
		"Item": "NFT People #3991",
		"Score": 22
	  },
	  {
		"Index": 4932,
		"Rank": 76,
		"Item": "NFT People #4378",
		"Score": 22
	  },
	  {
		"Index": 4933,
		"Rank": 76,
		"Item": "NFT People #4520",
		"Score": 22
	  },
	  {
		"Index": 4934,
		"Rank": 77,
		"Item": "NFT People #0718",
		"Score": 21
	  },
	  {
		"Index": 4935,
		"Rank": 77,
		"Item": "NFT People #0736",
		"Score": 21
	  },
	  {
		"Index": 4936,
		"Rank": 77,
		"Item": "NFT People #0845",
		"Score": 21
	  },
	  {
		"Index": 4937,
		"Rank": 77,
		"Item": "NFT People #0875",
		"Score": 21
	  },
	  {
		"Index": 4938,
		"Rank": 77,
		"Item": "NFT People #1275",
		"Score": 21
	  },
	  {
		"Index": 4939,
		"Rank": 77,
		"Item": "NFT People #2790",
		"Score": 21
	  },
	  {
		"Index": 4940,
		"Rank": 77,
		"Item": "NFT People #3187",
		"Score": 21
	  },
	  {
		"Index": 4941,
		"Rank": 77,
		"Item": "NFT People #3315",
		"Score": 21
	  },
	  {
		"Index": 4942,
		"Rank": 77,
		"Item": "NFT People #3520",
		"Score": 21
	  },
	  {
		"Index": 4943,
		"Rank": 77,
		"Item": "NFT People #3936",
		"Score": 21
	  },
	  {
		"Index": 4944,
		"Rank": 77,
		"Item": "NFT People #3967",
		"Score": 21
	  },
	  {
		"Index": 4945,
		"Rank": 77,
		"Item": "NFT People #4208",
		"Score": 21
	  },
	  {
		"Index": 4946,
		"Rank": 78,
		"Item": "NFT People #0372",
		"Score": 20
	  },
	  {
		"Index": 4947,
		"Rank": 78,
		"Item": "NFT People #0410",
		"Score": 20
	  },
	  {
		"Index": 4948,
		"Rank": 78,
		"Item": "NFT People #0455",
		"Score": 20
	  },
	  {
		"Index": 4949,
		"Rank": 78,
		"Item": "NFT People #0680",
		"Score": 20
	  },
	  {
		"Index": 4950,
		"Rank": 78,
		"Item": "NFT People #1143",
		"Score": 20
	  },
	  {
		"Index": 4951,
		"Rank": 78,
		"Item": "NFT People #1522",
		"Score": 20
	  },
	  {
		"Index": 4952,
		"Rank": 78,
		"Item": "NFT People #1536",
		"Score": 20
	  },
	  {
		"Index": 4953,
		"Rank": 78,
		"Item": "NFT People #2237",
		"Score": 20
	  },
	  {
		"Index": 4954,
		"Rank": 78,
		"Item": "NFT People #3473",
		"Score": 20
	  },
	  {
		"Index": 4955,
		"Rank": 78,
		"Item": "NFT People #3663",
		"Score": 20
	  },
	  {
		"Index": 4956,
		"Rank": 78,
		"Item": "NFT People #4241",
		"Score": 20
	  },
	  {
		"Index": 4957,
		"Rank": 78,
		"Item": "NFT People #4407",
		"Score": 20
	  },
	  {
		"Index": 4958,
		"Rank": 79,
		"Item": "NFT People #1612",
		"Score": 19
	  },
	  {
		"Index": 4959,
		"Rank": 79,
		"Item": "NFT People #1745",
		"Score": 19
	  },
	  {
		"Index": 4960,
		"Rank": 79,
		"Item": "NFT People #1837",
		"Score": 19
	  },
	  {
		"Index": 4961,
		"Rank": 79,
		"Item": "NFT People #2052",
		"Score": 19
	  },
	  {
		"Index": 4962,
		"Rank": 79,
		"Item": "NFT People #2405",
		"Score": 19
	  },
	  {
		"Index": 4963,
		"Rank": 79,
		"Item": "NFT People #2694",
		"Score": 19
	  },
	  {
		"Index": 4964,
		"Rank": 80,
		"Item": "NFT People #0513",
		"Score": 18
	  },
	  {
		"Index": 4965,
		"Rank": 80,
		"Item": "NFT People #1106",
		"Score": 18
	  },
	  {
		"Index": 4966,
		"Rank": 80,
		"Item": "NFT People #1591",
		"Score": 18
	  },
	  {
		"Index": 4967,
		"Rank": 80,
		"Item": "NFT People #3018",
		"Score": 18
	  },
	  {
		"Index": 4968,
		"Rank": 80,
		"Item": "NFT People #3458",
		"Score": 18
	  },
	  {
		"Index": 4969,
		"Rank": 80,
		"Item": "NFT People #3871",
		"Score": 18
	  },
	  {
		"Index": 4970,
		"Rank": 80,
		"Item": "NFT People #4222",
		"Score": 18
	  },
	  {
		"Index": 4971,
		"Rank": 81,
		"Item": "NFT People #0402",
		"Score": 17
	  },
	  {
		"Index": 4972,
		"Rank": 81,
		"Item": "NFT People #0698",
		"Score": 17
	  },
	  {
		"Index": 4973,
		"Rank": 81,
		"Item": "NFT People #2275",
		"Score": 17
	  },
	  {
		"Index": 4974,
		"Rank": 81,
		"Item": "NFT People #3149",
		"Score": 17
	  },
	  {
		"Index": 4975,
		"Rank": 81,
		"Item": "NFT People #3982",
		"Score": 17
	  },
	  {
		"Index": 4976,
		"Rank": 81,
		"Item": "NFT People #4384",
		"Score": 17
	  },
	  {
		"Index": 4977,
		"Rank": 81,
		"Item": "NFT People #4813",
		"Score": 17
	  },
	  {
		"Index": 4978,
		"Rank": 82,
		"Item": "NFT People #0287",
		"Score": 16
	  },
	  {
		"Index": 4979,
		"Rank": 82,
		"Item": "NFT People #2487",
		"Score": 16
	  },
	  {
		"Index": 4980,
		"Rank": 82,
		"Item": "NFT People #2871",
		"Score": 16
	  },
	  {
		"Index": 4981,
		"Rank": 82,
		"Item": "NFT People #3424",
		"Score": 16
	  },
	  {
		"Index": 4982,
		"Rank": 82,
		"Item": "NFT People #4165",
		"Score": 16
	  },
	  {
		"Index": 4983,
		"Rank": 83,
		"Item": "NFT People #1483",
		"Score": 15
	  },
	  {
		"Index": 4984,
		"Rank": 84,
		"Item": "NFT People #0244",
		"Score": 14
	  },
	  {
		"Index": 4985,
		"Rank": 84,
		"Item": "NFT People #1037",
		"Score": 14
	  },
	  {
		"Index": 4986,
		"Rank": 84,
		"Item": "NFT People #1927",
		"Score": 14
	  },
	  {
		"Index": 4987,
		"Rank": 84,
		"Item": "NFT People #2879",
		"Score": 14
	  },
	  {
		"Index": 4988,
		"Rank": 84,
		"Item": "NFT People #4323",
		"Score": 14
	  },
	  {
		"Index": 4989,
		"Rank": 84,
		"Item": "NFT People #4811",
		"Score": 14
	  },
	  {
		"Index": 4990,
		"Rank": 84,
		"Item": "NFT People #4925",
		"Score": 14
	  },
	  {
		"Index": 4991,
		"Rank": 85,
		"Item": "NFT People #1148",
		"Score": 13
	  },
	  {
		"Index": 4992,
		"Rank": 85,
		"Item": "NFT People #1890",
		"Score": 13
	  },
	  {
		"Index": 4993,
		"Rank": 86,
		"Item": "NFT People #1577",
		"Score": 12
	  },
	  {
		"Index": 4994,
		"Rank": 86,
		"Item": "NFT People #3055",
		"Score": 12
	  },
	  {
		"Index": 4995,
		"Rank": 87,
		"Item": "NFT People #0750",
		"Score": 11
	  },
	  {
		"Index": 4996,
		"Rank": 88,
		"Item": "NFT People #0165",
		"Score": 10
	  },
	  {
		"Index": 4997,
		"Rank": 88,
		"Item": "NFT People #2008",
		"Score": 10
	  },
	  {
		"Index": 4998,
		"Rank": 88,
		"Item": "NFT People #2642",
		"Score": 10
	  },
	  {
		"Index": 4999,
		"Rank": 89,
		"Item": "NFT People #0831",
		"Score": 9
	  },
	  {
		"Index": 5000,
		"Rank": 89,
		"Item": "NFT People #3861",
		"Score": 9
	  },
	  {
		"Index": 5001,
		"Rank": 89,
		"Item": "NFT People #4253",
		"Score": 9
	  },
	  {
		"Index": 5002,
		"Rank": 90,
		"Item": "NFT People #4337",
		"Score": 4
	  },
	  {
		"Index": 5003,
		"Rank": 91,
		"Item": "NFT People #3438",
		"Score": 1
	  },
	  {
		"Index": 5004,
		"Rank": 92,
		"Item": "NFT People #1592",
		"Score": 0
	  }
	 ]